webpackJsonp([2],{

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = trackLink;

var _dom = __webpack_require__(86);

function trackLink(trackable, event) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!trackable) return;
    if (trackable instanceof Array) {
        trackable.forEach(function (el) {
            return setupTrackLink(el, event, params);
        });
        return;
    } else if (trackable instanceof NodeList) {
        for (var i = 0; i < trackable.length; i++) {
            setupTrackLink(trackable[i], event, params);
        }
        return;
    } else {
        setupTrackLink(trackable, event, params);
        return;
    }
} //
// Segment analytics link tracking that includes experiment data.
// The Segment implementation allows a single element or an Array to be passed
// in, so we're keeping this as close as possible to this.
// See: https://segment.com/docs/sources/website/analytics.js/#track-link
// - https://github.com/segmentio/analytics.js/blob/a111102f50118c92d0f5034b71cad8cfb44c3592/analytics.js#L483-L522
// - https://github.com/DefinitelyTyped/DefinitelyTyped/blob/92434b8642aeff543ca3736ae9ef93aa7d93b764/types/segment-analytics/index.d.ts#L150-L156

function setupTrackLink(element, event, params) {
    var trackParams = window.trackParams || {};
    params = Object.assign({ url: window.location.href, target_path: (0, _dom.getLinkTargetPath)(element), target_url: (0, _dom.getLinkTargetUrl)(element, window.location) }, trackParams, params);
    if (false) {
        element.addEventListener('click', function () {
            console.info('Track link: "%s": %o', event, params); // eslint-disable-line no-console
        });
    }
    if (window.analytics) {
        window.analytics.trackLink(element, event, params);
    }
}

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDimensionsConstrainedToContainer = getDimensionsConstrainedToContainer;
function getDimensionsConstrainedToContainer(elementDimensions, containerDimensions) {
    if (elementDimensions.width < containerDimensions.width && elementDimensions.height < containerDimensions.height) {
        return elementDimensions;
    }
    var widthScale = containerDimensions.width / elementDimensions.width;
    var heightScale = containerDimensions.height / elementDimensions.height;
    var scale = Math.min(widthScale, heightScale);
    return {
        width: Math.floor(elementDimensions.width * scale),
        height: Math.floor(elementDimensions.height * scale)
    };
}
exports.default = getDimensionsConstrainedToContainer;

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDimensionsConstrainedToContainerWidth = getDimensionsConstrainedToContainerWidth;
function getDimensionsConstrainedToContainerWidth(elementDimensions, containerDimensions) {
    var newDimensions = {
        width: containerDimensions.width,
        height: Math.floor(containerDimensions.width / elementDimensions.width * elementDimensions.height)
    };
    return containerDimensions.width > elementDimensions.width ? elementDimensions : newDimensions;
}
exports.default = getDimensionsConstrainedToContainerWidth;

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLinkTargetPath = getLinkTargetPath;
function getLinkTargetPath(node) {
    if (!node) return null;
    var href = node.getAttribute('href');
    if (href && href.match(/^http/)) {
        return href.replace(/^http[s]{0,1}:\/\/.[^/]+[/]*/, '/');
    }
    return href;
}
exports.default = getLinkTargetPath;

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLinkTargetUrl = getLinkTargetUrl;
function getLinkTargetUrl(node) {
    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;

    if (!node) return null;
    var href = node.getAttribute('href');
    var origin = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
    if (href && !href.match(/^http/)) {
        return '' + origin + href;
    }
    return href;
}
exports.default = getLinkTargetUrl;

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pill = function Pill(_ref) {
    var title = _ref.title,
        _ref$variations = _ref.variations,
        variations = _ref$variations === undefined ? ['tag'] : _ref$variations,
        children = _ref.children,
        onDelete = _ref.onDelete,
        deleteButtonProps = _ref.deleteButtonProps;
    return _react2.default.createElement("span", { className: (0, _app.getComponentClasses)('pill', variations.concat(onDelete ? ['deletable'] : [])), title: title }, children, onDelete && _react2.default.createElement("button", Object.assign({}, deleteButtonProps, { type: "button", className: "pill__delete", onClick: onDelete })));
};
exports.default = Pill;

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PillGroup = function PillGroup(_ref) {
  var children = _ref.children,
      variations = _ref.variations;
  return _react2.default.createElement("div", { className: (0, _app.getComponentClasses)('pill-group', variations) }, _react2.default.Children.map(children, function (child) {
    return _react2.default.createElement("div", { className: "pill-group__item" }, child);
  }));
};
exports.default = PillGroup;

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Avatar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _getComponentClasses = __webpack_require__(13);

var _getComponentClasses2 = _interopRequireDefault(_getComponentClasses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Avatar = exports.Avatar = function (_React$Component) {
    _inherits(Avatar, _React$Component);

    function Avatar() {
        _classCallCheck(this, Avatar);

        return _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).apply(this, arguments));
    }

    _createClass(Avatar, [{
        key: 'placeholder',
        value: function placeholder() {
            return React.createElement("span", { className: (0, _getComponentClasses2.default)('avatar', this.props.variations) }, React.createElement("span", { className: "avatar__image avatar__image--placeholder" }));
        }
    }, {
        key: 'avatar',
        value: function avatar(user) {
            var attrs = this.props.isOnline ? { 'data-online': true } : {};
            var variations = this.props.variations;

            if (this.props.isLinked && user.profileUrl) {
                return React.createElement("a", Object.assign({ className: (0, _getComponentClasses2.default)('avatar', variations), href: user.profileUrl }, attrs), React.createElement("img", { alt: "", role: "presentation", className: "avatar__image", src: user.avatarUrl }), this.onlineIndicator());
            } else {
                return React.createElement("span", Object.assign({ className: (0, _getComponentClasses2.default)('avatar', variations) }, attrs), React.createElement("img", { alt: "", role: "presentation", className: "avatar__image", src: user.avatarUrl }), this.onlineIndicator());
            }
        }
    }, {
        key: 'onlineIndicator',
        value: function onlineIndicator() {
            return React.createElement("div", { className: "avatar__indicator" });
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.user) {
                return this.avatar(this.props.user);
            } else {
                return this.placeholder();
            }
        }
    }]);

    return Avatar;
}(React.Component);

Avatar.defaultProps = {
    variations: ['medium'],
    isLinked: true,
    isOnline: false
};

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["default"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(111);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HoverableElement = undefined;

var _lodash = __webpack_require__(64);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

var _HoverCard = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A positioning component wrapper that positions the given `hoverElement` relatively to its wrapped children
 * Used by components like DropdownButton and Tooltip.
 */
var HoverableElement = exports.HoverableElement = function HoverableElement(_ref) {
  var _ref$alignmentOffset = _ref.alignmentOffset,
      alignmentOffset = _ref$alignmentOffset === undefined ? 0 : _ref$alignmentOffset,
      _ref$hasTransition = _ref.hasTransition,
      hasTransition = _ref$hasTransition === undefined ? false : _ref$hasTransition,
      hoverElement = _ref.hoverElement,
      _ref$hoverPosition = _ref.hoverPosition,
      hoverPosition = _ref$hoverPosition === undefined ? 'down-center' : _ref$hoverPosition,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === undefined ? false : _ref$isActive,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'tooltip' : _ref$type,
      onHoverElementShow = _ref.onHoverElementShow,
      onHoverElementHide = _ref.onHoverElementHide,
      _ref$variations = _ref.variations,
      variations = _ref$variations === undefined ? [] : _ref$variations,
      _ref$hoverCardVariati = _ref.hoverCardVariations,
      hoverCardVariations = _ref$hoverCardVariati === undefined ? [''] : _ref$hoverCardVariati,
      children = _ref.children;

  var id = (0, _lodash2.default)('hoverable_');
  return _react2.default.createElement("span", { className: (0, _app.getComponentClasses)('hover-card-anchor', variations), id: id }, children, _react2.default.createElement(_HoverCard.HoverCard, { anchorNodeSelector: '#' + id, alignmentOffset: alignmentOffset, hasTransition: hasTransition, hasAnimation: false, hoverPosition: hoverPosition, isActive: isActive, type: type, onShow: onHoverElementShow, onHide: onHoverElementHide, variations: hoverCardVariations }, hoverElement));
};
exports.default = HoverableElement;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HoverCard = __webpack_require__(114);

Object.defineProperty(exports, 'HoverCard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HoverCard).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HoverCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clsx = __webpack_require__(11);

var _clsx2 = _interopRequireDefault(_clsx);

var _lodash = __webpack_require__(25);

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(37);

var _app = __webpack_require__(2);

var _elementPosition = __webpack_require__(19);

var _DetachableElement = __webpack_require__(89);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * The `hoverElement` relatively to a hoverable element
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Used by components like DropdownButton and Tooltip.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

// TODO: propose publishing `element-position` to npm


var HoverCard = exports.HoverCard = function (_React$Component) {
    _inherits(HoverCard, _React$Component);

    function HoverCard(props) {
        _classCallCheck(this, HoverCard);

        var _this = _possibleConstructorReturn(this, (HoverCard.__proto__ || Object.getPrototypeOf(HoverCard)).call(this, props));

        _this.updatePosition = _this.updatePosition.bind(_this);
        return _this;
    }

    _createClass(HoverCard, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.isActive && this.props.onShow) {
                this.props.onShow(this.contentNode);
            } else if (this.props.onHide) {
                this.props.onHide();
            }
            this.updatePosition();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('scroll', this.debouncedUpdatePositionFunc, true);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updatePosition();
            if (!this.debouncedUpdatePositionFunc) {
                this.debouncedUpdatePositionFunc = (0, _lodash2.default)(this.updatePosition, 50);
            }
            window.addEventListener('scroll', this.debouncedUpdatePositionFunc, true);
        }
    }, {
        key: 'updatePosition',
        value: function updatePosition() {
            var anchorElement = document.querySelector(this.props.anchorNodeSelector);
            var cardElement = this.cardNode;
            var triangleElement = this.triangleNode;
            var hoverPosition = this.props.hoverPosition || '';
            var cardPosition = void 0;
            if (this.props.isActive && anchorElement && this.triangleNode && this.cardNode) {
                cardPosition = this.positionCard(cardElement, anchorElement, triangleElement, hoverPosition);
                this.positionTriangle(triangleElement, anchorElement, cardElement, cardPosition);
                this.setTransformOrigin(cardElement, triangleElement);
            }
        }
    }, {
        key: 'getPercentageString',
        value: function getPercentageString(part, total) {
            return total > 0 ? Math.round(part / total * 100) + '%' : '0%';
        }
    }, {
        key: 'positionCard',
        value: function positionCard(cardElement, anchorElement, triangleElement, position) {
            var triangleRect = triangleElement.getBoundingClientRect();
            var distance = this.props.distance || 0;
            return (0, _elementPosition.positionElementWithAutoAdjustment)(cardElement, anchorElement, position, distance + triangleRect.height / 2, this.props.alignmentOffset) || ''; // return value might be `null`for `cardPosition` used in `positionTriangle()`
        }
    }, {
        key: 'positionTriangle',
        value: function positionTriangle(triangleElement, anchorElement, cardElement, cardPosition) {
            var positionDirection = cardPosition.split('-').shift();
            var triangleDestinationPosition = {};
            var anchorRect = anchorElement.getBoundingClientRect();
            var cardRect = cardElement.getBoundingClientRect();
            var triangleRect = triangleElement.getBoundingClientRect();
            var triangleDestinationPageOffsetX = anchorRect.left + anchorRect.width / 2 - triangleRect.width / 2;
            var triangleDestinationPageOffsetY = anchorRect.top + anchorRect.height / 2 - triangleRect.height / 2;
            if (positionDirection && ['down', 'up'].indexOf(positionDirection) > -1) {
                if (cardRect.width >= anchorRect.width) {
                    triangleDestinationPosition['left'] = triangleDestinationPageOffsetX - cardRect.left;
                } else {
                    triangleDestinationPosition['left'] = (cardRect.width - triangleRect.width) / 2;
                }
            }
            if (positionDirection && ['left', 'right'].indexOf(positionDirection) > -1) {
                if (cardRect.height >= anchorRect.height) {
                    triangleDestinationPosition['top'] = triangleDestinationPageOffsetY - cardRect.top;
                } else {
                    triangleDestinationPosition['top'] = (cardRect.height - triangleRect.height) / 2;
                }
            }
            triangleElement.style.top = triangleDestinationPosition.top + 'px';
            triangleElement.style.left = triangleDestinationPosition.left + 'px';
            triangleElement.className = '';
            triangleElement.classList.add('hover-card__triangle', 'hover-card__triangle--' + positionDirection);
            return triangleDestinationPosition;
        }
    }, {
        key: 'setTransformOrigin',
        value: function setTransformOrigin(cardElement, triangleElement) {
            var trianglePosition = {
                left: triangleElement.offsetLeft,
                top: triangleElement.offsetTop
            };
            var cardRect = cardElement.getBoundingClientRect();
            var transformOrigin = {};
            if (this.props.hasAnimation) {
                transformOrigin['transform-origin-x'] = this.getPercentageString(trianglePosition.left, cardRect.width);
                transformOrigin['transform-origin-y'] = this.getPercentageString(trianglePosition.top, cardRect.height);
                cardElement.style.transformOrigin = transformOrigin['transform-origin-x'] + ' ' + transformOrigin['transform-origin-y'];
            }
        }
    }, {
        key: 'hoverCardContent',
        value: function hoverCardContent(hoverCardClassNames) {
            var _this2 = this;

            return _react2.default.createElement("div", { className: hoverCardClassNames, ref: function ref(n) {
                    if (n) _this2.cardNode = n;
                } }, _react2.default.createElement("div", { className: "hover-card__content", ref: function ref(n) {
                    if (n) _this2.contentNode = n;
                } }, this.props.children), _react2.default.createElement("div", { className: "hover-card__triangle", ref: function ref(n) {
                    if (n) _this2.triangleNode = n;
                } }));
        }
    }, {
        key: 'render',
        value: function render() {
            var hoverCardClassNames = (0, _clsx2.default)((0, _app.getComponentClasses)('hover-card', this.props.variations), {
                'hover-card--with-transition': this.props.hasTransition,
                'hover-card--with-animation': this.props.hasAnimation,
                'hover-card--tooltip': this.props.type === 'tooltip',
                'hover-card--dropdown': this.props.type === 'dropdown',
                'hover-card--tour': this.props.type === 'tour'
            });
            if (this.props.isActive) {
                if (this.props.hasAnimation || this.props.hasTransition) {
                    return _react2.default.createElement(_DetachableElement.DetachableElement, null, _react2.default.createElement(_reactTransitionGroup.CSSTransition, { in: true, timeout: { enter: this.props.hasAnimation ? 300 : 200, exit: 0 }, classNames: "hover-card-", appear: true }, this.hoverCardContent(hoverCardClassNames)));
                } else {
                    return _react2.default.createElement(_DetachableElement.DetachableElement, null, this.hoverCardContent(hoverCardClassNames));
                }
            } else {
                return null;
            }
        }
    }]);

    return HoverCard;
}(_react2.default.Component);

HoverCard.defaultProps = {
    alignmentOffset: 0,
    distance: 3,
    hasTransition: false,
    hasAnimation: false,
    hoverPosition: 'down-center',
    isActive: false,
    type: 'tooltip',
    onShow: function onShow(_el) {},
    onHide: function onHide() {},
    variations: [],
    children: ''
};
exports.default = HoverCard;

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(63);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(8);

var _IconButton = __webpack_require__(21);

var _ToggleButton = __webpack_require__(136);

var _ToggleButton2 = _interopRequireDefault(_ToggleButton);

var _xhr = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavoriteButton = function FavoriteButton(_ref) {
    var isFavorite = _ref.isFavorite,
        favoriteUrl = _ref.favoriteUrl,
        onFavorite = _ref.onFavorite;
    return _react2.default.createElement(_ToggleButton2.default, {
        isToggled: isFavorite,
        xhrUrl: favoriteUrl,
        toggleRequest: _xhr.toggleRequest,
        onSuccess: onFavorite,
        render: function render(_ref2) {
            var isToggled = _ref2.isToggled,
                onToggle = _ref2.onToggle;
            return _react2.default.createElement(
                _IconButton.IconButton,
                {
                    variations: ['soft-toggle', (0, _classnames2.default)({ selected: isToggled })],
                    onClick: onToggle
                },
                _react2.default.createElement(_Icon.Icon, { type: 'heart-1' })
            );
        }
    });
};

FavoriteButton.defaultProps = {
    onFavorite: function onFavorite() {
        return undefined;
    }
};

FavoriteButton.propTypes = {
    isFavorite: _propTypes2.default.bool.isRequired,
    favoriteUrl: _propTypes2.default.string.isRequired,
    onFavorite: _propTypes2.default.func
};

exports.default = FavoriteButton;

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Alert = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

var _Icon = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alert = exports.Alert = function (_React$Component) {
    _inherits(Alert, _React$Component);

    function Alert() {
        _classCallCheck(this, Alert);

        var _this = _possibleConstructorReturn(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).apply(this, arguments));

        _this.state = {
            hidden: false
        };
        _this.hide = function () {
            _this.setState({ hidden: true }, _this.onHide);
        };
        _this.onHide = function () {
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
        };
        return _this;
    }

    _createClass(Alert, [{
        key: 'render',
        value: function render() {
            var variations = this.props.variations ? this.props.variations.slice() : [];
            if (this.props.alertType) {
                (0, _app.deprecated)("alertType={${this.props.alertType}} is deprecated, use variations={['`${this.props.alertType}`']}");
                variations = [this.props.alertType];
            }
            if (this.state.hidden) {
                return null;
            }
            return _react2.default.createElement("div", { className: (0, _app.getComponentClasses)('alert', variations) }, _react2.default.createElement("div", { className: "alert__icon" }, this.props.icon), _react2.default.createElement("div", { className: "alert__body" }, _react2.default.createElement("div", { className: "alert__message" }, this.props.children)), _react2.default.createElement(Alert.HideButton, { isDismissable: Boolean(this.props.canBeDismissed), onClick: this.hide }));
        }
    }]);

    return Alert;
}(_react2.default.Component);

Alert.HideButton = function (_ref) {
    var isDismissable = _ref.isDismissable,
        onClick = _ref.onClick;

    return isDismissable ? _react2.default.createElement("div", { role: "button", "aria-label": "Dismiss", className: "alert__dismiss", onClick: onClick }) : null; //eslint-disable-line
};
Alert.defaultProps = {
    variations: ['info'],
    icon: _react2.default.createElement(_Icon.Icon, { type: 'exclamation-point-1' }),
    canBeDismissed: false
};
exports.default = Alert;

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createStore = __webpack_require__(53);

var _createStore2 = _interopRequireDefault(_createStore);

var _urlHash = __webpack_require__(420);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createStore2.default)({
    storeName: 'DesignCommentsStore',

    // FIXME: refactor into 2.5 stores: DesignCommentsStore and CommentEditorStore,
    //
    //  * DesignCommentsStore should be a dataset and cache pointer,
    //    no need for this.commentCache vs this.comments.
    //    Might also benefit from a flat comment cache Object indexed by comment.id,
    //    plus secondary designId-keyed lists of commentIds.
    //  * CommentEditorStore should own selectedComment (rename to activeComment?), editorLocation

    handlers: {
        // FIXME: all methods starting with `designComments` could benefit from clearer names
        DESIGN_COMMENTS_LOAD_START: 'designCommentsLoadStart',
        DESIGN_COMMENTS_LOAD_FINISH: 'designCommentsLoadFinish',
        DESIGN_COMMENT_SELECTED: 'designCommentsChangeSelection',
        DESIGN_COMMENT_CREATE_START: 'designCommentCreateStart',
        DESIGN_COMMENT_CREATE_FINISH: 'designCommentCreateFinish',
        DESIGN_COMMENT_CREATE_ERROR: 'designCommentCreateError',
        DESIGN_COMMENT_ENTER_START: 'designCommentEnterStart',
        DESIGN_COMMENT_ENTER_CANCEL: 'removePendingComments',
        DESIGN_COMMENT_DELETE_START: 'designCommentDeleteStart',
        DESIGN_COMMENT_DELETE_FINISH: 'designCommentDeleteFinish',
        DESIGN_COMMENT_DELETE_ERROR: 'designCommentDeleteError',
        DESIGN_COMMENT_EDIT_START: 'designCommentEditStart',
        DESIGN_COMMENT_EDIT_CANCEL: 'designCommentEditCancel',
        DESIGN_COMMENT_UPDATE_START: 'designCommentUpdateStart',
        DESIGN_COMMENT_UPDATE_FINISH: 'designCommentUpdateFinish',
        DESIGN_COMMENT_UPDATE_ERROR: 'designCommentUpdateError',
        DESIGN_COMMENTS_CLEAR: 'designCommentsClear'
    },

    initialize: function initialize() {
        this.reset();
    },

    setModel: function setModel(model) {
        this.model = model;
    },

    getModel: function getModel() {
        return this.model;
    },

    setCollectionModel: function setCollectionModel(collectionModel) {
        this.collectionModel = collectionModel;
    },

    getCollectionModel: function getCollectionModel() {
        return this.collectionModel;
    },

    reset: function reset() {
        this.commentsCache = {};

        // FIXME: remove this property, provide comments() that uses
        // cache pointer to return filtered dataset.
        this.comments = [];
        this.currentDesignId = null;

        // FIXME: isLoadingComments is also used as a "last lookup missing from cache" flag.
        this.isLoadingComments = false;
        this.isLoaded = false;

        // FIXME: refac. to CommentEditorStore
        this.selectedComment = null;
        this.selectedCommentEditingLocation = null;
        this.selectedCommentStatus = null;
        this.selectedCommentIdFromURL = (0, _urlHash.getIdFromUrlHash)(window.location.hash);
    },

    designCommentsClear: function designCommentsClear(payload) {
        this.reset();
        this.emitChange();
        if (payload && payload.callback) {
            payload.callback();
        }
    },

    designCommentsLoadStart: function designCommentsLoadStart(_ref) {
        var designId = _ref.designId;

        this.currentDesignId = designId;
        this.comments = this.commentsCache[this.currentDesignId] || [];

        // FIXME: Async loading status is better managed by RequestStore to inform loading UI etc
        // This cache test is an odd definition of "loading"
        this.isLoadingComments = !this.commentsCache[this.currentDesignId];

        // FIXME: move to a comment editor action and a handler in CommentEditorStore
        if (this.selectedComment) {
            this.setSelectedComment(this.findCommentById(this.selectedComment.id));
        }

        this.emitChange();
    },

    designCommentsLoadFinish: function designCommentsLoadFinish(_ref2) {
        var designId = _ref2.designId,
            comments = _ref2.comments;

        if (this.currentDesignId !== designId) {
            return;
        }

        // FIXME: components should connect to RequestStore instead
        this.isLoadingComments = false;
        this.isLoaded = true;

        this.comments = comments;

        // FIXME: refac. this.cache(k, v)
        this.commentsCache[designId] = comments;

        // FIXME: move to a commentEditor action and a handler in CommentEditorStore
        if (this.selectedComment) {
            this.setSelectedComment(this.findCommentById(this.selectedComment.id));
        } else if (this.selectedCommentIdFromURL) {
            this.setSelectedComment(this.findCommentByIdFromUrl(this.selectedCommentIdFromURL));
        }

        this.emitChange();
    },

    designCommentsChangeSelection: function designCommentsChangeSelection(_ref3) {
        var comment = _ref3.comment;

        if (comment && this.findCommentById(comment.id)) {
            this.removePendingCommentsExcept(comment);
            this.setSelectedComment(comment);
        } else {
            this.removeAllPendingComments();
            this.setSelectedComment(null);
        }

        this.emitChange();
    },

    designCommentCreateStart: function designCommentCreateStart(_ref4) {
        var _this = this;

        var comment = _ref4.comment;

        this.comments = this.comments.filter(function (comment) {
            return _this.model.isPersisted(comment);
        });

        this.comments.push(comment);

        // FIXME: refac. to CommentEditorStore
        this.setSelectedComment(comment);
        this.selectedCommentStatus = 'saving';

        this.emitChange();
    },

    designCommentCreateFinish: function designCommentCreateFinish(_ref5) {
        var comment = _ref5.comment,
            selectCommentOnFinish = _ref5.selectCommentOnFinish;

        if (this.currentDesignId !== comment.designId) {
            return;
        }

        this.removeAllPendingComments();
        this.comments.push(comment);

        // FIXME: refac. to `this.setInCache(k, v)`
        this.commentsCache[comment.designId] = this.comments;

        if (selectCommentOnFinish) {
            this.setSelectedComment(comment);
        }

        this.emitChange();
    },

    designCommentCreateError: function designCommentCreateError() {
        var _this2 = this;

        var comment = this.comments.find(function (item) {
            return !_this2.model.isPersisted(item);
        });

        if (comment) {
            this.setSelectedComment(comment);
            this.selectedCommentStatus = 'error';
            this.emitChange();
        }
    },

    // FIXME: move to CommentEditorStore
    designCommentDeleteStart: function designCommentDeleteStart(_ref6) {
        var comment = _ref6.comment;

        this.selectedComment = comment;
        this.selectedCommentStatus = 'deleting';

        this.emitChange();
    },

    designCommentDeleteFinish: function designCommentDeleteFinish(_ref7) {
        var _this3 = this;

        var comment = _ref7.comment;

        this.comments = this.comments.filter(function (cm) {
            return !_this3.model.equal(cm, comment);
        });

        // FIXME: move to CommentEditorStore
        if (this.model.equal(comment, this.selectedComment)) {
            this.setSelectedComment(null);
        }

        this.emitChange();
    },

    // FIXME: move to CommentEditorStore
    designCommentDeleteError: function designCommentDeleteError(_ref8) {
        var comment = _ref8.comment;

        var _comment = comment && this.findCommentById(comment.id);

        if (_comment) {
            this.selectedComment = _comment;
            this.selectedCommentStatus = 'error';
            this.emitChange();

            this.deferResetCommentStatus(_comment);
        }
    },

    designCommentEditStart: function designCommentEditStart(_ref9) {
        var comment = _ref9.comment,
            editingLocation = _ref9.editingLocation;

        this.selectedComment = comment;

        // FIXME refac. to CommentEditorStore
        this.selectedCommentStatus = 'editing';
        this.selectedCommentEditingLocation = editingLocation;

        this.emitChange();
    },

    designCommentEditCancel: function designCommentEditCancel(payload) {
        this.selectedComment = payload.comment;
        this.selectedCommentStatus = null;
        this.selectedCommentEditingLocation = null;

        this.emitChange();
    },

    designCommentEnterStart: function designCommentEnterStart(payload) {
        var comment = payload.comment;
        this.comments.push(comment);
        this.setSelectedComment(comment);

        // FIXME refac. to CommentEditorStore
        this.selectedCommentStatus = 'creating';

        this.emitChange();
    },

    designCommentUpdateStart: function designCommentUpdateStart(_ref10) {
        var comment = _ref10.comment;

        this.selectedComment = comment;

        // FIXME refac. to CommentEditorStore || del
        this.selectedCommentStatus = 'saving';

        this.updateComment(comment);
        this.emitChange();
    },

    designCommentUpdateFinish: function designCommentUpdateFinish(payload) {
        var updatedComment = payload.comment;

        if (updatedComment && this.findCommentById(updatedComment.id)) {
            this.updateComment(updatedComment);
            this.commentsCache[updatedComment.designId] = this.comments;

            if (this.model.equal(updatedComment, this.selectedComment)) {
                this.selectedCommentStatus = null;
            }

            this.emitChange();
        }
    },

    designCommentUpdateError: function designCommentUpdateError(payload) {
        var comment = payload.comment;

        if (comment && this.findCommentById(comment.id)) {
            this.selectedComment = comment;
            this.selectedCommentStatus = 'error';
            this.emitChange();
            this.deferResetCommentStatus(comment);
        }
    },

    removePendingComments: function removePendingComments() {
        this.setSelectedComment(null);
        this.removeAllPendingComments();
        this.emitChange();
    },

    //
    // Helper functions
    //
    deferResetCommentStatus: function deferResetCommentStatus(comment, timeout) {
        var _this4 = this;

        window.setTimeout(function () {
            _this4.updateComment(comment);
            if (_this4.model.equal(_this4.selectedComment, comment)) {
                _this4.selectedCommentStatus = null;
                _this4.emitChange();
            }
        }, timeout || 1000);
    },

    removePendingCommentsExcept: function removePendingCommentsExcept(exceptionComment) {
        var _this5 = this;

        this.comments = this.comments.filter(function (comment) {
            return _this5.model.equal(comment, exceptionComment) || _this5.model.isPersisted(comment);
        });
    },

    removeAllPendingComments: function removeAllPendingComments() {
        this.comments = this.comments.filter(function (comment) {
            return !!comment.id;
        });
    },

    setSelectedComment: function setSelectedComment(comment) {
        if (!comment || this.selectedComment && !this.model.equal(this.selectedComment, comment)) {
            this.selectedCommentStatus = null;
        }

        this.selectedComment = comment;
    },

    findCommentById: function findCommentById(id) {
        return this.comments.find(function (comment) {
            return String(comment.id) === String(id);
        }) || null;
    },

    getNumericIdAsString: function getNumericIdAsString(id) {
        if (typeof id === 'string') {
            var idParts = id.split('/');
            return String(idParts[idParts.length - 1]);
        }
        return id.toString();
    },


    findCommentByIdFromUrl: function findCommentByIdFromUrl(idFromUrl) {
        var _this6 = this;

        return this.comments.find(function (comment) {
            return _this6.getNumericIdAsString(comment.id) === String(idFromUrl);
        }) || null;
    },

    updateComment: function updateComment(comment) {
        var target = this.findCommentById(comment.id);
        Object.assign(target, comment);
    }
});

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _addons = __webpack_require__(83);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnlineStatusStore = function (_BaseStore) {
    _inherits(OnlineStatusStore, _BaseStore);

    function OnlineStatusStore(dispatcher) {
        _classCallCheck(this, OnlineStatusStore);

        var _this = _possibleConstructorReturn(this, (OnlineStatusStore.__proto__ || Object.getPrototypeOf(OnlineStatusStore)).call(this, dispatcher));

        _this.users = {};
        return _this;
    }

    _createClass(OnlineStatusStore, [{
        key: 'updateStatuses',
        value: function updateStatuses(onlineStatuses) {
            this.users = onlineStatuses;
            this.emitChange();
        }
    }, {
        key: 'getOnlineStatus',
        value: function getOnlineStatus(id) {
            return this.users[id] ? this.users[id].isOnline : null;
        }
    }, {
        key: 'getLastSeenTime',
        value: function getLastSeenTime(id) {
            return this.users[id] ? this.users[id].lastSeenTime : null;
        }
    }]);

    return OnlineStatusStore;
}(_addons.BaseStore);

OnlineStatusStore.storeName = 'OnlineStatusStore';
OnlineStatusStore.handlers = {
    ONLINE_STATUS_SUCCESS: 'updateStatuses'
};

exports.default = OnlineStatusStore;

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


module.exports = __webpack_require__(42);


/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bugsnag = __webpack_require__(157);

Object.keys(_bugsnag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _bugsnag[key];
    }
  });
});

var _trackEvent = __webpack_require__(66);

Object.defineProperty(exports, 'trackEvent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_trackEvent).default;
  }
});

var _trackLink = __webpack_require__(102);

Object.defineProperty(exports, 'trackLink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_trackLink).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1247);


/***/ }),

/***/ 1247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // eslint-disable-line no-restricted-imports


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _reactRouterDom = __webpack_require__(65);

var _reactIntl = __webpack_require__(6);

var _fluxibleAddonsReact = __webpack_require__(95);

var _index = __webpack_require__(413);

var _index2 = _interopRequireDefault(_index);

var _di = __webpack_require__(463);

var _di2 = _interopRequireDefault(_di);

var _fluxible = __webpack_require__(156);

var _fluxible2 = _interopRequireDefault(_fluxible);

var _OnlineStatusStore = __webpack_require__(118);

var _OnlineStatusStore2 = _interopRequireDefault(_OnlineStatusStore);

var _DesignDetailsSidebar = __webpack_require__(467);

var _DesignDetailsSidebar2 = _interopRequireDefault(_DesignDetailsSidebar);

var _history = __webpack_require__(88);

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
    var appNode = document.getElementById('design-details-app');
    var dataNode = document.getElementById('ddo-app-data');

    var _JSON$parse = JSON.parse(dataNode.textContent),
        initData = _JSON$parse.initData;

    var activeUser = initData.activeUser,
        intlMessages = initData.intlMessages,
        designCollection = initData.designCollection;

    var ddoPath = '/profiles/:parentId/designs/:designId';
    var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    var NoOpComponent = function NoOpComponent() {
        return null;
    };

    window.REQUEST_TOKENS = {
        DESIGN_COMMENT_CREATE_FINISH: csrfToken,
        DESIGN_COMMENT_DELETE_FINISH: csrfToken,
        DESIGN_COMMENT_UPDATE: csrfToken,
        DESIGN_UPDATE_LIKE_STATUS: csrfToken
    };

    var fluxibleApp = new _fluxible2.default({
        stores: [_OnlineStatusStore2.default]
    });

    var fluxibleContext = fluxibleApp.createContext();

    var _ddo = (0, _index2.default)({
        fluxibleApp: fluxibleApp,
        fluxibleContext: fluxibleContext,
        activeUser: activeUser,
        designCollection: _di2.default.designCollection.fromJSON(designCollection),
        isInline: true,
        models: _di2.default,
        goBack: function goBack() {
            _history2.default.go(-1);
        },
        goTo: function goTo(path) {
            _history2.default.replace(path);
        },
        csrfToken: document.querySelector('meta[name=csrf-token]').getAttribute('content')
    }),
        DdoComponent = _ddo.DdoComponent,
        setDesignCollection = _ddo.setDesignCollection;

    window.addEventListener('newDdoDesignCollectionAvailable', function (e) {
        setDesignCollection(_di2.default.designCollection.fromJSON(e.detail));
    });

    (0, _jquery2.default)(document).on('click', '[data-design-details-item]', function (e) {
        if (e.metaKey || e.ctrlKey) {
            return true;
        }

        e.preventDefault();

        _history2.default.push((0, _jquery2.default)(this).attr('href'));
    });

    _reactDom2.default.render(_react2.default.createElement(
        _reactIntl.IntlProvider,
        { locale: document.documentElement.lang, messages: intlMessages },
        _react2.default.createElement(
            _fluxibleAddonsReact.FluxibleComponent,
            { context: fluxibleContext.getComponentContext() },
            _react2.default.createElement(
                _reactRouterDom.Router,
                { history: _history2.default },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reactRouterDom.Route, {
                        path: ddoPath,
                        component: function component(props) {
                            return _react2.default.createElement(DdoComponent, {
                                designId: props.match.params.designId,
                                renderSidebar: function renderSidebar(sidebarProps) {
                                    return _react2.default.createElement(_DesignDetailsSidebar2.default, _extends({
                                        activeUser: activeUser
                                    }, sidebarProps));
                                }
                            });
                        }
                    }),
                    _react2.default.createElement(NoOpComponent, { path: '*' })
                )
            )
        )
    ), appNode);
});

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DisplayName = __webpack_require__(161);

Object.defineProperty(exports, 'DisplayName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DisplayName).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clsx = __webpack_require__(11);

var _clsx2 = _interopRequireDefault(_clsx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getComponentClasses = function getComponentClasses(baseClassName) {
  var variations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var extraClassName = arguments[2];
  return (0, _clsx2.default)(baseClassName, variations.filter(function (v) {
    return v !== '';
  }).map(function (v) {
    return baseClassName + '--' + v;
  }), extraClassName).trim();
};
exports.default = getComponentClasses;

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Desktop = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactResponsive = __webpack_require__(32);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _breakpoints = __webpack_require__(38);

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Desktop = exports.Desktop = function Desktop(_ref) {
  var children = _ref.children,
      values = _ref.values;
  return _react2.default.createElement(_reactResponsive2.default, { minWidth: _breakpoints2.default.normal[0], children: children, values: values });
};
exports.default = Desktop;

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mobile = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactResponsive = __webpack_require__(32);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _breakpoints = __webpack_require__(38);

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Mobile = exports.Mobile = function Mobile(_ref) {
  var values = _ref.values,
      children = _ref.children;
  return _react2.default.createElement(_reactResponsive2.default, { maxWidth: _breakpoints2.default.normal[0], children: children, values: values });
};
exports.default = Mobile;

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(80);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(155);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(133);

var _PathUtils = __webpack_require__(71);

var _createTransitionManager = __webpack_require__(134);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(135);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(193);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(194);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(71);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(80);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToggleButton = function (_React$Component) {
    _inherits(ToggleButton, _React$Component);

    function ToggleButton(props) {
        _classCallCheck(this, ToggleButton);

        var _this = _possibleConstructorReturn(this, (ToggleButton.__proto__ || Object.getPrototypeOf(ToggleButton)).call(this, props));

        _this.state = {
            isToggled: props.isToggled,
            xhrUrl: props.xhrUrl
        };

        _this.handleToggle = _this.handleToggle.bind(_this);
        return _this;
    }

    _createClass(ToggleButton, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.abortRequest();
        }
    }, {
        key: 'abortRequest',
        value: function abortRequest() {
            if (this.request) {
                this.request.abort();
            }
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            this.abortRequest();
            this.request = this.props.toggleRequest(this.state.isToggled, this.state.xhrUrl);
            this.request.then(function () {
                _this2.props.onSuccess(_this2.state.isToggled);
            }).catch(function () {
                _this2.setState(function (state) {
                    return {
                        isToggled: !state.isToggled
                    };
                });
            });
        }
    }, {
        key: 'handleToggle',
        value: function handleToggle() {
            this.setState(function (state) {
                return {
                    isToggled: !state.isToggled
                };
            }, this.save);
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.render({
                isToggled: this.state.isToggled,
                onToggle: this.handleToggle
            });
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.xhrUrl === prevState.xhrUrl) return null;

            return {
                isToggled: nextProps.isToggled,
                xhrUrl: nextProps.xhrUrl
            };
        }
    }]);

    return ToggleButton;
}(_react2.default.Component);

ToggleButton.defaultProps = {
    onSuccess: function onSuccess() {
        return undefined;
    }
};

ToggleButton.propTypes = {
    xhrUrl: _propTypes2.default.string.isRequired,
    isToggled: _propTypes2.default.bool.isRequired,
    render: _propTypes2.default.func.isRequired,
    toggleRequest: _propTypes2.default.func.isRequired,
    onSuccess: _propTypes2.default.func
};

exports.default = ToggleButton;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createStore = __webpack_require__(53);

var _createStore2 = _interopRequireDefault(_createStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (0, _createStore2.default)({
    storeName: 'DesignSketchesStore',

    handlers: {
        SET_DESIGN_SKETCH_STATE: 'setDesignSketchState',
        SET_DESIGN_SKETCH: 'setDesignSketch',
        ADD_DESIGN_PATH: 'addDesignPath',
        UNDO_LAST_DESIGN_PATH: 'undoLastDesignPath'
    },

    initialize: function initialize() {
        this.designs = {};
    },

    setDesignSketch: function setDesignSketch(_ref) {
        var designId = _ref.designId,
            sketch = _ref.sketch;

        this.designs[designId] = this.designs[designId] || { sketch: [], state: null };

        this.designs = _extends({}, this.designs, _defineProperty({}, designId, _extends({}, this.designs[designId], {
            sketch: sketch
        })));
        this.emitChange();
    },

    getDesignSketch: function getDesignSketch(designId) {
        return this.designs[designId] ? this.designs[designId].sketch : [];
    },

    getPathsFromDesignSketch: function getPathsFromDesignSketch(designId) {
        var sketch = this.getDesignSketch(designId);
        return sketch.map(function (pathObj) {
            return pathObj.path;
        });
    },

    addDesignPath: function addDesignPath(_ref2) {
        var designId = _ref2.designId,
            path = _ref2.path;

        this.designs[designId] = this.designs[designId] || { sketch: [], state: null };

        this.designs = _extends({}, this.designs, _defineProperty({}, designId, _extends({}, this.designs[designId], {
            sketch: [].concat(_toConsumableArray(this.designs[designId].sketch), [{ path: path }])
        })));

        this.emitChange();
    },

    undoLastDesignPath: function undoLastDesignPath(_ref3) {
        var designId = _ref3.designId;

        if (this.designs[designId]) {
            this.designs = _extends({}, this.designs, _defineProperty({}, designId, _extends({}, this.designs[designId], {
                sketch: this.designs[designId].sketch.slice(0, -1)
            })));
            this.emitChange();
        }
    },

    setDesignSketchState: function setDesignSketchState(_ref4) {
        var state = _ref4.state,
            designId = _ref4.designId;

        this.designs[designId] = this.designs[designId] || { sketch: [], state: null };

        this.designs = _extends({}, this.designs, _defineProperty({}, designId, _extends({}, this.designs[designId], {
            state: state
        })));
        this.emitChange();
    },

    getDesignSketchState: function getDesignSketchState(designId) {
        return this.designs[designId] ? this.designs[designId].state : null;
    }
});

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadDesignComments = loadDesignComments;
exports.resetSelectedComment = resetSelectedComment;
exports.resetComments = resetComments;
exports.selectDesignComment = selectDesignComment;
exports.deleteDesignComment = deleteDesignComment;
exports.createDesignComment = createDesignComment;
exports.editDesignComment = editDesignComment;
exports.cancelEditDesignComment = cancelEditDesignComment;
exports.updateDesignComment = updateDesignComment;
exports.enterDesignComment = enterDesignComment;
exports.cancelEnterDesignComment = cancelEnterDesignComment;

var _request = __webpack_require__(172);

var _request2 = _interopRequireDefault(_request);

var _constants = __webpack_require__(173);

var _constants2 = _interopRequireDefault(_constants);

var _request3 = __webpack_require__(275);

var _DesignCommentsStore = __webpack_require__(117);

var _DesignCommentsStore2 = _interopRequireDefault(_DesignCommentsStore);

var _designComment = __webpack_require__(174);

var _designComment2 = _interopRequireDefault(_designComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Remains until 'isLoading' is refactored out of DesignCommentsStore
var loadDesignCommentsXhr = null;

function loadDesignComments(context, _ref) {
    var designId = _ref.designId,
        commentsUrl = _ref.commentsUrl;

    var apiRequest = (0, _request2.default)('GET', commentsUrl, _constants2.default.DESIGN_COMMENTS_LOADED);

    context.dispatch(_constants2.default.DESIGN_COMMENTS_LOAD_START, { designId: designId });

    if (loadDesignCommentsXhr) {
        loadDesignCommentsXhr.abort();
    }

    var promise = (0, _request.resolve)(apiRequest).then(function (response) {
        var comments = context.getStore(_DesignCommentsStore2.default).getCollectionModel().fromJSON(response);

        context.dispatch(_constants2.default.DESIGN_COMMENTS_LOAD_FINISH, { designId: designId, comments: comments });
    }).catch(function (e) {
        context.dispatch('DESIGN_COMMENTS_LOAD_ERROR');
        throw e;
    });

    // The test expect a promise, but returning a promise actually changes the semantic of the action and tells
    // fluxible to wait for the promise to be complete before executing the callback, which is not what we want
    // Returning an object containing the promise let us inspect the promise without changing the action behaviour
    return {
        _promise: promise
    };
}

function resetSelectedComment(context) {
    return Promise.resolve().then(function () {
        context.dispatch(_constants2.default.DESIGN_COMMENT_SELECTED, { comment: null });
    });
}

function resetComments(context, payload) {
    return Promise.resolve().then(function () {
        context.dispatch(_constants2.default.DESIGN_COMMENTS_CLEAR, payload);
    });
}

function selectDesignComment(context, _ref2) {
    var comment = _ref2.comment;

    return Promise.resolve().then(function () {
        context.dispatch(_constants2.default.DESIGN_COMMENT_SELECTED, { comment: comment });
    });
}

function deleteDesignComment(context, _ref3) {
    var comment = _ref3.comment,
        csrfToken = _ref3.csrfToken;

    context.dispatch(_constants2.default.DESIGN_COMMENT_DELETE_START, { comment: comment });

    if (!comment.links.delete) {
        return Promise.reject(new Error('Invalid attempt to delete comment'));
    }

    var apiRequest = (0, _request2.default)('DELETE', comment.links.delete, _constants2.default.DESIGN_COMMENT_DELETE_FINISH).set('X-Csrf-Token', csrfToken);

    return (0, _request.resolve)(apiRequest).then(function (response) {
        context.dispatch(_constants2.default.DESIGN_COMMENT_DELETE_FINISH, {
            comment: context.getStore(_DesignCommentsStore2.default).getModel().fromJSON(response)
        });
    }).catch(function (e) {
        context.dispatch(_constants2.default.DESIGN_COMMENT_DELETE_ERROR, e);
    });
}

function createDesignComment(context, _ref4) {
    var comment = _ref4.comment,
        design = _ref4.design,
        csrfToken = _ref4.csrfToken,
        _ref4$selectCommentOn = _ref4.selectCommentOnFinish,
        selectCommentOnFinish = _ref4$selectCommentOn === undefined ? true : _ref4$selectCommentOn;

    context.dispatch(_constants2.default.DESIGN_COMMENT_CREATE_START, { comment: comment });
    var requestData = {
        message: comment.message
    };

    if (comment.annotation) {
        requestData.annotationX = comment.annotation.x;
        requestData.annotationY = comment.annotation.y;
    }

    var apiRequest = (0, _request.post)(design.links.createComment, _constants2.default.DESIGN_COMMENT_CREATE_FINISH).set('X-Csrf-Token', csrfToken).send(requestData);

    return context.executeAction(_request3.resolveRequest, { request: apiRequest }).then(function (response) {
        context.dispatch(_constants2.default.DESIGN_COMMENT_CREATE_FINISH, {
            comment: context.getStore(_DesignCommentsStore2.default).getModel().fromJSON(response),
            selectCommentOnFinish: selectCommentOnFinish
        });
    }).catch(function (e) {
        context.dispatch(_constants2.default.DESIGN_COMMENT_CREATE_ERROR, e);
    });
}

function editDesignComment(context, _ref5) {
    var comment = _ref5.comment,
        editingLocation = _ref5.editingLocation;

    return Promise.resolve().then(function () {
        context.dispatch(_constants2.default.DESIGN_COMMENT_EDIT_START, { comment: comment, editingLocation: editingLocation });
    });
}

function cancelEditDesignComment(context, _ref6) {
    var comment = _ref6.comment;

    return Promise.resolve().then(function () {
        context.dispatch(_constants2.default.DESIGN_COMMENT_EDIT_CANCEL, { comment: comment });
    });
}

function updateDesignComment(context, _ref7) {
    var comment = _ref7.comment,
        csrfToken = _ref7.csrfToken;

    var apiRequest = (0, _request.put)(comment.links.edit).set('X-Csrf-Token', csrfToken).send(comment);

    // FIXME: find what UI changes are hinged on DESIGN_COMMENT_UPDATE_{START|FINISH}
    // use API_REQUEST_START and API_REQUEST_END instead for consistency and removing
    // bloat from DesignCommentsStore
    return Promise.resolve().then(function () {
        context.dispatch(_constants2.default.DESIGN_COMMENT_UPDATE_START, { comment: comment });
    }).then(function () {
        return (0, _request.resolve)(apiRequest);
    }).then(function (response) {
        context.dispatch(_constants2.default.DESIGN_COMMENT_UPDATE_FINISH, {
            comment: context.getStore(_DesignCommentsStore2.default).getModel().fromJSON(response)
        });
    }).catch(function (e) {
        context.dispatch(_constants2.default.DESIGN_COMMENT_UPDATE_FINISH, { comment: comment });
        throw e;
    });
}

function enterDesignComment(context, _ref8) {
    var activeUser = _ref8.activeUser,
        position = _ref8.position;

    var comment = _designComment2.default.create({
        creator: activeUser,
        annotation: position
    });

    context.dispatch('DESIGN_COMMENT_ENTER_START', { comment: comment });
}

function cancelEnterDesignComment(context, payload, done) {
    context.dispatch('DESIGN_COMMENT_ENTER_CANCEL');
    done();
}

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = propertyOrNull;
// Safely get property that might not exist from object that might not exist
function propertyOrNull(obj) {
    for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        props[_key - 1] = arguments[_key];
    }

    return props.reduce(function (obj, property) {
        if (obj) {
            return obj[property] !== undefined ? obj[property] : null;
        } else {
            return null;
        }
    }, obj);
}

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _superagent = __webpack_require__(15);

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

exports.default = {
    getOnlineStatus: function getOnlineStatus(context, _ref, done) {
        var lastSeenTimesUrl = _ref.lastSeenTimesUrl;

        var onlineStatuses = {};
        _superagent2.default.get(lastSeenTimesUrl).end(function (err, res) {
            if (!err) {
                var times = res.body.times;

                // FIXME: Use Object.keys
                for (var id in times) {
                    // eslint-disable-line
                    var now = new Date();
                    onlineStatuses[id] = {
                        isOnline: new Date(times[id]) >= now.setMinutes(now.getMinutes() - 5),
                        lastSeenTime: times[id]
                    };
                }
                context.dispatch('ONLINE_STATUS_SUCCESS', onlineStatuses);
            }
            done();
        });
    }
};

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(48);
var RequestBase = __webpack_require__(49);
var isObject = __webpack_require__(22);
var ResponseBase = __webpack_require__(50);
var Agent = __webpack_require__(52);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AnchorMenuItemAction = __webpack_require__(214);

Object.defineProperty(exports, 'AnchorMenuItemAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AnchorMenuItemAction).default;
  }
});

var _ButtonMenuItemAction = __webpack_require__(217);

Object.defineProperty(exports, 'ButtonMenuItemAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonMenuItemAction).default;
  }
});

var _Menu = __webpack_require__(219);

Object.defineProperty(exports, 'Menu', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Menu).default;
  }
});

var _MenuItemAction = __webpack_require__(94);

Object.defineProperty(exports, 'MenuItemAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuItemAction).default;
  }
});

var _MenuItemActionList = __webpack_require__(220);

Object.defineProperty(exports, 'MenuItemActionList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuItemActionList).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var bugsnag = exports.bugsnag = {
    notify: function notify(errorName, errorMessage, metaData, severity) {
        if (!window.Bugsnag) {
            return console.error(errorName, errorMessage, metaData); // eslint-disable-line no-console
        }
        window.Bugsnag.notify(errorName, errorMessage, metaData, severity);
    }
};
exports.default = bugsnag;

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(67);

Object.defineProperty(exports, 'Button', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisplayName = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(6);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisplayName = exports.DisplayName = function DisplayName(_ref) {
    var _ref$user = _ref.user,
        user = _ref$user === undefined ? {
        isActive: false
    } : _ref$user,
        _ref$variations = _ref.variations,
        variations = _ref$variations === undefined ? [] : _ref$variations,
        _ref$isLinked = _ref.isLinked,
        isLinked = _ref$isLinked === undefined ? true : _ref$isLinked,
        _ref$isTruncated = _ref.isTruncated,
        isTruncated = _ref$isTruncated === undefined ? false : _ref$isTruncated,
        _ref$limit = _ref.limit,
        limit = _ref$limit === undefined ? 20 : _ref$limit;

    if (isLinked && user.profileUrl) {
        variations.push('link');
    }
    if (isTruncated) {
        variations.push('truncate');
    }
    var classes = (0, _app.getComponentClasses)('display-name', variations);
    var truncate = function truncate(name, limit) {
        return name.split('').slice(0, limit).join('');
    };
    var displayName = user.isActive && _react2.default.createElement(_reactIntl.FormattedMessage, { id: "own_username" }) || isTruncated && user.name && truncate(user.name, limit) || user.name;
    if (isLinked && user.profileUrl) {
        return _react2.default.createElement("a", { className: classes, href: user.profileUrl }, displayName);
    } else {
        return _react2.default.createElement("span", { className: classes }, displayName);
    }
};
exports.default = DisplayName;

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Sidebar = exports.Main = exports.Frame = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Frame = exports.Frame = function (_React$Component) {
    _inherits(Frame, _React$Component);

    function Frame() {
        _classCallCheck(this, Frame);

        return _possibleConstructorReturn(this, (Frame.__proto__ || Object.getPrototypeOf(Frame)).apply(this, arguments));
    }

    _createClass(Frame, [{
        key: 'render',
        value: function render() {
            var data = {};
            if (this.props.isSidebarHidden) {
                data['data-sidebar-hidden'] = true;
            }
            if (this.props.isAnimatable) {
                data['data-animatable'] = true;
            }
            return _react2.default.createElement("div", Object.assign({ className: "fullscreen-frame" }, data), this.props.children);
        }
    }]);

    return Frame;
}(_react2.default.Component);

var Main = exports.Main = (0, _app.bemComponent)('fullscreen-frame__main', 'Main');
var Sidebar = exports.Sidebar = (0, _app.bemComponent)('fullscreen-frame__sidebar', 'Sidebar');

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.Header = undefined;

var _app = __webpack_require__(2);

var Header = exports.Header = (0, _app.bemComponent)('fullscreen-header');
var Item = exports.Item = (0, _app.bemComponent)('fullscreen-header__item');

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});
exports.Body = exports.Header = exports.Main = undefined;

var _clsx = __webpack_require__(11);

var _clsx2 = _interopRequireDefault(_clsx);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Main = exports.Main = function Main(_ref) {
        var hasHeader = _ref.hasHeader,
            children = _ref.children;
        return _react2.default.createElement("div", { className: (0, _clsx2.default)({
                        'fullscreen-main': true,
                        'fullscreen-main--has-header': hasHeader
                }) }, children);
};
var Header = exports.Header = (0, _app.bemComponent)('fullscreen-main__header', 'Header');
var Body = exports.Body = (0, _app.bemComponent)('fullscreen-main__body', 'Body');

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clsx = __webpack_require__(11);

var _clsx2 = _interopRequireDefault(_clsx);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(37);

var _app = __webpack_require__(2);

var _FixedViewportElement = __webpack_require__(167);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FullscreenOverlay = function (_React$Component) {
    _inherits(FullscreenOverlay, _React$Component);

    function FullscreenOverlay() {
        _classCallCheck(this, FullscreenOverlay);

        return _possibleConstructorReturn(this, (FullscreenOverlay.__proto__ || Object.getPrototypeOf(FullscreenOverlay)).apply(this, arguments));
    }

    _createClass(FullscreenOverlay, [{
        key: 'overlayBody',
        value: function overlayBody() {
            return _react2.default.createElement("div", null, !this.props.isClosing && _react2.default.createElement("div", { role: "button", onClick: this.props.onClick, className: "fullscreen-overlay__content" }, this.props.children));
        }
    }, {
        key: 'animatedOverlayBody',
        value: function animatedOverlayBody() {
            return _react2.default.createElement(_reactTransitionGroup.CSSTransition, { in: true, classNames: "fullscreen-overlay-", timeout: this.props.animationDuration || 230, appear: true, unmountOnExit: true }, this.overlayBody());
        }
    }, {
        key: 'renderBody',
        value: function renderBody() {
            var data = {};
            var classes = (0, _clsx2.default)((0, _app.getComponentClasses)('fullscreen-overlay', this.props.variations), {
                'fullscreen-overlay--scrollable-small-screen': this.props.isScrollableSmallScreens
            });
            if (this.props.isActive) {
                data['data-fullscreen-overlay-active'] = true;
                if (this.props.enableScroll) {
                    data['data-enable-scroll'] = true;
                }
            }
            if (this.props.hasAdminBarOffset) {
                data['data-offset-admin-bar'] = true;
            }
            return _react2.default.createElement("div", Object.assign({ className: classes }, data), this.props.hasOpeningAndClosingAnimation ? this.animatedOverlayBody() : this.overlayBody());
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.isActive && !this.props.isClosing) {
                return _react2.default.createElement(_FixedViewportElement.FixedViewportElement, null, this.renderBody());
            }
            return this.renderBody();
        }
    }]);

    return FullscreenOverlay;
}(_react2.default.Component);

exports.default = FullscreenOverlay;

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FixedViewportElement = __webpack_require__(168);

Object.defineProperty(exports, 'FixedViewportElement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FixedViewportElement).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FixedViewportElement = function (_React$Component) {
    _inherits(FixedViewportElement, _React$Component);

    function FixedViewportElement() {
        _classCallCheck(this, FixedViewportElement);

        var _this = _possibleConstructorReturn(this, (FixedViewportElement.__proto__ || Object.getPrototypeOf(FixedViewportElement)).apply(this, arguments));

        _this.toggleFixedViewport = function () {
            var fixedViewportActive = FixedViewportElement.instanceCount > 0 ? true : false;
            var body = document.querySelector('body');
            if (body) {
                if (fixedViewportActive) {
                    body.setAttribute('data-fixed-viewport-active', 'true');
                } else {
                    body.removeAttribute('data-fixed-viewport-active');
                }
            }
        };
        return _this;
    }

    _createClass(FixedViewportElement, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.scrollPosition = window.pageYOffset;
            this.incrementNumberOfOverlays();
            this.toggleFixedViewport();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.decrementNumberOfOverlays();
            this.toggleFixedViewport();
            if (this.scrollPosition) {
                window.scrollTo(0, this.scrollPosition);
            }
        }
    }, {
        key: 'incrementNumberOfOverlays',
        value: function incrementNumberOfOverlays() {
            FixedViewportElement.instanceCount++;
        }
    }, {
        key: 'decrementNumberOfOverlays',
        value: function decrementNumberOfOverlays() {
            FixedViewportElement.instanceCount--;
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);

    return FixedViewportElement;
}(_react2.default.Component);

exports.default = FixedViewportElement;

FixedViewportElement.instanceCount = 0;

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Body = exports.Footer = exports.Header = exports.Main = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Main = exports.Main = function Main(_ref) {
    var children = _ref.children;
    return _react2.default.createElement("div", { className: "fullscreen-sidebar" }, _react2.default.createElement("div", { className: "fullscreen-sidebar__inner" }, children));
};
var Header = exports.Header = (0, _app.bemComponent)('fullscreen-sidebar__header', 'Header');
var Footer = exports.Footer = (0, _app.bemComponent)('fullscreen-sidebar__footer', 'Footer');
var Body = exports.Body = function Body(_ref2) {
    var children = _ref2.children;
    return _react2.default.createElement("div", { className: "fullscreen-sidebar__body" }, _react2.default.createElement("div", { className: "fullscreen-sidebar__body__inner", id: "fullscreenSidebar" }, children));
};

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

__webpack_require__(256);

var _createStore = __webpack_require__(53);

var _createStore2 = _interopRequireDefault(_createStore);

var _lodash = __webpack_require__(419);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(271);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createStore2.default)({
    storeName: 'DesignCollectionStore',

    handlers: {
        SET_DESIGN_COLLECTION: 'setDesignCollection',
        UPDATE_DESIGN_START: 'startUpdateDesign',
        UPDATE_DESIGN_FAILED: 'revertUpdateDesign',
        UPDATE_DESIGN_SUCCESS: 'updateDesign',
        UPDATE_DESIGN_COLLECTION_PAGE_DATA_APPEND: 'appendDesignData',
        UPDATE_DESIGN_COLLECTION_PAGE_DATA_PREPEND: 'prependDesignData',
        LOAD_DESIGN_SUCCESS: 'reloadDesignData',
        SET_DESIGN_DATA: 'reloadDesignData'
    },

    initialize: function initialize() {
        this.designs = [];
        this.totalDesignCount = null;
        this.designOffset = null;
        this.isLoading = true;
        this.designPageUrls = [];

        this.prevPageUrl = null;
        this.nextPageUrl = null;
    },

    // public API methods

    setModel: function setModel(model) {
        this.model = model;
    },

    getModel: function getModel() {
        return this.model;
    },

    setCollectionModel: function setCollectionModel(collectionModel) {
        this.collectionModel = collectionModel;
    },

    getCollectionModel: function getCollectionModel() {
        return this.collectionModel;
    },

    getCurrentPage: function getCurrentPage(designId) {
        var index = this.getDesignIndexByDesignId(designId);
        return index + this.designOffset + 1;
    },

    getDesign: function getDesign(designId) {
        var index = this.getDesignIndexByDesignId(designId);
        return this.getDesignByIndex(index);
    },

    getPreviousDesign: function getPreviousDesign(designId) {
        var index = this.getDesignIndexByDesignId(designId);
        return this.getDesignByIndex(index - 1);
    },

    getNextDesign: function getNextDesign(designId) {
        var index = this.getDesignIndexByDesignId(designId);
        return this.getDesignByIndex(index + 1);
    },

    // handler methods

    setDesignCollection: function setDesignCollection(designCollection) {
        this.initialize();
        this.designs = designCollection.designs;
        this.designPageUrls = designCollection.designPageUrls;
        this.totalDesignCount = designCollection.totalDesignCount;
        this.designOffset = designCollection.designPageOffset;

        if (this.designPageUrls && this.designPageUrls.length > 1) {
            var currentPageIndex = this.designPageUrls.indexOf(designCollection.currentPageUrl);
            this.prevPageUrl = this.designPageUrls[currentPageIndex - 1];
            this.nextPageUrl = this.designPageUrls[currentPageIndex + 1];
        }

        this.emitChange();
    },

    reloadDesignData: function reloadDesignData(design) {
        var index = this.getDesignIndexByDesignId(design.designId);
        if (index) {
            this.designs[index] = design;
            this.emitChange();
        }
        window.dispatchEvent(new CustomEvent('ddoDidLoadDesign', { detail: { design: design } }));
    },

    appendDesignData: function appendDesignData(data) {
        // append the new data to the old data and de-dupe based on file id (self url)
        this.designs = (0, _lodash2.default)((0, _lodash4.default)([this.designs, data.designs]), function (design) {
            return design.designId;
        });

        this.updateNextPageUrl(data.pageUrl);
        this.emitChange();
    },

    prependDesignData: function prependDesignData(data) {
        // prepend the new data to the old data and de-dupe based on designId
        var designCount = this.designs.length;
        this.designs = (0, _lodash2.default)((0, _lodash4.default)([data.designs, this.designs]), function (design) {
            return design.designId;
        });
        var newlyAddedDesignsCount = this.designs.length - designCount;
        this.designOffset = this.designOffset - newlyAddedDesignsCount;

        this.updatePrevPageUrl(data.pageUrl);
        this.emitChange();
    },

    startUpdateDesign: function startUpdateDesign(data) {
        var updatedDesign = _extends({}, data.design, data.data);
        this.emitChangeForUpdatedDesign(updatedDesign);
    },

    revertUpdateDesign: function revertUpdateDesign(data) {
        var updatedDesign = _extends({}, data.design);
        this.emitChangeForUpdatedDesign(updatedDesign);
    },

    updateDesign: function updateDesign(design) {
        this.emitChangeForUpdatedDesign(design);

        // hook into flightjs to refresh underlying page
        var event = new window.CustomEvent('uiDesignDetailsOverlayDesignUpdated', {
            bubbles: true
        });
        document.querySelector('html').dispatchEvent(event);
    },

    // private methods

    getDesignByIndex: function getDesignByIndex(index) {
        return this.designs[index] || null;
    },

    emitChangeForUpdatedDesign: function emitChangeForUpdatedDesign(design) {
        var designIndexToUpdate = this.getDesignIndexByDesignId(design.designId);
        var designToUpdate = this.designs[designIndexToUpdate];

        if (designToUpdate) {
            this.designs[designIndexToUpdate] = _extends({}, designToUpdate, design);
        }

        this.emitChange();
    },

    getDesignIndexByDesignId: function getDesignIndexByDesignId(designId) {
        return this.designs.findIndex(function (design) {
            return design && design.designId === parseInt(designId, 10);
        });
    },

    updatePrevPageUrl: function updatePrevPageUrl(loadedPageUrl) {
        if (this.prevPageUrl === loadedPageUrl) {
            // navigating backward
            var prevPageIndex = this.designPageUrls.indexOf(this.prevPageUrl) - 1;
            this.prevPageUrl = this.designPageUrls[prevPageIndex];
        }
    },

    updateNextPageUrl: function updateNextPageUrl(loadedPageUrl) {
        if (this.nextPageUrl === loadedPageUrl) {
            // navigating forward
            var nextPageIndex = this.designPageUrls.indexOf(this.nextPageUrl) + 1;
            this.nextPageUrl = this.designPageUrls[nextPageIndex];
        }
    }
});

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonList = __webpack_require__(427);

Object.defineProperty(exports, 'ButtonList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonList).default;
  }
});
Object.defineProperty(exports, 'ButtonListItem', {
  enumerable: true,
  get: function get() {
    return _ButtonList.ButtonListItem;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STATUS = undefined;
exports.default = request;
exports.get = get;
exports.post = post;
exports.put = put;
exports.resolve = resolve;
exports.pendingRequestKeys = pendingRequestKeys;

var _superagent = __webpack_require__(15);

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

var requests = {};
var TIMEOUT = 10000;

var STATUS = exports.STATUS = {
    NOT_FOUND: 404,
    TIMEOUT: 408,
    FORBIDDEN: 403,
    ERROR: 500
};

/*
 * API request, with opt-in request key
 * Supplying a key will cause in-flight requests of the
 * same key to be cancelled.
 *
 * This is the desired behaviour for things like autocomplete,
 * where user interaction can cause multiple API requests, but the
 * user is only interested in the results for the latest one
 */
function request(method, url) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var req = (0, _superagent2.default)(method, url).timeout(TIMEOUT).type('application/json');

    // monkey-patch SuperAgent instance to include
    // key we use for cancelling conflicting requests
    req.requestKey = key;
    return req;
}

function get(path) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return request('GET', path, key);
}

function post(path) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return request('POST', path, key).type('form');
}

function put(path) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return request('PUT', path, key).type('form');
}

function resolve(req) {
    if (req.requestKey) {
        registerRequest(req);
    }

    return new Promise(function (accept, reject) {
        req.end(function (err, res) {
            if (err) {
                if (err.timeout === TIMEOUT) {
                    return reject(new Error('API timeout'));
                }

                return reject(err);
            }

            // superagent doesn't auto-parse hal+json
            if (res.type === 'application/hal+json') {
                res.body = JSON.parse(res.text);
            }

            // TODO: more thorough HTTP code coverage
            if (res.status === 403) {
                reject(new Error('Forbidden response from API'));
            } else if (!res.ok) {
                reject(new Error('API returned bad response'));
            } else {
                accept(res.body);
            }
        });
    });
}

function pendingRequestKeys() {
    return Object.keys(requests);
}

function registerRequest(req) {
    var key = req.requestKey;
    if (!key) {
        return;
    }
    if (requests.hasOwnProperty(key)) {
        requests[key].abort();
    }
    requests[key] = req;
}

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    API_REQUEST_START: 'API_REQUEST_START',
    API_REQUEST_END: 'API_REQUEST_END',
    DESIGN_COMMENTS_LOAD_START: 'DESIGN_COMMENTS_LOAD_START',
    DESIGN_COMMENTS_LOAD_FINISH: 'DESIGN_COMMENTS_LOAD_FINISH',
    DESIGN_COMMENT_SELECTED: 'DESIGN_COMMENT_SELECTED',
    DESIGN_COMMENT_DELETE_START: 'DESIGN_COMMENT_DELETE_START',
    DESIGN_COMMENT_DELETE_FINISH: 'DESIGN_COMMENT_DELETE_FINISH',
    DESIGN_COMMENT_DELETE_ERROR: 'DESIGN_COMMENT_DELETE_ERROR',
    DESIGN_COMMENT_CREATE_START: 'DESIGN_COMMENT_CREATE_START',
    DESIGN_COMMENT_CREATE_FINISH: 'DESIGN_COMMENT_CREATE_FINISH',
    DESIGN_COMMENT_CREATE_ERROR: 'DESIGN_COMMENT_CREATE_ERROR',
    DESIGN_COMMENT_EDIT_START: 'DESIGN_COMMENT_EDIT_START',
    DESIGN_COMMENT_EDIT_CANCEL: 'DESIGN_COMMENT_EDIT_CANCEL',
    DESIGN_COMMENT_UPDATE: 'DESIGN_COMMENT_UPDATE',
    DESIGN_COMMENT_UPDATE_START: 'DESIGN_COMMENT_UPDATE_START',
    DESIGN_COMMENT_UPDATE_FINISH: 'DESIGN_COMMENT_UPDATE_FINISH',
    DESIGN_COMMENT_UPDATE_ERROR: 'DESIGN_COMMENT_UPDATE_FINISH',
    UPDATE_DESIGN_START: 'UPDATE_DESIGN_START',
    UPDATE_DESIGN_SUCCESS: 'UPDATE_DESIGN_SUCCESS',
    UPDATE_DESIGN_FAILED: 'UPDATE_DESIGN_FAILED',
    LOAD_DESIGN_SUCCESS: 'LOAD_DESIGN_SUCCESS',
    LOAD_DESIGN_FAILED: 'LOAD_DESIGN_FAILED',
    DELETE_FILE: 'DELETE_FILE',
    SET_DESIGN_DATA: 'SET_DESIGN_DATA',
    SET_DESIGN_COLLECTION: 'SET_DESIGN_COLLECTION',
    UPDATE_DESIGN_COLLECTION_PAGE_DATA_APPEND: 'UPDATE_DESIGN_COLLECTION_PAGE_DATA_APPEND',
    UPDATE_DESIGN_COLLECTION_PAGE_DATA_PREPEND: 'UPDATE_DESIGN_COLLECTION_PAGE_DATA_PREPEND',
    DESIGN_COMMENTS_CLEAR: 'DESIGN_COMMENTS_CLEAR',
    DESIGN_COMMENTS_LOADED: 'DESIGN_COMMENTS_LOADED',
    SET_DESIGN_SKETCH_STATE: 'SET_DESIGN_SKETCH_STATE',
    SET_DESIGN_SKETCH: 'SET_DESIGN_SKETCH',
    ADD_DESIGN_PATH: 'ADD_DESIGN_PATH',
    UNDO_LAST_DESIGN_PATH: 'UNDO_LAST_DESIGN_PATH'
};

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propertyOrNull = __webpack_require__(14);

var _propertyOrNull2 = _interopRequireDefault(_propertyOrNull);

var _user = __webpack_require__(209);

var _user2 = _interopRequireDefault(_user);

var _design = __webpack_require__(276);

var _design2 = _interopRequireDefault(_design);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    create: create,
    defaultProperties: defaultProperties,
    fromJSON: fromJSON,
    isPersisted: isPersisted,
    equal: equal
};


function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function equal(obj1, obj2) {
    return obj1 && obj2 && obj1.id === obj2.id;
}

function isPersisted(obj) {
    return !!obj.id;
}

function defaultProperties() {
    return {
        id: null,
        message: null,
        createdAt: new Date().toString(),
        annotation: null,
        isDeleted: false,
        creator: null,
        design: null,
        designId: null, // questionable. Added to ease DesignStore changes
        links: {
            self: null,
            delete: null,
            edit: null
        },

        permission: {
            canDelete: false,
            canEdit: false,
            secondsRemainingEdit: 0,
            secondsRemainingDelete: 0
        }
    };
}

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    var defaults = defaultProperties();

    return {
        id: (0, _propertyOrNull2.default)(json._links.self, 'href'),
        designId: (0, _propertyOrNull2.default)(json._embedded.design, 'designId'),
        message: json.message,
        formattedMessage: json.formattedMessage,
        annotation: json.annotationX && json.annotationY ? { x: json.annotationX || null, y: json.annotationY || null } : null,
        isDeleted: json.isDeleted,
        links: {
            self: (0, _propertyOrNull2.default)(json._links.self, 'href'),
            edit: (0, _propertyOrNull2.default)(json._links.edit, 'href'),
            delete: (0, _propertyOrNull2.default)(json._links.delete, 'href')
        },
        createdAt: json.createdAt,
        creator: _user2.default.fromJSON(json._embedded.creator),
        permission: Object.assign({}, defaults.permission, json._embedded.permission || {}),
        design: _design2.default.fromJSON(json._embedded.file)
    };
}

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    ENTER: 'Enter',
    SPACE: ' ',
    ESCAPE: 'Escape',
    UP: 'ArrowUp',
    DOWN: 'ArrowDown',
    TAB: 'Tab'
};

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12), __webpack_require__(62)(module)))

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Menu = __webpack_require__(152);

var _HoverableElement = __webpack_require__(97);

var _keyConstants = __webpack_require__(18);

var _keyConstants2 = _interopRequireDefault(_keyConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */

// eslint-disable-line no-restricted-imports


// FIXME: remove, these are not public api


function isLetterKeyCode(keyCode) {
    return keyCode >= 65 && keyCode <= 90;
}

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //
// DEPRECATED COMPONENT, DO NOT USE!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //

/**
 * A wrapper component that adds dropdown behaviours to its wrapped children element.
 * It supports smart dropdown repositioning by default.
 *
 * Example:
 * var object1 = {label: 'foo', key: 'f1', ...}; // object1 contains props for creating MenuItemAction component
 * var items=[object1, ...]
 * <DropdownMenu itemData={items}><h1>world</h1></DropdownMenu>
 *
 * Note:
 * DropdownMenu make no assumption on the tab order of the anchor element it wraps. To allow full ARIA keyboard
 * behaviours, make sure the anchor element has tabbing enabled. (i.e. being form elements or having tabIndex)
 */

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //
// DEPRECATED COMPONENT, DO NOT USE!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! //

var DropdownMenu = function (_React$Component) {
    _inherits(DropdownMenu, _React$Component);

    function DropdownMenu(props) {
        _classCallCheck(this, DropdownMenu);

        var _this = _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call(this, props));

        _this.state = {
            isActive: false,
            currentFocusIndex: -1,
            isAnchorFocused: false
        };

        _this.anchorWrapper = null;

        _this.onItemSelect = _this.onItemSelect.bind(_this);
        _this.onItemKeyDown = _this.onItemKeyDown.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.getMenuItem = _this.getMenuItem.bind(_this);
        _this.deactivate = _this.deactivate.bind(_this);
        _this.activate = _this.activate.bind(_this);
        _this.toggle = _this.toggle.bind(_this);
        _this.focusNextItem = _this.focusNextItem.bind(_this);
        _this.focusPrevItem = _this.focusPrevItem.bind(_this);
        _this.onAnchorClick = _this.onAnchorClick.bind(_this);
        _this.onAnchorFocus = _this.onAnchorFocus.bind(_this);
        _this.onAnchorKeyDown = _this.onAnchorKeyDown.bind(_this);
        _this.handleEscKey = _this.handleEscKey.bind(_this);
        _this.handleLetterKeys = _this.handleLetterKeys.bind(_this);
        _this.handleHoverElementShow = _this.handleHoverElementShow.bind(_this);
        _this.handleHoverElementHide = _this.handleHoverElementHide.bind(_this);
        return _this;
    }

    _createClass(DropdownMenu, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isAnchorFocused) {
                this.focusOnAnchor();
                this.setState({ isAnchorFocused: false });
            }
        }
    }, {
        key: 'focusOnAnchor',
        value: function focusOnAnchor() {
            (0, _jquery2.default)(this.anchorWrapper).children().focus();
        }
    }, {
        key: 'getMenuItem',
        value: function getMenuItem(props, i) {
            return _react2.default.createElement(_Menu.ButtonMenuItemAction, _extends({}, props, {
                key: props.key || props.label + i,
                isEnabled: true,
                isFocused: this.state.isActive && this.state.currentFocusIndex === i,
                onSelect: this.onItemSelect.bind(this, props),
                onKeyDown: this.onItemKeyDown.bind(this, props),
                onBlur: this.onBlur
            }));
        }
    }, {
        key: 'getHoverElement',
        value: function getHoverElement(menuItemsData) {
            return _react2.default.createElement(
                _Menu.Menu,
                { variations: ['constrained'] },
                _react2.default.createElement(
                    _Menu.MenuItemActionList,
                    null,
                    menuItemsData.map(this.getMenuItem)
                )
            );
        }
    }, {
        key: 'activate',
        value: function activate() {
            if (!this.state.isActive) {
                this.setState({ isActive: true });
            }
        }
    }, {
        key: 'deactivate',
        value: function deactivate(isAnchorFocused) {
            if (this.state.isActive) {
                this.setState({
                    isActive: false,
                    currentFocusIndex: -1,
                    isAnchorFocused: isAnchorFocused || false
                });
            }
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            if (this.state.isActive) {
                this.deactivate(true);
            } else {
                this.activate();
            }
        }
    }, {
        key: 'focusNextItem',
        value: function focusNextItem(criteriaFunction, backward) {
            var options = this.props.itemData;
            var direction = backward ? -1 : 1;
            var targetIndex;
            var targetData;

            for (var i = 1; i <= options.length; i++) {
                targetIndex = (this.state.currentFocusIndex + options.length + direction * i) % options.length;
                targetData = options[targetIndex];

                if (!criteriaFunction || criteriaFunction(targetData)) {
                    return this.setState({ currentFocusIndex: targetIndex });
                }
            }
        }
    }, {
        key: 'focusPrevItem',
        value: function focusPrevItem(criteriaFunction) {
            this.focusNextItem(criteriaFunction, true);
        }
    }, {
        key: 'onAnchorClick',
        value: function onAnchorClick() {
            this.toggle();
        }
    }, {
        key: 'onAnchorFocus',
        value: function onAnchorFocus() {
            this.setState({ isAnchorFocused: true });
        }
    }, {
        key: 'onAnchorKeyDown',
        value: function onAnchorKeyDown(event) {
            var hasHandledKey = false;

            hasHandledKey = hasHandledKey || this.handleEscKey(event);
            hasHandledKey = hasHandledKey || this.handleLetterKeys(event);

            if (event.key === _keyConstants2.default.SPACE || event.key === _keyConstants2.default.ENTER) {
                this.toggle();
                hasHandledKey = true;
            }

            if (event.key === _keyConstants2.default.DOWN) {
                this.activate();
                this.focusNextItem();
                hasHandledKey = true;
            }

            if (hasHandledKey) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
    }, {
        key: 'onBlur',
        value: function onBlur() {
            // Use setTimeout to allow new activeElement be set before we handle the event.
            // this.isMounted check is required due to the asynchronous nature of setTimeout call.
            setTimeout(function () {
                var activeEl = document.activeElement;
                if (this.hoverElementNode && !_jquery2.default.contains(this.hoverElementNode, activeEl)) {
                    this.deactivate();
                }
            }.bind(this), 0);
        }
    }, {
        key: 'onItemKeyDown',
        value: function onItemKeyDown(itemData, event) {
            var hasHandledKey = false;

            hasHandledKey = hasHandledKey || this.handleEscKey(event);
            hasHandledKey = hasHandledKey || this.handleLetterKeys(event);

            if (event.key === _keyConstants2.default.DOWN && this.state.isActive) {
                this.focusNextItem();
                hasHandledKey = true;
            }

            if (event.key === _keyConstants2.default.UP && this.state.isActive) {
                this.focusPrevItem();
                hasHandledKey = true;
            }

            if (hasHandledKey) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
    }, {
        key: 'onItemSelect',
        value: function onItemSelect(selectedItemData) {
            if (this.props.onSelect) {
                this.props.onSelect(selectedItemData);
            }

            this.deactivate(true);
        }
    }, {
        key: 'handleEscKey',
        value: function handleEscKey(keyEvent) {
            if (keyEvent.key === _keyConstants2.default.ESCAPE && this.state.isActive) {
                this.deactivate(true);
                return true;
            }

            return false;
        }
    }, {
        key: 'handleLetterKeys',
        value: function handleLetterKeys(keyEvent) {
            var letter = String.fromCharCode(keyEvent.keyCode);

            if (isLetterKeyCode(keyEvent.keyCode) && this.state.isActive) {
                this.focusNextItem(function (data) {
                    return data.label && data.label.charAt(0).toLowerCase() === letter.toLowerCase();
                });
                return true;
            }

            return false;
        }
    }, {
        key: 'handleHoverElementShow',
        value: function handleHoverElementShow(hoverElementNode) {
            this.hoverElementNode = hoverElementNode;
        }
    }, {
        key: 'handleHoverElementHide',
        value: function handleHoverElementHide() {
            this.hoverElementNode = null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _HoverableElement.HoverableElement,
                {
                    hoverElement: this.getHoverElement(this.props.itemData),
                    hoverPosition: this.props.position,
                    isActive: this.state.isActive,
                    type: 'dropdown',
                    hasTransition: false,
                    onHoverElementShow: this.handleHoverElementShow,
                    onHoverElementHide: this.handleHoverElementHide
                },
                _react2.default.createElement(
                    'span',
                    {
                        onKeyDown: this.onAnchorKeyDown,
                        onBlur: this.onBlur,
                        onFocus: this.onAnchorFocus,
                        onClick: this.onAnchorClick,
                        className: 'hover-card-anchor',
                        'aria-haspopup': true,
                        'aria-expanded': this.state.isActive,
                        ref: function ref(element) {
                            _this2.anchorWrapper = element;
                        }
                    },
                    this.props.children
                )
            );
        }
    }]);

    return DropdownMenu;
}(_react2.default.Component);

DropdownMenu.defaultProps = {
    itemData: [],
    position: 'down-center'
};

DropdownMenu.propTypes = {
    onSelect: _propTypes2.default.func,
    itemData: _propTypes2.default.arrayOf(_propTypes2.default.object),
    position: _propTypes2.default.oneOf(['up-left', 'up-center', 'up-right', 'down-left', 'down-center', 'down-right', 'left-top', 'left-middle', 'left-bottom', 'right-top', 'right-middle', 'right-bottom', 'up-fluid', 'down-fluid'])
};

exports.default = DropdownMenu;

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.positionElement = positionElement;
exports.positionElementWithAutoAdjustment = positionElementWithAutoAdjustment;
exports.getPossiblePositions = getPossiblePositions;
/**
 * Utility functions for positioning a given dom element around an anchor dom element.
 */
var locations = {
    'up-left': { direction: 'up', alignment: 'left', coordinate: [-1, -2] },
    'up-center': { direction: 'up', alignment: 'center', coordinate: [0, -2] },
    'up-right': { direction: 'up', alignment: 'right', coordinate: [1, -2] },
    'down-left': { direction: 'down', alignment: 'left', coordinate: [-1, 2] },
    'down-center': { direction: 'down', alignment: 'center', coordinate: [0, 2] },
    'down-right': { direction: 'down', alignment: 'right', coordinate: [1, 2] },
    'left-top': { direction: 'left', alignment: 'top', coordinate: [-6, -1] },
    'left-middle': { direction: 'left', alignment: 'middle', coordinate: [-6, 0] },
    'left-bottom': { direction: 'left', alignment: 'bottom', coordinate: [-6, 1] },
    'right-top': { direction: 'right', alignment: 'top', coordinate: [6, -1] },
    'right-middle': { direction: 'right', alignment: 'middle', coordinate: [6, 0] },
    'right-bottom': { direction: 'right', alignment: 'bottom', coordinate: [6, 1] },
    'up-fluid': { direction: 'up', alignment: 'fluid', coordinate: [0, -15] },
    'down-fluid': { direction: 'down', alignment: 'fluid', coordinate: [0, 15] }
};
function getDistanceSquared(locationNameA, locationNameB) {
    var locationA = locations[locationNameA];
    var locationB = locations[locationNameB];
    return Math.pow(locationA.coordinate[0] - locationB.coordinate[0], 2) + Math.pow(locationA.coordinate[1] - locationB.coordinate[1], 2);
}
function getPosition(anchorElement, element, location) {
    var distance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var alignmentOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    var anchorRect = anchorElement && anchorElement.getBoundingClientRect();
    var elemRect = element && element.getBoundingClientRect();
    var scrollTop = document.documentElement.scrollTop;
    var position = {};
    if (!anchorRect || !elemRect) {
        return position;
    }
    switch (location.direction) {
        case 'up':
            position.top = anchorRect.top + scrollTop - distance - elemRect.height;
            break;
        case 'down':
            position.top = anchorRect.top + scrollTop + distance + anchorRect.height;
            break;
        case 'left':
            position.left = anchorRect.left - distance - elemRect.width;
            break;
        case 'right':
            position.left = anchorRect.left + distance + anchorRect.width;
            break;
    }
    if (location.alignment !== 'fluid') {
        switch (location.alignment) {
            case 'left':
                position.left = anchorRect.left + alignmentOffset;
                break;
            case 'center':
                position.left = anchorRect.left + anchorRect.width / 2 - elemRect.width / 2;
                break;
            case 'right':
                position.left = anchorRect.left + anchorRect.width - elemRect.width - alignmentOffset;
                break;
            case 'top':
                position.top = anchorRect.top + scrollTop + alignmentOffset;
                break;
            case 'middle':
                position.top = anchorRect.top + scrollTop + anchorRect.height / 2 - elemRect.height / 2;
                break;
            case 'bottom':
                position.top = anchorRect.top + scrollTop + (anchorRect.height - elemRect.height) - alignmentOffset;
                break;
        }
    }
    return position;
}
function isOffPage(element) {
    var elemRect = element && element.getBoundingClientRect();
    var windowWidth = document.documentElement.clientWidth;
    var windowHeight = document.documentElement.clientHeight;
    return windowWidth && windowHeight && elemRect && (elemRect.right > windowWidth || // overflow right?
    elemRect.bottom > windowHeight || // overflow bottom?
    elemRect.left < 0 || // overflow left?
    elemRect.top < 0); // overflow top?
}
function positionElement(element, anchorElement, locationName, distance, alignmentOffset) {
    var location = locations[locationName];
    element.style.top = '';
    element.style.left = '';
    element.style.width = '';
    // Setting to current width as wrapping occurs on right edge
    if (location.alignment !== 'fluid') {
        // Round up width up and add 1px to prevent edge case wrapping
        var width = element && Math.ceil(element.getBoundingClientRect().width) + 1;
        element.style.width = width + 'px';
    }
    var newPosition = getPosition(anchorElement, element, location, distance, alignmentOffset);
    element.style.top = newPosition.top + 'px';
    element.style.left = newPosition.left + 'px';
    // Recalculate in case of wrapping
    if (location.direction === 'up') {
        var recalculatedNewPosition = getPosition(anchorElement, element, location, distance, alignmentOffset);
        element.style.top = recalculatedNewPosition.top + 'px';
        element.style.left = recalculatedNewPosition.left + 'px';
    }
    return locationName;
}
function positionElementWithAutoAdjustment(element, anchorElement, locationName, distance, alignmentOffset) {
    var orderedLocations = Object.keys(locations).sort(function (a, b) {
        return getDistanceSquared(a, locationName) - getDistanceSquared(b, locationName);
    });
    var finalLocationName = null;
    var isEveryAutoLocationOffPage = orderedLocations.every(function (locName) {
        positionElement(element, anchorElement, locName, distance, alignmentOffset);
        finalLocationName = locName;
        return isOffPage(element);
    });
    // If we cannot fit the element on page automatically with any of our settings,
    // use the default `locationName` otherwise the final location checked is the location used.
    if (isEveryAutoLocationOffPage) {
        positionElement(element, anchorElement, locationName, distance, alignmentOffset);
        finalLocationName = locationName;
    }
    return finalLocationName;
}
function getPossiblePositions() {
    return Object.keys(locations);
}

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementPosition = exports.keyConstants = exports.filterObjectByKeys = exports.propertyOrNull = exports.getComponentClasses = exports.deprecated = exports.bemComponent = exports.assignProps = undefined;

var _assignProps = __webpack_require__(35);

Object.defineProperty(exports, 'assignProps', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_assignProps).default;
  }
});

var _bemComponent = __webpack_require__(33);

Object.defineProperty(exports, 'bemComponent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bemComponent).default;
  }
});

var _deprecated = __webpack_require__(39);

Object.defineProperty(exports, 'deprecated', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deprecated).default;
  }
});

var _getComponentClasses = __webpack_require__(13);

Object.defineProperty(exports, 'getComponentClasses', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getComponentClasses).default;
  }
});

var _propertyOrNull = __webpack_require__(14);

Object.defineProperty(exports, 'propertyOrNull', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_propertyOrNull).default;
  }
});

var _filterObjectByKeys = __webpack_require__(40);

Object.defineProperty(exports, 'filterObjectByKeys', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_filterObjectByKeys).default;
  }
});

var _keyConstants = __webpack_require__(18);

Object.defineProperty(exports, 'keyConstants', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_keyConstants).default;
  }
});

var _elementPosition = __webpack_require__(19);

var elementPosition = _interopRequireWildcard(_elementPosition);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.elementPosition = elementPosition;

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Spinner = __webpack_require__(24);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PaneSpinner(_ref) {
    var paneTop = _ref.paneTop,
        viewportHeight = _ref.viewportHeight,
        paneHeight = _ref.paneHeight;

    var visibleHeight = viewportHeight > paneHeight ? paneHeight : viewportHeight;
    var rectHeight = paneTop < 0 ? visibleHeight : visibleHeight - paneTop;
    var rectTop = paneTop < 0 ? Math.abs(paneTop) : 0;

    var visibleRect = {
        position: 'absolute',
        top: rectTop,
        left: 0,
        height: rectHeight,
        width: '100%'
    };

    return _react2.default.createElement(
        'div',
        { style: visibleRect },
        _react2.default.createElement(_Spinner.Spinner, { variations: ['centered', 'large', 'soft'] })
    );
}

PaneSpinner.propTypes = {
    paneTop: _propTypes2.default.number.isRequired,
    viewportHeight: _propTypes2.default.number.isRequired,
    paneHeight: _propTypes2.default.number.isRequired
};

exports.default = PaneSpinner;

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    FLUID: 'fluid',
    FIT_TO_WIDTH: 'fit-to-width',
    FIT_TO_CONTAINER: 'fit-to-container',
    FIT_TO_NATIVE: 'fit-to-native'
};

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadDesignSketches = loadDesignSketches;
exports.updateDesignSketches = updateDesignSketches;
exports.undoLastDesignPath = undoLastDesignPath;
exports.addDesignPath = addDesignPath;

var _request = __webpack_require__(172);

var _request2 = _interopRequireDefault(_request);

var _constants = __webpack_require__(173);

var _constants2 = _interopRequireDefault(_constants);

var _request3 = __webpack_require__(275);

var _DesignSketchesStore = __webpack_require__(138);

var _DesignSketchesStore2 = _interopRequireDefault(_DesignSketchesStore);

var _DesignCollectionStore = __webpack_require__(170);

var _DesignCollectionStore2 = _interopRequireDefault(_DesignCollectionStore);

var _lodash = __webpack_require__(25);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadDesignSketches(context, _ref) {
    var loadDesignSketchesUrl = _ref.loadDesignSketchesUrl,
        designId = _ref.designId;

    context.dispatch(_constants2.default.SET_DESIGN_SKETCH_STATE, { state: 'loading', designId: designId });

    var apiRequest = (0, _request2.default)('GET', loadDesignSketchesUrl, _constants2.default.SET_DESIGN_SKETCH);

    (0, _request.resolve)(apiRequest).then(function (sketch) {
        context.dispatch(_constants2.default.SET_DESIGN_SKETCH, { designId: designId, sketch: sketch });
        context.dispatch(_constants2.default.SET_DESIGN_SKETCH_STATE, { state: null, designId: designId });
    }).catch(function () {
        context.dispatch(_constants2.default.SET_DESIGN_SKETCH_STATE, { state: 'error', designId: designId });
    });
}

function updateDesignSketches(context, _ref2) {
    var designId = _ref2.designId,
        csrfToken = _ref2.csrfToken;

    context.dispatch(_constants2.default.SET_DESIGN_SKETCH_STATE, { state: 'saving', designId: designId });

    var sketch = context.getStore(_DesignSketchesStore2.default).getDesignSketch(designId);
    var design = context.getStore(_DesignCollectionStore2.default).getDesign(designId);

    var apiRequest = (0, _request2.default)('POST', design.links.updateSketches, _constants2.default.DESIGN_SKETCH_UPDATE_SUCCESS).set('X-Csrf-Token', csrfToken).send(sketch);

    return context.executeAction(_request3.resolveRequest, { request: apiRequest }).then(function () {
        context.dispatch(_constants2.default.SET_DESIGN_SKETCH_STATE, { state: 'saved', designId: designId });
    }).catch(function () {
        context.dispatch(_constants2.default.SET_DESIGN_SKETCH_STATE, { state: 'error', designId: designId });
    });
}

function undoLastDesignPath(context, _ref3) {
    var designId = _ref3.designId,
        csrfToken = _ref3.csrfToken;

    context.dispatch(_constants2.default.UNDO_LAST_DESIGN_PATH, { designId: designId });
    debounceUpdateDesignSketch(context, designId, csrfToken);
}

var debounceUpdateDesignSketch = (0, _lodash2.default)(function (context, designId, csrfToken) {
    context.executeAction(updateDesignSketches, { designId: designId, csrfToken: csrfToken });
}, 1000);

function addDesignPath(context, _ref4) {
    var designId = _ref4.designId,
        path = _ref4.path,
        csrfToken = _ref4.csrfToken;

    // Round coordinates to the nearest pixel to avoid saving paths with an unnecessary amount of precision
    var roundedPath = path.map(function (point) {
        return {
            x: Math.round(point.x),
            y: Math.round(point.y)
        };
    });
    context.dispatch(_constants2.default.ADD_DESIGN_PATH, {
        designId: designId,
        path: roundedPath
    });
    debounceUpdateDesignSketch(context, designId, csrfToken);
}

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propertyOrNull = __webpack_require__(14);

var _propertyOrNull2 = _interopRequireDefault(_propertyOrNull);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    create: create,
    defaultProperties: defaultProperties,
    fromJSON: fromJSON,
    equal: equal
};


function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function equal(obj1, obj2) {
    return obj1 && obj2 && obj1.userId === obj2.userId;
}

function defaultProperties() {
    return {
        userId: null,
        showUrl: null,
        name: null,
        avatarUrl: null
    };
}

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    var data = {
        userId: (0, _propertyOrNull2.default)(json, 'userId'),
        name: (0, _propertyOrNull2.default)(json, 'name') || (0, _propertyOrNull2.default)(json, 'displayName'),
        avatarUrl: (0, _propertyOrNull2.default)(json, 'avatarUrl')
    };

    if (json.profileUrl) {
        data.profileUrl = json.profileUrl;
    } else if (json.showUrl) {
        data.profileUrl = json.showUrl;
    } else if (json._links && json._links.self) {
        data.profileUrl = json._links.self.href;
    }

    return data;
}

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconButton = __webpack_require__(87);

Object.defineProperty(exports, 'IconButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _avatars = __webpack_require__(448);

Object.defineProperty(exports, 'avatars', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_avatars).default;
  }
});

var _borders = __webpack_require__(449);

Object.defineProperty(exports, 'borders', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_borders).default;
  }
});

var _boxShadows = __webpack_require__(450);

Object.defineProperty(exports, 'boxShadows', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_boxShadows).default;
  }
});

var _breakpoints = __webpack_require__(38);

Object.defineProperty(exports, 'breakpoints', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_breakpoints).default;
  }
});

var _colors = __webpack_require__(211);

Object.defineProperty(exports, 'colors', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_colors).default;
  }
});

var _minHeights = __webpack_require__(451);

Object.defineProperty(exports, 'minHeights', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_minHeights).default;
  }
});

var _semanticIcons = __webpack_require__(277);

Object.defineProperty(exports, 'semanticIcons', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_semanticIcons).default;
  }
});

var _spaces = __webpack_require__(452);

Object.defineProperty(exports, 'spaces', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_spaces).default;
  }
});

var _typography = __webpack_require__(453);

Object.defineProperty(exports, 'typography', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_typography).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// orange
var heritage = exports.heritage = '#ff7e65';
var sandyButt = exports.sandyButt = '#f6caa2';
//red
var risingSun = exports.risingSun = '#ce283D';
var littlePiggy = exports.littlePiggy = '#f0a9b7';
// purple
var berlinThing = exports.berlinThing = '#752873';
var lavendork = exports.lavendork = '#b36ea7';
// blue
var pacific = exports.pacific = '#1f3ca6';
var carnaval = exports.carnaval = '#81a3e6';
//green
var forrestLyf = exports.forrestLyf = '#2f9780';
var mildredsCar = exports.mildredsCar = '#a4d2d4';
// brown
var looseAlmond = exports.looseAlmond = '#95837b';
var theTanTan = exports.theTanTan = '#cbbba5';
// neutrals
var puntRoad = exports.puntRoad = '#555555';
var fiftyFirstShade = exports.fiftyFirstShade = '#999999';
var pebbleBeach = exports.pebbleBeach = '#cccccc';
var t1000 = exports.t1000 = '#e6e6e6';
var karlTheFog = exports.karlTheFog = '#f3f2f0';
var bleachedAs = exports.bleachedAs = '#ffffff';
var semantic = exports.semantic = {
    success: forrestLyf,
    error: risingSun,
    info: puntRoad,
    caution: berlinThing,
    callout: heritage,
    active: heritage
};
var typography = exports.typography = {
    root: puntRoad,
    heading: puntRoad,
    linkText: pacific,
    small: pebbleBeach,
    blockquote: {
        base: 'inherit',
        cite: pebbleBeach
    },
    attribution: fiftyFirstShade,
    displayName: puntRoad,
    hr: puntRoad,
    soft: fiftyFirstShade,
    softer: pebbleBeach,
    softText: pebbleBeach,
    softIcon: t1000,
    softIconFocus: pebbleBeach,
    actionHover: pacific,
    contentBorder: t1000,
    contentBackground: bleachedAs
};
var vivid = exports.vivid = {
    heritage: heritage,
    sandyButt: sandyButt,
    risingSun: risingSun,
    littlePiggy: littlePiggy,
    berlinThing: berlinThing,
    lavendork: lavendork,
    pacific: pacific,
    carnaval: carnaval,
    forrestLyf: forrestLyf,
    mildredsCar: mildredsCar,
    looseAlmond: looseAlmond,
    theTanTan: theTanTan
};
var social = exports.social = {
    twitter: '#55acee',
    facebook: '#3b5998',
    pinterest: '#bd081c',
    linkedin: '#0077b5'
};
var packages = exports.packages = {
    bronze: '#e0b48c',
    silver: '#b2b2b2',
    gold: '#e8b954',
    platinum: puntRoad,
    custom: carnaval
};
var colors = {
    // Named
    heritage: heritage,
    sandyButt: sandyButt,
    risingSun: risingSun,
    littlePiggy: littlePiggy,
    berlinThing: berlinThing,
    lavendork: lavendork,
    pacific: pacific,
    carnaval: carnaval,
    forrestLyf: forrestLyf,
    mildredsCar: mildredsCar,
    looseAlmond: looseAlmond,
    theTanTan: theTanTan,
    puntRoad: puntRoad,
    fiftyFirstShade: fiftyFirstShade,
    pebbleBeach: pebbleBeach,
    t1000: t1000,
    karlTheFog: karlTheFog,
    bleachedAs: bleachedAs,
    // Groups
    semantic: semantic,
    typography: typography,
    vivid: vivid,
    social: social,
    packages: packages
};
exports.default = colors;

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propertyOrNull = __webpack_require__(14);

var _propertyOrNull2 = _interopRequireDefault(_propertyOrNull);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    create: create,
    defaultProperties: defaultProperties,
    fromJSON: fromJSON,
    equal: equal
};


function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function equal(obj1, obj2) {
    return obj1 && obj2 && obj1.userId === obj2.userId;
}

function defaultProperties() {
    return {
        userId: null,
        showUrl: null,
        name: null,
        avatarUrl: null,
        isFavorite: false
    };
}

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    var data = {
        userId: (0, _propertyOrNull2.default)(json, 'userId'),
        name: (0, _propertyOrNull2.default)(json, 'name') || (0, _propertyOrNull2.default)(json, 'displayName'),
        avatarUrl: (0, _propertyOrNull2.default)(json, 'avatarUrl'),
        isFavorite: (0, _propertyOrNull2.default)(json, 'isFavorite')
    };

    if (json.profileUrl) {
        data.profileUrl = json.profileUrl;
    } else if (json.showUrl) {
        data.profileUrl = json.showUrl;
    } else if (json._links && json._links.self) {
        data.profileUrl = json._links.self.href;
    }

    return data;
}

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _design = __webpack_require__(276);

var _design2 = _interopRequireDefault(_design);

var _user = __webpack_require__(212);

var _user2 = _interopRequireDefault(_user);

var _propertyOrNull = __webpack_require__(14);

var _propertyOrNull2 = _interopRequireDefault(_propertyOrNull);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    var data = {
        designId: (0, _propertyOrNull2.default)(json, 'design_id'),
        projectDesignId: (0, _propertyOrNull2.default)(json, 'projectDesignId'),
        creator: _user2.default.fromJSON(json._embedded.creator),
        permission: json._embedded.permission || {},
        showUrl: (0, _propertyOrNull2.default)(json._links.showUrl, 'href'),
        likes: json.likes || [],
        links: {
            self: (0, _propertyOrNull2.default)(json._links.self, 'href'),
            delete: (0, _propertyOrNull2.default)(json._links.delete, 'href'),
            comments: (0, _propertyOrNull2.default)(json._links.comments, 'href'),
            createComment: (0, _propertyOrNull2.default)(json._links.createComment, 'href'),
            toggleDeliverable: (0, _propertyOrNull2.default)(json._links.toggleDeliverable, 'href'),
            inviteToWorkUrl: (0, _propertyOrNull2.default)(json._links.inviteToWorkUrl, 'href'),
            profileUrl: (0, _propertyOrNull2.default)(json._links.profileUrl, 'href'),
            likeDesignUrl: (0, _propertyOrNull2.default)(json._links.likeDesignUrl, 'href'),
            editDesignUrl: (0, _propertyOrNull2.default)(json._links.editDesignUrl, 'href'),
            contestUrl: (0, _propertyOrNull2.default)(json._links.contestUrl, 'href'),
            lastSeenTimeUrl: (0, _propertyOrNull2.default)(json._links.lastSeenTimeUrl, 'href'), // this will no longer be used once Profiles adopts the React-Flux implementation for online statuses
            lastSeenTimesUrl: (0, _propertyOrNull2.default)(json._links.lastSeenTimesUrl, 'href'),
            designLikesUrl: (0, _propertyOrNull2.default)(json._links.designLikesUrl, 'href')
        }
    };

    var keys = ['name', 'isDeleted', 'size', 'width', 'height', 's3Bucket', 's3Object', 'createdAt', 'previewUrl', 'showUrl', 'likeCount', 'likedByUser', 'shareData', 'description', 'categoryEntryInfo', 'tags', 'marketingCtaButton', 'dataFavoriteDesignerUrl', 'login_or_signup'];

    keys.forEach(function (k) {
        data[k] = (0, _propertyOrNull2.default)(json, k);
    });

    return data;
}

// Replace the fromJSON implementation with our own
/* eslint-disable no-underscore-dangle */

exports.default = Object.assign({}, _design2.default, { fromJSON: fromJSON });

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AnchorMenuItemAction = __webpack_require__(215);

var _AnchorMenuItemAction2 = _interopRequireDefault(_AnchorMenuItemAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AnchorMenuItemAction2.default;

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AnchorMenuItemAction = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MenuItemAction = __webpack_require__(94);

var _MenuItemAction2 = _interopRequireDefault(_MenuItemAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var AnchorMenuItemAction = exports.AnchorMenuItemAction = function (_React$Component) {
    _inherits(AnchorMenuItemAction, _React$Component);

    function AnchorMenuItemAction() {
        _classCallCheck(this, AnchorMenuItemAction);

        return _possibleConstructorReturn(this, (AnchorMenuItemAction.__proto__ || Object.getPrototypeOf(AnchorMenuItemAction)).apply(this, arguments));
    }

    _createClass(AnchorMenuItemAction, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                _a$anchorProps = _a.anchorProps,
                anchorProps = _a$anchorProps === undefined ? {} : _a$anchorProps,
                children = _a.children,
                forwardRef = _a.forwardRef,
                url = _a.url,
                props = __rest(_a, ["anchorProps", "children", "forwardRef", "url"]);
            return _react2.default.createElement("a", Object.assign({ ref: forwardRef, className: "menu__item__action__link", href: url }, anchorProps, props), children);
        }
    }]);

    return AnchorMenuItemAction;
}(_react2.default.Component);

exports.default = (0, _MenuItemAction2.default)(AnchorMenuItemAction);

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.MenuItemAction = MenuItemAction;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

var _Pill = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
function MenuItemAction(WrappedComponent) {
    var MenuItemAction = function (_React$Component) {
        _inherits(MenuItemAction, _React$Component);

        function MenuItemAction() {
            _classCallCheck(this, MenuItemAction);

            var _this = _possibleConstructorReturn(this, (MenuItemAction.__proto__ || Object.getPrototypeOf(MenuItemAction)).apply(this, arguments));

            _this._menuItemAction = _react2.default.createRef();
            return _this;
        }

        _createClass(MenuItemAction, [{
            key: 'maybeFocus',
            value: function maybeFocus() {
                if (this._menuItemAction && this._menuItemAction.current && this.props.isFocused) {
                    this._menuItemAction.current.focus();
                }
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.maybeFocus();
            }
        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if (this.props.isFocused != prevProps.isFocused) {
                    this.maybeFocus();
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _a = this.props,
                    icon = _a.icon,
                    label = _a.label,
                    notification = _a.notification,
                    count = _a.count,
                    isFocused = _a.isFocused,
                    isSelected = _a.isSelected,
                    isDisabled = _a.isDisabled,
                    variations = _a.variations,
                    onBlur = _a.onBlur,
                    onKeyDown = _a.onKeyDown,
                    children = _a.children,
                    props = __rest(_a, ["icon", "label", "notification", "count", "isFocused", "isSelected", "isDisabled", "variations", "onBlur", "onKeyDown", "children"]);
                var variants = [].concat(_toConsumableArray(variations ? variations.slice() : []), [isSelected ? 'selected' : '', icon ? 'has-icon' : '', notification && notification > 0 ? 'has-pill' : '']).filter(function (x) {
                    return x;
                });
                return _react2.default.createElement("li", { className: (0, _app.getComponentClasses)('menu__item__action', variants), role: "menuitem", onBlur: onBlur, onKeyDown: onKeyDown, "data-disabled": isDisabled }, _react2.default.createElement(WrappedComponent, Object.assign({ tabIndex: 0, forwardRef: this._menuItemAction }, props), _react2.default.createElement(MenuItemAction.Icon, { icon: icon }), _react2.default.createElement("span", { className: "menu__item__action__label" }, label ? label : children, _react2.default.createElement(MenuItemAction.Count, { amount: count })), _react2.default.createElement(MenuItemAction.Notification, { notification: notification })));
            }
        }]);

        return MenuItemAction;
    }(_react2.default.Component);

    MenuItemAction.Count = function (_ref) {
        var amount = _ref.amount;
        return amount !== undefined ? _react2.default.createElement("small", { className: "menu__item__action__label__small" }, '(' + amount + ')') : null;
    };
    MenuItemAction.Icon = function (_ref2) {
        var icon = _ref2.icon;
        return icon ? _react2.default.createElement("span", { className: "menu__item__action__icon" }, icon) : null;
    };
    MenuItemAction.Notification = function (_ref3) {
        var notification = _ref3.notification;
        return notification ? _react2.default.createElement("span", { className: "menu__item__action__pill" }, _react2.default.createElement(_Pill.Pill, { variations: ['notification', 'small'] }, notification)) : null;
    };
    MenuItemAction.defaultProps = {
        variations: [],
        isFocused: false,
        isSelected: false,
        isDisabled: false,
        onBlur: function onBlur() {},
        onSelect: function onSelect() {},
        onKeyDown: function onKeyDown() {},
        anchorProps: {}
    };
    return MenuItemAction;
}
exports.default = MenuItemAction;

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonMenuItemAction = __webpack_require__(218);

var _ButtonMenuItemAction2 = _interopRequireDefault(_ButtonMenuItemAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ButtonMenuItemAction2.default;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ButtonMenuItemAction = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _keyConstants = __webpack_require__(18);

var _keyConstants2 = _interopRequireDefault(_keyConstants);

var _MenuItemAction = __webpack_require__(94);

var _MenuItemAction2 = _interopRequireDefault(_MenuItemAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonMenuItemAction = exports.ButtonMenuItemAction = function (_React$Component) {
    _inherits(ButtonMenuItemAction, _React$Component);

    function ButtonMenuItemAction() {
        _classCallCheck(this, ButtonMenuItemAction);

        return _possibleConstructorReturn(this, (ButtonMenuItemAction.__proto__ || Object.getPrototypeOf(ButtonMenuItemAction)).apply(this, arguments));
    }

    _createClass(ButtonMenuItemAction, [{
        key: 'onKeyDown',
        value: function onKeyDown(e) {
            if (e.key === _keyConstants2.default.SPACE || e.key === _keyConstants2.default.ENTER) {
                var event = e;
                this.props.onSelect(event);
                e.preventDefault();
                e.stopPropagation();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement("button", { ref: this.props.forwardRef, onKeyDown: this.onKeyDown, className: "menu__item__action__link", onClick: this.props.onSelect }, this.props.children);
        }
    }]);

    return ButtonMenuItemAction;
}(_react2.default.Component);

exports.default = (0, _MenuItemAction2.default)(ButtonMenuItemAction);

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Menu = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
var Menu = exports.Menu = function Menu(_ref) {
    var _ref$variations = _ref.variations,
        variations = _ref$variations === undefined ? [] : _ref$variations,
        onClick = _ref.onClick,
        children = _ref.children;
    return _react2.default.createElement("div", { role: "menu", className: (0, _app.getComponentClasses)('menu', variations), onClick: onClick }, _react2.default.createElement("div", { className: "menu__inner" }, children));
};
exports.default = Menu;

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MenuItemActionList = __webpack_require__(221);

var _MenuItemActionList2 = _interopRequireDefault(_MenuItemActionList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MenuItemActionList2.default;

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemActionList = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuItemActionList = exports.MenuItemActionList = function MenuItemActionList(_ref) {
  var children = _ref.children;
  return _react2.default.createElement("ul", { className: "menu__item menu__item--action-list" }, children);
};
exports.default = MenuItemActionList;

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatMessage;

var _intlFormatCache = __webpack_require__(247);

var _intlFormatCache2 = _interopRequireDefault(_intlFormatCache);

var _intlMessageformat = __webpack_require__(231);

var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Creating instances of Intl formats is an expensive operation.
var createMessageFormatter = (0, _intlFormatCache2.default)(_intlMessageformat2.default);
// Format a message replacing ICU placeholders with their values.
function formatMessage(message) {
    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var msg = createMessageFormatter(message, _intlMessageformat2.default.defaultLocale);
    return msg.format(values);
}

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Spinner = __webpack_require__(68);

Object.defineProperty(exports, 'Spinner', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Spinner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LinkWithIcon = __webpack_require__(253);

Object.defineProperty(exports, 'LinkWithIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LinkWithIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var LinkWithIcon = function (_React$Component) {
    _inherits(LinkWithIcon, _React$Component);

    function LinkWithIcon() {
        _classCallCheck(this, LinkWithIcon);

        return _possibleConstructorReturn(this, (LinkWithIcon.__proto__ || Object.getPrototypeOf(LinkWithIcon)).apply(this, arguments));
    }

    _createClass(LinkWithIcon, [{
        key: 'getLinkChildren',
        value: function getLinkChildren() {
            return [_react2.default.createElement("span", { className: "link-with-icon__icon", key: "icon" }, this.props.icon), _react2.default.createElement("span", { className: "link-with-icon__label", key: "label" }, this.props.children)];
        }
    }, {
        key: 'render',
        value: function render() {
            var classes = (0, _app.getComponentClasses)('link-with-icon', this.props.variations);
            var _a = this.props,
                variations = _a.variations,
                icon = _a.icon,
                props = __rest(_a, ["variations", "icon"]);
            return _react2.default.createElement("a", Object.assign({}, props, { className: classes }), this.getLinkChildren());
        }
    }]);

    return LinkWithIcon;
}(_react2.default.Component);

exports.default = LinkWithIcon;

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativeTime = __webpack_require__(255);

Object.defineProperty(exports, 'RelativeTime', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RelativeTime).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativeTime;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAbsoluteDateString(date, locale) {
    var format = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
        timeZoneName: 'short'
    };
    return Intl.DateTimeFormat(locale, format).format(new Date(date));
}
function RelativeTime(_ref, _ref2) {
    var date = _ref.date;
    var intl = _ref2.intl;

    return _react2.default.createElement("span", { title: getAbsoluteDateString(date, intl.locale) }, _react2.default.createElement(_reactIntl.FormattedRelative, { value: date }));
}
RelativeTime.contextTypes = {
    intl: _reactIntl.intlShape
};

/***/ }),

/***/ 256:
/***/ (function(module, exports) {

// Polyfill for creating CustomEvents on IE9/10/11

// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

try {
    var ce = new window.CustomEvent('test');
    ce.preventDefault();
    if (ce.defaultPrevented !== true) {
        // IE has problems with .preventDefault() on custom events
        // http://stackoverflow.com/questions/23349191
        throw new Error('Could not prevent default');
    }
} catch(e) {
  var CustomEvent = function(event, params) {
    var evt, origPrevent;
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };

    evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    origPrevent = evt.preventDefault;
    evt.preventDefault = function () {
      origPrevent.call(this);
      try {
        Object.defineProperty(this, 'defaultPrevented', {
          get: function () {
            return true;
          }
        });
      } catch(e) {
        this.defaultPrevented = true;
      }
    };
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent; // expose definition to window
}


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(10));

var _reactLifecyclesCompat = __webpack_require__(28);

var _PropTypes = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = flatten;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.0 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)(module), __webpack_require__(12)))

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.19.2
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.IPv6 = factory(root);
  }
}(this, function (root) {
  'use strict';

  /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";

  console.log(_in, _out, _expected, _out === _expected);
  */

  // save current IPv6 variable, if any
  var _IPv6 = root && root.IPv6;

  function bestPresentation(address) {
    // based on:
    // Javascript to test an IPv6 address for proper format, and to
    // present the "best text representation" according to IETF Draft RFC at
    // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
    // 8 Feb 2010 Rich Brown, Dartware, LLC
    // Please feel free to use this code as long as you provide a link to
    // http://www.intermapper.com
    // http://intermapper.com/support/tools/IPV6-Validator.aspx
    // http://download.dartware.com/thirdparty/ipv6validator.js

    var _address = address.toLowerCase();
    var segments = _address.split(':');
    var length = segments.length;
    var total = 8;

    // trim colons (:: or ::a:b:c… or …a:b:c::)
    if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
      // must have been ::
      // remove first two items
      segments.shift();
      segments.shift();
    } else if (segments[0] === '' && segments[1] === '') {
      // must have been ::xxxx
      // remove the first item
      segments.shift();
    } else if (segments[length - 1] === '' && segments[length - 2] === '') {
      // must have been xxxx::
      segments.pop();
    }

    length = segments.length;

    // adjust total segments for IPv4 trailer
    if (segments[length - 1].indexOf('.') !== -1) {
      // found a "." which means IPv4
      total = 7;
    }

    // fill empty segments them with "0000"
    var pos;
    for (pos = 0; pos < length; pos++) {
      if (segments[pos] === '') {
        break;
      }
    }

    if (pos < total) {
      segments.splice(pos, 1, '0000');
      while (segments.length < total) {
        segments.splice(pos, 0, '0000');
      }
    }

    // strip leading zeros
    var _segments;
    for (var i = 0; i < total; i++) {
      _segments = segments[i].split('');
      for (var j = 0; j < 3 ; j++) {
        if (_segments[0] === '0' && _segments.length > 1) {
          _segments.splice(0,1);
        } else {
          break;
        }
      }

      segments[i] = _segments.join('');
    }

    // find longest sequence of zeroes and coalesce them into one segment
    var best = -1;
    var _best = 0;
    var _current = 0;
    var current = -1;
    var inzeroes = false;
    // i; already declared

    for (i = 0; i < total; i++) {
      if (inzeroes) {
        if (segments[i] === '0') {
          _current += 1;
        } else {
          inzeroes = false;
          if (_current > _best) {
            best = current;
            _best = _current;
          }
        }
      } else {
        if (segments[i] === '0') {
          inzeroes = true;
          current = i;
          _current = 1;
        }
      }
    }

    if (_current > _best) {
      best = current;
      _best = _current;
    }

    if (_best > 1) {
      segments.splice(best, _best, '');
    }

    length = segments.length;

    // assemble remaining segments
    var result = '';
    if (segments[0] === '')  {
      result = ':';
    }

    for (i = 0; i < length; i++) {
      result += segments[i];
      if (i === length - 1) {
        break;
      }

      result += ':';
    }

    if (segments[length - 1] === '') {
      result += ':';
    }

    return result;
  }

  function noConflict() {
    /*jshint validthis: true */
    if (root.IPv6 === this) {
      root.IPv6 = _IPv6;
    }

    return this;
  }

  return {
    best: bestPresentation,
    noConflict: noConflict
  };
}));


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.19.2
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
  }
}(this, function (root) {
  'use strict';

  // save current SecondLevelDomains variable, if any
  var _SecondLevelDomains = root && root.SecondLevelDomains;

  var SLD = {
    // list of known Second Level Domains
    // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
    // ----
    // publicsuffix.org is more current and actually used by a couple of browsers internally.
    // downside is it also contains domains like "dyndns.org" - which is fine for the security
    // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
    // ----
    list: {
      'ac':' com gov mil net org ',
      'ae':' ac co gov mil name net org pro sch ',
      'af':' com edu gov net org ',
      'al':' com edu gov mil net org ',
      'ao':' co ed gv it og pb ',
      'ar':' com edu gob gov int mil net org tur ',
      'at':' ac co gv or ',
      'au':' asn com csiro edu gov id net org ',
      'ba':' co com edu gov mil net org rs unbi unmo unsa untz unze ',
      'bb':' biz co com edu gov info net org store tv ',
      'bh':' biz cc com edu gov info net org ',
      'bn':' com edu gov net org ',
      'bo':' com edu gob gov int mil net org tv ',
      'br':' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
      'bs':' com edu gov net org ',
      'bz':' du et om ov rg ',
      'ca':' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
      'ck':' biz co edu gen gov info net org ',
      'cn':' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
      'co':' com edu gov mil net nom org ',
      'cr':' ac c co ed fi go or sa ',
      'cy':' ac biz com ekloges gov ltd name net org parliament press pro tm ',
      'do':' art com edu gob gov mil net org sld web ',
      'dz':' art asso com edu gov net org pol ',
      'ec':' com edu fin gov info med mil net org pro ',
      'eg':' com edu eun gov mil name net org sci ',
      'er':' com edu gov ind mil net org rochest w ',
      'es':' com edu gob nom org ',
      'et':' biz com edu gov info name net org ',
      'fj':' ac biz com info mil name net org pro ',
      'fk':' ac co gov net nom org ',
      'fr':' asso com f gouv nom prd presse tm ',
      'gg':' co net org ',
      'gh':' com edu gov mil org ',
      'gn':' ac com gov net org ',
      'gr':' com edu gov mil net org ',
      'gt':' com edu gob ind mil net org ',
      'gu':' com edu gov net org ',
      'hk':' com edu gov idv net org ',
      'hu':' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
      'id':' ac co go mil net or sch web ',
      'il':' ac co gov idf k12 muni net org ',
      'in':' ac co edu ernet firm gen gov i ind mil net nic org res ',
      'iq':' com edu gov i mil net org ',
      'ir':' ac co dnssec gov i id net org sch ',
      'it':' edu gov ',
      'je':' co net org ',
      'jo':' com edu gov mil name net org sch ',
      'jp':' ac ad co ed go gr lg ne or ',
      'ke':' ac co go info me mobi ne or sc ',
      'kh':' com edu gov mil net org per ',
      'ki':' biz com de edu gov info mob net org tel ',
      'km':' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
      'kn':' edu gov net org ',
      'kr':' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
      'kw':' com edu gov net org ',
      'ky':' com edu gov net org ',
      'kz':' com edu gov mil net org ',
      'lb':' com edu gov net org ',
      'lk':' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
      'lr':' com edu gov net org ',
      'lv':' asn com conf edu gov id mil net org ',
      'ly':' com edu gov id med net org plc sch ',
      'ma':' ac co gov m net org press ',
      'mc':' asso tm ',
      'me':' ac co edu gov its net org priv ',
      'mg':' com edu gov mil nom org prd tm ',
      'mk':' com edu gov inf name net org pro ',
      'ml':' com edu gov net org presse ',
      'mn':' edu gov org ',
      'mo':' com edu gov net org ',
      'mt':' com edu gov net org ',
      'mv':' aero biz com coop edu gov info int mil museum name net org pro ',
      'mw':' ac co com coop edu gov int museum net org ',
      'mx':' com edu gob net org ',
      'my':' com edu gov mil name net org sch ',
      'nf':' arts com firm info net other per rec store web ',
      'ng':' biz com edu gov mil mobi name net org sch ',
      'ni':' ac co com edu gob mil net nom org ',
      'np':' com edu gov mil net org ',
      'nr':' biz com edu gov info net org ',
      'om':' ac biz co com edu gov med mil museum net org pro sch ',
      'pe':' com edu gob mil net nom org sld ',
      'ph':' com edu gov i mil net ngo org ',
      'pk':' biz com edu fam gob gok gon gop gos gov net org web ',
      'pl':' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
      'pr':' ac biz com edu est gov info isla name net org pro prof ',
      'ps':' com edu gov net org plo sec ',
      'pw':' belau co ed go ne or ',
      'ro':' arts com firm info nom nt org rec store tm www ',
      'rs':' ac co edu gov in org ',
      'sb':' com edu gov net org ',
      'sc':' com edu gov net org ',
      'sh':' co com edu gov net nom org ',
      'sl':' com edu gov net org ',
      'st':' co com consulado edu embaixada gov mil net org principe saotome store ',
      'sv':' com edu gob org red ',
      'sz':' ac co org ',
      'tr':' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
      'tt':' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
      'tw':' club com ebiz edu game gov idv mil net org ',
      'mu':' ac co com gov net or org ',
      'mz':' ac co edu gov org ',
      'na':' co com ',
      'nz':' ac co cri geek gen govt health iwi maori mil net org parliament school ',
      'pa':' abo ac com edu gob ing med net nom org sld ',
      'pt':' com edu gov int net nome org publ ',
      'py':' com edu gov mil net org ',
      'qa':' com edu gov mil net org ',
      're':' asso com nom ',
      'ru':' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
      'rw':' ac co com edu gouv gov int mil net ',
      'sa':' com edu gov med net org pub sch ',
      'sd':' com edu gov info med net org tv ',
      'se':' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
      'sg':' com edu gov idn net org per ',
      'sn':' art com edu gouv org perso univ ',
      'sy':' com edu gov mil net news org ',
      'th':' ac co go in mi net or ',
      'tj':' ac biz co com edu go gov info int mil name net nic org test web ',
      'tn':' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
      'tz':' ac co go ne or ',
      'ua':' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
      'ug':' ac co go ne or org sc ',
      'uk':' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
      'us':' dni fed isa kids nsn ',
      'uy':' com edu gub mil net org ',
      've':' co com edu gob info mil net org web ',
      'vi':' co com k12 net org ',
      'vn':' ac biz com edu gov health info int name net org pro ',
      'ye':' co com gov ltd me net org plc ',
      'yu':' ac co edu gov org ',
      'za':' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
      'zm':' ac co com edu gov net org sch ',
      // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
      'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
      'net': 'gb jp se uk ',
      'org': 'ae',
      'de': 'com '
    },
    // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
    // in both performance and memory footprint. No initialization required.
    // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
    // Following methods use lastIndexOf() rather than array.split() in order
    // to avoid any memory allocations.
    has: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') >= 0;
    },
    is: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset >= 0) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
    },
    get: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return null;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return null;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return null;
      }
      if (sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') < 0) {
        return null;
      }
      return domain.slice(sldOffset+1);
    },
    noConflict: function(){
      if (root.SecondLevelDomains === this) {
        root.SecondLevelDomains = _SecondLevelDomains;
      }
      return this;
    }
  };

  return SLD;
}));


/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resolveRequest = resolveRequest;
exports.requestStart = requestStart;
exports.requestEnd = requestEnd;

var _request = __webpack_require__(172);

var _constants = __webpack_require__(173);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolveRequest(context, _ref) {
    var request = _ref.request,
        _ref$dispatchEnd = _ref.dispatchEnd,
        dispatchEnd = _ref$dispatchEnd === undefined ? true : _ref$dispatchEnd;

    return context.executeAction(requestStart, request.requestKey).then(function () {
        return (0, _request.resolve)(request);
    }).then(function (resolved) {
        if (dispatchEnd) {
            context.executeAction(requestEnd, request.requestKey);
            return resolved;
        } else {
            return resolved;
        }
    });
}

function requestStart(context, key) {
    return Promise.resolve(key).then(function () {
        context.dispatch(_constants2.default.API_REQUEST_START, key);
    });
}

function requestEnd(context, key) {
    return Promise.resolve(key).then(function () {
        context.dispatch(_constants2.default.API_REQUEST_END, key);
    });
}

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propertyOrNull = __webpack_require__(14);

var _propertyOrNull2 = _interopRequireDefault(_propertyOrNull);

var _user = __webpack_require__(209);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    create: create,
    defaultProperties: defaultProperties,
    fromJSON: fromJSON
};


function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function defaultProperties() {
    return {
        designId: null,
        size: null,
        width: null,
        height: null,
        createdAt: new Date().toString(),
        downloadUrl: null,
        previewUrl: null,
        showUrl: null,
        s3Bucket: null,
        s3Object: null,
        creator: null,
        permission: {
            canAnnotate: false,
            canComment: false,
            canView: false,
            canSketch: false,
            canViewComments: false,
            canViewSketches: false
        },
        links: {
            self: null,
            delete: null,
            comments: null,
            createComment: null,
            sketches: null,
            updateSketches: null
        }
    };
}

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    var defaults = defaultProperties();
    var data = {
        designId: (0, _propertyOrNull2.default)(json, 'designId'),
        creator: _user2.default.fromJSON(json._embedded.creator),
        permission: Object.assign({}, defaults.permission, json._embedded.permission || {}),
        links: {
            self: (0, _propertyOrNull2.default)(json._links.self, 'href'),
            delete: (0, _propertyOrNull2.default)(json._links.delete, 'href'),
            comments: (0, _propertyOrNull2.default)(json._links.messages, 'href'),
            createComment: (0, _propertyOrNull2.default)(json._links.createMessage, 'href'),
            sketches: (0, _propertyOrNull2.default)(json._links.sketches, 'href'),
            updateSketches: (0, _propertyOrNull2.default)(json._links.updateSketches, 'href')
        }
    };

    var keys = ['name', 'isDeliverable', 'isDeleted', 'size', 'width', 'height', 's3Bucket', 's3Object', 'createdAt', 'downloadUrl', 'previewUrl', 'showUrl'];

    keys.forEach(function (k) {
        return data[k] = (0, _propertyOrNull2.default)(json, k);
    });
    return data;
}

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var semanticIcons = exports.semanticIcons = {
    error: 'x-1',
    warning: 'info-1',
    caution: 'info-1',
    success: 'tick-1'
};
exports.default = semanticIcons;

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PopoverCard = __webpack_require__(279);

Object.defineProperty(exports, 'PopoverCard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PopoverCard).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Card = __webpack_require__(280);

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverCard = function (_React$Component) {
    _inherits(PopoverCard, _React$Component);

    function PopoverCard(props) {
        _classCallCheck(this, PopoverCard);

        var _this = _possibleConstructorReturn(this, (PopoverCard.__proto__ || Object.getPrototypeOf(PopoverCard)).call(this, props));

        _this.cardNode = null;
        _this.layerNode = null;
        _this.target = null;
        return _this;
    }

    _createClass(PopoverCard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.layerNode = this.props.layerSelector ? document.querySelector(this.props.layerSelector) : this.createTempLayer();
            this.cardNode = document.createElement('div');
            this.layerNode.appendChild(this.cardNode);
            this.update();
        }
        // Creates a layer element at the end of the body if a selector wasn't given

    }, {
        key: 'createTempLayer',
        value: function createTempLayer() {
            this.tempLayer = document.createElement('div');
            this.tempLayer.style.zIndex = '10';
            this.tempLayer.style.position = 'absolute';
            this.tempLayer.style.width = '100%';
            this.tempLayer.style.top = '0';
            document.body.appendChild(this.tempLayer);
            return this.tempLayer;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.update();
        }
    }, {
        key: 'update',
        value: function update() {
            if (this.target instanceof HTMLElement) {
                (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, _react2.default.createElement(_Card2.default, { target: this.target, variations: this.props.variations, placement: this.props.placement }, this.props.card), this.cardNode);
            } else {
                console.error('PopoverCard render error');
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var _this2 = this;

            this.cardNode.dataset.closing = 'true';
            window.setTimeout(function () {
                _reactDom2.default.unmountComponentAtNode(_this2.cardNode);
                _this2.layerNode.removeChild(_this2.cardNode);
                if (_this2.tempLayer) {
                    document.body.removeChild(_this2.tempLayer);
                }
            }, 200);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
                ref: function ref(el) {
                    return _this3.target = _reactDom2.default.findDOMNode(el);
                }
            });
        }
    }]);

    return PopoverCard;
}(_react2.default.Component);

exports.default = PopoverCard;

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(180);

var _lodash2 = _interopRequireDefault(_lodash);

var _popper = __webpack_require__(281);

var _popper2 = _interopRequireDefault(_popper);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Card = function (_React$Component) {
    _inherits(Card, _React$Component);

    function Card(props) {
        _classCallCheck(this, Card);

        var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));

        _this.popper = null;
        _this.card = null;
        _this.arrow = null;
        _this.state = {
            popperStyle: {},
            popperAttributes: {},
            arrowStyle: {}
        };
        _this.applyReactStyle = _this.applyReactStyle.bind(_this);
        _this.update = _this.update.bind(_this);
        return _this;
    }

    _createClass(Card, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var placement = this.props.placement;

            var behavior = ['bottom', 'top', 'left', 'right'];
            var boundariesElement = 'viewport';
            if (!this.arrow) return;
            var options = {
                placement: placement || 'bottom',
                modifiers: {
                    offset: {
                        offset: '10,10'
                    },
                    flip: placement ? {} : { behavior: behavior },
                    preventOverflow: placement // Turn off automatic placement features when a placement is manually set
                    ? undefined : { boundariesElement: boundariesElement, padding: 10 },
                    arrow: {
                        element: this.arrow
                    },
                    applyStyle: { enabled: false },
                    applyReactStyle: {
                        enabled: true,
                        fn: this.applyReactStyle,
                        order: 900
                    }
                }
            };
            this.popper = new _popper2.default(this.props.target, this.card, options);
            window.addEventListener('promo-bar-show', this.update);
            window.addEventListener('promo-bar-hide', this.update);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(props, state) {
            return !(0, _lodash2.default)(this.props, props) || !(0, _lodash2.default)(this.state, state);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.popper.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.popper.destroy();
            this.popper = null;
            window.removeEventListener('promo-bar-show', this.update);
            window.removeEventListener('promo-bar-hide', this.update);
        }
    }, {
        key: 'update',
        value: function update() {
            if (this.popper) {
                this.popper.update();
            }
        }
    }, {
        key: 'applyReactStyle',
        value: function applyReactStyle(data) {
            var attributes = {
                'data-placement': data.placement || 'bottom',
                'data-out-of-boundaries': data.hide || undefined
            };
            this.setState({
                popperStyle: data.styles,
                popperAttributes: attributes,
                arrowStyle: data.offsets.arrow
            });
            return data;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var classes = (0, _app.getComponentClasses)('popover-card', this.props.variations);
            return _react2.default.createElement("div", Object.assign({ className: classes, ref: function ref(card) {
                    return _this2.card = card;
                }, style: this.state.popperStyle }, this.state.popperAttributes), _react2.default.createElement("div", { className: "popover-card__arrow", style: this.state.arrowStyle, ref: function ref(arrow) {
                    return _this2.arrow = arrow;
                } }), _react2.default.createElement("div", { className: "popover-card__content" }, _react2.default.createElement("div", { className: "popover-card__content__inner" }, this.props.children)));
        }
    }]);

    return Card;
}(_react2.default.Component);

exports.default = Card;

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12)))

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _clsx = __webpack_require__(11);

var _clsx2 = _interopRequireDefault(_clsx);

var _reactIntl = __webpack_require__(6);

var _RelativeTime = __webpack_require__(254);

var _Avatar = __webpack_require__(36);

var _DisplayName = __webpack_require__(126);

var _ButtonList = __webpack_require__(171);

var _IconButton = __webpack_require__(21);

var _Icon = __webpack_require__(8);

var _Alert = __webpack_require__(79);

var _propertyOrNull = __webpack_require__(14);

var _propertyOrNull2 = _interopRequireDefault(_propertyOrNull);

var _CommentForm = __webpack_require__(283);

var _CommentForm2 = _interopRequireDefault(_CommentForm);

var _CSSTransition = __webpack_require__(60);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _designComments = __webpack_require__(139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */


// Actions


var Comment = function (_React$Component) {
    _inherits(Comment, _React$Component);

    function Comment(props) {
        _classCallCheck(this, Comment);

        var _this = _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).call(this, props));

        _this.element = _react2.default.createRef();
        _this.deleteActionTimeout = null;
        _this.editActionTimeout = null;
        _this.state = {
            isEditActionBlocked: false,
            isDeleteActionBlocked: false,
            isVisible: true,
            maxHeight: 'none'
        };
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleDeleteClick = _this.handleDeleteClick.bind(_this);
        _this.handleEditClick = _this.handleEditClick.bind(_this);
        _this.handleDelete = _this.handleDelete.bind(_this);
        _this.setMaxHeightBeforeAnimatingOut = _this.setMaxHeightBeforeAnimatingOut.bind(_this);
        return _this;
    }

    _createClass(Comment, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.clearTimeout(this.deleteActionTimeout);
            window.clearTimeout(this.editActionTimeout);
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.setActionExpiry(this.props.comment);
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.status === 'error') {
                this.setState({ isVisible: false });
            }
            if (nextProps.comment.permission.secondsRemainingEdit !== this.props.comment.permission.secondsRemainingEdit) {
                this.setActionExpiry(nextProps.comment);
            }

            if (parseInt(this.props.comment.permission.secondsRemainingDelete, 10) > 0) {
                if (nextProps.comment.permission.secondsRemainingDelete !== this.props.comment.permission.secondsRemainingDelete) {
                    this.setActionExpiry(nextProps.comment);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var comment = this.props.comment;
            var classes = (0, _clsx2.default)({
                comment: true,
                'comment--comment-pane': this.props.commentLocation === 'pane',
                'comment--spacious': this.props.hasExtraPadding,
                'comment--highlight': this.isHighlighted(),
                'comment--sending': this.props.status === 'saving',
                'comment--deleting': this.props.status === 'deleting',
                'comment--error': this.props.status === 'error',
                'comment--annotation': comment.annotation && this.props.canShowAnnotationMarker,
                'comment--deleted': comment.isDeleted
            });

            return _react2.default.createElement(
                _CSSTransition2.default,
                {
                    classNames: 'collapsible-',
                    'in': this.state.isVisible,
                    timeout: 500,
                    onExit: this.setMaxHeightBeforeAnimatingOut,
                    onExiting: function onExiting() {
                        if (_this2.props.commentLocation === 'pane') {
                            _this2.setState({ maxHeight: 0 });
                        }
                    },
                    onExited: function onExited() {
                        return _this2.handleDelete();
                    }
                },
                _react2.default.createElement(
                    'div',
                    { className: 'collapsible', style: { maxHeight: this.state.maxHeight } },
                    _react2.default.createElement(
                        'div',
                        { ref: this.element, className: classes, onClick: this.handleClick },
                        this.visibleHeader(),
                        this.deletedAlert(),
                        _react2.default.createElement(
                            'div',
                            { className: 'comment__body' },
                            this.getCommentBodyElement(this.props.comment, this.props.status)
                        ),
                        this.commentActions()
                    )
                )
            );
        }

        // Handles cases where the permission to complete an action expires after render

    }, {
        key: 'setActionExpiry',
        value: function setActionExpiry(comment) {
            var _this3 = this;

            var newState = {};

            ['Edit', 'Delete'].forEach(function (name) {
                // State is temporary, props are the source of truth.
                // If the props say permission is denied,
                // there's no need for our state and timers
                if (!(0, _propertyOrNull2.default)(comment.permissions, 'can' + name) && _this3.state['is' + name + 'ActionBlocked']) {
                    newState['is' + name + 'ActionBlocked'] = false;
                    window.clearTimeout(_this3[name.toLowerCase() + 'ActionTimeout']);
                }

                // If the incoming comment has an expiry, set a timer to modify the state
                if (parseInt((0, _propertyOrNull2.default)(comment.permission, 'secondsRemaining' + name), 10) > 0) {
                    _this3[name.toLowerCase() + 'ActionTimeout'] = window.setTimeout(function () {
                        // this syntax is due to a limitation in es6 template literals
                        var state = {};
                        state['is' + name + 'ActionBlocked'] = true;
                        _this3.setState(state);
                    }, comment.permission['secondsRemaining' + name] * 1000);
                }
            });

            // single combined state change for all actions to avoid re-renders
            this.setState(newState);
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            if (!this.props.isSelected) {
                this.context.executeAction(_designComments.selectDesignComment, { comment: this.props.comment });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(message) {
            var comment = Object.assign({}, this.props.comment, { message: message, creator: this.getUser() });

            if (this.props.comment.id) {
                this.context.executeAction(_designComments.updateDesignComment, {
                    comment: comment,
                    csrfToken: this.context.csrfToken
                });
            } else {
                this.context.executeAction(_designComments.createDesignComment, {
                    comment: comment,
                    design: this.props.design,
                    csrfToken: this.context.csrfToken,
                    selectCommentOnFinish: this.props.selectCommentAfterCreate
                });
            }
        }
    }, {
        key: 'handleCancel',
        value: function handleCancel() {
            if (this.props.comment.id) {
                this.context.executeAction(_designComments.cancelEditDesignComment, { comment: this.props.comment });
            } else {
                this.context.executeAction(_designComments.cancelEnterDesignComment, { comment: this.props.comment });
            }
        }
    }, {
        key: 'handleDelete',
        value: function handleDelete() {
            this.context.executeAction(_designComments.deleteDesignComment, {
                comment: this.props.comment,
                csrfToken: this.context.csrfToken
            });
        }
    }, {
        key: 'setMaxHeightBeforeAnimatingOut',
        value: function setMaxHeightBeforeAnimatingOut() {
            var _this4 = this;

            if (this.element.current) {
                var commentHeight = this.element.current.getBoundingClientRect().height;
                this.setState({ maxHeight: commentHeight + 'px' }, function () {
                    return _this4.setState({ isVisible: false });
                });
            }
        }
    }, {
        key: 'handleDeleteClick',
        value: function handleDeleteClick() {
            this.setState({ isVisible: false });
        }
    }, {
        key: 'handleEditClick',
        value: function handleEditClick() {
            this.context.executeAction(_designComments.editDesignComment, {
                comment: this.props.comment,
                editingLocation: this.props.commentLocation
            });
        }
    }, {
        key: 'getUser',
        value: function getUser() {
            return this.context.activeUser;
        }
    }, {
        key: 'getCommentForm',
        value: function getCommentForm(comment) {
            return _react2.default.createElement(_CommentForm2.default, {
                onSubmit: this.handleSubmit,
                onCancel: this.handleCancel,
                hasCancelButton: true,
                isAutoFocus: true,
                isVertical: true,
                comment: comment,
                criticalError: this.timeoutErrorMessage()
            });
        }
    }, {
        key: 'timeoutErrorMessage',
        value: function timeoutErrorMessage() {
            if ((this.hasEditActionTimedOut() || this.haveAllActionsTimedOut()) && this.props.status === 'editing') {
                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'comment_action_timeout' });
            }
        }
    }, {
        key: 'getCommentContent',
        value: function getCommentContent(comment, status) {
            if (status === 'saving' || status === 'error') {
                return comment.message.split('\n').map(function (item, i) {
                    return _react2.default.createElement(
                        'p',
                        { key: 'unsaved-comment#' + i },
                        item
                    );
                });
            } else {
                return _react2.default.createElement('div', {
                    dangerouslySetInnerHTML: { __html: comment.formattedMessage },
                    key: comment.id
                });
            }
        }
    }, {
        key: 'getCommentStatusElement',
        value: function getCommentStatusElement(comment, status) {
            if (status === 'error') {
                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'comment_error' });
            } else if (status === 'deleting') {
                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'comment_deleting' });
            } else if (status === 'saving') {
                return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'comment_sending' });
            } else {
                return _react2.default.createElement(_RelativeTime.RelativeTime, { date: comment.createdAt });
            }
        }
    }, {
        key: 'getCommentBodyElement',
        value: function getCommentBodyElement(comment, status) {
            if (status === 'editing' || status === 'creating') {
                return this.getCommentForm(comment);
            } else {
                return this.getCommentContent(comment, status);
            }
        }
    }, {
        key: 'hasEditActionTimedOut',
        value: function hasEditActionTimedOut() {
            return this.state.isEditActionBlocked;
        }
    }, {
        key: 'haveAllActionsTimedOut',
        value: function haveAllActionsTimedOut() {
            return this.state.isEditActionBlocked && this.state.isDeleteActionBlocked;
        }
    }, {
        key: 'isHighlighted',
        value: function isHighlighted() {
            return this.props.isSelected && this.props.canHighlight;
        }
    }, {
        key: 'commentActions',
        value: function commentActions() {
            var actions = [];
            var permissions = this.props.comment.permission;

            // there are a few scenarios where we skip actions.
            // Exit early if we meet any of those to simplify later conditionals
            if (!this.props.isSelected || !permissions.canDelete && !permissions.canEdit) {
                return null;
            }

            if (permissions.canEdit && !this.state.isEditActionBlocked) {
                actions.push(_react2.default.createElement(
                    _ButtonList.ButtonListItem,
                    { key: 'editButton' },
                    _react2.default.createElement(
                        _IconButton.IconButton,
                        {
                            variations: this.isHighlighted() ? [] : ['on-white'],
                            onClick: this.handleEditClick
                        },
                        _react2.default.createElement(_Icon.Icon, { type: 'edit-1' })
                    )
                ));
            }

            if (permissions.canDelete && !this.state.isDeleteActionBlocked) {
                actions.push(_react2.default.createElement(
                    _ButtonList.ButtonListItem,
                    { key: 'deleteButton' },
                    _react2.default.createElement(
                        _IconButton.IconButton,
                        {
                            variations: this.isHighlighted() ? [] : ['on-white'],
                            onClick: this.handleDeleteClick
                        },
                        _react2.default.createElement(_Icon.Icon, { type: 'trash-2' })
                    )
                ));
            }

            if (actions.length === 0) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'comment__footer' },
                _react2.default.createElement(
                    _ButtonList.ButtonList,
                    { variations: ['spacious'] },
                    actions
                )
            );
        }
    }, {
        key: 'visibleHeader',
        value: function visibleHeader() {
            if (this.props.isHeaderVisible) {
                return _react2.default.createElement(
                    'div',
                    { className: 'comment__header' },
                    _react2.default.createElement(
                        'div',
                        { className: 'comment__header__avatar' },
                        _react2.default.createElement(_Avatar.Avatar, {
                            user: this.props.comment.creator,
                            variations: ['block', 'extra-small']
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'comment__header__user' },
                        _react2.default.createElement(_DisplayName.DisplayName, { user: this.props.comment.creator })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'comment__header__status' },
                        this.getCommentStatusElement(this.props.comment, this.props.status)
                    )
                );
            }
        }
    }, {
        key: 'deletedAlert',
        value: function deletedAlert() {
            if (this.props.comment.isDeleted) {
                return _react2.default.createElement(
                    _Alert.Alert,
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'comment_deleted' })
                );
            }
        }
    }]);

    return Comment;
}(_react2.default.Component);

exports.default = Comment;


Comment.contextTypes = {
    executeAction: _propTypes2.default.func,
    activeUser: _propTypes2.default.object,
    csrfToken: _propTypes2.default.string
};

Comment.propTypes = {
    design: _propTypes2.default.object.isRequired,
    canHighlight: _propTypes2.default.bool,
    canShowAnnotationMarker: _propTypes2.default.bool,
    comment: _propTypes2.default.object,
    hasExtraPadding: _propTypes2.default.bool,
    isHeaderVisible: _propTypes2.default.bool,
    isSelected: _propTypes2.default.bool,
    status: _propTypes2.default.oneOf(['creating', 'editing', 'saving', 'deleting', 'error']),
    commentLocation: _propTypes2.default.oneOf(['pane', 'canvas']),
    selectCommentAfterCreate: _propTypes2.default.bool
};

Comment.defaultProps = {
    hasExtraPadding: false,
    isSelected: false,
    isHeaderVisible: true,
    canHighlight: true,
    canShowAnnotationMarker: true,
    commentLocation: 'pane'
};

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ScrollIntoViewElement = __webpack_require__(284);

var _Avatar = __webpack_require__(36);

var _CommentField = __webpack_require__(457);

var _reactIntl = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */


var CommentForm = function (_React$Component) {
    _inherits(CommentForm, _React$Component);

    function CommentForm(props) {
        _classCallCheck(this, CommentForm);

        var _this = _possibleConstructorReturn(this, (CommentForm.__proto__ || Object.getPrototypeOf(CommentForm)).call(this, props));

        _this.errorMessage = _this.errorMessage.bind(_this);
        return _this;
    }

    _createClass(CommentForm, [{
        key: 'errorMessage',
        value: function errorMessage() {
            if (!this.props.showErrorMessage) return null;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'comment_submit_failure' })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var submitButtonLabel = _react2.default.createElement('span', { className: 'icon icon--sent-1' });

            return _react2.default.createElement(
                _ScrollIntoViewElement.ScrollIntoViewElement,
                {
                    scrollingContainer: this.props.scrollingContainer,
                    isEnabled: true
                },
                this.errorMessage(),
                _react2.default.createElement(
                    'div',
                    { className: 'comment-submit', onClick: this.props.onClick },
                    this.props.author && _react2.default.createElement(
                        'div',
                        { className: 'comment-submit__avatar' },
                        _react2.default.createElement(_Avatar.Avatar, {
                            user: this.props.author,
                            variations: ['block', 'extra-small']
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'comment-submit__form' },
                        _react2.default.createElement(_CommentField.CommentField, {
                            placeholder: this.context.intl.formatMessage({
                                id: 'comment_form_placeholder'
                            }),
                            layout: this.props.isVertical ? 'vertical' : 'horizontal',
                            isAutoFocus: this.props.isAutoFocus,
                            submitButtonLabel: submitButtonLabel,
                            submitButtonTooltip: this.context.intl.formatMessage({
                                id: 'send_message_tooltip'
                            }),
                            cancelButtonLabel: this.context.intl.formatMessage({
                                id: 'comment_cancel'
                            }),
                            textValue: this.props.comment && this.props.comment.message,
                            hasCancelButton: this.props.hasCancelButton,
                            onCancel: this.props.onCancel,
                            onSubmit: this.props.onSubmit,
                            onKeyDown: this.props.onKeyDown,
                            onKeyUp: this.props.onKeyUp,
                            criticalError: this.props.criticalError,
                            hasFieldError: this.props.showErrorMessage
                        })
                    )
                )
            );
        }
    }]);

    return CommentForm;
}(_react2.default.Component);

exports.default = CommentForm;


CommentForm.contextTypes = {
    intl: _propTypes2.default.object
};

CommentForm.propTypes = {
    author: _propTypes2.default.object,
    comment: _propTypes2.default.object,
    isVertical: _propTypes2.default.bool,
    isAutoFocus: _propTypes2.default.bool,
    hasCancelButton: _propTypes2.default.bool,
    onCancel: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    onSubmit: _propTypes2.default.func,
    onKeyDown: _propTypes2.default.func,
    onKeyUp: _propTypes2.default.func,
    scrollingContainer: _propTypes2.default.object,
    showErrorMessage: _propTypes2.default.bool,
    criticalError: _propTypes2.default.object
};

CommentForm.defaultProps = {
    hasCancelButton: false,
    isAutoFocus: false,
    isVertical: false,
    onCancel: function onCancel() {},
    onClick: function onClick() {},
    onSubmit: function onSubmit() {},
    onKeyDown: function onKeyDown() {},
    onKeyUp: function onKeyUp() {}
};

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollIntoViewElement = __webpack_require__(456);

Object.defineProperty(exports, 'ScrollIntoViewElement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollIntoViewElement).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _IconButton = __webpack_require__(21);

var _Icon = __webpack_require__(8);

var _bemComponent = __webpack_require__(33);

var _bemComponent2 = _interopRequireDefault(_bemComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SidebarHeader = function (_React$Component) {
    _inherits(SidebarHeader, _React$Component);

    function SidebarHeader() {
        _classCallCheck(this, SidebarHeader);

        return _possibleConstructorReturn(this, (SidebarHeader.__proto__ || Object.getPrototypeOf(SidebarHeader)).apply(this, arguments));
    }

    _createClass(SidebarHeader, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'sidebar-header' },
                this.props.isCloseButtonEnabled && _react2.default.createElement(
                    'div',
                    { className: 'sidebar-header__close-button' },
                    _react2.default.createElement(
                        _IconButton.IconButton,
                        {
                            onClick: this.props.closeOverlayHandler,
                            variations: ['on-white']
                        },
                        _react2.default.createElement(_Icon.Icon, { type: 'x-3' })
                    )
                ),
                this.props.children
            );
        }
    }]);

    return SidebarHeader;
}(_react2.default.Component);

SidebarHeader.propTypes = {
    closeOverlayHandler: _propTypes2.default.func,
    isCloseButtonEnabled: _propTypes2.default.bool,
    children: _propTypes2.default.node
};

SidebarHeader.defaultProps = {
    closeOverlayHandler: null,
    isCloseButtonEnabled: true
};

exports.default = {
    Main: SidebarHeader,
    Heading: (0, _bemComponent2.default)('sidebar-header__heading'),
    HeadingText: (0, _bemComponent2.default)('sidebar-header__heading__text'),
    HeadingPill: (0, _bemComponent2.default)('sidebar-header__heading__pill'),
    SubHeading: (0, _bemComponent2.default)('sidebar-header__sub-heading'),
    Section: (0, _bemComponent2.default)('sidebar-header__section'),
    Description: (0, _bemComponent2.default)('sidebar-header__description'),
    DescriptionItem: (0, _bemComponent2.default)('sidebar-header__description__item')
};

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DdoCommentProps = exports.SelectedCommentEditingLocation = exports.SelectedCommentStatus = exports.SidebarPanes = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _consts = __webpack_require__(287);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarPanes = exports.SidebarPanes = _propTypes2.default.oneOf([_consts.SIDEBAR_PANE_DEFAULT, _consts.SIDEBAR_PANE_LIKES_LIST]);
var SelectedCommentStatus = exports.SelectedCommentStatus = _propTypes2.default.oneOf(['creating', 'editing', 'saving', 'deleting', 'error']);

var SelectedCommentEditingLocation = exports.SelectedCommentEditingLocation = _propTypes2.default.oneOf(['canvas', 'pane', null]);

var DdoCommentProps = exports.DdoCommentProps = {
    isLoadingComments: _propTypes2.default.bool.isRequired,
    comments: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    selectedComment: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    selectedCommentStatus: SelectedCommentStatus,
    selectedCommentEditingLocation: SelectedCommentEditingLocation
};

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Sidebar panes
var SIDEBAR_PANE_DEFAULT = exports.SIDEBAR_PANE_DEFAULT = 'default';
var SIDEBAR_PANE_LIKES_LIST = exports.SIDEBAR_PANE_LIKES_LIST = 'likes';

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(28);

var _ChildMapping = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

!function(root, factory) {
     true ? module.exports = factory(__webpack_require__(0)) : "function" == typeof define && define.amd ? define([ "react" ], factory) : "object" == typeof exports ? exports.MediaQuery = factory(require("react")) : root.MediaQuery = factory(root.react);
}("undefined" != typeof self ? self : this, function(__WEBPACK_EXTERNAL_MODULE_6__) {
    return function(modules) {
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
            module.l = !0, module.exports;
        }
        var installedModules = {};
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                configurable: !1,
                enumerable: !0,
                get: getter
            });
        }, __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function() {
                return module.default;
            } : function() {
                return module;
            };
            return __webpack_require__.d(getter, "a", getter), getter;
        }, __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 5);
    }([ function(module, exports, __webpack_require__) {
        var ReactIs = __webpack_require__(1);
        module.exports = __webpack_require__(8)(ReactIs.isElement, !0);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        module.exports = __webpack_require__(7);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function toHyphenLower(match) {
            return "-" + match.toLowerCase();
        }
        function hyphenateStyleName(name) {
            if (cache.hasOwnProperty(name)) return cache[name];
            var hName = name.replace(uppercasePattern, toHyphenLower);
            return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
        }
        var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
        __webpack_exports__.a = hyphenateStyleName;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {}, ownKeys = Object.keys(source);
                "function" == typeof Object.getOwnPropertySymbols && (ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                }))), ownKeys.forEach(function(key) {
                    _defineProperty(target, key, source[key]);
                });
            }
            return target;
        }
        function _defineProperty(obj, key, value) {
            return key in obj ? Object.defineProperty(obj, key, {
                value: value,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : obj[key] = value, obj;
        }
        var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0), __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__), stringOrNumber = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([ __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number ]), matchers = {
            orientation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([ "portrait", "landscape" ]),
            scan: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([ "progressive", "interlace" ]),
            aspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            deviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            height: stringOrNumber,
            deviceHeight: stringOrNumber,
            width: stringOrNumber,
            deviceWidth: stringOrNumber,
            color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            colorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            monochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            resolution: stringOrNumber
        }, features = _objectSpread({
            minAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            maxAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            minDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            maxDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            minHeight: stringOrNumber,
            maxHeight: stringOrNumber,
            minDeviceHeight: stringOrNumber,
            maxDeviceHeight: stringOrNumber,
            minWidth: stringOrNumber,
            maxWidth: stringOrNumber,
            minDeviceWidth: stringOrNumber,
            maxDeviceWidth: stringOrNumber,
            minColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            maxColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            minColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            maxColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            minMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            maxMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            minResolution: stringOrNumber,
            maxResolution: stringOrNumber
        }, matchers), types = {
            all: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            grid: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            aural: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            braille: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            handheld: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            print: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            projection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            screen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            tty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            tv: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            embossed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
        }, all = _objectSpread({}, types, features);
        matchers.type = Object.keys(types), __webpack_exports__.a = {
            all: all,
            types: types,
            matchers: matchers,
            features: features
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function _typeof(obj) {
            return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            })(obj);
        }
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function _createClass(Constructor, protoProps, staticProps) {
            return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), 
            Constructor;
        }
        function _possibleConstructorReturn(self, call) {
            return !call || "object" !== _typeof(call) && "function" != typeof call ? _assertThisInitialized(self) : call;
        }
        function _getPrototypeOf(o) {
            return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            })(o);
        }
        function _assertThisInitialized(self) {
            if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self;
        }
        function _inherits(subClass, superClass) {
            if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    writable: !0,
                    configurable: !0
                }
            }), superClass && _setPrototypeOf(subClass, superClass);
        }
        function _setPrototypeOf(o, p) {
            return (_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                return o.__proto__ = p, o;
            })(o, p);
        }
        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {}, ownKeys = Object.keys(source);
                "function" == typeof Object.getOwnPropertySymbols && (ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                }))), ownKeys.forEach(function(key) {
                    _defineProperty(target, key, source[key]);
                });
            }
            return target;
        }
        function _defineProperty(obj, key, value) {
            return key in obj ? Object.defineProperty(obj, key, {
                value: value,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : obj[key] = value, obj;
        }
        Object.defineProperty(__webpack_exports__, "__esModule", {
            value: !0
        }), __webpack_require__.d(__webpack_exports__, "default", function() {
            return MediaQuery;
        });
        var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(6), __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__), __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0), __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__), __WEBPACK_IMPORTED_MODULE_2_matchmediaquery__ = __webpack_require__(11), __WEBPACK_IMPORTED_MODULE_2_matchmediaquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_matchmediaquery__), __WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name__ = __webpack_require__(3), __WEBPACK_IMPORTED_MODULE_4__mediaQuery__ = __webpack_require__(4), __WEBPACK_IMPORTED_MODULE_5__toQuery__ = __webpack_require__(13);
        __webpack_require__.d(__webpack_exports__, "toQuery", function() {
            return __WEBPACK_IMPORTED_MODULE_5__toQuery__.a;
        });
        var defaultTypes = {
            component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
            query: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
            values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_4__mediaQuery__.a.matchers),
            children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([ __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func ]),
            onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
        }, excludedQueryKeys = Object.keys(defaultTypes), omit = function(object, keys) {
            var newObject = _objectSpread({}, object);
            return keys.forEach(function(key) {
                return delete newObject[key];
            }), newObject;
        }, getValues = function(_ref) {
            var values = _ref.values;
            if (!values) return null;
            var keys = Object.keys(values);
            return 0 === keys.length ? null : keys.reduce(function(result, key) {
                return result[Object(__WEBPACK_IMPORTED_MODULE_3_hyphenate_style_name__.a)(key)] = values[key], 
                result;
            }, {});
        }, getQuery = function(props) {
            return props.query || Object(__WEBPACK_IMPORTED_MODULE_5__toQuery__.a)(omit(props, excludedQueryKeys));
        }, MediaQuery = function(_React$Component) {
            function MediaQuery() {
                var _getPrototypeOf2, _this;
                _classCallCheck(this, MediaQuery);
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                return _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MediaQuery)).call.apply(_getPrototypeOf2, [ this ].concat(args))), 
                _defineProperty(_assertThisInitialized(_this), "state", {
                    matches: !1,
                    mq: null,
                    query: "",
                    values: null
                }), _defineProperty(_assertThisInitialized(_this), "componentDidMount", function() {
                    _this.state.mq.addListener(_this.updateMatches), _this.updateMatches();
                }), _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function(prevProps, prevState) {
                    _this.state.mq !== prevState.mq && (_this.cleanupMediaQuery(prevState.mq), _this.state.mq.addListener(_this.updateMatches)), 
                    _this.props.onChange && prevState.matches !== _this.state.matches && _this.props.onChange(_this.state.matches);
                }), _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function() {
                    _this._unmounted = !0, _this.cleanupMediaQuery(_this.state.mq);
                }), _defineProperty(_assertThisInitialized(_this), "cleanupMediaQuery", function(mq) {
                    mq && (mq.removeListener(_this.updateMatches), mq.dispose());
                }), _defineProperty(_assertThisInitialized(_this), "updateMatches", function() {
                    _this._unmounted || _this.state.mq.matches !== _this.state.matches && _this.setState({
                        matches: _this.state.mq.matches
                    });
                }), _defineProperty(_assertThisInitialized(_this), "render", function() {
                    return "function" == typeof _this.props.children ? _this.props.children(_this.state.matches) : _this.state.matches ? _this.props.children : null;
                }), _this;
            }
            return _inherits(MediaQuery, _React$Component), _createClass(MediaQuery, null, [ {
                key: "getDerivedStateFromProps",
                value: function(props, state) {
                    var query = getQuery(props);
                    if (!query) throw new Error("Invalid or missing MediaQuery!");
                    var values = getValues(props);
                    if (query === state.query && values === state.values) return null;
                    var mq = __WEBPACK_IMPORTED_MODULE_2_matchmediaquery___default()(query, values || {}, !!values);
                    return {
                        matches: mq.matches,
                        mq: mq,
                        query: query,
                        values: values
                    };
                }
            } ]), MediaQuery;
        }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
        _defineProperty(MediaQuery, "displayName", "MediaQuery"), _defineProperty(MediaQuery, "defaultProps", {
            values: null
        });
    }, function(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_6__;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        !function() {
            function isValidElementType(type) {
                return "string" == typeof type || "function" == typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || "object" == typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
            }
            function typeOf(object) {
                if ("object" == typeof object && null !== object) {
                    var $$typeof = object.$$typeof;
                    switch ($$typeof) {
                      case REACT_ELEMENT_TYPE:
                        var type = object.type;
                        switch (type) {
                          case REACT_ASYNC_MODE_TYPE:
                          case REACT_CONCURRENT_MODE_TYPE:
                          case REACT_FRAGMENT_TYPE:
                          case REACT_PROFILER_TYPE:
                          case REACT_STRICT_MODE_TYPE:
                          case REACT_SUSPENSE_TYPE:
                            return type;

                          default:
                            var $$typeofType = type && type.$$typeof;
                            switch ($$typeofType) {
                              case REACT_CONTEXT_TYPE:
                              case REACT_FORWARD_REF_TYPE:
                              case REACT_PROVIDER_TYPE:
                                return $$typeofType;

                              default:
                                return $$typeof;
                            }
                        }

                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PORTAL_TYPE:
                        return $$typeof;
                    }
                }
            }
            function isAsyncMode(object) {
                return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = !0, 
                lowPriorityWarning$1(!1, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), 
                isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
            }
            function isConcurrentMode(object) {
                return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
            }
            function isContextConsumer(object) {
                return typeOf(object) === REACT_CONTEXT_TYPE;
            }
            function isContextProvider(object) {
                return typeOf(object) === REACT_PROVIDER_TYPE;
            }
            function isElement(object) {
                return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
            }
            function isForwardRef(object) {
                return typeOf(object) === REACT_FORWARD_REF_TYPE;
            }
            function isFragment(object) {
                return typeOf(object) === REACT_FRAGMENT_TYPE;
            }
            function isLazy(object) {
                return typeOf(object) === REACT_LAZY_TYPE;
            }
            function isMemo(object) {
                return typeOf(object) === REACT_MEMO_TYPE;
            }
            function isPortal(object) {
                return typeOf(object) === REACT_PORTAL_TYPE;
            }
            function isProfiler(object) {
                return typeOf(object) === REACT_PROFILER_TYPE;
            }
            function isStrictMode(object) {
                return typeOf(object) === REACT_STRICT_MODE_TYPE;
            }
            function isSuspense(object) {
                return typeOf(object) === REACT_SUSPENSE_TYPE;
            }
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
            var hasSymbol = "function" == typeof Symbol && Symbol.for, REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103, REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106, REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107, REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108, REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114, REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109, REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110, REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111, REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111, REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112, REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113, REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115, REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116, lowPriorityWarning = function() {}, printWarning = function(format) {
                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
                var argIndex = 0, message = "Warning: " + format.replace(/%s/g, function() {
                    return args[argIndex++];
                });
                "undefined" != typeof console && console.warn(message);
                try {
                    throw new Error(message);
                } catch (x) {}
            };
            lowPriorityWarning = function(condition, format) {
                if (void 0 === format) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");
                if (!condition) {
                    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) args[_key2 - 2] = arguments[_key2];
                    printWarning.apply(void 0, [ format ].concat(args));
                }
            };
            var lowPriorityWarning$1 = lowPriorityWarning, AsyncMode = REACT_ASYNC_MODE_TYPE, ConcurrentMode = REACT_CONCURRENT_MODE_TYPE, ContextConsumer = REACT_CONTEXT_TYPE, ContextProvider = REACT_PROVIDER_TYPE, Element = REACT_ELEMENT_TYPE, ForwardRef = REACT_FORWARD_REF_TYPE, Fragment = REACT_FRAGMENT_TYPE, Lazy = REACT_LAZY_TYPE, Memo = REACT_MEMO_TYPE, Portal = REACT_PORTAL_TYPE, Profiler = REACT_PROFILER_TYPE, StrictMode = REACT_STRICT_MODE_TYPE, Suspense = REACT_SUSPENSE_TYPE, hasWarnedAboutDeprecatedIsAsyncMode = !1;
            exports.typeOf = typeOf, exports.AsyncMode = AsyncMode, exports.ConcurrentMode = ConcurrentMode, 
            exports.ContextConsumer = ContextConsumer, exports.ContextProvider = ContextProvider, 
            exports.Element = Element, exports.ForwardRef = ForwardRef, exports.Fragment = Fragment, 
            exports.Lazy = Lazy, exports.Memo = Memo, exports.Portal = Portal, exports.Profiler = Profiler, 
            exports.StrictMode = StrictMode, exports.Suspense = Suspense, exports.isValidElementType = isValidElementType, 
            exports.isAsyncMode = isAsyncMode, exports.isConcurrentMode = isConcurrentMode, 
            exports.isContextConsumer = isContextConsumer, exports.isContextProvider = isContextProvider, 
            exports.isElement = isElement, exports.isForwardRef = isForwardRef, exports.isFragment = isFragment, 
            exports.isLazy = isLazy, exports.isMemo = isMemo, exports.isPortal = isPortal, exports.isProfiler = isProfiler, 
            exports.isStrictMode = isStrictMode, exports.isSuspense = isSuspense;
        }();
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function emptyFunctionThatReturnsNull() {
            return null;
        }
        var ReactIs = __webpack_require__(1), assign = __webpack_require__(9), ReactPropTypesSecret = __webpack_require__(2), checkPropTypes = __webpack_require__(10), has = Function.call.bind(Object.prototype.hasOwnProperty), printWarning = function() {};
        printWarning = function(text) {
            var message = "Warning: " + text;
            "undefined" != typeof console && console.error(message);
            try {
                throw new Error(message);
            } catch (x) {}
        }, module.exports = function(isValidElement, throwOnDirectAccess) {
            function getIteratorFn(maybeIterable) {
                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                if ("function" == typeof iteratorFn) return iteratorFn;
            }
            function is(x, y) {
                return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
            }
            function PropTypeError(message) {
                this.message = message, this.stack = "";
            }
            function createChainableTypeChecker(validate) {
                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                    if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, 
                    secret !== ReactPropTypesSecret) {
                        if (throwOnDirectAccess) {
                            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                            throw err.name = "Invariant Violation", err;
                        }
                        if ("undefined" != typeof console) {
                            var cacheKey = componentName + ":" + propName;
                            !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), 
                            manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
                        }
                    }
                    return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
                }
                var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, !1);
                return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
            }
            function createPrimitiveTypeChecker(expectedType) {
                function validate(props, propName, componentName, location, propFullName, secret) {
                    var propValue = props[propName];
                    if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createArrayOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                    var propValue = props[propName];
                    if (!Array.isArray(propValue)) {
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
                    }
                    for (var i = 0; i < propValue.length; i++) {
                        var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                        if (error instanceof Error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createInstanceTypeChecker(expectedClass) {
                function validate(props, propName, componentName, location, propFullName) {
                    if (!(props[propName] instanceof expectedClass)) {
                        var expectedClassName = expectedClass.name || ANONYMOUS;
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createEnumTypeChecker(expectedValues) {
                function validate(props, propName, componentName, location, propFullName) {
                    for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
                    var valuesString = JSON.stringify(expectedValues, function(key, value) {
                        return "symbol" === getPreciseType(value) ? String(value) : value;
                    });
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` supplied to `" + componentName + "`, expected one of " + valuesString + ".");
                }
                return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (printWarning(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), 
                emptyFunctionThatReturnsNull);
            }
            function createObjectOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
                    for (var key in propValue) if (has(propValue, key)) {
                        var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                        if (error instanceof Error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createUnionTypeChecker(arrayOfTypeCheckers) {
                function validate(props, propName, componentName, location, propFullName) {
                    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                        if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
                    }
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
                }
                if (!Array.isArray(arrayOfTypeCheckers)) return printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), 
                emptyFunctionThatReturnsNull;
                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                    var checker = arrayOfTypeCheckers[i];
                    if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), 
                    emptyFunctionThatReturnsNull;
                }
                return createChainableTypeChecker(validate);
            }
            function createShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                    for (var key in shapeTypes) {
                        var checker = shapeTypes[key];
                        if (checker) {
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createStrictShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                    var allKeys = assign({}, props[propName], shapeTypes);
                    for (var key in allKeys) {
                        var checker = shapeTypes[key];
                        if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                        var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                        if (error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function isNode(propValue) {
                switch (typeof propValue) {
                  case "number":
                  case "string":
                  case "undefined":
                    return !0;

                  case "boolean":
                    return !propValue;

                  case "object":
                    if (Array.isArray(propValue)) return propValue.every(isNode);
                    if (null === propValue || isValidElement(propValue)) return !0;
                    var iteratorFn = getIteratorFn(propValue);
                    if (!iteratorFn) return !1;
                    var step, iterator = iteratorFn.call(propValue);
                    if (iteratorFn !== propValue.entries) {
                        for (;!(step = iterator.next()).done; ) if (!isNode(step.value)) return !1;
                    } else for (;!(step = iterator.next()).done; ) {
                        var entry = step.value;
                        if (entry && !isNode(entry[1])) return !1;
                    }
                    return !0;

                  default:
                    return !1;
                }
            }
            function isSymbol(propType, propValue) {
                return "symbol" === propType || !!propValue && ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
            }
            function getPropType(propValue) {
                var propType = typeof propValue;
                return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
            }
            function getPreciseType(propValue) {
                if (void 0 === propValue || null === propValue) return "" + propValue;
                var propType = getPropType(propValue);
                if ("object" === propType) {
                    if (propValue instanceof Date) return "date";
                    if (propValue instanceof RegExp) return "regexp";
                }
                return propType;
            }
            function getPostfixForTypeWarning(value) {
                var type = getPreciseType(value);
                switch (type) {
                  case "array":
                  case "object":
                    return "an " + type;

                  case "boolean":
                  case "date":
                  case "regexp":
                    return "a " + type;

                  default:
                    return type;
                }
            }
            function getClassName(propValue) {
                return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
            }
            var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
                array: createPrimitiveTypeChecker("array"),
                bool: createPrimitiveTypeChecker("boolean"),
                func: createPrimitiveTypeChecker("function"),
                number: createPrimitiveTypeChecker("number"),
                object: createPrimitiveTypeChecker("object"),
                string: createPrimitiveTypeChecker("string"),
                symbol: createPrimitiveTypeChecker("symbol"),
                any: function() {
                    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                }(),
                arrayOf: createArrayOfTypeChecker,
                element: function() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!isValidElement(propValue)) {
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }(),
                elementType: function() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!ReactIs.isValidElementType(propValue)) {
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement type.");
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }(),
                instanceOf: createInstanceTypeChecker,
                node: function() {
                    function validate(props, propName, componentName, location, propFullName) {
                        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
                    }
                    return createChainableTypeChecker(validate);
                }(),
                objectOf: createObjectOfTypeChecker,
                oneOf: createEnumTypeChecker,
                oneOfType: createUnionTypeChecker,
                shape: createShapeTypeChecker,
                exact: createStrictShapeTypeChecker
            };
            return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, 
            ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache, ReactPropTypes.PropTypes = ReactPropTypes, 
            ReactPropTypes;
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function toObject(val) {
            if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(val);
        }
        /*
object-assign
(c) Sindre Sorhus
@license MIT
*/
        var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
        module.exports = function() {
            try {
                if (!Object.assign) return !1;
                var test1 = new String("abc");
                if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
                for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
                if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
                    return test2[n];
                }).join("")) return !1;
                var test3 = {};
                return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                    test3[letter] = letter;
                }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
            } catch (err) {
                return !1;
            }
        }() ? Object.assign : function(target, source) {
            for (var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++) {
                from = Object(arguments[s]);
                for (var key in from) hasOwnProperty.call(from, key) && (to[key] = from[key]);
                if (getOwnPropertySymbols) {
                    symbols = getOwnPropertySymbols(from);
                    for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
                }
            }
            return to;
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
            for (var typeSpecName in typeSpecs) if (has(typeSpecs, typeSpecName)) {
                var error;
                try {
                    if ("function" != typeof typeSpecs[typeSpecName]) {
                        var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
                        throw err.name = "Invariant Violation", err;
                    }
                    error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                } catch (ex) {
                    error = ex;
                }
                if (!error || error instanceof Error || printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), 
                error instanceof Error && !(error.message in loggedTypeFailures)) {
                    loggedTypeFailures[error.message] = !0;
                    var stack = getStack ? getStack() : "";
                    printWarning("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
                }
            }
        }
        var printWarning = function() {}, ReactPropTypesSecret = __webpack_require__(2), loggedTypeFailures = {}, has = Function.call.bind(Object.prototype.hasOwnProperty);
        printWarning = function(text) {
            var message = "Warning: " + text;
            "undefined" != typeof console && console.error(message);
            try {
                throw new Error(message);
            } catch (x) {}
        }, checkPropTypes.resetWarningCache = function() {
            loggedTypeFailures = {};
        }, module.exports = checkPropTypes;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function Mql(query, values, forceStatic) {
            function addListener(listener) {
                mql && mql.addListener(listener);
            }
            function removeListener(listener) {
                mql && mql.removeListener(listener);
            }
            function update(evt) {
                self.matches = evt.matches, self.media = evt.media;
            }
            function dispose() {
                mql && mql.removeListener(update);
            }
            var self = this;
            if (dynamicMatch && !forceStatic) {
                var mql = dynamicMatch.call(window, query);
                this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
            } else this.matches = staticMatch(query, values), this.media = query;
            this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
        }
        function matchMedia(query, values, forceStatic) {
            return new Mql(query, values, forceStatic);
        }
        var staticMatch = __webpack_require__(12).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
        module.exports = matchMedia;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function matchQuery(mediaQuery, values) {
            return parseQuery(mediaQuery).some(function(query) {
                var inverse = query.inverse, typeMatch = "all" === query.type || values.type === query.type;
                if (typeMatch && inverse || !typeMatch && !inverse) return !1;
                var expressionsMatch = query.expressions.every(function(expression) {
                    var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
                    if (!value) return !1;
                    switch (feature) {
                      case "orientation":
                      case "scan":
                        return value.toLowerCase() === expValue.toLowerCase();

                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        expValue = toPx(expValue), value = toPx(value);
                        break;

                      case "resolution":
                        expValue = toDpi(expValue), value = toDpi(value);
                        break;

                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case "device-pixel-ratio":
                        expValue = toDecimal(expValue), value = toDecimal(value);
                        break;

                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
                    }
                    switch (modifier) {
                      case "min":
                        return value >= expValue;

                      case "max":
                        return value <= expValue;

                      default:
                        return value === expValue;
                    }
                });
                return expressionsMatch && !inverse || !expressionsMatch && inverse;
            });
        }
        function parseQuery(mediaQuery) {
            return mediaQuery.split(",").map(function(query) {
                query = query.trim();
                var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
                return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", 
                expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
                    var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                    return {
                        modifier: feature[1],
                        feature: feature[2],
                        value: captures[2]
                    };
                }), parsed;
            });
        }
        function toDecimal(ratio) {
            var numbers, decimal = Number(ratio);
            return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), 
            decimal;
        }
        function toDpi(resolution) {
            var value = parseFloat(resolution);
            switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
              case "dpcm":
                return value / 2.54;

              case "dppx":
                return 96 * value;

              default:
                return value;
            }
        }
        function toPx(length) {
            var value = parseFloat(length);
            switch (String(length).match(RE_LENGTH_UNIT)[1]) {
              case "em":
              case "rem":
                return 16 * value;

              case "cm":
                return 96 * value / 2.54;

              case "mm":
                return 96 * value / 2.54 / 10;

              case "in":
                return 96 * value;

              case "pt":
                return 72 * value;

              case "pc":
                return 72 * value / 12;

              default:
                return value;
            }
        }
        exports.match = matchQuery, exports.parse = parseQuery;
        var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function keyVal(k, v) {
            var realKey = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__.a)(k);
            return "number" == typeof v && (v = "".concat(v, "px")), !0 === v ? k : !1 === v ? negate(k) : "(".concat(realKey, ": ").concat(v, ")");
        }
        function join(conds) {
            return conds.join(" and ");
        }
        var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(3), __WEBPACK_IMPORTED_MODULE_1__mediaQuery__ = __webpack_require__(4), negate = function(cond) {
            return "not ".concat(cond);
        };
        __webpack_exports__.a = function(obj) {
            var rules = [];
            return Object.keys(__WEBPACK_IMPORTED_MODULE_1__mediaQuery__.a.all).forEach(function(k) {
                var v = obj[k];
                null != v && rules.push(keyVal(k, v));
            }), join(rules);
        };
    } ]);
});
//# sourceMappingURL=react-responsive.js.map

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _getComponentClasses = __webpack_require__(13);

var _getComponentClasses2 = _interopRequireDefault(_getComponentClasses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var bemComponent = function bemComponent(baseClassName) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Block';

    var BemComponent = _react2.default.forwardRef(function (_a, ref) {
        var variations = _a.variations,
            className = _a.className,
            props = __rest(_a, ["variations", "className"]);

        return _react2.default.createElement("div", Object.assign({ className: (0, _getComponentClasses2.default)(baseClassName, variations, className), ref: ref }, props));
    });
    BemComponent.displayName = displayName;
    return BemComponent;
};
exports.default = bemComponent;

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = assignProps;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function assignProps(Component, props) {
    var AssignProps = function AssignProps(thisProps) {
        var allProps = Object.assign({}, props, thisProps);
        return _react2.default.createElement(Component, Object.assign({}, allProps));
    };
    AssignProps.displayName = 'assignProps(' + (Component.displayName || Component.name) + ')';
    return AssignProps;
}

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Avatar = __webpack_require__(109);

Object.keys(_Avatar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Avatar[key];
    }
  });
});

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(60));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(76));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(30));

var _Transition = _interopRequireDefault(__webpack_require__(27));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    small: [0, 599],
    medium: [600, 899],
    normal: [900, 1299],
    large: [1300, null]
};

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deprecated;
function deprecated(message) {
    if (false) {
        console.warn('DEPRECATED: ' + message); //eslint-disable-line no-console
    }
}

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = filterObjectByKeys;
function filterObjectByKeys(obj, allowedKeys) {
    var result = {};
    Object.keys(obj).forEach(function (k) {
        if (allowedKeys.indexOf(k) !== -1) {
            result[k] = obj[k];
        }
    });
    return result;
}

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonGroup = __webpack_require__(69);

Object.defineProperty(exports, 'ButtonGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonGroup).default;
  }
});
Object.defineProperty(exports, 'ButtonGroupItem', {
  enumerable: true,
  get: function get() {
    return _ButtonGroup.ButtonGroupItem;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = ddo;

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _connectToStores = __webpack_require__(91);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _urijs = __webpack_require__(417);

var _urijs2 = _interopRequireDefault(_urijs);

var _getCsrfToken = __webpack_require__(418);

var _getCsrfToken2 = _interopRequireDefault(_getCsrfToken);

var _DesignCollectionStore = __webpack_require__(170);

var _DesignCollectionStore2 = _interopRequireDefault(_DesignCollectionStore);

var _DesignCommentsStore = __webpack_require__(117);

var _DesignCommentsStore2 = _interopRequireDefault(_DesignCommentsStore);

var _DesignSketchesStore = __webpack_require__(138);

var _DesignSketchesStore2 = _interopRequireDefault(_DesignSketchesStore);

var _AppComponent = __webpack_require__(421);

var _AppComponent2 = _interopRequireDefault(_AppComponent);

var _setDesignData2 = __webpack_require__(462);

var _designComments = __webpack_require__(139);

var _designSketches = __webpack_require__(208);

var _user = __webpack_require__(209);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// stores


// actions


function ddo(_ref) {
    var fluxibleApp = _ref.fluxibleApp,
        fluxibleContext = _ref.fluxibleContext,
        _ref$activeUser = _ref.activeUser,
        activeUser = _ref$activeUser === undefined ? {} : _ref$activeUser,
        _ref$designCollection = _ref.designCollection,
        designCollection = _ref$designCollection === undefined ? null : _ref$designCollection,
        _ref$isInline = _ref.isInline,
        isInline = _ref$isInline === undefined ? false : _ref$isInline,
        _ref$models = _ref.models,
        models = _ref$models === undefined ? {} : _ref$models,
        _ref$goBack = _ref.goBack,
        goBack = _ref$goBack === undefined ? function () {
        return undefined;
    } : _ref$goBack,
        _ref$goTo = _ref.goTo,
        goTo = _ref$goTo === undefined ? function () {
        return undefined;
    } : _ref$goTo,
        _ref$csrfToken = _ref.csrfToken,
        csrfToken = _ref$csrfToken === undefined ? null : _ref$csrfToken;

    [_DesignCollectionStore2.default, _DesignCommentsStore2.default, _DesignSketchesStore2.default].map(fluxibleApp.registerStore, fluxibleApp);

    fluxibleContext.getStore(_DesignCommentsStore2.default).setModel(models.designComment);
    fluxibleContext.getStore(_DesignCommentsStore2.default).setCollectionModel(models.designCommentCollection);
    fluxibleContext.getStore(_DesignCollectionStore2.default).setModel(models.design);
    fluxibleContext.getStore(_DesignCollectionStore2.default).setCollectionModel(models.designCollection);

    if (designCollection) {
        fluxibleContext.getStore(_DesignCollectionStore2.default).setDesignCollection(designCollection);
    }

    var ConnectedAppComponent = (0, _connectToStores2.default)(_AppComponent2.default, [_DesignCollectionStore2.default, _DesignCommentsStore2.default], function (ctx, props) {
        var collectionStore = ctx.getStore(_DesignCollectionStore2.default);
        var design = collectionStore.getDesign(props.designId);
        var nextDesign = collectionStore.getNextDesign(props.designId);
        var previousDesign = collectionStore.getPreviousDesign(props.designId);

        if (window.Bugsnag && !design) {
            window.Bugsnag.notify('ddo-missing-design', 'DDO missing designid: ' + props.designId, {
                designId: props.designId,
                len: collectionStore.designs.length,
                designs: JSON.stringify(collectionStore.designs.map(function (d) {
                    return d.designId;
                }))
            });
        }

        return {
            design: design,
            nextPageUrl: collectionStore.nextPageUrl,
            prevPageUrl: collectionStore.prevPageUrl,
            previousDesign: previousDesign,
            nextDesign: nextDesign,
            selectedComment: ctx.getStore(_DesignCommentsStore2.default).selectedComment,
            isInline: isInline,
            isTransitioning: props.isTransitioning,
            goBack: goBack,
            goToNext: function goToNext() {
                props.setTransitioning(true);
                if (!nextDesign) return;
                ctx.executeAction(_designComments.resetComments, {
                    callback: function callback() {
                        return goTo((0, _urijs2.default)(nextDesign.showUrl).resource());
                    }
                });
            },
            goToPrevious: function goToPrevious() {
                props.setTransitioning(true);
                if (!previousDesign) return;
                ctx.executeAction(_designComments.resetComments, {
                    callback: function callback() {
                        return goTo((0, _urijs2.default)(previousDesign.showUrl).resource());
                    }
                });
            },
            clearDesignCommentSelection: function clearDesignCommentSelection() {
                ctx.executeAction(_designComments.resetSelectedComment);
            }
        };
    }, {
        executeAction: _propTypes2.default.func
    });

    var DdoComponent = function (_Component) {
        _inherits(DdoComponent, _Component);

        function DdoComponent(props) {
            _classCallCheck(this, DdoComponent);

            var _this = _possibleConstructorReturn(this, (DdoComponent.__proto__ || Object.getPrototypeOf(DdoComponent)).call(this, props));

            _this.state = {
                isTransitioning: false
            };

            _this.setTransitioning = _this.setTransitioning.bind(_this);
            return _this;
        }

        _createClass(DdoComponent, [{
            key: 'getChildContext',
            value: function getChildContext() {
                return {
                    activeUser: _user2.default.fromJSON(activeUser),
                    csrfToken: csrfToken || (0, _getCsrfToken2.default)(),
                    scribblesEnabled: true
                };
            }
        }, {
            key: 'UNSAFE_componentWillReceiveProps',
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.designId !== this.props.designId) {
                    this.setDesign(nextProps.designId);
                    this.setTransitioning(false);
                }
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.setDesign(this.props.designId);
            }
        }, {
            key: 'setDesign',
            value: function setDesign(designId) {
                this.context.executeAction(_setDesignData2.loadDesign, designId);
                this.context.executeAction(_setDesignData2.loadMoreDesigns, designId);
                this.context.executeAction(_designComments.resetComments);

                var design = this.context.getStore(_DesignCollectionStore2.default).getDesign(designId);

                if (design.links.comments && design.permission.canViewComments) {
                    this.context.executeAction(_designComments.loadDesignComments, {
                        commentsUrl: design.links.comments,
                        designId: design.designId
                    });
                }

                if (design.links.sketches && design.permission.canViewSketches) {
                    this.context.executeAction(_designSketches.loadDesignSketches, {
                        loadDesignSketchesUrl: design.links.sketches,
                        designId: design.designId
                    });
                }
            }
        }, {
            key: 'setTransitioning',
            value: function setTransitioning(isTransitioning) {
                this.setState({ isTransitioning: isTransitioning });
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(ConnectedAppComponent, _extends({}, this.props, {
                    setTransitioning: this.setTransitioning,
                    isTransitioning: this.state.isTransitioning
                }));
            }
        }]);

        return DdoComponent;
    }(_react.Component);

    DdoComponent.propTypes = {
        designId: _propTypes2.default.string.isRequired
    };

    DdoComponent.contextTypes = {
        executeAction: _propTypes2.default.func,
        getStore: _propTypes2.default.func
    };

    DdoComponent.childContextTypes = {
        activeUser: _propTypes2.default.object,
        csrfToken: _propTypes2.default.string,
        scribblesEnabled: _propTypes2.default.bool
    };

    // -----------
    // PUBLIC API
    // -----------
    return {
        DdoComponent: DdoComponent,

        setDesignCollection: function setDesignCollection(designCollection) {
            return fluxibleContext.executeAction(_setDesignData2.setDesignCollection, designCollection);
        },
        setDesignData: function setDesignData(design) {
            return fluxibleContext.executeAction(_setDesignData2.setDesignData, design);
        }
    };
}

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(415);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(416);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.19.2
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */
(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory(__webpack_require__(272), __webpack_require__(273), __webpack_require__(274));
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(272), __webpack_require__(273), __webpack_require__(274)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
  }
}(this, function (punycode, IPv6, SLD, root) {
  'use strict';
  /*global location, escape, unescape */
  // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
  /*jshint camelcase: false */

  // save current URI variable, if any
  var _URI = root && root.URI;

  function URI(url, base) {
    var _urlSupplied = arguments.length >= 1;
    var _baseSupplied = arguments.length >= 2;

    // Allow instantiation without the 'new' keyword
    if (!(this instanceof URI)) {
      if (_urlSupplied) {
        if (_baseSupplied) {
          return new URI(url, base);
        }

        return new URI(url);
      }

      return new URI();
    }

    if (url === undefined) {
      if (_urlSupplied) {
        throw new TypeError('undefined is not a valid argument for URI');
      }

      if (typeof location !== 'undefined') {
        url = location.href + '';
      } else {
        url = '';
      }
    }

    if (url === null) {
      if (_urlSupplied) {
        throw new TypeError('null is not a valid argument for URI');
      }
    }

    this.href(url);

    // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
    if (base !== undefined) {
      return this.absoluteTo(base);
    }

    return this;
  }

  function isInteger(value) {
    return /^[0-9]+$/.test(value);
  }

  URI.version = '1.19.2';

  var p = URI.prototype;
  var hasOwn = Object.prototype.hasOwnProperty;

  function escapeRegEx(string) {
    // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
    return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
  }

  function getType(value) {
    // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
    if (value === undefined) {
      return 'Undefined';
    }

    return String(Object.prototype.toString.call(value)).slice(8, -1);
  }

  function isArray(obj) {
    return getType(obj) === 'Array';
  }

  function filterArrayValues(data, value) {
    var lookup = {};
    var i, length;

    if (getType(value) === 'RegExp') {
      lookup = null;
    } else if (isArray(value)) {
      for (i = 0, length = value.length; i < length; i++) {
        lookup[value[i]] = true;
      }
    } else {
      lookup[value] = true;
    }

    for (i = 0, length = data.length; i < length; i++) {
      /*jshint laxbreak: true */
      var _match = lookup && lookup[data[i]] !== undefined
        || !lookup && value.test(data[i]);
      /*jshint laxbreak: false */
      if (_match) {
        data.splice(i, 1);
        length--;
        i--;
      }
    }

    return data;
  }

  function arrayContains(list, value) {
    var i, length;

    // value may be string, number, array, regexp
    if (isArray(value)) {
      // Note: this can be optimized to O(n) (instead of current O(m * n))
      for (i = 0, length = value.length; i < length; i++) {
        if (!arrayContains(list, value[i])) {
          return false;
        }
      }

      return true;
    }

    var _type = getType(value);
    for (i = 0, length = list.length; i < length; i++) {
      if (_type === 'RegExp') {
        if (typeof list[i] === 'string' && list[i].match(value)) {
          return true;
        }
      } else if (list[i] === value) {
        return true;
      }
    }

    return false;
  }

  function arraysEqual(one, two) {
    if (!isArray(one) || !isArray(two)) {
      return false;
    }

    // arrays can't be equal if they have different amount of content
    if (one.length !== two.length) {
      return false;
    }

    one.sort();
    two.sort();

    for (var i = 0, l = one.length; i < l; i++) {
      if (one[i] !== two[i]) {
        return false;
      }
    }

    return true;
  }

  function trimSlashes(text) {
    var trim_expression = /^\/+|\/+$/g;
    return text.replace(trim_expression, '');
  }

  URI._parts = function() {
    return {
      protocol: null,
      username: null,
      password: null,
      hostname: null,
      urn: null,
      port: null,
      path: null,
      query: null,
      fragment: null,
      // state
      preventInvalidHostname: URI.preventInvalidHostname,
      duplicateQueryParameters: URI.duplicateQueryParameters,
      escapeQuerySpace: URI.escapeQuerySpace
    };
  };
  // state: throw on invalid hostname
  // see https://github.com/medialize/URI.js/pull/345
  // and https://github.com/medialize/URI.js/issues/354
  URI.preventInvalidHostname = false;
  // state: allow duplicate query parameters (a=1&a=1)
  URI.duplicateQueryParameters = false;
  // state: replaces + with %20 (space in query strings)
  URI.escapeQuerySpace = true;
  // static properties
  URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
  URI.idn_expression = /[^a-z0-9\._-]/i;
  URI.punycode_expression = /(xn--)/i;
  // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
  URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
  // credits to Rich Brown
  // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
  // specification: http://www.ietf.org/rfc/rfc4291.txt
  URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  // expression used is "gruber revised" (@gruber v2) determined to be the
  // best solution in a regex-golf we did a couple of ages ago at
  // * http://mathiasbynens.be/demo/url-regex
  // * http://rodneyrehm.de/t/url-regex.html
  URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
  URI.findUri = {
    // valid "scheme://" or "www."
    start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
    // everything up to the next whitespace
    end: /[\s\r\n]|$/,
    // trim trailing punctuation captured by end RegExp
    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
    // balanced parens inclusion (), [], {}, <>
    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g,
  };
  // http://www.iana.org/assignments/uri-schemes.html
  // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
  URI.defaultPorts = {
    http: '80',
    https: '443',
    ftp: '21',
    gopher: '70',
    ws: '80',
    wss: '443'
  };
  // list of protocols which always require a hostname
  URI.hostProtocols = [
    'http',
    'https'
  ];

  // allowed hostname characters according to RFC 3986
  // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
  // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
  URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
  // map DOM Elements to their URI attribute
  URI.domAttributes = {
    'a': 'href',
    'blockquote': 'cite',
    'link': 'href',
    'base': 'href',
    'script': 'src',
    'form': 'action',
    'img': 'src',
    'area': 'href',
    'iframe': 'src',
    'embed': 'src',
    'source': 'src',
    'track': 'src',
    'input': 'src', // but only if type="image"
    'audio': 'src',
    'video': 'src'
  };
  URI.getDomAttribute = function(node) {
    if (!node || !node.nodeName) {
      return undefined;
    }

    var nodeName = node.nodeName.toLowerCase();
    // <input> should only expose src for type="image"
    if (nodeName === 'input' && node.type !== 'image') {
      return undefined;
    }

    return URI.domAttributes[nodeName];
  };

  function escapeForDumbFirefox36(value) {
    // https://github.com/medialize/URI.js/issues/91
    return escape(value);
  }

  // encoding / decoding according to RFC3986
  function strictEncodeURIComponent(string) {
    // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
    return encodeURIComponent(string)
      .replace(/[!'()*]/g, escapeForDumbFirefox36)
      .replace(/\*/g, '%2A');
  }
  URI.encode = strictEncodeURIComponent;
  URI.decode = decodeURIComponent;
  URI.iso8859 = function() {
    URI.encode = escape;
    URI.decode = unescape;
  };
  URI.unicode = function() {
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
  };
  URI.characters = {
    pathname: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
        map: {
          // -._~!'()*
          '%24': '$',
          '%26': '&',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%3A': ':',
          '%40': '@'
        }
      },
      decode: {
        expression: /[\/\?#]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23'
        }
      }
    },
    reserved: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
        map: {
          // gen-delims
          '%3A': ':',
          '%2F': '/',
          '%3F': '?',
          '%23': '#',
          '%5B': '[',
          '%5D': ']',
          '%40': '@',
          // sub-delims
          '%21': '!',
          '%24': '$',
          '%26': '&',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '='
        }
      }
    },
    urnpath: {
      // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
      // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
      // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
      // note that the colon character is not featured in the encoding map; this is because URI.js
      // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
      // should not appear unencoded in a segment itself.
      // See also the note above about RFC3986 and capitalalized hex digits.
      encode: {
        expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
        map: {
          '%21': '!',
          '%24': '$',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%40': '@'
        }
      },
      // These characters are the characters called out by RFC2141 as "reserved" characters that
      // should never appear in a URN, plus the colon character (see note above).
      decode: {
        expression: /[\/\?#:]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23',
          ':': '%3A'
        }
      }
    }
  };
  URI.encodeQuery = function(string, escapeQuerySpace) {
    var escaped = URI.encode(string + '');
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
  };
  URI.decodeQuery = function(string, escapeQuerySpace) {
    string += '';
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    try {
      return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
    } catch(e) {
      // we're not going to mess with weird encodings,
      // give up and return the undecoded original string
      // see https://github.com/medialize/URI.js/issues/87
      // see https://github.com/medialize/URI.js/issues/92
      return string;
    }
  };
  // generate encode/decode path functions
  var _parts = {'encode':'encode', 'decode':'decode'};
  var _part;
  var generateAccessor = function(_group, _part) {
    return function(string) {
      try {
        return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
          return URI.characters[_group][_part].map[c];
        });
      } catch (e) {
        // we're not going to mess with weird encodings,
        // give up and return the undecoded original string
        // see https://github.com/medialize/URI.js/issues/87
        // see https://github.com/medialize/URI.js/issues/92
        return string;
      }
    };
  };

  for (_part in _parts) {
    URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
    URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
  }

  var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
    return function(string) {
      // Why pass in names of functions, rather than the function objects themselves? The
      // definitions of some functions (but in particular, URI.decode) will occasionally change due
      // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
      // that the functions we use here are "fresh".
      var actualCodingFunc;
      if (!_innerCodingFuncName) {
        actualCodingFunc = URI[_codingFuncName];
      } else {
        actualCodingFunc = function(string) {
          return URI[_codingFuncName](URI[_innerCodingFuncName](string));
        };
      }

      var segments = (string + '').split(_sep);

      for (var i = 0, length = segments.length; i < length; i++) {
        segments[i] = actualCodingFunc(segments[i]);
      }

      return segments.join(_sep);
    };
  };

  // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
  URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
  URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
  URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
  URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');

  URI.encodeReserved = generateAccessor('reserved', 'encode');

  URI.parse = function(string, parts) {
    var pos;
    if (!parts) {
      parts = {
        preventInvalidHostname: URI.preventInvalidHostname
      };
    }
    // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]

    // extract fragment
    pos = string.indexOf('#');
    if (pos > -1) {
      // escaping?
      parts.fragment = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract query
    pos = string.indexOf('?');
    if (pos > -1) {
      // escaping?
      parts.query = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract protocol
    if (string.substring(0, 2) === '//') {
      // relative-scheme
      parts.protocol = null;
      string = string.substring(2);
      // extract "user:pass@host:port"
      string = URI.parseAuthority(string, parts);
    } else {
      pos = string.indexOf(':');
      if (pos > -1) {
        parts.protocol = string.substring(0, pos) || null;
        if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
          // : may be within the path
          parts.protocol = undefined;
        } else if (string.substring(pos + 1, pos + 3) === '//') {
          string = string.substring(pos + 3);

          // extract "user:pass@host:port"
          string = URI.parseAuthority(string, parts);
        } else {
          string = string.substring(pos + 1);
          parts.urn = true;
        }
      }
    }

    // what's left must be the path
    parts.path = string;

    // and we're done
    return parts;
  };
  URI.parseHost = function(string, parts) {
    if (!string) {
      string = '';
    }

    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    // https://github.com/medialize/URI.js/pull/233
    string = string.replace(/\\/g, '/');

    // extract host:port
    var pos = string.indexOf('/');
    var bracketPos;
    var t;

    if (pos === -1) {
      pos = string.length;
    }

    if (string.charAt(0) === '[') {
      // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
      // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
      // IPv6+port in the format [2001:db8::1]:80 (for the time being)
      bracketPos = string.indexOf(']');
      parts.hostname = string.substring(1, bracketPos) || null;
      parts.port = string.substring(bracketPos + 2, pos) || null;
      if (parts.port === '/') {
        parts.port = null;
      }
    } else {
      var firstColon = string.indexOf(':');
      var firstSlash = string.indexOf('/');
      var nextColon = string.indexOf(':', firstColon + 1);
      if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
        // IPv6 host contains multiple colons - but no port
        // this notation is actually not allowed by RFC 3986, but we're a liberal parser
        parts.hostname = string.substring(0, pos) || null;
        parts.port = null;
      } else {
        t = string.substring(0, pos).split(':');
        parts.hostname = t[0] || null;
        parts.port = t[1] || null;
      }
    }

    if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
      pos++;
      string = '/' + string;
    }

    if (parts.preventInvalidHostname) {
      URI.ensureValidHostname(parts.hostname, parts.protocol);
    }

    if (parts.port) {
      URI.ensureValidPort(parts.port);
    }

    return string.substring(pos) || '/';
  };
  URI.parseAuthority = function(string, parts) {
    string = URI.parseUserinfo(string, parts);
    return URI.parseHost(string, parts);
  };
  URI.parseUserinfo = function(string, parts) {
    // extract username:password
    var firstSlash = string.indexOf('/');
    var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
    var t;

    // authority@ must come before /path
    if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
      t = string.substring(0, pos).split(':');
      parts.username = t[0] ? URI.decode(t[0]) : null;
      t.shift();
      parts.password = t[0] ? URI.decode(t.join(':')) : null;
      string = string.substring(pos + 1);
    } else {
      parts.username = null;
      parts.password = null;
    }

    return string;
  };
  URI.parseQuery = function(string, escapeQuerySpace) {
    if (!string) {
      return {};
    }

    // throw out the funky business - "?"[name"="value"&"]+
    string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');

    if (!string) {
      return {};
    }

    var items = {};
    var splits = string.split('&');
    var length = splits.length;
    var v, name, value;

    for (var i = 0; i < length; i++) {
      v = splits[i].split('=');
      name = URI.decodeQuery(v.shift(), escapeQuerySpace);
      // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
      value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;

      if (hasOwn.call(items, name)) {
        if (typeof items[name] === 'string' || items[name] === null) {
          items[name] = [items[name]];
        }

        items[name].push(value);
      } else {
        items[name] = value;
      }
    }

    return items;
  };

  URI.build = function(parts) {
    var t = '';
    var requireAbsolutePath = false

    if (parts.protocol) {
      t += parts.protocol + ':';
    }

    if (!parts.urn && (t || parts.hostname)) {
      t += '//';
      requireAbsolutePath = true
    }

    t += (URI.buildAuthority(parts) || '');

    if (typeof parts.path === 'string') {
      if (parts.path.charAt(0) !== '/' && requireAbsolutePath) {
        t += '/';
      }

      t += parts.path;
    }

    if (typeof parts.query === 'string' && parts.query) {
      t += '?' + parts.query;
    }

    if (typeof parts.fragment === 'string' && parts.fragment) {
      t += '#' + parts.fragment;
    }
    return t;
  };
  URI.buildHost = function(parts) {
    var t = '';

    if (!parts.hostname) {
      return '';
    } else if (URI.ip6_expression.test(parts.hostname)) {
      t += '[' + parts.hostname + ']';
    } else {
      t += parts.hostname;
    }

    if (parts.port) {
      t += ':' + parts.port;
    }

    return t;
  };
  URI.buildAuthority = function(parts) {
    return URI.buildUserinfo(parts) + URI.buildHost(parts);
  };
  URI.buildUserinfo = function(parts) {
    var t = '';

    if (parts.username) {
      t += URI.encode(parts.username);
    }

    if (parts.password) {
      t += ':' + URI.encode(parts.password);
    }

    if (t) {
      t += '@';
    }

    return t;
  };
  URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
    // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
    // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
    // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
    // URI.js treats the query string as being application/x-www-form-urlencoded
    // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type

    var t = '';
    var unique, key, i, length;
    for (key in data) {
      if (hasOwn.call(data, key)) {
        if (isArray(data[key])) {
          unique = {};
          for (i = 0, length = data[key].length; i < length; i++) {
            if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
              t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
              if (duplicateQueryParameters !== true) {
                unique[data[key][i] + ''] = true;
              }
            }
          }
        } else if (data[key] !== undefined) {
          t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
        }
      }
    }

    return t.substring(1);
  };
  URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
    // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
    // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
    return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
  };

  URI.addQuery = function(data, name, value) {
    if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.addQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (data[name] === undefined) {
        data[name] = value;
        return;
      } else if (typeof data[name] === 'string') {
        data[name] = [data[name]];
      }

      if (!isArray(value)) {
        value = [value];
      }

      data[name] = (data[name] || []).concat(value);
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }
  };

  URI.setQuery = function(data, name, value) {
    if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.setQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      data[name] = value === undefined ? null : value;
    } else {
      throw new TypeError('URI.setQuery() accepts an object, string as the name parameter');
    }
  };

  URI.removeQuery = function(data, name, value) {
    var i, length, key;

    if (isArray(name)) {
      for (i = 0, length = name.length; i < length; i++) {
        data[name[i]] = undefined;
      }
    } else if (getType(name) === 'RegExp') {
      for (key in data) {
        if (name.test(key)) {
          data[key] = undefined;
        }
      }
    } else if (typeof name === 'object') {
      for (key in name) {
        if (hasOwn.call(name, key)) {
          URI.removeQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (value !== undefined) {
        if (getType(value) === 'RegExp') {
          if (!isArray(data[name]) && value.test(data[name])) {
            data[name] = undefined;
          } else {
            data[name] = filterArrayValues(data[name], value);
          }
        } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
          data[name] = undefined;
        } else if (isArray(data[name])) {
          data[name] = filterArrayValues(data[name], value);
        }
      } else {
        data[name] = undefined;
      }
    } else {
      throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
    }
  };
  URI.hasQuery = function(data, name, value, withinArray) {
    switch (getType(name)) {
      case 'String':
        // Nothing to do here
        break;

      case 'RegExp':
        for (var key in data) {
          if (hasOwn.call(data, key)) {
            if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
              return true;
            }
          }
        }

        return false;

      case 'Object':
        for (var _key in name) {
          if (hasOwn.call(name, _key)) {
            if (!URI.hasQuery(data, _key, name[_key])) {
              return false;
            }
          }
        }

        return true;

      default:
        throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
    }

    switch (getType(value)) {
      case 'Undefined':
        // true if exists (but may be empty)
        return name in data; // data[name] !== undefined;

      case 'Boolean':
        // true if exists and non-empty
        var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
        return value === _booly;

      case 'Function':
        // allow complex comparison
        return !!value(data[name], name, data);

      case 'Array':
        if (!isArray(data[name])) {
          return false;
        }

        var op = withinArray ? arrayContains : arraysEqual;
        return op(data[name], value);

      case 'RegExp':
        if (!isArray(data[name])) {
          return Boolean(data[name] && data[name].match(value));
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      case 'Number':
        value = String(value);
        /* falls through */
      case 'String':
        if (!isArray(data[name])) {
          return data[name] === value;
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      default:
        throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
    }
  };


  URI.joinPaths = function() {
    var input = [];
    var segments = [];
    var nonEmptySegments = 0;

    for (var i = 0; i < arguments.length; i++) {
      var url = new URI(arguments[i]);
      input.push(url);
      var _segments = url.segment();
      for (var s = 0; s < _segments.length; s++) {
        if (typeof _segments[s] === 'string') {
          segments.push(_segments[s]);
        }

        if (_segments[s]) {
          nonEmptySegments++;
        }
      }
    }

    if (!segments.length || !nonEmptySegments) {
      return new URI('');
    }

    var uri = new URI('').segment(segments);

    if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
      uri.path('/' + uri.path());
    }

    return uri.normalize();
  };

  URI.commonPath = function(one, two) {
    var length = Math.min(one.length, two.length);
    var pos;

    // find first non-matching character
    for (pos = 0; pos < length; pos++) {
      if (one.charAt(pos) !== two.charAt(pos)) {
        pos--;
        break;
      }
    }

    if (pos < 1) {
      return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
    }

    // revert to last /
    if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
      pos = one.substring(0, pos).lastIndexOf('/');
    }

    return one.substring(0, pos + 1);
  };

  URI.withinString = function(string, callback, options) {
    options || (options = {});
    var _start = options.start || URI.findUri.start;
    var _end = options.end || URI.findUri.end;
    var _trim = options.trim || URI.findUri.trim;
    var _parens = options.parens || URI.findUri.parens;
    var _attributeOpen = /[a-z0-9-]=["']?$/i;

    _start.lastIndex = 0;
    while (true) {
      var match = _start.exec(string);
      if (!match) {
        break;
      }

      var start = match.index;
      if (options.ignoreHtml) {
        // attribut(e=["']?$)
        var attributeOpen = string.slice(Math.max(start - 3, 0), start);
        if (attributeOpen && _attributeOpen.test(attributeOpen)) {
          continue;
        }
      }

      var end = start + string.slice(start).search(_end);
      var slice = string.slice(start, end);
      // make sure we include well balanced parens
      var parensEnd = -1;
      while (true) {
        var parensMatch = _parens.exec(slice);
        if (!parensMatch) {
          break;
        }

        var parensMatchEnd = parensMatch.index + parensMatch[0].length;
        parensEnd = Math.max(parensEnd, parensMatchEnd);
      }

      if (parensEnd > -1) {
        slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
      } else {
        slice = slice.replace(_trim, '');
      }

      if (slice.length <= match[0].length) {
        // the extract only contains the starting marker of a URI,
        // e.g. "www" or "http://"
        continue;
      }

      if (options.ignore && options.ignore.test(slice)) {
        continue;
      }

      end = start + slice.length;
      var result = callback(slice, start, end, string);
      if (result === undefined) {
        _start.lastIndex = end;
        continue;
      }

      result = String(result);
      string = string.slice(0, start) + result + string.slice(end);
      _start.lastIndex = start + result.length;
    }

    _start.lastIndex = 0;
    return string;
  };

  URI.ensureValidHostname = function(v, protocol) {
    // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
    // they are not part of DNS and therefore ignored by URI.js

    var hasHostname = !!v; // not null and not an empty string
    var hasProtocol = !!protocol;
    var rejectEmptyHostname = false;

    if (hasProtocol) {
      rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
    }

    if (rejectEmptyHostname && !hasHostname) {
      throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
    } else if (v && v.match(URI.invalid_hostname_characters)) {
      // test punycode
      if (!punycode) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
      }
      if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
      }
    }
  };

  URI.ensureValidPort = function (v) {
    if (!v) {
      return;
    }

    var port = Number(v);
    if (isInteger(port) && (port > 0) && (port < 65536)) {
      return;
    }

    throw new TypeError('Port "' + v + '" is not a valid port');
  };

  // noConflict
  URI.noConflict = function(removeAll) {
    if (removeAll) {
      var unconflicted = {
        URI: this.noConflict()
      };

      if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
        unconflicted.URITemplate = root.URITemplate.noConflict();
      }

      if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
        unconflicted.IPv6 = root.IPv6.noConflict();
      }

      if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
        unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
      }

      return unconflicted;
    } else if (root.URI === this) {
      root.URI = _URI;
    }

    return this;
  };

  p.build = function(deferBuild) {
    if (deferBuild === true) {
      this._deferred_build = true;
    } else if (deferBuild === undefined || this._deferred_build) {
      this._string = URI.build(this._parts);
      this._deferred_build = false;
    }

    return this;
  };

  p.clone = function() {
    return new URI(this);
  };

  p.valueOf = p.toString = function() {
    return this.build(false)._string;
  };


  function generateSimpleAccessor(_part){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        this._parts[_part] = v || null;
        this.build(!build);
        return this;
      }
    };
  }

  function generatePrefixAccessor(_part, _key){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        if (v !== null) {
          v = v + '';
          if (v.charAt(0) === _key) {
            v = v.substring(1);
          }
        }

        this._parts[_part] = v;
        this.build(!build);
        return this;
      }
    };
  }

  p.protocol = generateSimpleAccessor('protocol');
  p.username = generateSimpleAccessor('username');
  p.password = generateSimpleAccessor('password');
  p.hostname = generateSimpleAccessor('hostname');
  p.port = generateSimpleAccessor('port');
  p.query = generatePrefixAccessor('query', '?');
  p.fragment = generatePrefixAccessor('fragment', '#');

  p.search = function(v, build) {
    var t = this.query(v, build);
    return typeof t === 'string' && t.length ? ('?' + t) : t;
  };
  p.hash = function(v, build) {
    var t = this.fragment(v, build);
    return typeof t === 'string' && t.length ? ('#' + t) : t;
  };

  p.pathname = function(v, build) {
    if (v === undefined || v === true) {
      var res = this._parts.path || (this._parts.hostname ? '/' : '');
      return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
    } else {
      if (this._parts.urn) {
        this._parts.path = v ? URI.recodeUrnPath(v) : '';
      } else {
        this._parts.path = v ? URI.recodePath(v) : '/';
      }
      this.build(!build);
      return this;
    }
  };
  p.path = p.pathname;
  p.href = function(href, build) {
    var key;

    if (href === undefined) {
      return this.toString();
    }

    this._string = '';
    this._parts = URI._parts();

    var _URI = href instanceof URI;
    var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
    if (href.nodeName) {
      var attribute = URI.getDomAttribute(href);
      href = href[attribute] || '';
      _object = false;
    }

    // window.location is reported to be an object, but it's not the sort
    // of object we're looking for:
    // * location.protocol ends with a colon
    // * location.query != object.search
    // * location.hash != object.fragment
    // simply serializing the unknown object should do the trick
    // (for location, not for everything...)
    if (!_URI && _object && href.pathname !== undefined) {
      href = href.toString();
    }

    if (typeof href === 'string' || href instanceof String) {
      this._parts = URI.parse(String(href), this._parts);
    } else if (_URI || _object) {
      var src = _URI ? href._parts : href;
      for (key in src) {
        if (key === 'query') { continue; }
        if (hasOwn.call(this._parts, key)) {
          this._parts[key] = src[key];
        }
      }
      if (src.query) {
        this.query(src.query, false);
      }
    } else {
      throw new TypeError('invalid input');
    }

    this.build(!build);
    return this;
  };

  // identification accessors
  p.is = function(what) {
    var ip = false;
    var ip4 = false;
    var ip6 = false;
    var name = false;
    var sld = false;
    var idn = false;
    var punycode = false;
    var relative = !this._parts.urn;

    if (this._parts.hostname) {
      relative = false;
      ip4 = URI.ip4_expression.test(this._parts.hostname);
      ip6 = URI.ip6_expression.test(this._parts.hostname);
      ip = ip4 || ip6;
      name = !ip;
      sld = name && SLD && SLD.has(this._parts.hostname);
      idn = name && URI.idn_expression.test(this._parts.hostname);
      punycode = name && URI.punycode_expression.test(this._parts.hostname);
    }

    switch (what.toLowerCase()) {
      case 'relative':
        return relative;

      case 'absolute':
        return !relative;

      // hostname identification
      case 'domain':
      case 'name':
        return name;

      case 'sld':
        return sld;

      case 'ip':
        return ip;

      case 'ip4':
      case 'ipv4':
      case 'inet4':
        return ip4;

      case 'ip6':
      case 'ipv6':
      case 'inet6':
        return ip6;

      case 'idn':
        return idn;

      case 'url':
        return !this._parts.urn;

      case 'urn':
        return !!this._parts.urn;

      case 'punycode':
        return punycode;
    }

    return null;
  };

  // component specific input validation
  var _protocol = p.protocol;
  var _port = p.port;
  var _hostname = p.hostname;

  p.protocol = function(v, build) {
    if (v) {
      // accept trailing ://
      v = v.replace(/:(\/\/)?$/, '');

      if (!v.match(URI.protocol_expression)) {
        throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
      }
    }

    return _protocol.call(this, v, build);
  };
  p.scheme = p.protocol;
  p.port = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      if (v === 0) {
        v = null;
      }

      if (v) {
        v += '';
        if (v.charAt(0) === ':') {
          v = v.substring(1);
        }

        URI.ensureValidPort(v);
      }
    }
    return _port.call(this, v, build);
  };
  p.hostname = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      var x = { preventInvalidHostname: this._parts.preventInvalidHostname };
      var res = URI.parseHost(v, x);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      v = x.hostname;
      if (this._parts.preventInvalidHostname) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }
    }

    return _hostname.call(this, v, build);
  };

  // compound accessors
  p.origin = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var protocol = this.protocol();
      var authority = this.authority();
      if (!authority) {
        return '';
      }

      return (protocol ? protocol + '://' : '') + this.authority();
    } else {
      var origin = URI(v);
      this
        .protocol(origin.protocol())
        .authority(origin.authority())
        .build(!build);
      return this;
    }
  };
  p.host = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildHost(this._parts) : '';
    } else {
      var res = URI.parseHost(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.authority = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
    } else {
      var res = URI.parseAuthority(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.userinfo = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var t = URI.buildUserinfo(this._parts);
      return t ? t.substring(0, t.length -1) : t;
    } else {
      if (v[v.length-1] !== '@') {
        v += '@';
      }

      URI.parseUserinfo(v, this._parts);
      this.build(!build);
      return this;
    }
  };
  p.resource = function(v, build) {
    var parts;

    if (v === undefined) {
      return this.path() + this.search() + this.hash();
    }

    parts = URI.parse(v);
    this._parts.path = parts.path;
    this._parts.query = parts.query;
    this._parts.fragment = parts.fragment;
    this.build(!build);
    return this;
  };

  // fraction accessors
  p.subdomain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    // convenience, return "www" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // grab domain and add another segment
      var end = this._parts.hostname.length - this.domain().length - 1;
      return this._parts.hostname.substring(0, end) || '';
    } else {
      var e = this._parts.hostname.length - this.domain().length;
      var sub = this._parts.hostname.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(sub));

      if (v && v.charAt(v.length - 1) !== '.') {
        v += '.';
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      if (v) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }

      this._parts.hostname = this._parts.hostname.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.domain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // convenience, return "example.org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // if hostname consists of 1 or 2 segments, it must be the domain
      var t = this._parts.hostname.match(/\./g);
      if (t && t.length < 2) {
        return this._parts.hostname;
      }

      // grab tld and add another segment
      var end = this._parts.hostname.length - this.tld(build).length - 1;
      end = this._parts.hostname.lastIndexOf('.', end -1) + 1;
      return this._parts.hostname.substring(end) || '';
    } else {
      if (!v) {
        throw new TypeError('cannot set domain empty');
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      URI.ensureValidHostname(v, this._parts.protocol);

      if (!this._parts.hostname || this.is('IP')) {
        this._parts.hostname = v;
      } else {
        var replace = new RegExp(escapeRegEx(this.domain()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.tld = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // return "org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      var pos = this._parts.hostname.lastIndexOf('.');
      var tld = this._parts.hostname.substring(pos + 1);

      if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
        return SLD.get(this._parts.hostname) || tld;
      }

      return tld;
    } else {
      var replace;

      if (!v) {
        throw new TypeError('cannot set TLD empty');
      } else if (v.match(/[^a-zA-Z0-9-]/)) {
        if (SLD && SLD.is(v)) {
          replace = new RegExp(escapeRegEx(this.tld()) + '$');
          this._parts.hostname = this._parts.hostname.replace(replace, v);
        } else {
          throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
        }
      } else if (!this._parts.hostname || this.is('IP')) {
        throw new ReferenceError('cannot set TLD on non-domain host');
      } else {
        replace = new RegExp(escapeRegEx(this.tld()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.directory = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path && !this._parts.hostname) {
        return '';
      }

      if (this._parts.path === '/') {
        return '/';
      }

      var end = this._parts.path.length - this.filename().length - 1;
      var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');

      return v ? URI.decodePath(res) : res;

    } else {
      var e = this._parts.path.length - this.filename().length;
      var directory = this._parts.path.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(directory));

      // fully qualifier directories begin with a slash
      if (!this.is('relative')) {
        if (!v) {
          v = '/';
        }

        if (v.charAt(0) !== '/') {
          v = '/' + v;
        }
      }

      // directories always end with a slash
      if (v && v.charAt(v.length - 1) !== '/') {
        v += '/';
      }

      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.filename = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v !== 'string') {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var pos = this._parts.path.lastIndexOf('/');
      var res = this._parts.path.substring(pos+1);

      return v ? URI.decodePathSegment(res) : res;
    } else {
      var mutatedDirectory = false;

      if (v.charAt(0) === '/') {
        v = v.substring(1);
      }

      if (v.match(/\.?\//)) {
        mutatedDirectory = true;
      }

      var replace = new RegExp(escapeRegEx(this.filename()) + '$');
      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);

      if (mutatedDirectory) {
        this.normalizePath(build);
      } else {
        this.build(!build);
      }

      return this;
    }
  };
  p.suffix = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var filename = this.filename();
      var pos = filename.lastIndexOf('.');
      var s, res;

      if (pos === -1) {
        return '';
      }

      // suffix may only contain alnum characters (yup, I made this up.)
      s = filename.substring(pos+1);
      res = (/^[a-z0-9%]+$/i).test(s) ? s : '';
      return v ? URI.decodePathSegment(res) : res;
    } else {
      if (v.charAt(0) === '.') {
        v = v.substring(1);
      }

      var suffix = this.suffix();
      var replace;

      if (!suffix) {
        if (!v) {
          return this;
        }

        this._parts.path += '.' + URI.recodePath(v);
      } else if (!v) {
        replace = new RegExp(escapeRegEx('.' + suffix) + '$');
      } else {
        replace = new RegExp(escapeRegEx(suffix) + '$');
      }

      if (replace) {
        v = URI.recodePath(v);
        this._parts.path = this._parts.path.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.segment = function(segment, v, build) {
    var separator = this._parts.urn ? ':' : '/';
    var path = this.path();
    var absolute = path.substring(0, 1) === '/';
    var segments = path.split(separator);

    if (segment !== undefined && typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (segment !== undefined && typeof segment !== 'number') {
      throw new Error('Bad segment "' + segment + '", must be 0-based integer');
    }

    if (absolute) {
      segments.shift();
    }

    if (segment < 0) {
      // allow negative indexes to address from the end
      segment = Math.max(segments.length + segment, 0);
    }

    if (v === undefined) {
      /*jshint laxbreak: true */
      return segment === undefined
        ? segments
        : segments[segment];
      /*jshint laxbreak: false */
    } else if (segment === null || segments[segment] === undefined) {
      if (isArray(v)) {
        segments = [];
        // collapse empty elements within array
        for (var i=0, l=v.length; i < l; i++) {
          if (!v[i].length && (!segments.length || !segments[segments.length -1].length)) {
            continue;
          }

          if (segments.length && !segments[segments.length -1].length) {
            segments.pop();
          }

          segments.push(trimSlashes(v[i]));
        }
      } else if (v || typeof v === 'string') {
        v = trimSlashes(v);
        if (segments[segments.length -1] === '') {
          // empty trailing elements have to be overwritten
          // to prevent results such as /foo//bar
          segments[segments.length -1] = v;
        } else {
          segments.push(v);
        }
      }
    } else {
      if (v) {
        segments[segment] = trimSlashes(v);
      } else {
        segments.splice(segment, 1);
      }
    }

    if (absolute) {
      segments.unshift('');
    }

    return this.path(segments.join(separator), build);
  };
  p.segmentCoded = function(segment, v, build) {
    var segments, i, l;

    if (typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (v === undefined) {
      segments = this.segment(segment, v, build);
      if (!isArray(segments)) {
        segments = segments !== undefined ? URI.decode(segments) : undefined;
      } else {
        for (i = 0, l = segments.length; i < l; i++) {
          segments[i] = URI.decode(segments[i]);
        }
      }

      return segments;
    }

    if (!isArray(v)) {
      v = (typeof v === 'string' || v instanceof String) ? URI.encode(v) : v;
    } else {
      for (i = 0, l = v.length; i < l; i++) {
        v[i] = URI.encode(v[i]);
      }
    }

    return this.segment(segment, v, build);
  };

  // mutating query string
  var q = p.query;
  p.query = function(v, build) {
    if (v === true) {
      return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    } else if (typeof v === 'function') {
      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      var result = v.call(this, data);
      this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else if (v !== undefined && typeof v !== 'string') {
      this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else {
      return q.call(this, v, build);
    }
  };
  p.setQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);

    if (typeof name === 'string' || name instanceof String) {
      data[name] = value !== undefined ? value : null;
    } else if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          data[key] = name[key];
        }
      }
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }

    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.addQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.addQuery(data, name, value === undefined ? null : value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.removeQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.removeQuery(data, name, value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.hasQuery = function(name, value, withinArray) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    return URI.hasQuery(data, name, value, withinArray);
  };
  p.setSearch = p.setQuery;
  p.addSearch = p.addQuery;
  p.removeSearch = p.removeQuery;
  p.hasSearch = p.hasQuery;

  // sanitizing URLs
  p.normalize = function() {
    if (this._parts.urn) {
      return this
        .normalizeProtocol(false)
        .normalizePath(false)
        .normalizeQuery(false)
        .normalizeFragment(false)
        .build();
    }

    return this
      .normalizeProtocol(false)
      .normalizeHostname(false)
      .normalizePort(false)
      .normalizePath(false)
      .normalizeQuery(false)
      .normalizeFragment(false)
      .build();
  };
  p.normalizeProtocol = function(build) {
    if (typeof this._parts.protocol === 'string') {
      this._parts.protocol = this._parts.protocol.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizeHostname = function(build) {
    if (this._parts.hostname) {
      if (this.is('IDN') && punycode) {
        this._parts.hostname = punycode.toASCII(this._parts.hostname);
      } else if (this.is('IPv6') && IPv6) {
        this._parts.hostname = IPv6.best(this._parts.hostname);
      }

      this._parts.hostname = this._parts.hostname.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizePort = function(build) {
    // remove port of it's the protocol's default
    if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
      this._parts.port = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizePath = function(build) {
    var _path = this._parts.path;
    if (!_path) {
      return this;
    }

    if (this._parts.urn) {
      this._parts.path = URI.recodeUrnPath(this._parts.path);
      this.build(!build);
      return this;
    }

    if (this._parts.path === '/') {
      return this;
    }

    _path = URI.recodePath(_path);

    var _was_relative;
    var _leadingParents = '';
    var _parent, _pos;

    // handle relative paths
    if (_path.charAt(0) !== '/') {
      _was_relative = true;
      _path = '/' + _path;
    }

    // handle relative files (as opposed to directories)
    if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
      _path += '/';
    }

    // resolve simples
    _path = _path
      .replace(/(\/(\.\/)+)|(\/\.$)/g, '/')
      .replace(/\/{2,}/g, '/');

    // remember leading parents
    if (_was_relative) {
      _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
      if (_leadingParents) {
        _leadingParents = _leadingParents[0];
      }
    }

    // resolve parents
    while (true) {
      _parent = _path.search(/\/\.\.(\/|$)/);
      if (_parent === -1) {
        // no more ../ to resolve
        break;
      } else if (_parent === 0) {
        // top level cannot be relative, skip it
        _path = _path.substring(3);
        continue;
      }

      _pos = _path.substring(0, _parent).lastIndexOf('/');
      if (_pos === -1) {
        _pos = _parent;
      }
      _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
    }

    // revert to relative
    if (_was_relative && this.is('relative')) {
      _path = _leadingParents + _path.substring(1);
    }

    this._parts.path = _path;
    this.build(!build);
    return this;
  };
  p.normalizePathname = p.normalizePath;
  p.normalizeQuery = function(build) {
    if (typeof this._parts.query === 'string') {
      if (!this._parts.query.length) {
        this._parts.query = null;
      } else {
        this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
      }

      this.build(!build);
    }

    return this;
  };
  p.normalizeFragment = function(build) {
    if (!this._parts.fragment) {
      this._parts.fragment = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizeSearch = p.normalizeQuery;
  p.normalizeHash = p.normalizeFragment;

  p.iso8859 = function() {
    // expect unicode input, iso8859 output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = escape;
    URI.decode = decodeURIComponent;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.unicode = function() {
    // expect iso8859 input, unicode output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = strictEncodeURIComponent;
    URI.decode = unescape;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.readable = function() {
    var uri = this.clone();
    // removing username, password, because they shouldn't be displayed according to RFC 3986
    uri.username('').password('').normalize();
    var t = '';
    if (uri._parts.protocol) {
      t += uri._parts.protocol + '://';
    }

    if (uri._parts.hostname) {
      if (uri.is('punycode') && punycode) {
        t += punycode.toUnicode(uri._parts.hostname);
        if (uri._parts.port) {
          t += ':' + uri._parts.port;
        }
      } else {
        t += uri.host();
      }
    }

    if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
      t += '/';
    }

    t += uri.path(true);
    if (uri._parts.query) {
      var q = '';
      for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
        var kv = (qp[i] || '').split('=');
        q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace)
          .replace(/&/g, '%26');

        if (kv[1] !== undefined) {
          q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace)
            .replace(/&/g, '%26');
        }
      }
      t += '?' + q.substring(1);
    }

    t += URI.decodeQuery(uri.hash(), true);
    return t;
  };

  // resolving relative and absolute URLs
  p.absoluteTo = function(base) {
    var resolved = this.clone();
    var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
    var basedir, i, p;

    if (this._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    if (!(base instanceof URI)) {
      base = new URI(base);
    }

    if (resolved._parts.protocol) {
      // Directly returns even if this._parts.hostname is empty.
      return resolved;
    } else {
      resolved._parts.protocol = base._parts.protocol;
    }

    if (this._parts.hostname) {
      return resolved;
    }

    for (i = 0; (p = properties[i]); i++) {
      resolved._parts[p] = base._parts[p];
    }

    if (!resolved._parts.path) {
      resolved._parts.path = base._parts.path;
      if (!resolved._parts.query) {
        resolved._parts.query = base._parts.query;
      }
    } else {
      if (resolved._parts.path.substring(-2) === '..') {
        resolved._parts.path += '/';
      }

      if (resolved.path().charAt(0) !== '/') {
        basedir = base.directory();
        basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
        resolved._parts.path = (basedir ? (basedir + '/') : '') + resolved._parts.path;
        resolved.normalizePath();
      }
    }

    resolved.build();
    return resolved;
  };
  p.relativeTo = function(base) {
    var relative = this.clone().normalize();
    var relativeParts, baseParts, common, relativePath, basePath;

    if (relative._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    base = new URI(base).normalize();
    relativeParts = relative._parts;
    baseParts = base._parts;
    relativePath = relative.path();
    basePath = base.path();

    if (relativePath.charAt(0) !== '/') {
      throw new Error('URI is already relative');
    }

    if (basePath.charAt(0) !== '/') {
      throw new Error('Cannot calculate a URI relative to another relative URI');
    }

    if (relativeParts.protocol === baseParts.protocol) {
      relativeParts.protocol = null;
    }

    if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
      return relative.build();
    }

    if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
      return relative.build();
    }

    if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
      relativeParts.hostname = null;
      relativeParts.port = null;
    } else {
      return relative.build();
    }

    if (relativePath === basePath) {
      relativeParts.path = '';
      return relative.build();
    }

    // determine common sub path
    common = URI.commonPath(relativePath, basePath);

    // If the paths have nothing in common, return a relative URL with the absolute path.
    if (!common) {
      return relative.build();
    }

    var parents = baseParts.path
      .substring(common.length)
      .replace(/[^\/]*$/, '')
      .replace(/.*?\//g, '../');

    relativeParts.path = (parents + relativeParts.path.substring(common.length)) || './';

    return relative.build();
  };

  // comparing URIs
  p.equals = function(uri) {
    var one = this.clone();
    var two = new URI(uri);
    var one_map = {};
    var two_map = {};
    var checked = {};
    var one_query, two_query, key;

    one.normalize();
    two.normalize();

    // exact match
    if (one.toString() === two.toString()) {
      return true;
    }

    // extract query string
    one_query = one.query();
    two_query = two.query();
    one.query('');
    two.query('');

    // definitely not equal if not even non-query parts match
    if (one.toString() !== two.toString()) {
      return false;
    }

    // query parameters have the same length, even if they're permuted
    if (one_query.length !== two_query.length) {
      return false;
    }

    one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
    two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);

    for (key in one_map) {
      if (hasOwn.call(one_map, key)) {
        if (!isArray(one_map[key])) {
          if (one_map[key] !== two_map[key]) {
            return false;
          }
        } else if (!arraysEqual(one_map[key], two_map[key])) {
          return false;
        }

        checked[key] = true;
      }
    }

    for (key in two_map) {
      if (hasOwn.call(two_map, key)) {
        if (!checked[key]) {
          // two contains a parameter not present in one
          return false;
        }
      }
    }

    return true;
  };

  // state
  p.preventInvalidHostname = function(v) {
    this._parts.preventInvalidHostname = !!v;
    return this;
  };

  p.duplicateQueryParameters = function(v) {
    this._parts.duplicateQueryParameters = !!v;
    return this;
  };

  p.escapeQuerySpace = function(v) {
    this._parts.escapeQuerySpace = !!v;
    return this;
  };

  return URI;
}));


/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getCsrfToken;

var _jsCookie = __webpack_require__(198);

function getCsrfToken() {
    return (0, _jsCookie.get)('_99csrf');
} // TODO: replace with `packages/common/utils/app/getCsrfToken.ts`

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity]
 *  The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length)
    ? baseUniq(array, baseIteratee(iteratee, 2))
    : [];
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = uniqBy;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12), __webpack_require__(62)(module)))

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var inherits = __webpack_require__(46);
var EventEmitter = __webpack_require__(93);
var CHANGE_EVENT = 'change';

/**
 * @class BaseStore
 * @extends EventEmitter
 * @param dispatcher The dispatcher interface
 * @constructor
 */
function BaseStore(dispatcher) {
    this.dispatcher = dispatcher;
    this._hasChanged = false;
    EventEmitter.call(this);
    if (this.initialize) {
        this.initialize();
    }
}

inherits(BaseStore, EventEmitter);

/**
 * Convenience method for getting the store context object.
 * @method getContext
 * @return {Object} Returns the store context object.
 */
BaseStore.prototype.getContext = function getContext() {
    return this.dispatcher.getContext();
};

/**
 * Add a listener for the change event
 * @method addChangeListener
 * @param {Function} callback
 */
BaseStore.prototype.addChangeListener = function addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
};

/**
 * Remove a listener for the change event
 * @method removeChangeListener
 * @param {Function} callback
 */
BaseStore.prototype.removeChangeListener = function removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
};

/**
 * Determines whether the store should dehydrate or not. By default, only dehydrates
 * if the store has emitted an update event. If no update has been emitted, it is assumed
 * that the store is in its default state and therefore does not need to dehydrate.
 * @method shouldDehydrate
 * @returns {boolean}
 */
BaseStore.prototype.shouldDehydrate = function shouldDehydrate() {
    return this._hasChanged;
};

/**
 * Emit a change event
 * @method emitChange
 * @param {*} param=this
 */
BaseStore.prototype.emitChange = function emitChange(param) {
    this._hasChanged = true;
    this.emit(CHANGE_EVENT, param || this);
};

module.exports = BaseStore;


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getIdFromUrlHash = getIdFromUrlHash;
function getIdFromUrlHash() {
    var hashParts = window.location.hash.split('#');
    return hashParts.length >= 2 ? hashParts[1].split('-')[1] : null;
}

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _screenfull = __webpack_require__(422);

var _screenfull2 = _interopRequireDefault(_screenfull);

var _reactResponsive = __webpack_require__(32);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _preloadImage = __webpack_require__(423);

var _preloadImage2 = _interopRequireDefault(_preloadImage);

var _breakpoints = __webpack_require__(38);

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _Fullscreen = __webpack_require__(78);

var _zoomLevelConstants = __webpack_require__(207);

var _zoomLevelConstants2 = _interopRequireDefault(_zoomLevelConstants);

var _zoom = __webpack_require__(424);

var _DesignDetailsSidebar = __webpack_require__(425);

var _DesignDetailsHeader = __webpack_require__(426);

var _AdminBarStatusProvider = __webpack_require__(433);

var _AdminBarStatusProvider2 = _interopRequireDefault(_AdminBarStatusProvider);

var _BlankSlate = __webpack_require__(434);

var _BlankSlate2 = _interopRequireDefault(_BlankSlate);

var _PreviewAlert = __webpack_require__(437);

var _PreviewAlert2 = _interopRequireDefault(_PreviewAlert);

var _DesignPane = __webpack_require__(438);

var _DesignPane2 = _interopRequireDefault(_DesignPane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var msUntilPreloadPagination = 5000;

var AppComponent = function (_React$Component) {
    _inherits(AppComponent, _React$Component);

    function AppComponent() {
        _classCallCheck(this, AppComponent);

        var _this = _possibleConstructorReturn(this, (AppComponent.__proto__ || Object.getPrototypeOf(AppComponent)).call(this));

        _this.inactiveUiTimer = null;
        _this.paginationPreloadTimer = null;

        _this.state = {
            isPresentationMode: false,
            zoomLevel: _zoomLevelConstants2.default.FIT_TO_CONTAINER,
            availableZoomLevels: [],
            viewSize: null,
            feedbackMode: 'annotate'
        };

        _this.clearDesignCommentSelection = _this.clearDesignCommentSelection.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleMaximize = _this.handleMaximize.bind(_this);
        _this.handleMinimize = _this.handleMinimize.bind(_this);
        _this.handleFullscreenChange = _this.handleFullscreenChange.bind(_this);
        _this.closeOverlayHandler = _this.closeOverlayHandler.bind(_this);
        _this.zoomIn = _this.zoomIn.bind(_this);
        _this.zoomOut = _this.zoomOut.bind(_this);
        return _this;
    }

    _createClass(AppComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('keydown', this.handleKeyDown);
            if (_screenfull2.default.enabled) {
                window.addEventListener(_screenfull2.default.raw.fullscreenchange, this.handleFullscreenChange);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _this2 = this;

            window.clearTimeout(this.paginationPreloadTimer);
            this.paginationPreloadTimer = window.setTimeout(function () {
                if (_this2.props.nextDesign) {
                    (0, _preloadImage2.default)(_this2.props.nextDesign.previewUrl);
                }
                if (_this2.props.previousDesign) {
                    (0, _preloadImage2.default)(_this2.props.previousDesign.previewUrl);
                }
            }, msUntilPreloadPagination);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.handleKeyDown);
            if (_screenfull2.default.enabled) {
                window.removeEventListener(_screenfull2.default.raw.fullscreenchange, this.handleFullscreenChange);
            }

            window.clearTimeout(this.inactiveUiTimer);
            window.clearTimeout(this.paginationPreloadTimer);
        }
    }, {
        key: 'setZoomLevel',
        value: function setZoomLevel(targetZoomLevel) {
            if (!this.state.viewSize) {
                return null;
            }

            var designDimensions = {
                width: this.props.design.width,
                height: this.props.design.height
            };

            var availableZoomLevels = (0, _zoom.getAvailableZoomLevels)(designDimensions, this.state.viewSize);

            var isValidTargetZoom = !targetZoomLevel || availableZoomLevels.indexOf(targetZoomLevel) === -1;
            var zoomLevel = isValidTargetZoom ? this.getDefaultZoomLevel(availableZoomLevels) : targetZoomLevel;

            this.setState({
                availableZoomLevels: availableZoomLevels,
                zoomLevel: zoomLevel
            });
        }
    }, {
        key: 'getDefaultZoomLevel',
        value: function getDefaultZoomLevel(availableZoomLevels) {
            if (availableZoomLevels.indexOf(_zoomLevelConstants2.default.FIT_TO_CONTAINER) > -1) {
                return _zoomLevelConstants2.default.FIT_TO_CONTAINER;
            } else if (availableZoomLevels.indexOf(_zoomLevelConstants2.default.FIT_TO_NATIVE) > -1) {
                return _zoomLevelConstants2.default.FIT_TO_NATIVE;
            } else {
                return _zoomLevelConstants2.default.FLUID;
            }
        }
    }, {
        key: 'zoomOut',
        value: function zoomOut() {
            var level = this.getPrevZoomLevel();
            if (level) {
                this.setZoomLevel(level);
            }
        }
    }, {
        key: 'zoomIn',
        value: function zoomIn() {
            var level = this.getNextZoomLevel();
            if (level) {
                this.setZoomLevel(level);
            }
        }
    }, {
        key: 'canZoomIn',
        value: function canZoomIn() {
            return Boolean(this.getNextZoomLevel());
        }
    }, {
        key: 'canZoomOut',
        value: function canZoomOut() {
            return Boolean(this.getPrevZoomLevel());
        }
    }, {
        key: 'getNextZoomLevel',
        value: function getNextZoomLevel() {
            var index = this.state.availableZoomLevels.indexOf(this.state.zoomLevel);
            var nextIndex = index + 1;
            return this.state.availableZoomLevels[nextIndex] ? this.state.availableZoomLevels[nextIndex] : null;
        }
    }, {
        key: 'getPrevZoomLevel',
        value: function getPrevZoomLevel() {
            var index = this.state.availableZoomLevels.indexOf(this.state.zoomLevel);
            var prevIndex = index - 1;
            return this.state.availableZoomLevels[prevIndex] ? this.state.availableZoomLevels[prevIndex] : null;
        }
    }, {
        key: 'closeOverlayHandler',
        value: function closeOverlayHandler() {
            var _this3 = this;

            if (document.querySelector('body[data-modal-status="active"]') === null) {
                // Both the modal and the overlay are listening for ESC events
                if (this.props.isInline) {
                    window.setTimeout(function () {
                        _this3.props.goBack();
                    }, this.props.onCloseDelayDuration);
                }
            }
            window.dispatchEvent(new CustomEvent('ddoDidClose'));
        }
    }, {
        key: 'isKeypressInTextarea',
        value: function isKeypressInTextarea(e) {
            return e.target && e.target.nodeName === 'TEXTAREA';
        }
    }, {
        key: 'isArrowKeypress',
        value: function isArrowKeypress(e) {
            return [39, 37].indexOf(e.keyCode) > -1;
        }
    }, {
        key: 'handleEsc',
        value: function handleEsc(e) {
            if (this.isKeypressInTextarea(e)) {
                this.clearDesignCommentSelection();
                _reactDom2.default.findDOMNode(this).focus(); // eslint-disable-line react/no-find-dom-node
            } else if (this.props.selectedComment && this.props.selectedComment.annotation) {
                this.clearDesignCommentSelection();
            } else if (this.state.isPresentationMode) {
                this.handleMinimize();
            } else {
                this.closeOverlayHandler();
            }
        }
    }, {
        key: 'handleArrowKeys',
        value: function handleArrowKeys(e) {
            if (!this.isKeypressInTextarea(e)) {
                // left
                if (e.keyCode === 37) {
                    this.props.goToPrevious();
                }

                // right
                if (e.keyCode === 39) {
                    this.props.goToNext();
                }
            }
        }
    }, {
        key: 'handleKeyDown',
        value: function handleKeyDown(e) {
            if (!this.isKeypressInTextarea(e)) {
                // "+" key
                if (e.shiftKey && e.keyCode === 187) {
                    return this.zoomIn();
                }

                // "-" key
                if (e.keyCode === 189) {
                    return this.zoomOut();
                }
            }

            // ESC
            if (e.keyCode === 27) {
                return this.handleEsc(e);
            }

            if (this.isArrowKeypress(e)) {
                return this.handleArrowKeys(e);
            }
        }
    }, {
        key: 'clearDesignCommentSelection',
        value: function clearDesignCommentSelection() {
            if (this.props.selectedComment) {
                this.props.clearDesignCommentSelection();
            }
        }
    }, {
        key: 'handleMaximize',
        value: function handleMaximize() {
            if (_screenfull2.default.enabled) {
                _screenfull2.default.request();
            }

            this.setState(function () {
                return {
                    isPresentationMode: true
                };
            });
        }
    }, {
        key: 'handleFullscreenChange',
        value: function handleFullscreenChange() {
            if (_screenfull2.default.enabled) {
                this.setState(function () {
                    return {
                        isPresentationMode: _screenfull2.default.isFullscreen
                    };
                });
            }
        }
    }, {
        key: 'handleMinimize',
        value: function handleMinimize() {
            if (_screenfull2.default.enabled) {
                _screenfull2.default.exit();
            }

            this.setState(function () {
                return {
                    isPresentationMode: false
                };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            return _react2.default.createElement(_AdminBarStatusProvider2.default, {
                render: function render(hasAdminBarOffset) {
                    return _react2.default.createElement(
                        'div',
                        {
                            style: {
                                height: '100%',
                                width: '100%',
                                position: 'absolute',
                                left: '0',
                                top: '0'
                            },
                            id: 'design-details-annotations-anchor'
                        },
                        _react2.default.createElement(
                            _Fullscreen.FullscreenOverlay,
                            {
                                onClick: _this4.clearDesignCommentSelection,
                                isActive: true,
                                isScrollableSmallScreens: true,
                                handleKeyDown: _this4.handleKeyDown,
                                enableScroll: _this4.props.isInline,
                                closeOverlayHandler: _this4.closeOverlayHandler,
                                hasAdminBarOffset: hasAdminBarOffset
                            },
                            _react2.default.createElement(
                                _Fullscreen.FullscreenFrame.Frame,
                                { isSidebarHidden: _this4.state.isPresentationMode },
                                _react2.default.createElement(
                                    _Fullscreen.FullscreenFrame.Main,
                                    null,
                                    _react2.default.createElement(
                                        _Fullscreen.FullscreenMain.Main,
                                        { hasHeader: true },
                                        _react2.default.createElement(
                                            _Fullscreen.FullscreenMain.Header,
                                            null,
                                            _react2.default.createElement(_DesignDetailsHeader.ConnectedDesignDetailsHeader, {
                                                feedbackMode: _this4.state.feedbackMode,
                                                toggleFeedbackMode: function toggleFeedbackMode(feedbackMode) {
                                                    return _this4.setState({ feedbackMode: feedbackMode });
                                                },
                                                design: _this4.props.design,
                                                zoomIn: _this4.canZoomIn() ? _this4.zoomIn : null,
                                                zoomOut: _this4.canZoomOut() ? _this4.zoomOut : null,
                                                goToPrevious: _this4.props.goToPrevious,
                                                goToNext: _this4.props.goToNext,
                                                closeOverlayHandler: _this4.closeOverlayHandler,
                                                handleMaximize: _this4.handleMaximize,
                                                handleMinimize: _this4.handleMinimize,
                                                isPresentationMode: _this4.state.isPresentationMode,
                                                isInline: _this4.props.isInline,
                                                seeMoreDesignsUrl: _this4.props.headerSeeMoreDesignsUrl
                                            })
                                        ),
                                        _react2.default.createElement(
                                            _Fullscreen.FullscreenMain.Body,
                                            { variations: ['design-details'] },
                                            _react2.default.createElement(_PreviewAlert2.default, { design: _this4.props.design }),
                                            _this4.renderDesignPane(),
                                            _react2.default.createElement(_BlankSlate2.default, { design: _this4.props.design }),
                                            _this4.props.renderDesignCanvasOverlay && _this4.props.renderDesignCanvasOverlay({
                                                design: _this4.props.design
                                            })
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    _Fullscreen.FullscreenFrame.Sidebar,
                                    null,
                                    _this4.renderSidebar()
                                )
                            )
                        )
                    );
                }
            });
        }
    }, {
        key: 'renderSidebar',
        value: function renderSidebar() {
            var _this5 = this;

            return _react2.default.createElement(
                _reactResponsive2.default,
                { minWidth: _breakpoints2.default.normal[0] },
                function (isDesktop) {
                    if (isDesktop || !isDesktop && _this5.state.feedbackMode != 'sketch') {
                        return _react2.default.createElement(_DesignDetailsSidebar.ConnectedSidebarComponent, {
                            renderSidebar: _this5.props.renderSidebar,
                            goToNext: _this5.props.goToNext,
                            goToPrevious: _this5.props.goToPrevious,
                            design: _this5.props.design,
                            isInline: _this5.props.isInline,
                            closeOverlayHandler: _this5.closeOverlayHandler
                        });
                    }
                    return null;
                }
            );
        }
    }, {
        key: 'renderDesignPane',
        value: function renderDesignPane() {
            var _this6 = this;

            if (!this.props.design.permission.canView || !this.props.design.width) return null;

            return _react2.default.createElement(_DesignPane2.default, {
                feedbackMode: this.state.feedbackMode,
                isPresentationMode: this.state.isPresentationMode,
                zoomLevel: this.state.zoomLevel,
                onSize: function onSize(size) {
                    return _this6.setState({ viewSize: size }, function () {
                        return _this6.setZoomLevel(_this6.state.zoomLevel);
                    });
                },
                design: this.props.design,
                goToNext: this.props.goToNext,
                goToPrevious: this.props.goToPrevious,
                isTransitioning: this.props.isTransitioning
            });
        }
    }]);

    return AppComponent;
}(_react2.default.Component);

exports.default = AppComponent;


AppComponent.propTypes = {
    design: _propTypes2.default.object.isRequired,
    goBack: _propTypes2.default.func.isRequired,
    goToNext: _propTypes2.default.func.isRequired,
    goToPrevious: _propTypes2.default.func.isRequired,
    selectedComment: _propTypes2.default.object,
    nextDesign: _propTypes2.default.object,
    previousDesign: _propTypes2.default.object,
    isInline: _propTypes2.default.bool,
    onCloseDelayDuration: _propTypes2.default.number,
    renderSidebar: _propTypes2.default.func.isRequired,
    renderDesignCanvasOverlay: _propTypes2.default.func, // TODO provide this to DesignPane
    headerSeeMoreDesignsUrl: _propTypes2.default.string,
    clearDesignCommentSelection: _propTypes2.default.func,
    isTransitioning: _propTypes2.default.bool
};

AppComponent.defaultProps = {
    nextDesign: null,
    previousDesign: null,
    isInline: true,
    hasFocusedComment: false,
    onCloseDelayDuration: 230,
    isTransitioning: false
};

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

/*!
* screenfull
* v3.3.3 - 2018-09-04
* (c) Sindre Sorhus; MIT License
*/
(function () {
	'use strict';

	var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
	var isCommonjs = typeof module !== 'undefined' && module.exports;
	var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;

	var fn = (function () {
		var val;

		var fnMap = [
			[
				'requestFullscreen',
				'exitFullscreen',
				'fullscreenElement',
				'fullscreenEnabled',
				'fullscreenchange',
				'fullscreenerror'
			],
			// New WebKit
			[
				'webkitRequestFullscreen',
				'webkitExitFullscreen',
				'webkitFullscreenElement',
				'webkitFullscreenEnabled',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			// Old WebKit (Safari 5.1)
			[
				'webkitRequestFullScreen',
				'webkitCancelFullScreen',
				'webkitCurrentFullScreenElement',
				'webkitCancelFullScreen',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			[
				'mozRequestFullScreen',
				'mozCancelFullScreen',
				'mozFullScreenElement',
				'mozFullScreenEnabled',
				'mozfullscreenchange',
				'mozfullscreenerror'
			],
			[
				'msRequestFullscreen',
				'msExitFullscreen',
				'msFullscreenElement',
				'msFullscreenEnabled',
				'MSFullscreenChange',
				'MSFullscreenError'
			]
		];

		var i = 0;
		var l = fnMap.length;
		var ret = {};

		for (; i < l; i++) {
			val = fnMap[i];
			if (val && val[1] in document) {
				for (i = 0; i < val.length; i++) {
					ret[fnMap[0][i]] = val[i];
				}
				return ret;
			}
		}

		return false;
	})();

	var eventNameMap = {
		change: fn.fullscreenchange,
		error: fn.fullscreenerror
	};

	var screenfull = {
		request: function (elem) {
			var request = fn.requestFullscreen;

			elem = elem || document.documentElement;

			// Work around Safari 5.1 bug: reports support for
			// keyboard in fullscreen even though it doesn't.
			// Browser sniffing, since the alternative with
			// setTimeout is even worse.
			if (/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) {
				elem[request]();
			} else {
				elem[request](keyboardAllowed ? Element.ALLOW_KEYBOARD_INPUT : {});
			}
		},
		exit: function () {
			document[fn.exitFullscreen]();
		},
		toggle: function (elem) {
			if (this.isFullscreen) {
				this.exit();
			} else {
				this.request(elem);
			}
		},
		onchange: function (callback) {
			this.on('change', callback);
		},
		onerror: function (callback) {
			this.on('error', callback);
		},
		on: function (event, callback) {
			var eventName = eventNameMap[event];
			if (eventName) {
				document.addEventListener(eventName, callback, false);
			}
		},
		off: function (event, callback) {
			var eventName = eventNameMap[event];
			if (eventName) {
				document.removeEventListener(eventName, callback, false);
			}
		},
		raw: fn
	};

	if (!fn) {
		if (isCommonjs) {
			module.exports = false;
		} else {
			window.screenfull = false;
		}

		return;
	}

	Object.defineProperties(screenfull, {
		isFullscreen: {
			get: function () {
				return Boolean(document[fn.fullscreenElement]);
			}
		},
		element: {
			enumerable: true,
			get: function () {
				return document[fn.fullscreenElement];
			}
		},
		enabled: {
			enumerable: true,
			get: function () {
				// Coerce to boolean in case of old WebKit
				return Boolean(document[fn.fullscreenEnabled]);
			}
		}
	});

	if (isCommonjs) {
		module.exports = screenfull;
	} else {
		window.screenfull = screenfull;
	}
})();


/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = preloadImage;
function preloadImage(src) {
    var image = new window.Image();
    image.src = src;
}

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDimensionsForZoomLevel = getDimensionsForZoomLevel;
exports.getAvailableZoomLevels = getAvailableZoomLevels;
exports.canFitToContainer = canFitToContainer;
exports.canFitToWidth = canFitToWidth;
exports.isEqualDimensions = isEqualDimensions;

var _zoomLevelConstants = __webpack_require__(207);

var _zoomLevelConstants2 = _interopRequireDefault(_zoomLevelConstants);

var _dom = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDimensionsForZoomLevel(zoomLevel, designDimensions, containerDimensions) {
    switch (zoomLevel) {
        case _zoomLevelConstants2.default.FLUID:
            return null;
        case _zoomLevelConstants2.default.FIT_TO_WIDTH:
            return (0, _dom.getDimensionsConstrainedToContainerWidth)(designDimensions, containerDimensions);
        case _zoomLevelConstants2.default.FIT_TO_CONTAINER:
            return (0, _dom.getDimensionsConstrainedToContainer)(designDimensions, containerDimensions);
        case _zoomLevelConstants2.default.FIT_TO_NATIVE:
            return designDimensions;
        default:
            return null;
    }
}

function getAvailableZoomLevels(designDimensions, containerDimensions) {
    var zoomLevels = [];

    if (!designDimensions || !containerDimensions) {
        return zoomLevels;
    }

    if (canFitToContainer(designDimensions, containerDimensions)) {
        zoomLevels.push(_zoomLevelConstants2.default.FIT_TO_CONTAINER);
    }

    if (canFitToWidth(designDimensions, containerDimensions)) {
        if (!isEqualDimensions((0, _dom.getDimensionsConstrainedToContainerWidth)(designDimensions, containerDimensions), (0, _dom.getDimensionsConstrainedToContainer)(designDimensions, containerDimensions))) {
            zoomLevels.push(_zoomLevelConstants2.default.FIT_TO_WIDTH);
        }
    }

    zoomLevels.push(_zoomLevelConstants2.default.FIT_TO_NATIVE);
    return zoomLevels;
}

function canFitToContainer(designDimensions, containerDimensions) {
    return !(designDimensions.width < containerDimensions.width && designDimensions.height < containerDimensions.height);
}

function canFitToWidth(designDimensions, containerDimensions) {
    return designDimensions.width > containerDimensions.width && designDimensions.height > containerDimensions.height;
}

function isEqualDimensions(a, b) {
    return a.width === b.width && a.height === b.height;
}

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConnectedSidebarComponent = undefined;

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _connectToStores = __webpack_require__(91);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _DesignCommentsStore = __webpack_require__(117);

var _DesignCommentsStore2 = _interopRequireDefault(_DesignCommentsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var InjectedSidebarComponent = function InjectedSidebarComponent(_ref) {
    var renderSidebar = _ref.renderSidebar,
        props = _objectWithoutProperties(_ref, ['renderSidebar']);

    return renderSidebar(props);
};

InjectedSidebarComponent.contextTypes = {
    getStore: _propTypes2.default.func
};

var ConnectedSidebarComponent = exports.ConnectedSidebarComponent = (0, _connectToStores2.default)(InjectedSidebarComponent, [_DesignCommentsStore2.default], function (context) {
    return {
        isLoadingComments: context.getStore(_DesignCommentsStore2.default).isLoadingComments,
        isLoaded: context.getStore(_DesignCommentsStore2.default).isLoaded,
        comments: context.getStore(_DesignCommentsStore2.default).comments,
        selectedComment: context.getStore(_DesignCommentsStore2.default).selectedComment,
        selectedCommentStatus: context.getStore(_DesignCommentsStore2.default).selectedCommentStatus,
        selectedCommentEditingLocation: context.getStore(_DesignCommentsStore2.default).selectedCommentEditingLocation
    };
});

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConnectedDesignDetailsHeader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(6);

var _Fullscreen = __webpack_require__(78);

var _ButtonList = __webpack_require__(171);

var _IconButton = __webpack_require__(21);

var _Icon = __webpack_require__(8);

var _LinkWithIcon = __webpack_require__(252);

var _Desktop = __webpack_require__(54);

var _Mobile = __webpack_require__(55);

var _FeedbackControls = __webpack_require__(428);

var _ViewControls = __webpack_require__(429);

var _ViewControls2 = _interopRequireDefault(_ViewControls);

var _DesignDetailsPagination = __webpack_require__(430);

var _DesignDetailsPagination2 = _interopRequireDefault(_DesignDetailsPagination);

var _connectToStores = __webpack_require__(91);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _DesignCollectionStore = __webpack_require__(170);

var _DesignCollectionStore2 = _interopRequireDefault(_DesignCollectionStore);

var _DesignSketchesStore = __webpack_require__(138);

var _DesignSketchesStore2 = _interopRequireDefault(_DesignSketchesStore);

var _DesignCommentsStore = __webpack_require__(117);

var _DesignCommentsStore2 = _interopRequireDefault(_DesignCommentsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pagination = (0, _reactIntl.injectIntl)(_DesignDetailsPagination2.default);

var DesignDetailsHeader = function (_React$Component) {
    _inherits(DesignDetailsHeader, _React$Component);

    function DesignDetailsHeader(props) {
        _classCallCheck(this, DesignDetailsHeader);

        var _this = _possibleConstructorReturn(this, (DesignDetailsHeader.__proto__ || Object.getPrototypeOf(DesignDetailsHeader)).call(this, props));

        _this.state = {
            idle: false
        };

        _this.setIdleState = _this.setIdleState.bind(_this);
        return _this;
    }

    _createClass(DesignDetailsHeader, [{
        key: 'setIdleState',
        value: function setIdleState(state) {
            this.setState({ idle: state });
        }
    }, {
        key: 'renderNavigation',
        value: function renderNavigation() {
            if (this.props.isInline) {
                return _react2.default.createElement(Pagination, {
                    key: this.props.design.designId,
                    currentPage: this.props.currentPage,
                    onNext: this.props.goToNext,
                    onPrevious: this.props.goToPrevious,
                    totalPages: this.props.totalPages
                });
            } else {
                var total = this.props.totalPages;
                return this.props.seeMoreDesignsUrl ? _react2.default.createElement(
                    _LinkWithIcon.LinkWithIcon,
                    { href: this.props.seeMoreDesignsUrl, icon: _react2.default.createElement(_Icon.Icon, { type: 'grid-1' }) },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: total > 1 ? 'see_all_designs' : 'see_other_designs',
                        values: { number: total }
                    })
                ) : _react2.default.createElement(
                    'div',
                    { className: 'logo-99designs' },
                    _react2.default.createElement(
                        'a',
                        { href: '/', className: 'logo-99designs__logo' },
                        '99designs'
                    )
                );
            }
        }
    }, {
        key: 'renderCloseButton',
        value: function renderCloseButton() {
            return _react2.default.createElement(
                _ButtonList.ButtonListItem,
                null,
                _react2.default.createElement(
                    _IconButton.IconButton,
                    {
                        key: 'closeBtn',
                        title: this.context.intl.formatMessage({ id: 'close_ddo_tooltip' }),
                        onClick: this.props.closeOverlayHandler
                    },
                    _react2.default.createElement(_Icon.Icon, { type: 'x-3' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var isLoadingComments = this.props.isLoadingComments;


            return _react2.default.createElement(
                _Fullscreen.FullscreenHeader.Header,
                {
                    variations: this.props.isPresentationMode && this.state.idle ? ['inactive', 'design-details'] : ['design-details']
                },
                _react2.default.createElement(
                    _Fullscreen.FullscreenHeader.Item,
                    { variations: ['design-details'] },
                    this.renderNavigation()
                ),
                isLoadingComments && _react2.default.createElement(
                    _Mobile.Mobile,
                    null,
                    _react2.default.createElement(StatusIndicator, { state: 'loading' })
                ),
                this.context.scribblesEnabled && this.props.design.permission.canViewSketches && _react2.default.createElement(
                    _Desktop.Desktop,
                    null,
                    _react2.default.createElement(StatusIndicator, { state: this.props.sketchState })
                ),
                this.context.scribblesEnabled && this.props.design.permission.canSketch && !this.props.isPresentationMode && _react2.default.createElement(
                    _Desktop.Desktop,
                    null,
                    _react2.default.createElement(_FeedbackControls.ConnectedFeedbackControls, {
                        designId: this.props.design.designId,
                        feedbackMode: this.props.feedbackMode,
                        toggleFeedbackMode: this.props.toggleFeedbackMode
                    })
                ),
                this.props.design.permission.canView && _react2.default.createElement(
                    _Desktop.Desktop,
                    null,
                    _react2.default.createElement(_ViewControls2.default, {
                        setIdleState: this.setIdleState,
                        handleMinimize: this.props.handleMinimize,
                        handleMaximize: this.props.handleMaximize,
                        isPresentationMode: this.props.isPresentationMode,
                        zoomIn: this.props.zoomIn,
                        zoomOut: this.props.zoomOut
                    })
                ),
                this.props.isInline && _react2.default.createElement(
                    _Mobile.Mobile,
                    null,
                    _react2.default.createElement(
                        _Fullscreen.FullscreenHeader.Item,
                        { variations: ['design-details'] },
                        this.renderCloseButton()
                    )
                )
            );
        }
    }]);

    return DesignDetailsHeader;
}(_react2.default.Component);

exports.default = DesignDetailsHeader;


DesignDetailsHeader.contextTypes = {
    intl: _propTypes2.default.object.isRequired,
    scribblesEnabled: _propTypes2.default.bool.isRequired
};

DesignDetailsHeader.propTypes = {
    design: _propTypes2.default.object,
    isInline: _propTypes2.default.bool,
    isPresentationMode: _propTypes2.default.bool,
    handleMaximize: _propTypes2.default.func,
    handleMinimize: _propTypes2.default.func,
    goToNext: _propTypes2.default.func,
    goToPrevious: _propTypes2.default.func,
    closeOverlayHandler: _propTypes2.default.func,
    totalPages: _propTypes2.default.number,
    currentPage: _propTypes2.default.number,
    seeMoreDesignsUrl: _propTypes2.default.string,
    zoomIn: _propTypes2.default.func,
    zoomOut: _propTypes2.default.func,
    feedbackMode: _propTypes2.default.string.isRequired,
    toggleFeedbackMode: _propTypes2.default.func.isRequired,
    sketchState: _propTypes2.default.string
};

DesignDetailsHeader.defaultProps = {
    isInline: true,
    isPresentationMode: false,
    handleMinimize: function handleMinimize() {},
    handleMaximize: function handleMaximize() {},
    goToPrevious: function goToPrevious() {},
    goToNext: function goToNext() {},
    closeOverlayHandler: function closeOverlayHandler() {},

    totalPages: 1,
    currentPage: 1,
    zoomIn: null,
    zoomOut: null,
    sketchState: ''
};

var ConnectedDesignDetailsHeader = exports.ConnectedDesignDetailsHeader = (0, _connectToStores2.default)(DesignDetailsHeader, [_DesignCollectionStore2.default, _DesignSketchesStore2.default, _DesignCommentsStore2.default], function (context, props) {
    var collectionStore = context.getStore(_DesignCollectionStore2.default);
    var isLoadingComments = context.getStore(_DesignCommentsStore2.default).isLoadingComments;
    return {
        totalPages: collectionStore.totalDesignCount,
        currentPage: collectionStore.getCurrentPage(props.design.designId),
        sketchState: context.getStore(_DesignSketchesStore2.default).getDesignSketchState(props.design.designId),
        isLoadingComments: isLoadingComments
    };
});

DesignDetailsHeader.propTypes = {
    state: _propTypes2.default.string
};

ConnectedDesignDetailsHeader.propTypes = DesignDetailsHeader.propTypes;
ConnectedDesignDetailsHeader.defaultProps = DesignDetailsHeader.defaultProps;

var StatusIndicator = function StatusIndicator(_ref) {
    var state = _ref.state;

    var message = void 0;
    switch (state) {
        case 'loading':
            message = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'sketches_loading' });
            break;
        case 'saving':
            message = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'sketches_saving' });
            break;
        case 'saved':
            message = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'sketches_saved' });
            break;
        case 'error':
            message = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'sketches_error' });
            break;
        default:
            message = null;
            break;
    }

    var variations = ['status'];

    if (state === 'saved') {
        variations.push('saved');
    }

    return _react2.default.createElement(
        _Fullscreen.FullscreenHeader.Item,
        { key: state, variations: variations },
        message
    );
};

StatusIndicator.propTypes = DesignDetailsHeader.propTypes;

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonListItem = exports.ButtonList = undefined;

var _app = __webpack_require__(2);

var ButtonList = exports.ButtonList = (0, _app.bemComponent)('button-list', 'ButtonList');
var ButtonListItem = exports.ButtonListItem = (0, _app.bemComponent)('button-list__item', 'ButtonListItem');
exports.default = ButtonList;

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConnectedFeedbackControls = undefined;

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Fullscreen = __webpack_require__(78);

var _ButtonList = __webpack_require__(171);

var _IconButton = __webpack_require__(21);

var _Icon = __webpack_require__(8);

var _platform = __webpack_require__(123);

var _connectToStores = __webpack_require__(91);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _DesignSketchesStore = __webpack_require__(138);

var _DesignSketchesStore2 = _interopRequireDefault(_DesignSketchesStore);

var _designSketches = __webpack_require__(208);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackControls = function FeedbackControls(props, context) {
    return _react2.default.createElement(
        _Fullscreen.FullscreenHeader.Item,
        { variations: ['design-details'] },
        _react2.default.createElement(
            _ButtonList.ButtonList,
            { variations: ['compact', 'flex'] },
            props.canUndo && _react2.default.createElement(
                _ButtonList.ButtonListItem,
                null,
                _react2.default.createElement(
                    _IconButton.IconButton,
                    {
                        onClick: props.undoLastPath,
                        variations: ['lighter', 'transparent-circled', 'bounce-in'],
                        title: context.intl.formatMessage({ id: 'undo_sketch' })
                    },
                    _react2.default.createElement(_Icon.Icon, { type: 'undo-1' })
                )
            )
        ),
        _react2.default.createElement(
            _ButtonList.ButtonList,
            { variations: ['compact', 'flex', 'darker'] },
            _react2.default.createElement(
                _ButtonList.ButtonListItem,
                { variations: ['flex'] },
                _react2.default.createElement(
                    _IconButton.IconButton,
                    {
                        title: context.intl.formatMessage({ id: 'sketch_feedback_mode' }),
                        onClick: function onClick() {
                            (0, _platform.trackEvent)('Clicked on scribbles tool');
                            props.toggleFeedbackMode('sketch');
                        },
                        variations: props.feedbackMode === 'sketch' ? ['on-dark', 'filled-circled', 'bounce-in'] : ['lighter', 'transparent-circled', 'bounce-in']
                    },
                    _react2.default.createElement(_Icon.Icon, { type: 'sketch-1' })
                )
            ),
            _react2.default.createElement(
                _ButtonList.ButtonListItem,
                null,
                _react2.default.createElement(
                    _IconButton.IconButton,
                    {
                        title: context.intl.formatMessage({ id: 'annotate_feedback_mode' }),
                        onClick: function onClick() {
                            (0, _platform.trackEvent)('Clicked on annotation tool');
                            props.toggleFeedbackMode('annotate');
                        },
                        variations: props.feedbackMode === 'annotate' ? ['on-dark', 'filled-circled'] : ['lighter', 'transparent-circled']
                    },
                    _react2.default.createElement(_Icon.Icon, { type: 'annotate-1' })
                )
            )
        )
    );
};

FeedbackControls.contextTypes = {
    intl: _propTypes2.default.object.isRequired
};

FeedbackControls.propTypes = {
    feedbackMode: _propTypes2.default.string.isRequired,
    toggleFeedbackMode: _propTypes2.default.func.isRequired,
    canUndo: _propTypes2.default.bool.isRequired,
    undoLastPath: _propTypes2.default.func.isRequired
};

var ConnectedFeedbackControls = exports.ConnectedFeedbackControls = (0, _connectToStores2.default)(FeedbackControls, [_DesignSketchesStore2.default], function (context, props) {
    var sketchesStore = context.getStore(_DesignSketchesStore2.default);
    return {
        canUndo: sketchesStore.getPathsFromDesignSketch(props.designId).length > 0,
        undoLastPath: function undoLastPath() {
            return context.executeAction(_designSketches.undoLastDesignPath, {
                designId: props.designId,
                csrfToken: context.csrfToken
            });
        }
    };
});

ConnectedFeedbackControls.contextTypes = {
    executeAction: _propTypes2.default.func.isRequired,
    getStore: _propTypes2.default.func.isRequired,
    csrfToken: _propTypes2.default.string
};

ConnectedFeedbackControls.propTypes = {
    designId: _propTypes2.default.number.isRequired,
    feedbackMode: _propTypes2.default.string.isRequired,
    toggleFeedbackMode: _propTypes2.default.func.isRequired
};

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Fullscreen = __webpack_require__(78);

var _ButtonList = __webpack_require__(171);

var _IconButton = __webpack_require__(21);

var _Icon = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewControls = function (_React$Component) {
    _inherits(ViewControls, _React$Component);

    function ViewControls(props) {
        _classCallCheck(this, ViewControls);

        var _this = _possibleConstructorReturn(this, (ViewControls.__proto__ || Object.getPrototypeOf(ViewControls)).call(this, props));

        _this.handleMaximize = _this.handleMaximize.bind(_this);
        _this.resetTimer = _this.resetTimer.bind(_this);
        return _this;
    }

    _createClass(ViewControls, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            if (this.props.isPresentationMode) {
                window.addEventListener('mousemove', this.resetTimer, true);
                window.addEventListener('keypress', this.resetTimer, true);
                window.addEventListener('click', this.resetTimer, true);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.isPresentationMode) {
                window.addEventListener('mousemove', this.resetTimer, true);
                window.addEventListener('keypress', this.resetTimer, true);
                window.addEventListener('click', this.resetTimer, true);
            } else {
                window.removeEventListener('mousemove', this.resetTimer);
                window.removeEventListener('keypress', this.resetTimer);
                window.removeEventListener('click', this.resetTimer);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.clearTimeout(this.idleTimer);
            window.removeEventListener('mousemove', this.resetTimer);
            window.removeEventListener('keypress', this.resetTimer);
            window.removeEventListener('click', this.resetTimer);
        }
    }, {
        key: 'resetTimer',
        value: function resetTimer() {
            var _this2 = this;

            this.props.setIdleState(false);
            window.clearTimeout(this.idleTimer);
            this.idleTimer = window.setTimeout(function () {
                _this2.props.setIdleState(true);
            }, 3000);
        }
    }, {
        key: 'handleMaximize',
        value: function handleMaximize() {
            this.resetTimer();
            this.props.handleMaximize();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _Fullscreen.FullscreenHeader.Item,
                { variations: ['design-details'] },
                _react2.default.createElement(
                    _ButtonList.ButtonList,
                    { variations: ['spacious'] },
                    _react2.default.createElement(
                        _ButtonList.ButtonListItem,
                        null,
                        _react2.default.createElement(
                            _IconButton.IconButton,
                            {
                                title: this.context.intl.formatMessage({ id: 'zoom_in_tooltip' }),
                                onClick: this.props.zoomIn,
                                variations: ['darker', 'on-white'],
                                isDisabled: this.props.zoomIn === null
                            },
                            _react2.default.createElement(_Icon.Icon, { type: 'zoom-in-1', variations: ['large'] })
                        )
                    ),
                    _react2.default.createElement(
                        _ButtonList.ButtonListItem,
                        null,
                        _react2.default.createElement(
                            _IconButton.IconButton,
                            {
                                onClick: this.props.zoomOut,
                                title: this.context.intl.formatMessage({ id: 'zoom_out_tooltip' }),
                                variations: ['darker', 'on-white'],
                                isDisabled: this.props.zoomOut === null
                            },
                            _react2.default.createElement(_Icon.Icon, { type: 'zoom-out-1', variations: ['large'] })
                        )
                    ),
                    _react2.default.createElement(
                        _ButtonList.ButtonListItem,
                        null,
                        this.props.isPresentationMode ? _react2.default.createElement(
                            _IconButton.IconButton,
                            {
                                key: 'minimizeBtn',
                                title: this.context.intl.formatMessage({
                                    id: 'exit_fullscreen_tooltip'
                                }),
                                variations: ['darker', 'on-white'],
                                onClick: this.props.handleMinimize
                            },
                            _react2.default.createElement(_Icon.Icon, { type: 'minimize-1', variations: ['large'] })
                        ) : _react2.default.createElement(
                            _IconButton.IconButton,
                            {
                                key: 'maximizeBtn',
                                title: this.context.intl.formatMessage({
                                    id: 'enter_fullscreen_tooltip'
                                }),
                                variations: ['darker', 'on-white'],
                                onClick: this.props.handleMaximize
                            },
                            _react2.default.createElement(_Icon.Icon, { type: 'maximize-1', variations: ['large'] })
                        )
                    )
                )
            );
        }
    }]);

    return ViewControls;
}(_react2.default.Component);

exports.default = ViewControls;


ViewControls.propTypes = {
    isPresentationMode: _propTypes2.default.bool,
    setIdleState: _propTypes2.default.func,
    handleMinimize: _propTypes2.default.func,
    handleMaximize: _propTypes2.default.func,
    zoomIn: _propTypes2.default.func,
    zoomOut: _propTypes2.default.func
};

ViewControls.contextTypes = {
    intl: _propTypes2.default.object.isRequired
};

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = __webpack_require__(431);

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactIntl = __webpack_require__(6);

var _Icon = __webpack_require__(8);

var _IconButton = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DesignDetailsPagination = function (_React$Component) {
    _inherits(DesignDetailsPagination, _React$Component);

    function DesignDetailsPagination(props) {
        _classCallCheck(this, DesignDetailsPagination);

        var _this = _possibleConstructorReturn(this, (DesignDetailsPagination.__proto__ || Object.getPrototypeOf(DesignDetailsPagination)).call(this, props));

        _this.shouldComponentUpdate = _reactAddonsPureRenderMixin2.default.shouldComponentUpdate.bind(_this);
        return _this;
    }

    _createClass(DesignDetailsPagination, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'pagination pagination--small pagination--design-details' },
                this.previousButton(),
                _react2.default.createElement(
                    'div',
                    { className: 'pagination__item' },
                    _react2.default.createElement(
                        'span',
                        null,
                        this.props.currentPage,
                        ' / ',
                        this.props.totalPages
                    )
                ),
                this.nextButton()
            );
        }
    }, {
        key: 'previousButton',
        value: function previousButton() {
            return _react2.default.createElement(
                'div',
                { className: 'pagination__item pagination--prev' },
                _react2.default.createElement(
                    _IconButton.IconButton,
                    {
                        variations: ['on-white'],
                        onClick: this.props.onPrevious,
                        title: this.props.intl.formatMessage({ id: 'pagination_previous_tooltip' }),
                        isDisabled: this.props.currentPage === 1
                    },
                    _react2.default.createElement(_Icon.Icon, { type: 'left-2', variations: ['2x'] })
                )
            );
        }
    }, {
        key: 'nextButton',
        value: function nextButton() {
            return _react2.default.createElement(
                'div',
                { className: 'pagination__item pagination__next' },
                _react2.default.createElement(
                    _IconButton.IconButton,
                    {
                        variations: ['on-white'],
                        onClick: this.props.onNext,
                        title: this.props.intl.formatMessage({ id: 'pagination_next_tooltip' }),
                        isDisabled: this.props.currentPage === this.props.totalPages
                    },
                    _react2.default.createElement(_Icon.Icon, { type: 'right-2', variations: ['2x'] })
                )
            );
        }
    }]);

    return DesignDetailsPagination;
}(_react2.default.Component);

exports.default = DesignDetailsPagination;


DesignDetailsPagination.propTypes = {
    totalPages: _propTypes2.default.number,
    currentPage: _propTypes2.default.number,
    onPrevious: _propTypes2.default.func,
    onNext: _propTypes2.default.func,
    intl: _reactIntl.intlShape.isRequired
};

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var shallowEqual = __webpack_require__(432);

module.exports = {
  shouldComponentUpdate: function(nextProps, nextState) {
    return (
      !shallowEqual(this.props, nextProps) ||
      !shallowEqual(this.state, nextState)
    );
  }
};


/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdminBarStatusProvider = function (_Component) {
    _inherits(AdminBarStatusProvider, _Component);

    function AdminBarStatusProvider(props) {
        _classCallCheck(this, AdminBarStatusProvider);

        var _this = _possibleConstructorReturn(this, (AdminBarStatusProvider.__proto__ || Object.getPrototypeOf(AdminBarStatusProvider)).call(this, props));

        _this.state = {
            hasAdminBarOffset: false
        };
        _this.showHandler = function () {
            return _this.setState({ hasAdminBarOffset: true });
        };
        _this.hideHandler = function () {
            return _this.setState({ hasAdminBarOffset: false });
        };
        return _this;
    }

    _createClass(AdminBarStatusProvider, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var adminBar = document.querySelector('[data-admin-bar]');
            if (adminBar) {
                adminBar.setAttribute('data-sticky', true);
                this.setState({ hasAdminBarOffset: !adminBar.getAttribute('data-hidden') });
            }
            window.addEventListener('brandContainer.ui.adminBarShown', this.showHandler);
            window.addEventListener('brandContainer.ui.adminBarHidden', this.hideHandler);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var adminBar = document.querySelector('[data-admin-bar]');
            if (adminBar) {
                adminBar.removeAttribute('data-sticky');
            }
            window.removeEventListener('brandContainer.ui.adminBarShown', this.showHandler);
            window.removeEventListener('brandContainer.ui.adminBarHidden', this.hideHandler);
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.render(this.state.hasAdminBarOffset);
        }
    }]);

    return AdminBarStatusProvider;
}(_react.Component);

AdminBarStatusProvider.propTypes = {
    render: _propTypes2.default.func.isRequired
};

exports.default = AdminBarStatusProvider;

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(6);

var _BlankSlate = __webpack_require__(435);

var _Icon = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlankSlate = function BlankSlate(_ref) {
    var design = _ref.design;

    if (design.permission.canView && design.width) {
        return null;
    }
    if (design.isDeleted) {
        return _react2.default.createElement(DeletedBlankSlate, null);
    }
    if (design.permission.canView && !design.width) {
        return _react2.default.createElement(FileBlankSlate, null);
    }
    if (!design.permission.canView && design.width) {
        return _react2.default.createElement(BlindBlankSlate, null);
    }
    return null;
};
exports.default = BlankSlate;

var FileBlankSlate = function FileBlankSlate() {
    return _react2.default.createElement(_BlankSlate.BlankSlate, { variations: ['wide'], icon: _react2.default.createElement(_Icon.Icon, { type: 'document-1' }), message: "" });
};
var BlindBlankSlate = function BlindBlankSlate() {
    return _react2.default.createElement(_BlankSlate.BlankSlate, { variations: ['wide'], icon: _react2.default.createElement(_Icon.Icon, { type: 'document-1' }), message: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, { id: "design_hidden_message" }) });
};
var DeletedBlankSlate = function DeletedBlankSlate() {
    return _react2.default.createElement(_BlankSlate.BlankSlate, { variations: ['wide'], icon: _react2.default.createElement(_Icon.Icon, { type: 'trash-2' }), message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "design_deleted_message" }) });
};

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BlankSlate = __webpack_require__(436);

Object.defineProperty(exports, 'BlankSlate', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BlankSlate).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlankSlate = function (_React$Component) {
    _inherits(BlankSlate, _React$Component);

    function BlankSlate() {
        _classCallCheck(this, BlankSlate);

        return _possibleConstructorReturn(this, (BlankSlate.__proto__ || Object.getPrototypeOf(BlankSlate)).apply(this, arguments));
    }

    _createClass(BlankSlate, [{
        key: 'render',
        value: function render() {
            var classes = (0, _app.getComponentClasses)('blank-slate', this.props.variations);
            return _react2.default.createElement("div", { className: classes }, _react2.default.createElement("div", { className: "blank-slate__icon" }, this.props.icon), _react2.default.createElement("h2", { className: "blank-slate__heading" }, this.props.message), this.props.description && _react2.default.createElement("div", { className: "blank-slate__description" }, this.props.description), this.props.action && _react2.default.createElement("div", { className: "blank-slate__action" }, this.props.action));
        }
    }]);

    return BlankSlate;
}(_react2.default.Component);

exports.default = BlankSlate;

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Alert = __webpack_require__(79);

var _reactIntl = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewAlert = function PreviewAlert(_ref) {
    var design = _ref.design;
    var isPreviewOnly = design.isPreviewOnly,
        canView = design.permission.canView,
        width = design.width;

    if (!isPreviewOnly || !canView || !width) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: 'design-details__alert' },
        _react2.default.createElement(
            _Alert.Alert,
            { canBeDismissed: true },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'file_is_preview_a' }),
            _react2.default.createElement(
                'a',
                { href: design.downloadUrl, className: 'link link--bleached-as' },
                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'file_is_preview_b' })
            ),
            '.'
        )
    );
};

PreviewAlert.propTypes = {
    design: _propTypes2.default.object.isRequired
};

exports.default = PreviewAlert;

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Sizer = __webpack_require__(439);

var _Sizer2 = _interopRequireDefault(_Sizer);

var _ScrollPane = __webpack_require__(440);

var _ScrollPane2 = _interopRequireDefault(_ScrollPane);

var _Positioner = __webpack_require__(441);

var _Positioner2 = _interopRequireDefault(_Positioner);

var _Artboard = __webpack_require__(442);

var _Artboard2 = _interopRequireDefault(_Artboard);

var _InputHandler = __webpack_require__(443);

var _SketchLayer = __webpack_require__(445);

var _SwipableArtboard = __webpack_require__(446);

var _SwipableArtboard2 = _interopRequireDefault(_SwipableArtboard);

var _AnnotationsCanvas = __webpack_require__(454);

var _AnnotationTooltip = __webpack_require__(461);

var _AnnotationTooltip2 = _interopRequireDefault(_AnnotationTooltip);

var _reactIntl = __webpack_require__(6);

var _Desktop = __webpack_require__(54);

var _Mobile = __webpack_require__(55);

var _reactResponsive = __webpack_require__(32);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _breakpoints = __webpack_require__(38);

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _zoomLevelConstants = __webpack_require__(207);

var _zoomLevelConstants2 = _interopRequireDefault(_zoomLevelConstants);

var _settings = __webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DesignPane = function (_Component) {
    _inherits(DesignPane, _Component);

    function DesignPane() {
        _classCallCheck(this, DesignPane);

        return _possibleConstructorReturn(this, (DesignPane.__proto__ || Object.getPrototypeOf(DesignPane)).apply(this, arguments));
    }

    _createClass(DesignPane, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var imageSize = {
                width: this.props.design.width,
                height: this.props.design.height
            };
            return _react2.default.createElement(
                _reactResponsive2.default,
                { maxWidth: _breakpoints2.default.normal[0] },
                function (isMobile) {
                    return _react2.default.createElement(
                        'div',
                        { style: { minHeight: isMobile ? '100vw' : undefined } },
                        _react2.default.createElement(_Sizer2.default, {
                            onSize: _this2.props.onSize,
                            render: function render(viewSize) {
                                var scale = void 0;
                                if (isMobile || _this2.props.zoomLevel == _zoomLevelConstants2.default.FLUID || _this2.props.zoomLevel == _zoomLevelConstants2.default.FIT_TO_WIDTH) {
                                    scale = viewSize.width / imageSize.width;
                                } else if (_this2.props.zoomLevel == _zoomLevelConstants2.default.FIT_TO_CONTAINER) {
                                    scale = Math.min(viewSize.width / imageSize.width, viewSize.height / imageSize.height);
                                } else {
                                    scale = 1.0;
                                }

                                scale = Math.min(1, scale);

                                return _react2.default.createElement(_Positioner2.default, {
                                    key: 'pos',
                                    imageSize: imageSize,
                                    viewSize: viewSize,
                                    scale: scale,
                                    render: function render(_ref) {
                                        var artboardSize = _ref.artboardSize,
                                            artboardOrigin = _ref.artboardOrigin,
                                            scaledImageSize = _ref.scaledImageSize,
                                            imageToScreen = _ref.imageToScreen,
                                            screenToImage = _ref.screenToImage;
                                        return _react2.default.createElement(
                                            _ScrollPane2.default,
                                            {
                                                viewSize: viewSize,
                                                scaledImageSize: scaledImageSize
                                            },
                                            _react2.default.createElement(
                                                _InputHandler.ConnectedInputHandler,
                                                {
                                                    canAnnotate: _this2.props.design.permission.canAnnotate,
                                                    canSketch: _this2.props.design.permission.canSketch,
                                                    designId: _this2.props.design.designId,
                                                    feedbackMode: _this2.props.feedbackMode,
                                                    isPresentationMode: _this2.props.isPresentationMode,
                                                    toImageSpace: screenToImage
                                                },
                                                function (_ref2) {
                                                    var currentPath = _ref2.currentPath,
                                                        isEditing = _ref2.isEditing,
                                                        isHovering = _ref2.isHovering;
                                                    return _react2.default.createElement(
                                                        _react2.default.Fragment,
                                                        null,
                                                        _react2.default.createElement(
                                                            _Mobile.Mobile,
                                                            null,
                                                            _react2.default.createElement(
                                                                _SwipableArtboard2.default,
                                                                {
                                                                    artboardOrigin: artboardOrigin,
                                                                    imageSize: imageSize,
                                                                    scale: scale,
                                                                    goToPrevious: _this2.props.goToPrevious,
                                                                    goToNext: _this2.props.goToNext,
                                                                    previewUrl: _this2.props.design.previewUrl,
                                                                    isPresentationMode: _this2.props.isPresentationMode,
                                                                    canViewSketches: _this2.props.design.permission.canViewSketches,
                                                                    designId: _this2.props.design.designId
                                                                },
                                                                function (_ref3) {
                                                                    var transitionStyle = _ref3.transitionStyle,
                                                                        swipeDirection = _ref3.swipeDirection;
                                                                    return _react2.default.createElement(
                                                                        _react2.default.Fragment,
                                                                        null,
                                                                        _this2.renderImage(artboardOrigin, imageSize, scale, transitionStyle),
                                                                        swipeDirection !== 'LEFT' && swipeDirection !== 'RIGHT' && _react2.default.createElement(
                                                                            _react2.default.Fragment,
                                                                            null,
                                                                            _this2.renderSketchLayer(artboardOrigin, artboardSize, scale, currentPath),
                                                                            _react2.default.createElement(_AnnotationsCanvas.ConnectedAnnotationsCanvas, {
                                                                                design: _this2.props.design,
                                                                                isPresentationMode: _this2.props.isPresentationMode,
                                                                                feedbackMode: _this2.props.feedbackMode,
                                                                                toImageSpace: screenToImage,
                                                                                toScreenSpace: imageToScreen,
                                                                                selectCommentAfterCreate: false
                                                                            })
                                                                        )
                                                                    );
                                                                }
                                                            )
                                                        ),
                                                        _react2.default.createElement(
                                                            _Desktop.Desktop,
                                                            null,
                                                            _react2.default.createElement(
                                                                _Artboard2.default,
                                                                {
                                                                    width: artboardSize.width,
                                                                    height: artboardSize.height
                                                                },
                                                                _this2.renderImage(artboardOrigin, imageSize, scale),
                                                                _this2.renderSketchLayer(artboardOrigin, artboardSize, scale, currentPath),
                                                                !_this2.props.isPresentationMode && _react2.default.createElement(_AnnotationsCanvas.ConnectedAnnotationsCanvas, {
                                                                    design: _this2.props.design,
                                                                    isPresentationMode: _this2.props.isPresentationMode,
                                                                    feedbackMode: _this2.props.feedbackMode,
                                                                    toImageSpace: screenToImage,
                                                                    toScreenSpace: imageToScreen,
                                                                    selectCommentAfterCreate: true
                                                                })
                                                            )
                                                        ),
                                                        isHovering && !isEditing && _this2.renderTooltip()
                                                    );
                                                }
                                            )
                                        );
                                    }
                                });
                            }
                        })
                    );
                }
            );
        }
    }, {
        key: 'renderImage',
        value: function renderImage(artboardOrigin, imageSize, scale) {
            var transitionStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            return !this.props.isTransitioning ? _react2.default.createElement('img', {
                alt: '',
                src: this.props.design.previewUrl,
                key: this.props.design.previewUrl,
                style: _extends({
                    backgroundColor: _settings.colors.karlTheFog,
                    position: 'absolute',
                    left: artboardOrigin.x + 'px',
                    top: artboardOrigin.y + 'px',
                    width: imageSize.width * scale + 'px',
                    height: imageSize.height * scale + 'px'
                }, transitionStyle)
            }) : null;
        }
    }, {
        key: 'renderSketchLayer',
        value: function renderSketchLayer(artboardOrigin, artboardSize, scale, currentPath) {
            if (this.props.isPresentationMode) return null;
            if (!this.props.design.permission.canViewSketches) return null;

            return _react2.default.createElement(
                _SketchLayer.SketchLayer,
                {
                    key: 'sketch',
                    artboardOrigin: artboardOrigin,
                    artboardSize: artboardSize,
                    scale: scale
                },
                _react2.default.createElement(_SketchLayer.ProvidePaths, {
                    designId: this.props.design.designId,
                    renderPath: function renderPath(path, key) {
                        return _react2.default.createElement(_SketchLayer.Path, { key: key, path: path, smooth: true });
                    }
                }),
                currentPath && _react2.default.createElement(_SketchLayer.Path, { key: 'current', path: currentPath })
            );
        }
    }, {
        key: 'renderTooltip',
        value: function renderTooltip() {
            if (this.props.isPresentationMode || !this.props.design.permission.canAnnotate) return null;

            if (this.props.feedbackMode == 'sketch') {
                return _react2.default.createElement(
                    _AnnotationTooltip2.default,
                    { key: 't' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'click_to_draw' })
                );
            }
            if (this.props.feedbackMode == 'annotate') {
                return _react2.default.createElement(
                    _AnnotationTooltip2.default,
                    { key: 't' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'click_to_comment' })
                );
            }
        }
    }]);

    return DesignPane;
}(_react.Component);

exports.default = DesignPane;

DesignPane.propTypes = {
    zoomLevel: _propTypes2.default.oneOf([_zoomLevelConstants2.default.FLUID, _zoomLevelConstants2.default.FIT_TO_WIDTH, _zoomLevelConstants2.default.FIT_TO_CONTAINER, _zoomLevelConstants2.default.FIT_TO_NATIVE]).isRequired,
    onSize: _propTypes2.default.func.isRequired,
    design: _propTypes2.default.object.isRequired,
    isPresentationMode: _propTypes2.default.bool.isRequired,
    feedbackMode: _propTypes2.default.string.isRequired,
    goToPrevious: _propTypes2.default.func,
    goToNext: _propTypes2.default.func,
    isTransitioning: _propTypes2.default.bool
};

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Sizer uses an iframe to reliably report the size of its parent element
// It works robustly even when the page resizes or reflows
var Sizer = function (_Component) {
    _inherits(Sizer, _Component);

    function Sizer(props) {
        _classCallCheck(this, Sizer);

        var _this = _possibleConstructorReturn(this, (Sizer.__proto__ || Object.getPrototypeOf(Sizer)).call(this, props));

        _this.ref = _this.ref.bind(_this);
        _this.state = {
            size: null
        };
        return _this;
    }

    _createClass(Sizer, [{
        key: 'ref',
        value: function ref(iframe) {
            var _this2 = this;

            if (iframe) {
                var update = window.onresize = function () {
                    var box = iframe.getBoundingClientRect();
                    var size = { width: box.width, height: box.height };
                    _this2.setState({ size: size });
                    _this2.props.onSize(size);
                };
                update();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return [_react2.default.createElement('iframe', {
                title: 'sizer',
                style: {
                    position: 'absolute',
                    left: '0',
                    top: '0',
                    width: '100%',
                    height: '100%',
                    margin: '0 0',
                    border: 'none',
                    opacity: '0',
                    visibility: 'hidden',
                    pointerEvents: 'none'
                },
                ref: this.ref,
                key: 'sizer'
            }), this.state.size !== null ? this.props.render(this.state.size) : null];
        }
    }]);

    return Sizer;
}(_react.Component);

exports.default = Sizer;


Sizer.propTypes = {
    onSize: _propTypes2.default.func.isRequired,
    render: _propTypes2.default.func.isRequired
};

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// A scrollable viewport that calculates whether to enable/disable scrollbars
var ScrollPane = function ScrollPane(_ref) {
    var scaledImageSize = _ref.scaledImageSize,
        viewSize = _ref.viewSize,
        children = _ref.children;
    return _react2.default.createElement(
        'div',
        {
            style: {
                position: 'absolute',
                left: '0',
                top: '0',
                width: '100%',
                height: '100%',
                margin: '0 0',
                border: 'none',
                overflowX: scaledImageSize.width > viewSize.width ? 'scroll' : 'hidden',
                overflowY: scaledImageSize.height > viewSize.height ? 'scroll' : 'hidden'
            }
        },
        children
    );
};

exports.default = ScrollPane;


ScrollPane.propTypes = {
    scaledImageSize: _propTypes2.default.shape({
        height: _propTypes2.default.number.isRequired,
        width: _propTypes2.default.number.isRequired
    }).isRequired,
    viewSize: _propTypes2.default.shape({
        height: _propTypes2.default.number.isRequired,
        width: _propTypes2.default.number.isRequired
    }).isRequired,
    children: _propTypes2.default.node.isRequired
};

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Positioner provides functions for positioning elements inside an Artboard
var Positioner = function Positioner(_ref) {
    var imageSize = _ref.imageSize,
        viewSize = _ref.viewSize,
        scale = _ref.scale,
        render = _ref.render;

    var scaledImageSize = {
        width: imageSize.width * scale,
        height: imageSize.height * scale
    };
    // Artboard needs to be at least as big as the visible viewport to recieve mouse events for annotating / sketching etc
    var artboardSize = {
        width: Math.max(scaledImageSize.width, viewSize.width),
        height: Math.max(scaledImageSize.height, viewSize.height)
    };
    // Center the image inside the artboard
    var artboardOrigin = {
        x: (artboardSize.width - scaledImageSize.width) / 2,
        y: (artboardSize.height - scaledImageSize.height) / 2
    };

    // Convert image coordinates to screen coordinates
    var imageToScreen = function imageToScreen(_ref2) {
        var x = _ref2.x,
            y = _ref2.y;
        return {
            x: x * scale + artboardOrigin.x,
            y: y * scale + artboardOrigin.y
        };
    };

    // Convert screen coordinates back to image coordinates (useful for mouse handlers)
    var screenToImage = function screenToImage(_ref3) {
        var x = _ref3.x,
            y = _ref3.y;
        return {
            x: (x - artboardOrigin.x) / scale,
            y: (y - artboardOrigin.y) / scale
        };
    };

    return render({
        artboardSize: artboardSize,
        artboardOrigin: artboardOrigin,
        scaledImageSize: scaledImageSize,
        imageToScreen: imageToScreen,
        screenToImage: screenToImage
    });
};

exports.default = Positioner;


Positioner.propTypes = {
    imageSize: _propTypes2.default.shape({
        height: _propTypes2.default.number.isRequired,
        width: _propTypes2.default.number.isRequired
    }).isRequired,
    viewSize: _propTypes2.default.shape({
        height: _propTypes2.default.number.isRequired,
        width: _propTypes2.default.number.isRequired
    }).isRequired,
    scale: _propTypes2.default.number.isRequired,
    render: _propTypes2.default.func
};

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// An "Artboard" reserves space to place an image and other annotations into using absolute positioning
var Artboard = function (_Component) {
    _inherits(Artboard, _Component);

    function Artboard() {
        _classCallCheck(this, Artboard);

        return _possibleConstructorReturn(this, (Artboard.__proto__ || Object.getPrototypeOf(Artboard)).apply(this, arguments));
    }

    _createClass(Artboard, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    style: {
                        position: 'relative',
                        width: this.props.width + 'px',
                        height: this.props.height + 'px'
                    }
                },
                this.props.children
            );
        }
    }]);

    return Artboard;
}(_react.Component);

exports.default = Artboard;

Artboard.propTypes = {
    width: _propTypes2.default.number,
    height: _propTypes2.default.number,
    children: _propTypes2.default.node
};

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConnectedInputHandler = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _simplifyJs = __webpack_require__(444);

var _simplifyJs2 = _interopRequireDefault(_simplifyJs);

var _connectToStores = __webpack_require__(91);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _DesignCommentsStore = __webpack_require__(117);

var _DesignCommentsStore2 = _interopRequireDefault(_DesignCommentsStore);

var _designComments = __webpack_require__(139);

var _designSketches = __webpack_require__(208);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

var InputHandler = function (_Component) {
    _inherits(InputHandler, _Component);

    function InputHandler(props) {
        _classCallCheck(this, InputHandler);

        var _this = _possibleConstructorReturn(this, (InputHandler.__proto__ || Object.getPrototypeOf(InputHandler)).call(this, props));

        _this.mouseDown = _this.mouseDown.bind(_this);
        _this.mouseMove = _this.mouseMove.bind(_this);
        _this.mouseUp = _this.mouseUp.bind(_this);
        _this.touchStart = _this.touchStart.bind(_this);
        _this.touchMove = _this.touchMove.bind(_this);
        _this.touchEnd = _this.touchEnd.bind(_this);

        _this.onClick = _this.onClick.bind(_this);
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);

        _this.onPointerDown = _this.onPointerDown.bind(_this);
        _this.onPointerMove = _this.onPointerMove.bind(_this);
        _this.onPointerUp = _this.onPointerUp.bind(_this);

        _this.state = {
            currentPath: null,
            isHovering: false
        };
        return _this;
    }

    _createClass(InputHandler, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Mouse/Touch move and up events bound to window so that drawing can continiue outside the DOM element and browser window
            window.addEventListener('mousemove', this.mouseMove);
            window.addEventListener('mouseup', this.mouseUp);
            window.addEventListener('touchmove', this.touchMove);
            window.addEventListener('touchend', this.touchEnd);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // Mouse/Touch move and up events bound to window so that drawing can continiue outside the DOM element and browser window
            window.removeEventListener('mousemove', this.mouseMove);
            window.removeEventListener('mouseup', this.mouseUp);
            window.removeEventListener('touchmove', this.touchMove);
            window.removeEventListener('touchend', this.touchEnd);
        }
    }, {
        key: 'onClick',
        value: function onClick(event) {
            if (!this.props.canAnnotate) return;
            if (this.props.feedbackMode !== 'annotate' || this.props.isPresentationMode) return;

            var position = this.pointerPosition(event);

            if (this.props.isAnnotating) {
                this.context.executeAction(_designComments.resetSelectedComment);
            } else {
                this.context.executeAction(_designComments.enterDesignComment, {
                    position: position,
                    activeUser: this.context.activeUser
                });
            }
        }
    }, {
        key: 'onMouseEnter',
        value: function onMouseEnter() {
            this.setState({
                isHovering: true
            });
        }
    }, {
        key: 'onMouseMove',
        value: function onMouseMove() {
            this.setState(function (state) {
                return state.isHovering ? null : { isHovering: true };
            });
        }
    }, {
        key: 'onMouseLeave',
        value: function onMouseLeave() {
            this.setState({
                isHovering: false
            });
        }
    }, {
        key: 'onPointerDown',
        value: function onPointerDown(position) {
            this.setState(function () {
                return {
                    currentPath: [position]
                };
            });
        }
    }, {
        key: 'onPointerMove',
        value: function onPointerMove(position) {
            this.setState(function (prevState) {
                if (prevState.currentPath !== null) {
                    return {
                        currentPath: [].concat(_toConsumableArray(prevState.currentPath), [position])
                    };
                } else {
                    return null;
                }
            });
        }
    }, {
        key: 'onPointerUp',
        value: function onPointerUp() {
            if (this.state.currentPath) {
                if (this.state.currentPath.length >= 3) {
                    // Simplify the path before saving. Tolerance of 2px and highQuality=true
                    var path = (0, _simplifyJs2.default)(this.state.currentPath, 2.0, true);
                    this.props.addDesignPath(path);
                }
                // TODO dhotson: perhaps if the path is too short, trigger comment annotation?

                this.setState({ currentPath: null });
            }
        }
    }, {
        key: 'mouseDown',
        value: function mouseDown(event) {
            if (!this.props.canSketch) return;
            if (this.props.feedbackMode !== 'sketch' || this.props.isPresentationMode) return;

            // Trigger on primary mouse click only
            if (event.button == 0) {
                event.preventDefault();
                this.onPointerDown(this.pointerPosition(event));
            }
        }
    }, {
        key: 'mouseUp',
        value: function mouseUp(event) {
            if (!this.props.canSketch) return;
            if (this.props.feedbackMode !== 'sketch' || this.props.isPresentationMode) return;

            event.preventDefault();
            this.onPointerUp(this.pointerPosition(event));
        }
    }, {
        key: 'mouseMove',
        value: function mouseMove(event) {
            if (!this.props.canSketch) return;
            if (this.props.feedbackMode !== 'sketch' || this.props.isPresentationMode) return;

            event.preventDefault();
            this.onPointerMove(this.pointerPosition(event));
        }
    }, {
        key: 'touchStart',
        value: function touchStart(event) {
            if (!this.props.canSketch) return;
            if (this.props.feedbackMode !== 'sketch' || this.props.isPresentationMode) return;

            event.preventDefault(); // preventDefault on touch start prevents scrolling
            var touch = event.touches.item(0);
            this.onPointerDown(this.pointerPosition(touch));
        }
    }, {
        key: 'touchEnd',
        value: function touchEnd(event) {
            if (!this.props.canSketch) return;
            if (this.props.feedbackMode !== 'sketch' || this.props.isPresentationMode) return;
            if (this.state.currentPath === null) return;

            var touch = event.changedTouches.item(0);
            this.onPointerUp(this.pointerPosition(touch));
        }
    }, {
        key: 'touchMove',
        value: function touchMove(event) {
            if (!this.props.canSketch) return;
            if (this.props.feedbackMode !== 'sketch' || this.props.isPresentationMode) return;
            if (this.state.currentPath === null) return;

            var touch = event.touches.item(0);
            this.onPointerMove(this.pointerPosition(touch));
        }

        // Calculate position of artboard element relative to document
        // by iterating up through element offsetParent's

    }, {
        key: 'elementPosition',
        value: function elementPosition() {
            var el = this.el;
            var left = el.offsetLeft - el.scrollLeft;
            var top = el.offsetTop - el.scrollTop;
            while (el) {
                left += el.offsetLeft - el.scrollLeft;
                top += el.offsetTop - el.scrollTop;
                el = el.offsetParent;
            }

            return {
                left: left,
                top: top
            };
        }

        // Calculate mouse position relative to artboard element

    }, {
        key: 'pointerPosition',
        value: function pointerPosition(eventOrTouch) {
            var elementPosition = this.elementPosition();
            // Calculate mouse position relative to artboard element
            return this.props.toImageSpace({
                x: eventOrTouch.pageX - elementPosition.left,
                y: eventOrTouch.pageY - elementPosition.top
            });
        }
    }, {
        key: 'cursor',
        value: function cursor() {
            if (this.props.isPresentationMode) {
                return 'default';
            }

            if (this.props.feedbackMode === 'annotate' && this.props.canAnnotate) {
                return 'crosshair';
            }

            if (this.props.feedbackMode === 'sketch' && this.props.canSketch) {
                return this.pencilCursor();
            }

            return 'default';
        }
    }, {
        key: 'pencilCursor',
        value: function pencilCursor() {
            var cursor1x = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAMFBMVEVHcEwAAAAKCgqcnJzZ2dn19fX////u7u4AAADm5uaUlJRVVVV2dnbv7+8pKSm7u7u4OrkAAAAAEHRSTlMABg8/cP7/rRyW////3jJXidydOwAAAJNJREFUeNrt0bsOxCAMRNEFg3k5y///bTwFipQRSbXdTnsuSIjPf7sF7IGjJIkx7D1l1VJXwd60D8ttFeTiPoaprIDOqw2fJgTsSbtlL/q6gd2vP6xrqjGwFziOa/siIM9wBLJxA+ONL15e/IAHej/5Lch97wimklNAToF7WU6BKLZ1/PKcU+rlXMTqfDkXwRX8g52QCAfFqDsYpAAAAABJRU5ErkJggg==';
            var cursor2x = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAYFBMVEVHcEwAAAAAAAD4+PgAAAAAAAAKCgoAAAAAAAAAAAAAAAAAAAAAAADg4ODq6ur09PS+vr4/Pz+3t7fZ2dmRkZHa2tr6+vr///9gYGBVVVWWlpaGhobExMTg4OBzc3OqqqqL1npXAAAAF3RSTlMAEx35DBAYAQMHIy8okq/YcUBOcUaD4ygdGvAAAAHgSURBVHhe7ZbrjqMwDEYnCcQ0hZbexvT+/m+5tpNOtFKBmJVWGqlHqvrrfNiOEfn6RXz48AEAGgKIZXojpIxlT19FKEKdkPSKoX91AiS9ZihCEnQ+62bfbU5Hb2plArfPT/dbZDrLEZyg882efUe/TfCmkgSdT+5tOF/viB0lcBdQ7K8q0yPi80wMlNBbH5so971DdzkLD4ffwcYSyv0DIvvCBfEQfM0Bxf1/I+L1/IKnkHoo9JFxD20ANHn+T5r+ffhp4VQSENuvxb/w7CRBfLcrCACI65t8Sbgl/9gGL6cA035+vnDlTRJ/HayZLgBe9R/wr/MT9uTLKTYw5/vsCzfSXb9uZxcx+7x/mSdiv2PfxBd63s+Hn16D7frffKT6w8uHmfm/8zfRrwp8P+Zb8ucOgP3NmD/RvxB9M+7HA5wZ4Ft/u5MFkhWeKYDndx/G/Ol3CMivjg7dG78t8pvYwFVfvyBH6BFv+vpzB/UB8bHUlw46xAlfF5Dnl31FgNrPAeP9FwYMol/i/pb7eQ8TGl8ASG9iwnXkl/afF8n4vhP267YNuhtN+hh6G0JLhGA1fk6ojffWWu+jvirW8xehNsTPla4B/Y0ysuRaCjEi0ah9SciIrgbyxT7rWqL8H/kD+qxPB7g2J9wAAAAASUVORK5CYII=';
            return '-webkit-image-set(url(' + cursor1x + ') 1x, url(' + cursor2x + ') 2x) 7 27, pointer';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                {
                    'data-input-handler': true,
                    onClick: this.onClick,
                    onTouchStart: this.touchStart,
                    onMouseDown: this.mouseDown,
                    onMouseMove: this.onMouseMove,
                    onMouseEnter: this.onMouseEnter,
                    onMouseLeave: this.onMouseLeave,
                    ref: function ref(el) {
                        return _this2.el = el;
                    },
                    style: {
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%',
                        cursor: this.cursor()
                    }
                },
                this.props.children({
                    isEditing: this.state.currentPath || this.props.isAnnotating,
                    currentPath: this.state.currentPath,
                    isHovering: this.state.isHovering
                })
            );
        }
    }]);

    return InputHandler;
}(_react.Component);

InputHandler.contextTypes = {
    executeAction: _propTypes2.default.func,
    activeUser: _propTypes2.default.object
};

InputHandler.propTypes = {
    canAnnotate: _propTypes2.default.bool.isRequired,
    canSketch: _propTypes2.default.bool.isRequired,
    isAnnotating: _propTypes2.default.bool.isRequired,
    feedbackMode: _propTypes2.default.string.isRequired,
    addDesignPath: _propTypes2.default.func.isRequired,
    toImageSpace: _propTypes2.default.func.isRequired,
    isPresentationMode: _propTypes2.default.bool.isRequired,
    children: _propTypes2.default.func
};

var ConnectedInputHandler = exports.ConnectedInputHandler = (0, _connectToStores2.default)(InputHandler, [_DesignCommentsStore2.default], function (ctx, props) {
    return {
        isAnnotating: Boolean(ctx.getStore(_DesignCommentsStore2.default).selectedComment),
        addDesignPath: function addDesignPath(path) {
            return ctx.executeAction(_designSketches.addDesignPath, {
                designId: props.designId,
                path: path,
                csrfToken: ctx.csrfToken
            });
        }
    };
});

ConnectedInputHandler.contextTypes = {
    getStore: _propTypes2.default.func,
    executeAction: _propTypes2.default.func,
    csrfToken: _propTypes2.default.string
};

ConnectedInputHandler.propTypes = {
    feedbackMode: _propTypes2.default.string.isRequired,
    toImageSpace: _propTypes2.default.func.isRequired,
    designId: _propTypes2.default.number.isRequired
};

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 (c) 2017, Vladimir Agafonkin
 Simplify.js, a high-performance JS polyline simplification library
 mourner.github.io/simplify-js
*/

(function () { 'use strict';

// to suit your point format, run search/replace for '.x' and '.y';
// for 3D version, see 3d branch (configurability would draw significant performance overhead)

// square distance between 2 points
function getSqDist(p1, p2) {

    var dx = p1.x - p2.x,
        dy = p1.y - p2.y;

    return dx * dx + dy * dy;
}

// square distance from a point to a segment
function getSqSegDist(p, p1, p2) {

    var x = p1.x,
        y = p1.y,
        dx = p2.x - x,
        dy = p2.y - y;

    if (dx !== 0 || dy !== 0) {

        var t = ((p.x - x) * dx + (p.y - y) * dy) / (dx * dx + dy * dy);

        if (t > 1) {
            x = p2.x;
            y = p2.y;

        } else if (t > 0) {
            x += dx * t;
            y += dy * t;
        }
    }

    dx = p.x - x;
    dy = p.y - y;

    return dx * dx + dy * dy;
}
// rest of the code doesn't care about point format

// basic distance-based simplification
function simplifyRadialDist(points, sqTolerance) {

    var prevPoint = points[0],
        newPoints = [prevPoint],
        point;

    for (var i = 1, len = points.length; i < len; i++) {
        point = points[i];

        if (getSqDist(point, prevPoint) > sqTolerance) {
            newPoints.push(point);
            prevPoint = point;
        }
    }

    if (prevPoint !== point) newPoints.push(point);

    return newPoints;
}

function simplifyDPStep(points, first, last, sqTolerance, simplified) {
    var maxSqDist = sqTolerance,
        index;

    for (var i = first + 1; i < last; i++) {
        var sqDist = getSqSegDist(points[i], points[first], points[last]);

        if (sqDist > maxSqDist) {
            index = i;
            maxSqDist = sqDist;
        }
    }

    if (maxSqDist > sqTolerance) {
        if (index - first > 1) simplifyDPStep(points, first, index, sqTolerance, simplified);
        simplified.push(points[index]);
        if (last - index > 1) simplifyDPStep(points, index, last, sqTolerance, simplified);
    }
}

// simplification using Ramer-Douglas-Peucker algorithm
function simplifyDouglasPeucker(points, sqTolerance) {
    var last = points.length - 1;

    var simplified = [points[0]];
    simplifyDPStep(points, 0, last, sqTolerance, simplified);
    simplified.push(points[last]);

    return simplified;
}

// both algorithms combined for awesome performance
function simplify(points, tolerance, highestQuality) {

    if (points.length <= 2) return points;

    var sqTolerance = tolerance !== undefined ? tolerance * tolerance : 1;

    points = highestQuality ? points : simplifyRadialDist(points, sqTolerance);
    points = simplifyDouglasPeucker(points, sqTolerance);

    return points;
}

// export as AMD module / Node module / browser or worker variable
if (true) !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() { return simplify; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
else if (typeof module !== 'undefined') {
    module.exports = simplify;
    module.exports.default = simplify;
} else if (typeof self !== 'undefined') self.simplify = simplify;
else window.simplify = simplify;

})();


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProvidePaths = exports.Path = exports.SketchLayer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _connectToStores = __webpack_require__(91);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _DesignSketchesStore = __webpack_require__(138);

var _DesignSketchesStore2 = _interopRequireDefault(_DesignSketchesStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SketchLayer = exports.SketchLayer = function (_Component) {
    _inherits(SketchLayer, _Component);

    function SketchLayer() {
        _classCallCheck(this, SketchLayer);

        return _possibleConstructorReturn(this, (SketchLayer.__proto__ || Object.getPrototypeOf(SketchLayer)).apply(this, arguments));
    }

    _createClass(SketchLayer, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var svgViewbox = -this.props.artboardOrigin.x / this.props.scale + ' ' + -this.props.artboardOrigin.y / this.props.scale + ' ' + this.props.artboardSize.width / this.props.scale + ' ' + this.props.artboardSize.height / this.props.scale;
            return _react2.default.createElement(
                'svg',
                {
                    ref: function ref(el) {
                        return _this2.el = el;
                    },
                    role: 'img',
                    width: '100%',
                    height: '100%',
                    viewBox: svgViewbox,
                    style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        filter: 'drop-shadow(1px 1px 0.5px rgba(0,0,0,0.2)) drop-shadow(2px 2px 3px rgba(0,0,0,0.25)) ',
                        pointerEvents: 'none' // Let the user right click and save the image underneath
                    }
                },
                this.props.children
            );
        }
    }]);

    return SketchLayer;
}(_react.Component);

SketchLayer.propTypes = {
    artboardOrigin: _propTypes2.default.object.isRequired,
    artboardSize: _propTypes2.default.object.isRequired,
    scale: _propTypes2.default.number.isRequired,
    children: _propTypes2.default.node.isRequired
};

var Path = exports.Path = function (_PureComponent) {
    _inherits(Path, _PureComponent);

    function Path() {
        _classCallCheck(this, Path);

        return _possibleConstructorReturn(this, (Path.__proto__ || Object.getPrototypeOf(Path)).apply(this, arguments));
    }

    _createClass(Path, [{
        key: 'render',
        value: function render() {
            if (this.props.path.length === 0) return null;

            var svgPath = void 0;
            if (this.props.smooth) {
                svgPath = catmullRomFitting(this.props.path);
            } else {
                svgPath = 'M ' + this.props.path[0].x + ' ' + this.props.path[0].y + this.props.path.slice(1).map(function (point) {
                    return ' L ' + point.x + ' ' + point.y;
                }).join(' ');
            }

            return _react2.default.createElement('path', {
                key: 'line',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                vectorEffect: 'non-scaling-stroke',
                strokeWidth: '5px',
                d: svgPath,
                stroke: '#ff7e65',
                fill: 'transparent'
            });
        }
    }]);

    return Path;
}(_react.PureComponent);

Path.propTypes = {
    path: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf({
        x: _propTypes2.default.number.isRequired,
        y: _propTypes2.default.number.isRequired
    }).isRequired).isRequired,
    smooth: _propTypes2.default.boolean
};

// Connect to Sketch store and provide path data to be rendered by a renderPath prop
var ProvidePaths = exports.ProvidePaths = (0, _connectToStores2.default)(function (_ref) {
    var paths = _ref.paths,
        renderPath = _ref.renderPath;
    return paths.map(renderPath);
}, [_DesignSketchesStore2.default], function (ctx, props) {
    return {
        paths: ctx.getStore(_DesignSketchesStore2.default).getPathsFromDesignSketch(props.designId)
    };
});
ProvidePaths.propTypes = {
    designId: _propTypes2.default.number.isRequired,
    renderPath: _propTypes2.default.func.isRequired
};

/**
 * From https://gist.github.com/nicholaswmin/c2661eb11cad5671d816
 *
 * Interpolates a Catmull-Rom Spline through a series of x/y points
 * Converts the CR Spline to Cubic Beziers for use with SVG items
 *
 * @param  {Array} points - Array of points, each point in object literal holding x/y values
 * @return {String} d - SVG string with cubic bezier curves representing the Catmull-Rom Spline
 */
var catmullRomFitting = function catmullRomFitting(points) {
    // If 'alpha' is 0.5 then the 'Centripetal' variant is used
    // If 'alpha' is 1 then the 'Chordal' variant is used
    var alpha = 0.5;

    var p0 = void 0,
        p1 = void 0,
        p2 = void 0,
        p3 = void 0,
        bp1 = void 0,
        bp2 = void 0,
        d1 = void 0,
        d2 = void 0,
        d3 = void 0,
        A = void 0,
        B = void 0,
        N = void 0,
        M = void 0;
    var d3powA = void 0,
        d2powA = void 0,
        d3pow2A = void 0,
        d2pow2A = void 0,
        d1pow2A = void 0,
        d1powA = void 0;
    var d = 'M ' + Math.round(points[0].x) + ',' + Math.round(points[0].y) + ' ';
    var length = points.length;
    for (var i = 0; i < length - 1; i++) {
        p0 = i == 0 ? points[0] : points[i - 1];
        p1 = points[i];
        p2 = points[i + 1];
        p3 = i + 2 < length ? points[i + 2] : p2;

        d1 = Math.sqrt(Math.pow(p0.x - p1.x, 2) + Math.pow(p0.y - p1.y, 2));
        d2 = Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
        d3 = Math.sqrt(Math.pow(p2.x - p3.x, 2) + Math.pow(p2.y - p3.y, 2));

        // Catmull-Rom to Cubic Bezier conversion matrix

        // A = 2d1^2a + 3d1^a * d2^a + d3^2a
        // B = 2d3^2a + 3d3^a * d2^a + d2^2a

        // [   0             1            0          0          ]
        // [   -d2^2a /N     A/N          d1^2a /N   0          ]
        // [   0             d3^2a /M     B/M        -d2^2a /M  ]
        // [   0             0            1          0          ]

        d3powA = Math.pow(d3, alpha);
        d3pow2A = Math.pow(d3, 2 * alpha);
        d2powA = Math.pow(d2, alpha);
        d2pow2A = Math.pow(d2, 2 * alpha);
        d1powA = Math.pow(d1, alpha);
        d1pow2A = Math.pow(d1, 2 * alpha);

        A = 2 * d1pow2A + 3 * d1powA * d2powA + d2pow2A;
        B = 2 * d3pow2A + 3 * d3powA * d2powA + d2pow2A;
        N = 3 * d1powA * (d1powA + d2powA);
        if (N > 0) {
            N = 1 / N;
        }
        M = 3 * d3powA * (d3powA + d2powA);
        if (M > 0) {
            M = 1 / M;
        }

        bp1 = {
            x: (-d2pow2A * p0.x + A * p1.x + d1pow2A * p2.x) * N,
            y: (-d2pow2A * p0.y + A * p1.y + d1pow2A * p2.y) * N
        };

        bp2 = {
            x: (d3pow2A * p1.x + B * p2.x - d2pow2A * p3.x) * M,
            y: (d3pow2A * p1.y + B * p2.y - d2pow2A * p3.y) * M
        };

        if (bp1.x == 0 && bp1.y == 0) {
            bp1 = p1;
        }
        if (bp2.x == 0 && bp2.y == 0) {
            bp2 = p2;
        }

        d += 'C' + bp1.x + ',' + bp1.y + ' ' + bp2.x + ',' + bp2.y + ' ' + p2.x + ',' + p2.y + ' ';
    }

    return d;
};

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactSwipeable = __webpack_require__(447);

var _reactResponsive = __webpack_require__(32);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _reactTransitionGroup = __webpack_require__(37);

var _platform = __webpack_require__(123);

var _settings = __webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var transitionStyles = {
    exited: {
        display: 'none'
    },
    exiting: {
        transition: 'transform 200ms linear'
    }
};

var offset = {
    left: -window.innerWidth - _settings.spaces.halfGutter,
    right: window.innerWidth + _settings.spaces.halfGutter
};

var horizontalSwipeThreshold = 40;
var isFlickThreshold = 0.4;

var SwipableArtboard = function (_Component) {
    _inherits(SwipableArtboard, _Component);

    function SwipableArtboard(props) {
        _classCallCheck(this, SwipableArtboard);

        var _this = _possibleConstructorReturn(this, (SwipableArtboard.__proto__ || Object.getPrototypeOf(SwipableArtboard)).call(this, props));

        _this.redirect = _this.redirect.bind(_this);
        _this.handleSwiping = _this.handleSwiping.bind(_this);
        _this.handleOnSwipedLeft = _this.handleOnSwipedLeft.bind(_this);
        _this.handleOnSwipedRight = _this.handleOnSwipedRight.bind(_this);
        _this.handleOnSwiped = _this.handleOnSwiped.bind(_this);
        _this.resetPosition = _this.resetPosition.bind(_this);
        _this.handleOnExited = _this.handleOnExited.bind(_this);

        _this.state = {
            swipeData: {
                deltaX: 0
            },
            applyTransition: false,
            swipeDirection: ''
        };
        return _this;
    }

    _createClass(SwipableArtboard, [{
        key: 'handleSwiping',
        value: function handleSwiping(_ref) {
            var deltaX = _ref.deltaX,
                dir = _ref.dir;

            this.setState({
                swipeData: {
                    deltaX: deltaX
                },
                swipeDirection: dir.toUpperCase()
            });
        }
    }, {
        key: 'hasSwipedOver50Percent',
        value: function hasSwipedOver50Percent(deltaX) {
            var swipeThreshhold = window.innerWidth / 2;
            var hasSwipedOver50Percent = deltaX + swipeThreshhold < 0 || deltaX > swipeThreshhold;
            return hasSwipedOver50Percent;
        }
    }, {
        key: 'resetPosition',
        value: function resetPosition() {
            this.setState({
                swipeData: {
                    deltaX: 0
                },
                swipeDirection: ''
            });
        }
    }, {
        key: 'handleOnSwipedLeft',
        value: function handleOnSwipedLeft(_ref2) {
            var deltaX = _ref2.deltaX,
                velocity = _ref2.velocity;

            if (velocity > isFlickThreshold || this.hasSwipedOver50Percent(deltaX)) {
                this.setState({
                    swipeData: {
                        deltaX: offset.right
                    }
                });
            } else {
                this.resetPosition();
            }
        }
    }, {
        key: 'handleOnSwipedRight',
        value: function handleOnSwipedRight(_ref3) {
            var deltaX = _ref3.deltaX,
                velocity = _ref3.velocity;

            if (velocity > isFlickThreshold || this.hasSwipedOver50Percent(deltaX)) {
                this.setState({
                    swipeData: {
                        deltaX: offset.left
                    }
                });
            } else {
                this.resetPosition();
            }
        }
    }, {
        key: 'handleOnSwiped',
        value: function handleOnSwiped() {
            if (this.state.swipeDirection === 'LEFT' || this.state.swipeDirection === 'RIGHT') {
                this.setState({
                    applyTransition: true
                });
            }
        }
    }, {
        key: 'handleOnExited',
        value: function handleOnExited() {
            if (this.state.swipeDirection) {
                this.redirect(this.state.swipeDirection);
            }

            this.setState({
                applyTransition: false,
                swipeData: {
                    deltaX: 0
                },
                swipeDirection: ''
            });
        }
    }, {
        key: 'redirect',
        value: function redirect(swipeDirection) {
            if (swipeDirection === 'LEFT') {
                (0, _platform.trackEvent)('Swiped To Navigate in DDO');
                this.props.goToNext();
            } else if (swipeDirection === 'RIGHT') {
                (0, _platform.trackEvent)('Swiped To Navigate in DDO');
                this.props.goToPrevious();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                artboardOrigin = _props.artboardOrigin,
                imageSize = _props.imageSize,
                scale = _props.scale,
                children = _props.children;
            var _state = this.state,
                swipeDirection = _state.swipeDirection,
                deltaX = _state.swipeData.deltaX;


            return _react2.default.createElement(
                _reactTransitionGroup.Transition,
                {
                    'in': !this.state.applyTransition,
                    timeout: 200,
                    onExited: this.handleOnExited
                },
                function (transitionState) {
                    return _react2.default.createElement(
                        _reactSwipeable.Swipeable,
                        {
                            onSwipedLeft: _this2.handleOnSwipedLeft,
                            onSwipedRight: _this2.handleOnSwipedRight,
                            onSwiped: _this2.handleOnSwiped,
                            onSwiping: _this2.handleSwiping,
                            preventDefaultTouchmoveEvent: true,
                            delta: horizontalSwipeThreshold
                        },
                        _react2.default.createElement(
                            _reactResponsive2.default,
                            { query: '(orientation: portrait)' },
                            _this2.renderPlaceholder(transitionState, artboardOrigin, imageSize, scale, offset.left, deltaX)
                        ),
                        children({
                            transitionStyle: _extends({}, _this2.getSwipeTransform(deltaX), transitionStyles[transitionState]),
                            swipeDirection: swipeDirection
                        }),
                        _react2.default.createElement(
                            _reactResponsive2.default,
                            { query: '(orientation: portrait)' },
                            _this2.renderPlaceholder(transitionState, artboardOrigin, imageSize, scale, offset.right, deltaX)
                        )
                    );
                }
            );
        }
    }, {
        key: 'getSwipeTransform',
        value: function getSwipeTransform(deltaX) {
            var swipeTransform = void 0;
            if (deltaX > horizontalSwipeThreshold || deltaX < -horizontalSwipeThreshold) {
                swipeTransform = { transform: 'translateX(' + (0 - deltaX) + 'px)' };
            }
            return swipeTransform;
        }
    }, {
        key: 'renderPlaceholder',
        value: function renderPlaceholder(transitionState, artboardOrigin, imageSize, scale, offset, deltaX) {
            return _react2.default.createElement('div', {
                style: _extends({
                    position: 'absolute',
                    left: offset + 'px',
                    top: artboardOrigin.y + 'px',
                    width: '100%',
                    height: imageSize.height * scale + 'px',
                    background: _settings.colors.karlTheFog
                }, this.getSwipeTransform(deltaX), transitionStyles[transitionState])
            });
        }
    }]);

    return SwipableArtboard;
}(_react.Component);

exports.default = SwipableArtboard;

SwipableArtboard.propTypes = {
    goToPrevious: _propTypes2.default.func,
    goToNext: _propTypes2.default.func,
    previewUrl: _propTypes2.default.string,
    artboardOrigin: _propTypes2.default.object,
    imageSize: _propTypes2.default.object,
    scale: _propTypes2.default.number,
    isPresentationMode: _propTypes2.default.bool,
    canViewSketches: _propTypes2.default.bool,
    designId: _propTypes2.default.number,
    children: _propTypes2.default.func
};

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWN", function() { return DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LEFT", function() { return LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RIGHT", function() { return RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swipeable", function() { return Swipeable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UP", function() { return UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useSwipeable", function() { return useSwipeable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var defaultProps = {
  preventDefaultTouchmoveEvent: false,
  delta: 10,
  rotationAngle: 0,
  trackMouse: false,
  trackTouch: true
};
var initialState = {
  xy: [0, 0],
  swiping: false,
  eventData: undefined,
  start: undefined
};
var LEFT = 'Left';
var RIGHT = 'Right';
var UP = 'Up';
var DOWN = 'Down';
var touchStart = 'touchstart';
var touchMove = 'touchmove';
var touchEnd = 'touchend';
var mouseMove = 'mousemove';
var mouseUp = 'mouseup';

function getDirection(absX, absY, deltaX, deltaY) {
  if (absX > absY) {
    if (deltaX > 0) {
      return LEFT;
    }

    return RIGHT;
  } else if (deltaY > 0) {
    return UP;
  }

  return DOWN;
}

function rotateXYByAngle(pos, angle) {
  if (angle === 0) return pos;
  var angleInRadians = Math.PI / 180 * angle;
  var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
  var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
  return [x, y];
}

function getHandlers(set, handlerProps) {
  var onStart = function onStart(event) {
    // if more than a single touch don't track, for now...
    if (event.touches && event.touches.length > 1) return;
    set(function (state, props) {
      // setup mouse listeners on document to track swipe since swipe can leave container
      if (props.trackMouse) {
        document.addEventListener(mouseMove, onMove);
        document.addEventListener(mouseUp, onUp);
      }

      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
      return _extends({}, state, initialState, {
        eventData: {
          initial: [].concat(xy),
          first: true
        },
        xy: xy,
        start: event.timeStamp || 0
      });
    });
  };

  var onMove = function onMove(event) {
    set(function (state, props) {
      if (!state.xy[0] || !state.xy[1] || event.touches && event.touches.length > 1) {
        return state;
      }

      var _ref2 = event.touches ? event.touches[0] : event,
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
          x = _rotateXYByAngle[0],
          y = _rotateXYByAngle[1];

      var deltaX = state.xy[0] - x;
      var deltaY = state.xy[1] - y;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      var time = (event.timeStamp || 0) - state.start;
      var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1); // if swipe is under delta and we have not started to track a swipe: skip update

      if (absX < props.delta && absY < props.delta && !state.swiping) return state;
      var dir = getDirection(absX, absY, deltaX, deltaY);

      var eventData = _extends({}, state.eventData, {
        event: event,
        absX: absX,
        absY: absY,
        deltaX: deltaX,
        deltaY: deltaY,
        velocity: velocity,
        dir: dir
      });

      props.onSwiping && props.onSwiping(eventData); // track if a swipe is cancelable(handler for swiping or swiped(dir) exists)
      // so we can call preventDefault if needed

      var cancelablePageSwipe = false;

      if (props.onSwiping || props.onSwiped || props["onSwiped" + dir]) {
        cancelablePageSwipe = true;
      }

      if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault(); // first is now always false

      return _extends({}, state, {
        eventData: _extends({}, eventData, {
          first: false
        }),
        swiping: true
      });
    });
  };

  var onEnd = function onEnd(event) {
    set(function (state, props) {
      var eventData;

      if (state.swiping) {
        eventData = _extends({}, state.eventData, {
          event: event
        });
        props.onSwiped && props.onSwiped(eventData);
        props["onSwiped" + eventData.dir] && props["onSwiped" + eventData.dir](eventData);
      }

      return _extends({}, state, initialState, {
        eventData: eventData
      });
    });
  };

  var cleanUpMouse = function cleanUpMouse() {
    // safe to just call removeEventListener
    document.removeEventListener(mouseMove, onMove);
    document.removeEventListener(mouseUp, onUp);
  };

  var onUp = function onUp(e) {
    cleanUpMouse();
    onEnd(e);
  };

  var attachTouch = function attachTouch(el) {
    if (el && el.addEventListener) {
      // attach touch event listeners and handlers
      var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
      tls.forEach(function (_ref3) {
        var e = _ref3[0],
            h = _ref3[1];
        return el.addEventListener(e, h);
      }); // return properly scoped cleanup method for removing listeners

      return function () {
        return tls.forEach(function (_ref4) {
          var e = _ref4[0],
              h = _ref4[1];
          return el.removeEventListener(e, h);
        });
      };
    }
  };

  var onRef = function onRef(el) {
    // "inline" ref functions are called twice on render, once with null then again with DOM element
    // ignore null here
    if (el === null) return;
    set(function (state, props) {
      // if the same DOM el as previous just return state
      if (state.el === el) return state;
      var addState = {}; // if new DOM el clean up old DOM and reset cleanUpTouch

      if (state.el && state.el !== el && state.cleanUpTouch) {
        state.cleanUpTouch();
        addState.cleanUpTouch = null;
      } // only attach if we want to track touch


      if (props.trackTouch && el) {
        addState.cleanUpTouch = attachTouch(el);
      } // store event attached DOM el for comparison, clean up, and re-attachment


      return _extends({}, state, {
        el: el
      }, addState);
    });
  }; // set ref callback to attach touch event listeners


  var output = {
    ref: onRef // if track mouse attach mouse down listener

  };

  if (handlerProps.trackMouse) {
    output.onMouseDown = onStart;
  }

  return [output, attachTouch];
}

function updateTransientState(state, props, attachTouch) {
  var addState = {}; // clean up touch handlers if no longer tracking touches

  if (!props.trackTouch && state.cleanUpTouch) {
    state.cleanUpTouch();
    addState.cleanUpTouch = null;
  } else if (props.trackTouch && !state.cleanUpTouch) {
    // attach/re-attach touch handlers
    if (state.el) {
      addState.cleanUpTouch = attachTouch(state.el);
    }
  }

  return _extends({}, state, addState);
}

function useSwipeable(props) {
  var trackMouse = props.trackMouse;
  var transientState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(_extends({}, initialState, {
    type: 'hook'
  }));
  var transientProps = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef();
  transientProps.current = _extends({}, defaultProps, props);

  var _React$useMemo = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
    return getHandlers(function (cb) {
      return transientState.current = cb(transientState.current, transientProps.current);
    }, {
      trackMouse: trackMouse
    });
  }, [trackMouse]),
      handlers = _React$useMemo[0],
      attachTouch = _React$useMemo[1];

  transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
  return handlers;
}
var Swipeable =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Swipeable, _React$PureComponent);

  function Swipeable(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _this._set = function (cb) {
      _this.transientState = cb(_this.transientState, _this.props);
    };

    _this.transientState = _extends({}, initialState, {
      type: 'class'
    });
    return _this;
  }

  var _proto = Swipeable.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        _this$props$nodeName = _this$props.nodeName,
        nodeName = _this$props$nodeName === void 0 ? 'div' : _this$props$nodeName,
        innerRef = _this$props.innerRef,
        children = _this$props.children,
        trackMouse = _this$props.trackMouse;

    var _getHandlers = getHandlers(this._set, {
      trackMouse: trackMouse
    }),
        handlers = _getHandlers[0],
        attachTouch = _getHandlers[1];

    this.transientState = updateTransientState(this.transientState, this.props, attachTouch);
    var ref = innerRef ? function (el) {
      return innerRef(el), handlers.ref(el);
    } : handlers.ref;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(nodeName, _extends({}, handlers, {
      className: className,
      style: style,
      ref: ref
    }), children);
  };

  return Swipeable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);
Swipeable.propTypes = {
  onSwiped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwiping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSwipedLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  delta: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  preventDefaultTouchmoveEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  nodeName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  trackMouse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  trackTouch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  rotationAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
Swipeable.defaultProps = defaultProps;




/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sizes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var size = exports.size = undefined;
(function (size) {
    size["ExtraLarge"] = "extra-large";
    size["Large"] = "large";
    size["Medium"] = "medium";
    size["Small"] = "small";
    size["ExtraSmall"] = "extra-small";
})(size || (exports.size = size = {}));
var sizes = exports.sizes = (_sizes = {}, _defineProperty(_sizes, size.ExtraLarge, 128), _defineProperty(_sizes, size.Large, 96), _defineProperty(_sizes, size.Medium, 64), _defineProperty(_sizes, size.Small, 48), _defineProperty(_sizes, size.ExtraSmall, 32), _sizes);
exports.default = { size: size, sizes: sizes };

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _colors = __webpack_require__(211);

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    blockquote: '5px solid ' + _colors2.default.pacific,
    abbr: '1px dotted ' + _colors2.default.pebbleBeach,
    content: '2px solid ' + _colors2.default.t1000,
    borderRadiuses: {
        base: 3,
        small: 3,
        medium: 5,
        large: 8
    }
};

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    low: '0 3px 9px 0 rgba(0, 0, 0, 0.1)',
    medium: '0 7px 21px 0 rgba(0, 0, 0, 0.1)',
    high: '0 14px 42px 0 rgba(0, 0, 0, 0.2)',
    button: '0 6px 20px 0 rgba(0,0,0,0.2)'
};

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    base: 44,
    small: 28,
    medium: 44,
    large: 56
};

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var space2 = exports.space2 = 2;
var space3 = exports.space3 = 3;
var space4 = exports.space4 = 5;
var space5 = exports.space5 = 7;
var space6 = exports.space6 = 10;
var space7 = exports.space7 = 15;
var space8 = exports.space8 = 20;
var space9 = exports.space9 = 22;
var space10 = exports.space10 = 30;
var space11 = exports.space11 = 35;
var space12 = exports.space12 = 45;
var space13 = exports.space13 = 50;
var space14 = exports.space14 = 60;
var space15 = exports.space15 = 90;
var space16 = exports.space16 = 120;
var quarterGutter = exports.quarterGutter = space5;
var halfGutter = exports.halfGutter = space7;
var gutter = exports.gutter = space10;
var doubleGutter = exports.doubleGutter = space14;
var sesquiGutter = exports.sesquiGutter = space12;
var oneAndHalfGutter = exports.oneAndHalfGutter = space12;
var tripleGutter = exports.tripleGutter = space15;
// replaces cta-icon, back-icon, forward-icon
var inlineIcon = exports.inlineIcon = space4;
var largeHeading = { top: 0, bottom: '1.6rem' };
var smallHeading = { top: 0, bottom: '0.8rem' };
var textBlock = '0 0 1.6rem';
var typography = exports.typography = {
    h0: largeHeading,
    h1: largeHeading,
    h2: largeHeading,
    h3: largeHeading,
    h4: largeHeading,
    h5: smallHeading,
    h6: smallHeading,
    h7: smallHeading,
    paragraph: textBlock,
    blockquote: {
        margin: textBlock,
        padding: '0 0 0 1rem'
    },
    hr: textBlock,
    ul: textBlock,
    ol: textBlock
};
var layout = exports.layout = {
    sectionTop: doubleGutter,
    sectionBottom: tripleGutter,
    smallSectionTop: oneAndHalfGutter,
    smallSectionBottom: doubleGutter,
    twoColumnLayout: {
        bottomSpacing: {
            all: doubleGutter,
            small: oneAndHalfGutter,
            medium: oneAndHalfGutter
        },
        bottomDistance: {
            all: oneAndHalfGutter,
            small: gutter,
            medium: gutter
        }
    },
    contentHeader: {
        topSpacing: {
            base: {
                all: oneAndHalfGutter,
                small: gutter,
                medium: gutter
            },
            compact: {
                all: space9,
                small: space7,
                medium: space7
            }
        },
        bottomSpacing: {
            all: oneAndHalfGutter,
            small: gutter,
            medium: gutter
        },
        backDistance: gutter,
        menuDistance: gutter
    },
    contentBody: {
        topSpacing: {
            base: {
                all: gutter,
                small: halfGutter,
                medium: halfGutter
            },
            spacious: {
                all: doubleGutter,
                small: oneAndHalfGutter,
                medium: oneAndHalfGutter
            }
        },
        bottomSpacing: {
            all: tripleGutter,
            small: doubleGutter,
            medium: doubleGutter
        }
    }
};
var spaces = {
    space2: space2,
    space3: space3,
    space4: space4,
    space5: space5,
    space6: space6,
    space7: space7,
    space8: space8,
    space9: space9,
    space10: space10,
    space11: space11,
    space12: space12,
    space13: space13,
    space14: space14,
    space15: space15,
    space16: space16,
    quarterGutter: quarterGutter,
    halfGutter: halfGutter,
    gutter: gutter,
    doubleGutter: doubleGutter,
    sesquiGutter: sesquiGutter,
    oneAndHalfGutter: oneAndHalfGutter,
    tripleGutter: tripleGutter,
    inlineIcon: inlineIcon,
    typography: typography,
    layout: layout
};
exports.default = spaces;

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rootFontFamily = 'Atlas Grotesk Web, sans-serif';
var headingFontFamily = 'Larsseit-Bold, sans-serif';
var fontFamilies = exports.fontFamilies = {
    root: rootFontFamily,
    heading: headingFontFamily,
    code: 'Monaco, Menlo, Consolas, Courier New, monospace',
    attribution: 'Georgia, serif',
    cite: 'Georgia, serif',
    links: {
        root: rootFontFamily,
        subtle: rootFontFamily,
        jumbo: headingFontFamily
    }
};
var typeScale = exports.typeScale = {
    size1: 12,
    size2: 14,
    size3: 16,
    size4: 19,
    size5: 24,
    size6: 32,
    size7: 40,
    size8: 48,
    size9: 60
};
var rootFontSize = typeScale.size3;
var fontSizes = exports.fontSizes = {
    root: rootFontSize,
    h0: {
        all: typeScale.size9,
        medium: typeScale.size8,
        mall: typeScale.size8
    },
    h1: {
        all: typeScale.size8,
        medium: typeScale.size7,
        small: typeScale.size7
    },
    h2: {
        all: typeScale.size7,
        medium: typeScale.size6,
        small: typeScale.size6
    },
    h3: {
        all: typeScale.size6,
        medium: typeScale.size5,
        small: typeScale.size5
    },
    h4: {
        all: typeScale.size5,
        medium: typeScale.size4,
        small: typeScale.size4
    },
    h5: {
        all: typeScale.size4,
        medium: typeScale.size3,
        small: typeScale.size3
    },
    h6: {
        all: typeScale.size3,
        medium: typeScale.size2,
        small: typeScale.size2
    },
    h7: {
        all: typeScale.size2,
        medium: typeScale.size1,
        small: typeScale.size1
    },
    primaryCrosslead: {
        all: typeScale.size6,
        small: typeScale.size3
    },
    primarySidelead: {
        all: typeScale.size6,
        small: typeScale.size3
    },
    small: '70%',
    blockquote: {
        base: 'inherit',
        cite: '85%'
    },
    links: {
        root: typeScale.size3,
        subtle: typeScale.size2,
        jumbo: typeScale.size4
    },
    code: rootFontSize,
    paragraphs: {
        jumbo: typeScale.size5,
        large: typeScale.size4,
        regular: rootFontSize,
        small: typeScale.size2
    }
};
var fontWeights = exports.fontWeights = {
    normal: 400,
    medium: 400,
    bold: 700,
    root: 400,
    text: 400,
    heading: 400
};
var headingLetterSpacing = {
    h0: '-0.045em',
    h1: '-0.035em',
    h2: '-0.025em',
    h3: '-0.015em',
    h4: '-0.005em',
    h5: 0,
    h6: 0,
    h7: 0
};
var letterSpacing = exports.letterSpacing = {
    h0: headingLetterSpacing.h0,
    h1: headingLetterSpacing.h1,
    h2: headingLetterSpacing.h2,
    h3: headingLetterSpacing.h3,
    h4: headingLetterSpacing.h4,
    h5: headingLetterSpacing.h5,
    h6: headingLetterSpacing.h6,
    h7: headingLetterSpacing.h7,
    typeScale: {
        size9: headingLetterSpacing.h0,
        size8: headingLetterSpacing.h1,
        size7: headingLetterSpacing.h2,
        size6: headingLetterSpacing.h3,
        size5: headingLetterSpacing.h4,
        size4: headingLetterSpacing.h5,
        size3: headingLetterSpacing.h6,
        size2: headingLetterSpacing.h7,
        size1: headingLetterSpacing.h7
    }
};
var smallLineHeight = 1.2;
var mediumLineHeight = 1.3;
var rootLineHeight = 1.6;
var h0LineHeight = 1.05;
var h1LineHeight = 1.05;
var h2LineHeight = 1.1;
var h3LineHeight = 1.15;
var h4LineHeight = 1.25;
var h5LineHeight = 1.3;
var h6LineHeight = 1.3;
var h7LineHeight = 1.3;
var lineHeights = exports.lineHeights = {
    small: smallLineHeight,
    medium: mediumLineHeight,
    root: rootLineHeight,
    h0: h0LineHeight,
    h1: h1LineHeight,
    h2: h2LineHeight,
    h3: h3LineHeight,
    h4: h4LineHeight,
    h5: h5LineHeight,
    h6: h6LineHeight,
    h7: h7LineHeight,
    text: rootLineHeight,
    heading: rootLineHeight,
    typeScale: {
        size9: h0LineHeight,
        size8: h1LineHeight,
        size7: h2LineHeight,
        size6: h3LineHeight,
        size5: h4LineHeight,
        size4: h5LineHeight,
        size3: h6LineHeight,
        size2: h7LineHeight,
        size1: h7LineHeight
    },
    paragraphs: {
        jumbo: 1.4,
        large: 1.4,
        regular: rootLineHeight,
        small: rootLineHeight
    }
};
var maxWidths = exports.maxWidths = {
    h0: '12em',
    h1: '12em',
    h2: '12em',
    h3: '12em',
    h4: '12em',
    h5: '12em',
    h6: '23em',
    h7: '23em',
    paragraph: '40em'
};
var fontStyles = exports.fontStyles = {
    em: 'italic'
};
var textRendering = exports.textRendering = {
    root: null,
    heading: 'optimizelegibility'
};
var textDecoration = exports.textDecoration = {
    anchor: {
        base: 'none',
        hover: 'underline',
        active: 'none'
    }
};
var typography = {
    fontFamilies: fontFamilies,
    typeScale: typeScale,
    fontSizes: fontSizes,
    fontWeights: fontWeights,
    letterSpacing: letterSpacing,
    lineHeights: lineHeights,
    maxWidths: maxWidths,
    fontStyles: fontStyles,
    textRendering: textRendering,
    textDecoration: textDecoration
};
exports.default = typography;

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConnectedAnnotationsCanvas = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Annotation = __webpack_require__(455);

var _Annotation2 = _interopRequireDefault(_Annotation);

var _Comment = __webpack_require__(282);

var _Comment2 = _interopRequireDefault(_Comment);

var _designComments = __webpack_require__(139);

var _connectToStores = __webpack_require__(91);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _DesignCommentsStore = __webpack_require__(117);

var _DesignCommentsStore2 = _interopRequireDefault(_DesignCommentsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Components


// Actions


var AnnotationsCanvas = function (_React$Component) {
    _inherits(AnnotationsCanvas, _React$Component);

    function AnnotationsCanvas() {
        _classCallCheck(this, AnnotationsCanvas);

        return _possibleConstructorReturn(this, (AnnotationsCanvas.__proto__ || Object.getPrototypeOf(AnnotationsCanvas)).apply(this, arguments));
    }

    _createClass(AnnotationsCanvas, [{
        key: 'renderAnnotation',
        value: function renderAnnotation(comment, selectCommentAfterCreate) {
            var isSelected = this.props.selectedComment && this.props.selectedComment.id === comment.id;

            var status = this.props.selectedCommentStatus;

            // Show read view if the selected comment is currently being edited elsewhere i.e the sidebar
            if (status === 'editing' && this.props.selectedCommentEditingLocation !== 'canvas') {
                status = null;
            }

            return _react2.default.createElement(
                _Annotation2.default,
                {
                    isDeleting: status === 'deleting',
                    isSelected: isSelected,
                    key: comment.id,
                    onClick: this.props.onSelectDesignComment.bind(this, comment),
                    position: this.props.toScreenSpace(comment.annotation)
                },
                _react2.default.createElement(_Comment2.default, {
                    design: this.props.design,
                    hasExtraPadding: false,
                    comment: comment,
                    status: status,
                    isSelected: isSelected,
                    commentLocation: 'canvas',
                    canHighlight: false,
                    canShowAnnotationMarker: false,
                    isHeaderVisible: false,
                    selectCommentAfterCreate: selectCommentAfterCreate
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return this.props.annotations.map(function (comment) {
                return _this2.renderAnnotation(comment, _this2.props.selectCommentAfterCreate);
            });
        }
    }]);

    return AnnotationsCanvas;
}(_react2.default.Component);

exports.default = AnnotationsCanvas;


AnnotationsCanvas.propTypes = {
    design: _propTypes2.default.object.isRequired,
    selectedCommentEditingLocation: _propTypes2.default.string,
    annotations: _propTypes2.default.array,
    selectedComment: _propTypes2.default.object,
    selectedCommentStatus: _propTypes2.default.oneOf(['creating', 'editing', 'saving', 'deleting', 'error']),
    toScreenSpace: _propTypes2.default.func.isRequired,
    onSelectDesignComment: _propTypes2.default.func.isRequired,
    selectCommentAfterCreate: _propTypes2.default.bool
};

var ConnectedAnnotationsCanvas = exports.ConnectedAnnotationsCanvas = (0, _connectToStores2.default)(AnnotationsCanvas, [_DesignCommentsStore2.default], function (context, props) {
    var selectedCommentEditingLocation = context.getStore(_DesignCommentsStore2.default).selectedCommentEditingLocation;
    var comments = context.getStore(_DesignCommentsStore2.default).comments;
    var annotations = comments.filter(function (comment) {
        return Boolean(comment.annotation);
    });

    return {
        selectedCommentEditingLocation: selectedCommentEditingLocation,
        annotations: annotations,
        selectedComment: context.getStore(_DesignCommentsStore2.default).selectedComment,
        selectedCommentStatus: context.getStore(_DesignCommentsStore2.default).selectedCommentStatus,
        onSelectDesignComment: function onSelectDesignComment(comment) {
            context.executeAction(_designComments.selectDesignComment, { comment: comment });
        },
        selectCommentAfterCreate: props.selectCommentAfterCreate
    };
});
ConnectedAnnotationsCanvas.contextTypes = {
    getStore: _propTypes2.default.func,
    executeAction: _propTypes2.default.func
};

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _clsx = __webpack_require__(11);

var _clsx2 = _interopRequireDefault(_clsx);

var _PopoverCard = __webpack_require__(278);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */


var Annotation = function (_React$Component) {
    _inherits(Annotation, _React$Component);

    function Annotation(props) {
        _classCallCheck(this, Annotation);

        var _this = _possibleConstructorReturn(this, (Annotation.__proto__ || Object.getPrototypeOf(Annotation)).call(this, props));

        _this.onClick = function (e) {
            e.stopPropagation();
            _this.props.onClick();
        };

        _this.onMouseDown = function (e) {
            e.stopPropagation();
        };
        return _this;
    }

    _createClass(Annotation, [{
        key: 'card',
        value: function card() {
            return _react2.default.createElement(
                'div',
                { className: 'annotation__content' },
                this.props.children
            );
        }
    }, {
        key: 'button',
        value: function button() {
            return _react2.default.createElement('button', {
                className: (0, _clsx2.default)({
                    annotation__marker: true,
                    'annotation__marker--deleting': this.props.isDeleting && this.props.isSelected
                }),
                style: {
                    left: this.props.position.x,
                    top: this.props.position.y
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    className: 'annotation',
                    onClick: this.onClick,
                    onMouseDown: this.onMouseDown,
                    'data-focus': this.props.isSelected || undefined
                },
                _react2.default.createElement(
                    _PopoverCard.PopoverCard,
                    {
                        variations: [this.props.isSelected ? '' : 'hidden'],
                        layerSelector: '#design-details-annotations-anchor',
                        card: this.card()
                    },
                    this.button()
                )
            );
        }
    }]);

    return Annotation;
}(_react2.default.Component);

exports.default = Annotation;


Annotation.propTypes = {
    children: _propTypes2.default.node,
    isDeleting: _propTypes2.default.bool,
    isSaving: _propTypes2.default.bool,
    isSelected: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    position: _propTypes2.default.shape({
        x: _propTypes2.default.number.isRequired,
        y: _propTypes2.default.number.isRequired
    }).isRequired
};

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getWindow() {
    typeof window === 'undefined' ? {} : window;
}

var ScrollIntoViewElement = function (_React$Component) {
    _inherits(ScrollIntoViewElement, _React$Component);

    function ScrollIntoViewElement() {
        _classCallCheck(this, ScrollIntoViewElement);

        return _possibleConstructorReturn(this, (ScrollIntoViewElement.__proto__ || Object.getPrototypeOf(ScrollIntoViewElement)).apply(this, arguments));
    }

    _createClass(ScrollIntoViewElement, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.isEnabled && this.props.scrollingTrigger && nextProps.scrollingTrigger && this.isOutOfView(this.props.scrollingContainer, _reactDom2.default.findDOMNode(this)) //eslint-disable-line react/no-find-dom-node
            ) {
                    this.scroll();
                }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.canScrollOnMount && this.isOutOfView(this.props.scrollingContainer, _reactDom2.default.findDOMNode(this)) //eslint-disable-line react/no-find-dom-node
            ) {
                    this.scroll();
                }
        }
    }, {
        key: 'isOutOfView',
        value: function isOutOfView(container, element) {
            var $element = $(element);
            var $container = $(container);
            var elementTop = $element.offset() ? $element.offset().top : 0;
            var containerTop = $container.offset() ? $container.offset().top : 0;
            var containerHeight = $container.height();
            var containerScroll = $container.scrollTop();
            var viewportTop = $(window).scrollTop();
            var viewportHeight = $(window).height();
            var isUnderContainer = elementTop > containerTop + containerHeight + containerScroll;
            var isAboveContainer = elementTop < containerTop;
            var isOutOfViewport = elementTop < viewportTop || elementTop > viewportTop + viewportHeight;

            return isUnderContainer || isAboveContainer || isOutOfViewport;
        }
    }, {
        key: 'scroll',
        value: function scroll() {
            _reactDom2.default.findDOMNode(this).scrollIntoView(true); //eslint-disable-line react/no-find-dom-node
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);

    return ScrollIntoViewElement;
}(_react2.default.Component);

exports.default = ScrollIntoViewElement;


ScrollIntoViewElement.propTypes = {
    isEnabled: _propTypes2.default.bool,
    scrollingTrigger: _propTypes2.default.any,
    scrollingContainer: _propTypes2.default.object,
    canScrollOnMount: _propTypes2.default.bool,
    children: _propTypes2.default.node
};

ScrollIntoViewElement.defaultProps = {
    isEnabled: true,
    canScrollOnMount: false,
    scrollingContainer: getWindow()
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CommentField = __webpack_require__(458);

Object.defineProperty(exports, 'CommentField', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CommentField).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

var _clsx = __webpack_require__(11);

var _clsx2 = _interopRequireDefault(_clsx);

var _Textarea = __webpack_require__(459);

var _Button = __webpack_require__(16);

var _Avatar = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-restricted-imports


var CommentField = function (_React$Component) {
    _inherits(CommentField, _React$Component);

    function CommentField(props) {
        _classCallCheck(this, CommentField);

        var _this = _possibleConstructorReturn(this, (CommentField.__proto__ || Object.getPrototypeOf(CommentField)).call(this, props));

        _this.state = {
            hasFocus: false,
            textValue: '',
            initialHeight: _this.getButtonHeight()
        };
        _this.handleFocus = _this.handleFocus.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        return _this;
    }

    _createClass(CommentField, [{
        key: 'handleFocus',
        value: function handleFocus(e) {
            this.props.onFocus(e);
            this.setState({
                hasFocus: true
            });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var trimmedValue = this.state.textValue.trim();

            e.stopPropagation();
            e.preventDefault();

            if (trimmedValue) {
                this.props.onSubmit(trimmedValue);
            }
        }
    }, {
        key: 'handleCancel',
        value: function handleCancel(e) {
            e.stopPropagation();
            e.preventDefault();

            this.props.onCancel();
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            this.setState({
                textValue: e.target.value
            });

            this.props.onChange(e);
        }
    }, {
        key: 'handleKeyDown',
        value: function handleKeyDown(e) {
            this.props.onKeyDown(e);
            // enter + (ctrl or cmd)
            if (e.keyCode === 13 && (e.ctrlKey || e.metaKey)) {
                return this.handleSubmit(e);
            }
        }

        // Hack to ensure input matches button height

    }, {
        key: 'getButtonHeight',
        value: function getButtonHeight() {
            var tmp = (0, _jquery2.default)('<button class="button button--primary">SAMPLE</button>').appendTo('body');
            var height = Math.ceil(tmp.outerHeight());
            tmp.remove();
            return height;
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            if (this.props.textValue) {
                this.setState({
                    textValue: this.props.textValue
                });
            }
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.textValue !== this.props.textValue) {
                this.setState({
                    textValue: nextProps.textValue
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var classes = (0, _clsx2.default)({
                'comment-field': true,
                'comment-field--vertical': this.props.layout === 'vertical',
                'comment-field--horizontal': this.props.layout === 'horizontal'
            });
            var fieldProps = this.getFieldProps();

            return _react2.default.createElement(
                'div',
                _extends({}, fieldProps, { className: classes, 'data-comment-field': true }),
                this.avatar(),
                _react2.default.createElement(
                    'div',
                    { className: 'comment-field__input' },
                    _react2.default.createElement(_Textarea.Textarea, {
                        placeholder: this.props.placeholder,
                        isFocused: this.props.isAutoFocus,
                        value: this.state.textValue,
                        isExpandable: true,
                        onChange: this.handleChange,
                        onFocus: this.handleFocus,
                        onKeyDown: this.handleKeyDown,
                        onKeyUp: this.props.onKeyUp,
                        maxHeight: 300,
                        minHeight: this.state.initialHeight
                    })
                ),
                this.criticalError(),
                this.buttons()
            );
        }
    }, {
        key: 'getFieldProps',
        value: function getFieldProps() {
            if (this.props.hasFieldError) {
                return { 'data-field-error': true };
            }
        }
    }, {
        key: 'avatar',
        value: function avatar() {
            if (!this.props.activeUser) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'comment-field__avatar' },
                _react2.default.createElement(_Avatar.Avatar, { user: this.props.activeUser, variations: ['extra-small', 'block'] })
            );
        }
    }, {
        key: 'criticalError',
        value: function criticalError() {
            if (!this.props.criticalError) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'comment-field__error' },
                this.props.criticalError
            );
        }
    }, {
        key: 'buttons',
        value: function buttons() {
            if (this.props.isAutoFocus || this.state.hasFocus || this.state.textValue.length > 0) {
                return _react2.default.createElement(
                    'div',
                    { className: 'comment-field__controls' },
                    _react2.default.createElement(
                        'div',
                        { className: 'comment-field__button' },
                        _react2.default.createElement(
                            _Button.Button,
                            {
                                variations: ['primary'],
                                isDisabled: Boolean(this.props.criticalError),
                                title: this.props.submitButtonTooltip || null,
                                onClick: this.handleSubmit,
                                'data-submit-comment-button': true
                            },
                            this.props.submitButtonLabel
                        )
                    ),
                    this.cancelButton()
                );
            }
        }
    }, {
        key: 'cancelButton',
        value: function cancelButton() {
            if (!this.props.hasCancelButton) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'comment-field__button' },
                _react2.default.createElement(
                    _Button.Button,
                    {
                        variations: ['link'],
                        onClick: this.handleCancel,
                        'data-cancel-comment-button': true
                    },
                    this.props.cancelButtonLabel
                )
            );
        }
    }]);

    return CommentField;
}(_react2.default.Component);

exports.default = CommentField;


CommentField.propTypes = {
    cancelButtonLabel: _propTypes2.default.string,
    hasCancelButton: _propTypes2.default.bool,
    isAutoFocus: _propTypes2.default.bool,
    layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
    placeholder: _propTypes2.default.string,
    submitButtonLabel: _propTypes2.default.node,
    submitButtonTooltip: _propTypes2.default.string,
    textValue: _propTypes2.default.string,
    activeUser: _propTypes2.default.object,
    onKeyDown: _propTypes2.default.func,
    onKeyUp: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onCancel: _propTypes2.default.func,
    onSubmit: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    criticalError: _propTypes2.default.node,
    hasFieldError: _propTypes2.default.bool
};

CommentField.defaultProps = {
    cancelButtonLabel: '[CANCEL]',
    hasCancelButton: false,
    isAutoFocus: false,
    layout: 'horizontal',
    onCancel: function onCancel() {},
    onSubmit: function onSubmit() {},
    onKeyDown: function onKeyDown() {},
    onKeyUp: function onKeyUp() {},
    onChange: function onChange() {},
    onFocus: function onFocus() {},

    placeholder: '',
    submitButtonLabel: '[SEND]',

    criticalError: null
};

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Textarea = __webpack_require__(460);

Object.defineProperty(exports, 'Textarea', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Textarea).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = __webpack_require__(5);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-line no-restricted-imports

var Textarea = function (_React$Component) {
    _inherits(Textarea, _React$Component);

    // _input = React.createRef();

    function Textarea(props) {
        _classCallCheck(this, Textarea);

        var _this = _possibleConstructorReturn(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleFocus = _this.handleFocus.bind(_this);
        return _this;
    }

    _createClass(Textarea, [{
        key: 'updateHeight',
        value: function updateHeight(textareaNode) {
            if (this.props.isExpandable && textareaNode.scrollHeight > textareaNode.clientHeight) {
                (0, _jquery2.default)(textareaNode).innerHeight(textareaNode.scrollHeight);
            } else if (this.props.isCollapsible) {
                this.initialiseHeight(textareaNode);
                (0, _jquery2.default)(textareaNode).innerHeight(textareaNode.scrollHeight);
            }
        }
    }, {
        key: 'initialiseHeight',
        value: function initialiseHeight(textarea) {
            (0, _jquery2.default)(textarea).outerHeight(this.props.minHeight || 'auto');
        }
    }, {
        key: 'maybeFocus',
        value: function maybeFocus() {
            if (this.props.isFocused) {
                this._input.focus();
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var textarea = this._input;
            this.initialiseHeight(textarea);
            this.applyResizeBehaviors(textarea);
            this.updateHeight(textarea);
            this.maybeFocus();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var textarea = this._input;
            this.updateHeight(textarea);

            if (!textarea.textContent) {
                textarea.removeAttribute('style');
            }

            if (this.props.isFocused != prevProps.isFocused) {
                this.maybeFocus();
            }
        }

        // In WebKit all textareas cannot be resized to under 150px. In Firefox they can be resized to 50px.
        // This takes over browser resizing as a workaround.

    }, {
        key: 'applyResizeBehaviors',
        value: function applyResizeBehaviors(textarea) {
            var resizableStart = function resizableStart() {
                textarea.originalW = textarea.clientWidth;
                textarea.originalH = textarea.clientHeight;
                textarea.onmousemove = resizableCheck;
                textarea.onmouseup = resizableEnd;
                textarea.onmouseout = resizableEnd;
            };

            var resizableCheck = function resizableCheck(e) {
                if (textarea.clientWidth !== textarea.originalW || textarea.clientHeight !== textarea.originalH) {
                    textarea.originalX = e.clientX;
                    textarea.originalY = e.clientY;
                    textarea.onmousemove = resizableMove;
                }
            };

            var resizableMove = function resizableMove(e) {
                var newW = textarea.originalW + e.clientX - textarea.originalX;
                var newH = textarea.originalH + e.clientY - textarea.originalY;
                var resize = textarea.style.resize;

                if (newW < textarea.originalW && ['horizontal', 'both'].indexOf(resize) > -1) {
                    textarea.style.width = newW + 'px';
                }

                if (newH < textarea.originalH && ['vertical', 'both'].indexOf(resize) > -1) {
                    textarea.style.height = newH + 'px';
                }
            };

            var resizableEnd = function resizableEnd() {
                textarea.onmousemove = null;
                textarea.onmouseout = null;
                textarea.onmouseup = null;
            };

            textarea.onmouseover = resizableStart;
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            this.props.onChange(e);
        }
    }, {
        key: 'handleFocus',
        value: function handleFocus(e) {
            this.props.onFocus(e);

            // If there is content in the textarea, move cursor to end of textarea on focus
            if (this.props.value.length > 0) {
                //eslint-disable-next-line react/no-find-dom-node
                _reactDom2.default.findDOMNode(this).setSelectionRange(this.props.value.length, this.props.value.length);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var textareaStyle = {
                resize: this.props.resize,
                minHeight: this.props.minHeight,
                maxHeight: this.props.maxHeight,
                boxSizing: 'border-box'
            };

            return _react2.default.createElement('textarea', {
                ref: function ref(c) {
                    return _this2._input = c;
                },
                onKeyDown: this.props.onKeyDown,
                onKeyUp: this.props.onKeyUp,
                style: textareaStyle,
                disabled: this.props.isDisabled,
                onChange: this.handleChange,
                onFocus: this.handleFocus,
                onBlur: this.props.onBlur,
                value: this.props.value,
                placeholder: this.props.placeholder,
                className: 'input-text input-width--max'
            });
        }
    }]);

    return Textarea;
}(_react2.default.Component);

Textarea.propTypes = {
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    minHeight: _propTypes2.default.number,
    maxHeight: _propTypes2.default.number,
    isExpandable: _propTypes2.default.bool,
    isCollapsible: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool,
    isFocused: _propTypes2.default.bool,
    resize: _propTypes2.default.oneOf(['none', 'both', 'horizontal', 'vertical']),
    onKeyDown: _propTypes2.default.func,
    onKeyUp: _propTypes2.default.func,
    placeholder: _propTypes2.default.string
};

Textarea.defaultProps = {
    value: '',
    minHeight: 0,
    isExpandable: false,
    isCollapsible: false,
    isFocused: false,
    resize: 'vertical',
    onKeyDown: function onKeyDown() {},
    onKeyUp: function onKeyUp() {},
    onFocus: function onFocus() {},
    onBlur: function onBlur() {},
    onChange: function onChange() {},

    placeholder: ''
};

exports.default = Textarea;

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnnotationTooltip = function (_React$Component) {
    _inherits(AnnotationTooltip, _React$Component);

    function AnnotationTooltip(props) {
        _classCallCheck(this, AnnotationTooltip);

        var _this = _possibleConstructorReturn(this, (AnnotationTooltip.__proto__ || Object.getPrototypeOf(AnnotationTooltip)).call(this, props));

        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
        _this.state = {
            x: null,
            y: null
        };
        return _this;
    }

    _createClass(AnnotationTooltip, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            window.addEventListener('mousemove', this.handleMouseMove);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('mousemove', this.handleMouseMove);
        }
    }, {
        key: 'handleMouseMove',
        value: function handleMouseMove(e) {
            this.setState({ x: e.clientX, y: e.clientY });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    className: 'annotation-tooltip annotation-tooltip--active',
                    style: {
                        left: this.state.x + 15 + 'px',
                        top: this.state.y - 14 + 'px'
                    }
                },
                this.props.children
            );
        }
    }]);

    return AnnotationTooltip;
}(_react2.default.Component);

exports.default = AnnotationTooltip;


AnnotationTooltip.propTypes = {
    children: _propTypes2.default.node
};

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setDesignCollection = setDesignCollection;
exports.setDesignData = setDesignData;
exports.loadDesign = loadDesign;
exports.loadMoreDesigns = loadMoreDesigns;

var _request = __webpack_require__(172);

var _request2 = _interopRequireDefault(_request);

var _constants = __webpack_require__(173);

var _constants2 = _interopRequireDefault(_constants);

var _DesignCollectionStore = __webpack_require__(170);

var _DesignCollectionStore2 = _interopRequireDefault(_DesignCollectionStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasPendingRequest = false;
var preLoadDistance = 2;

function appendDesignData(context, payload) {
    if (hasPendingRequest) return;
    hasPendingRequest = true;

    var apiRequest = (0, _request2.default)('GET', payload.nextPageUrl).set('X-Requested-With', 'XMLHttpRequest');

    return (0, _request.resolve)(apiRequest).then(function (data) {
        hasPendingRequest = false;
        var collection = context.getStore(_DesignCollectionStore2.default).getCollectionModel().fromJSON(data);

        context.dispatch(_constants2.default.UPDATE_DESIGN_COLLECTION_PAGE_DATA_APPEND, {
            designs: collection.designs,
            pageUrl: payload.nextPageUrl
        });
    }).catch(function () {
        hasPendingRequest = false;
    });
}

function prependDesignData(context, payload) {
    if (hasPendingRequest) return;
    hasPendingRequest = true;

    var apiRequest = (0, _request2.default)('GET', payload.prevPageUrl).set('X-Requested-With', 'XMLHttpRequest');

    return (0, _request.resolve)(apiRequest).then(function (data) {
        hasPendingRequest = false;
        var collection = context.getStore(_DesignCollectionStore2.default).getCollectionModel().fromJSON(data);

        context.dispatch(_constants2.default.UPDATE_DESIGN_COLLECTION_PAGE_DATA_PREPEND, {
            designs: collection.designs,
            pageUrl: payload.prevPageUrl
        });
    }).catch(function () {
        hasPendingRequest = false;
    });
}

function setDesignCollection(context, collection) {
    return Promise.resolve().then(function () {
        return context.dispatch(_constants2.default.SET_DESIGN_COLLECTION, collection);
    });
}

function setDesignData(context, payload) {
    return Promise.resolve().then(function () {
        return context.dispatch(_constants2.default.SET_DESIGN_DATA, context.getStore(_DesignCollectionStore2.default).getModel().fromJSON(payload));
    });
}

function loadDesign(context, designId) {
    var collectionStore = context.getStore(_DesignCollectionStore2.default);
    var currentDesign = collectionStore.getDesign(designId);
    var apiRequest = (0, _request2.default)('GET', currentDesign.links.self, _constants2.default.LOAD_DESIGN_SUCCESS);

    return (0, _request.resolve)(apiRequest).then(function (response) {
        context.dispatch(_constants2.default.LOAD_DESIGN_SUCCESS, context.getStore(_DesignCollectionStore2.default).getModel().fromJSON(response));
    }).catch(function (e) {
        context.dispatch(_constants2.default.LOAD_DESIGN_FAILED);
        throw e;
    });
}

function loadMoreDesigns(context, designId) {
    var collectionStore = context.getStore(_DesignCollectionStore2.default);
    var currentDesign = collectionStore.getDesign(designId);
    var designs = collectionStore.designs;
    var nextPageUrl = collectionStore.nextPageUrl;
    var prevPageUrl = collectionStore.prevPageUrl;

    var index = designs.indexOf(currentDesign);

    if (nextPageUrl && !designs[index + preLoadDistance]) {
        return appendDesignData(context, {
            nextPageUrl: nextPageUrl
        });
    }

    if (prevPageUrl && index - preLoadDistance < 0) {
        return prependDesignData(context, {
            prevPageUrl: prevPageUrl
        });
    }
}

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _user = __webpack_require__(212);

var _user2 = _interopRequireDefault(_user);

var _designCollection = __webpack_require__(464);

var _designCollection2 = _interopRequireDefault(_designCollection);

var _design = __webpack_require__(213);

var _design2 = _interopRequireDefault(_design);

var _designComment = __webpack_require__(465);

var _designComment2 = _interopRequireDefault(_designComment);

var _designCommentCollection = __webpack_require__(466);

var _designCommentCollection2 = _interopRequireDefault(_designCommentCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    user: _user2.default,
    designCollection: _designCollection2.default,
    designComment: _designComment2.default,
    design: _design2.default,
    designCommentCollection: _designCommentCollection2.default
};

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _design = __webpack_require__(213);

var _design2 = _interopRequireDefault(_design);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultProperties() {
    return {
        designs: []
    };
} /* eslint-disable no-underscore-dangle */

function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function fromJSON(json) {
    if (!json) {
        return null;
    }

    return {
        designs: json._embedded.designs.map(_design2.default.fromJSON),
        designPageUrls: json._links.designPageUrls ? json._links.designPageUrls.map(function (link) {
            return link.href;
        }) : [],
        currentPageUrl: json._links.currentPageUrl ? json._links.currentPageUrl.href : undefined,
        designPageOffset: json.designPageOffset,
        totalDesignCount: json.totalDesignCount
    };
}

exports.default = {
    create: create,
    defaultProperties: defaultProperties,
    fromJSON: fromJSON
};

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _user = __webpack_require__(212);

var _user2 = _interopRequireDefault(_user);

var _designComment = __webpack_require__(174);

var _designComment2 = _interopRequireDefault(_designComment);

var _propertyOrNull = __webpack_require__(14);

var _propertyOrNull2 = _interopRequireDefault(_propertyOrNull);

var _design = __webpack_require__(213);

var _design2 = _interopRequireDefault(_design);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Translate from Projects HAL API to local data structure
/* eslint-disable no-underscore-dangle */

function fromJSON(json) {
    if (!json) {
        return null;
    }

    return {
        id: (0, _propertyOrNull2.default)(json._links.self, 'href'),
        designId: (0, _propertyOrNull2.default)(json._embedded.design, 'design_id'),
        message: json.message,
        formattedMessage: json.formattedMessage,
        isDeleted: json.isDeleted,
        links: {
            self: (0, _propertyOrNull2.default)(json._links.self, 'href'),
            edit: (0, _propertyOrNull2.default)(json._links.edit, 'href'),
            delete: (0, _propertyOrNull2.default)(json._links.delete, 'href')
        },
        createdAt: json.createdAt,
        creator: _user2.default.fromJSON(json._embedded.creator),
        permission: json._embedded.permission || {},
        design: _design2.default.fromJSON(json._embedded.file)
    };
}

exports.default = Object.assign({}, _designComment2.default, { fromJSON: fromJSON });

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _designComment = __webpack_require__(174);

var _designComment2 = _interopRequireDefault(_designComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    defaultProperties: defaultProperties,
    fromJSON: fromJSON
};


function defaultProperties() {
    return [];
}

function fromJSON(json) {
    if (!json) {
        return null;
    }

    return json._embedded.design_comments.map(_designComment2.default.fromJSON);
}

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Fullscreen = __webpack_require__(78);

var _SidebarHeader = __webpack_require__(285);

var _SidebarHeader2 = _interopRequireDefault(_SidebarHeader);

var _DesignActions = __webpack_require__(468);

var _DesignActions2 = _interopRequireDefault(_DesignActions);

var _SidebarBodyPane = __webpack_require__(479);

var _SidebarBodyPane2 = _interopRequireDefault(_SidebarBodyPane);

var _WorkOriginDifferentiator = __webpack_require__(489);

var _WorkOriginDifferentiator2 = _interopRequireDefault(_WorkOriginDifferentiator);

var _propTypes3 = __webpack_require__(286);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SIDEBAR_MODE_DEFAULT = 'default';
var SIDEBAR_MODE_LIKES_LIST = 'likes';

var DesignDetailsSidebar = function (_React$Component) {
    _inherits(DesignDetailsSidebar, _React$Component);

    function DesignDetailsSidebar(props) {
        _classCallCheck(this, DesignDetailsSidebar);

        var _this = _possibleConstructorReturn(this, (DesignDetailsSidebar.__proto__ || Object.getPrototypeOf(DesignDetailsSidebar)).call(this, props));

        _this.state = {
            activePane: SIDEBAR_MODE_DEFAULT,
            designId: props.design.designId
        };

        _this.handlePaneChange = _this.handlePaneChange.bind(_this);
        return _this;
    }

    _createClass(DesignDetailsSidebar, [{
        key: 'handlePaneChange',
        value: function handlePaneChange(activePane) {
            this.setState({ activePane: activePane });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _Fullscreen.FullscreenSidebar.Main,
                null,
                _react2.default.createElement(
                    _Fullscreen.FullscreenSidebar.Header,
                    null,
                    _react2.default.createElement(
                        _SidebarHeader2.default.Main,
                        {
                            closeOverlayHandler: this.props.closeOverlayHandler,
                            isCloseButtonEnabled: this.props.isInline
                        },
                        _react2.default.createElement(_DesignActions2.default, {
                            design: this.props.design,
                            activeUser: this.props.activeUser,
                            activePane: this.state.activePane,
                            onLikeCountClick: this.handlePaneChange.bind(this, SIDEBAR_MODE_LIKES_LIST)
                        }),
                        _react2.default.createElement(_WorkOriginDifferentiator2.default, { design: this.props.design })
                    )
                ),
                _react2.default.createElement(
                    _Fullscreen.FullscreenSidebar.Body,
                    null,
                    _react2.default.createElement(_SidebarBodyPane2.default, {
                        onPaneChange: this.handlePaneChange,
                        activePane: this.state.activePane,
                        design: this.props.design,
                        activeUser: this.props.activeUser,
                        isLoadingComments: this.props.isLoadingComments,
                        comments: this.props.comments,
                        selectedComment: this.props.selectedComment,
                        selectedCommentStatus: this.props.selectedCommentStatus,
                        selectedCommentEditingLocation: this.props.selectedCommentEditingLocation
                    })
                )
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.design.designId !== prevState.designId) {
                return {
                    activePane: SIDEBAR_MODE_DEFAULT,
                    designId: nextProps.design.designId
                };
            }

            return null;
        }
    }]);

    return DesignDetailsSidebar;
}(_react2.default.Component);

exports.default = DesignDetailsSidebar;


DesignDetailsSidebar.contextTypes = {
    intl: _propTypes2.default.object
};

DesignDetailsSidebar.defaultProps = {
    selectedComment: null,
    selectedCommentStatus: null,
    selectedCommentEditingLocation: null
};

DesignDetailsSidebar.propTypes = _extends({
    design: _propTypes2.default.object.isRequired,
    closeOverlayHandler: _propTypes2.default.func.isRequired,
    isInline: _propTypes2.default.bool.isRequired,
    activeUser: _propTypes2.default.object.isRequired
}, _propTypes3.DdoCommentProps);

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SidebarHeader = __webpack_require__(285);

var _SidebarHeader2 = _interopRequireDefault(_SidebarHeader);

var _actions = __webpack_require__(469);

var _LikeButton = __webpack_require__(470);

var _LikeButton2 = _interopRequireDefault(_LikeButton);

var _ShareButtonDropdownMenu = __webpack_require__(471);

var _ShareButtonDropdownMenu2 = _interopRequireDefault(_ShareButtonDropdownMenu);

var _DesignAttribution = __webpack_require__(472);

var _DesignAttribution2 = _interopRequireDefault(_DesignAttribution);

var _ButtonGroup = __webpack_require__(41);

var _TrackClick = __webpack_require__(84);

var _TrackClick2 = _interopRequireDefault(_TrackClick);

var _UserInteractionCtas = __webpack_require__(475);

var _UserInteractionCtas2 = _interopRequireDefault(_UserInteractionCtas);

var _DesignEditButton = __webpack_require__(478);

var _DesignEditButton2 = _interopRequireDefault(_DesignEditButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DesignActions = function (_React$Component) {
    _inherits(DesignActions, _React$Component);

    function DesignActions(props) {
        _classCallCheck(this, DesignActions);

        var _this = _possibleConstructorReturn(this, (DesignActions.__proto__ || Object.getPrototypeOf(DesignActions)).call(this, props));

        _this.likeDesign = _this.likeDesign.bind(_this);
        _this.unlikeDesign = _this.unlikeDesign.bind(_this);
        _this.handleFavorite = _this.handleFavorite.bind(_this);
        return _this;
    }

    _createClass(DesignActions, [{
        key: 'likeDesign',
        value: function likeDesign(likeCount) {
            this.context.executeAction(_actions.likeDesignAction, {
                designId: this.props.design.designId,
                likeCount: likeCount
            });
        }
    }, {
        key: 'unlikeDesign',
        value: function unlikeDesign(likeCount) {
            this.context.executeAction(_actions.unlikeDesignAction, {
                designId: this.props.design.designId,
                likeCount: likeCount
            });
        }
    }, {
        key: 'handleFavorite',
        value: function handleFavorite(isFavorite) {
            this.context.executeAction(_actions.updateDesignAction, {
                designId: this.props.design.designId,
                creator: _extends({}, this.props.design.creator, {
                    isFavorite: isFavorite
                })
            });
        }
    }, {
        key: 'linkLikeCount',
        value: function linkLikeCount() {
            if (this.props.design.likeCount > 0 && this.props.activePane === 'default' && this.props.design.permission.canEdit) {
                return this.props.onLikeCountClick;
            }

            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                activeUser = _props.activeUser,
                design = _props.design;


            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _SidebarHeader2.default.Section,
                    null,
                    _react2.default.createElement(
                        _SidebarHeader2.default.Heading,
                        null,
                        _react2.default.createElement(
                            _SidebarHeader2.default.HeadingText,
                            null,
                            _react2.default.createElement(
                                'div',
                                null,
                                ' ',
                                design.name,
                                ' '
                            )
                        )
                    ),
                    _react2.default.createElement(_DesignAttribution2.default, {
                        design: design,
                        activeUser: activeUser,
                        onFavorite: this.handleFavorite
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'section' },
                        design.permission.canEdit ? _react2.default.createElement(_DesignEditButton2.default, { designId: design.designId }) : _react2.default.createElement(_UserInteractionCtas2.default, {
                            userId: design.creator.userId,
                            isUserAvailable: !design.permission.designerUnavailable
                        })
                    ),
                    _react2.default.createElement(
                        _ButtonGroup.ButtonGroup,
                        { variations: ['giant'] },
                        _react2.default.createElement(
                            _ButtonGroup.ButtonGroupItem,
                            null,
                            _react2.default.createElement(
                                _TrackClick2.default,
                                {
                                    event: 'Element Clicked On Design Overlay',
                                    element: 'like_button'
                                },
                                _react2.default.createElement(_LikeButton2.default, {
                                    isLiked: design.likedByUser,
                                    likeUrl: design.links.likeDesignUrl,
                                    likeCount: design.likeCount,
                                    onLike: this.likeDesign,
                                    onUnlike: this.unlikeDesign,
                                    canLike: design.permission.canLike,
                                    noPermissionMessage: design.login_or_signup,
                                    onLikeCountClick: this.linkLikeCount()
                                })
                            )
                        ),
                        _react2.default.createElement(
                            _ButtonGroup.ButtonGroupItem,
                            null,
                            _react2.default.createElement(_ShareButtonDropdownMenu2.default, { design: design })
                        )
                    )
                )
            );
        }
    }]);

    return DesignActions;
}(_react2.default.Component);

exports.default = DesignActions;


DesignActions.contextTypes = {
    executeAction: _propTypes2.default.func
};

DesignActions.propTypes = {
    design: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    activeUser: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    activePane: _propTypes2.default.string.isRequired,
    onLikeCountClick: _propTypes2.default.func
};

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.likeDesignAction = likeDesignAction;
exports.unlikeDesignAction = unlikeDesignAction;
exports.updateDesignAction = updateDesignAction;
function likeDesignAction(context, _ref) {
    var designId = _ref.designId,
        likeCount = _ref.likeCount;

    context.dispatch('UPDATE_DESIGN_SUCCESS', {
        designId: designId,
        likedByUser: true,
        likeCount: likeCount
    });
}

function unlikeDesignAction(context, _ref2) {
    var designId = _ref2.designId,
        likeCount = _ref2.likeCount;

    context.dispatch('UPDATE_DESIGN_SUCCESS', {
        designId: designId,
        likedByUser: false,
        likeCount: likeCount
    });
}

function updateDesignAction(context, payload) {
    context.dispatch('UPDATE_DESIGN_SUCCESS', payload);
}

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Icon = function (_React$Component) {
    _inherits(Icon, _React$Component);

    function Icon() {
        _classCallCheck(this, Icon);

        return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
    }

    _createClass(Icon, [{
        key: 'render',
        value: function render() {
            var variations = [];
            if (this.props.variations) {
                variations = [].concat(_toConsumableArray(this.props.variations), [this.props.type]);
            } else {
                variations = [this.props.type];
            }
            var classes = (0, _app.getComponentClasses)('icon', variations);
            return _react2.default.createElement("span", { className: classes }, this.props.children);
        }
    }]);

    return Icon;
}(_react2.default.Component);

exports.default = Icon;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(63);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Icon = __webpack_require__(8);

var _IconButton = __webpack_require__(21);

var _DropdownMenu = __webpack_require__(181);

var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);

var _xhr = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var toggleLikeStateFn = function toggleLikeStateFn(state) {
    return {
        isLiked: !state.isLiked,
        likeCount: state.isLiked ? state.likeCount - 1 : state.likeCount + 1
    };
};

var LikeButton = function (_React$Component) {
    _inherits(LikeButton, _React$Component);

    function LikeButton(props) {
        _classCallCheck(this, LikeButton);

        var _this = _possibleConstructorReturn(this, (LikeButton.__proto__ || Object.getPrototypeOf(LikeButton)).call(this, props));

        _this.state = {
            likeCount: props.likeCount,
            isLiked: props.isLiked,
            likeUrl: props.likeUrl
        };

        _this.handleLikeClick = _this.handleLikeClick.bind(_this);
        return _this;
    }

    _createClass(LikeButton, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.abortRequest();
        }
    }, {
        key: 'abortRequest',
        value: function abortRequest() {
            if (this.request) {
                this.request.abort();
            }
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            this.abortRequest();
            this.request = this.props.toggleRequest(this.state.isLiked, this.state.likeUrl);
            this.request.then(function () {
                if (_this2.state.isLiked) {
                    _this2.props.onLike(_this2.state.likeCount);
                } else {
                    _this2.props.onUnlike(_this2.state.likeCount);
                }
            }).catch(function () {
                _this2.setState(toggleLikeStateFn);
            });
        }
    }, {
        key: 'handleLikeClick',
        value: function handleLikeClick() {
            if (this.props.canLike) {
                this.setState(toggleLikeStateFn, this.save);
            }
        }
    }, {
        key: 'noPermissionMessage',
        value: function noPermissionMessage() {
            return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.noPermissionMessage } });
        }
    }, {
        key: 'likeCount',
        value: function likeCount() {
            if (!this.props.onLikeCountClick) return this.state.likeCount;

            return _react2.default.createElement(
                'button',
                { className: 'like-button__count__link', onClick: this.props.onLikeCountClick },
                this.state.likeCount
            );
        }
    }, {
        key: 'likeButton',
        value: function likeButton() {
            return _react2.default.createElement(
                'div',
                { className: 'like-button' },
                _react2.default.createElement(
                    'div',
                    { className: 'like-button__button' },
                    _react2.default.createElement(
                        _IconButton.IconButton,
                        {
                            variations: ['soft-toggle', (0, _classnames2.default)({ selected: this.state.isLiked })],
                            onClick: this.handleLikeClick
                        },
                        _react2.default.createElement(_Icon.Icon, { type: 'like-1' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'like-button__count' },
                    this.likeCount()
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.canLike) {
                return _react2.default.createElement(
                    _DropdownMenu2.default,
                    {
                        itemData: [{
                            label: this.noPermissionMessage(),
                            key: 'like'
                        }]
                    },
                    this.likeButton()
                );
            }
            return this.likeButton();
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.likeUrl === prevState.likeUrl) return null;

            return {
                likeCount: nextProps.likeCount,
                isLiked: nextProps.isLiked,
                likeUrl: nextProps.likeUrl
            };
        }
    }]);

    return LikeButton;
}(_react2.default.Component);

LikeButton.defaultProps = {
    likeCount: 0,
    onLikeCountClick: false,
    onLike: function onLike() {
        return undefined;
    },
    onUnlike: function onUnlike() {
        return undefined;
    },
    toggleRequest: _xhr.toggleRequest,
    canLike: false
};

LikeButton.propTypes = {
    isLiked: _propTypes2.default.bool.isRequired,
    likeUrl: _propTypes2.default.string.isRequired,
    likeCount: _propTypes2.default.number,
    onLikeCountClick: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool]),
    onLike: _propTypes2.default.func,
    onUnlike: _propTypes2.default.func,
    toggleRequest: _propTypes2.default.func,
    canLike: _propTypes2.default.bool,
    noPermissionMessage: _propTypes2.default.any
};

exports.default = LikeButton;

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = __webpack_require__(8);

var _DropdownMenu = __webpack_require__(181);

var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);

var _TrackClick = __webpack_require__(84);

var _TrackClick2 = _interopRequireDefault(_TrackClick);

var _trackEvent = __webpack_require__(66);

var _trackEvent2 = _interopRequireDefault(_trackEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShareButtonDropdownMenu = function (_React$Component) {
    _inherits(ShareButtonDropdownMenu, _React$Component);

    function ShareButtonDropdownMenu(props) {
        _classCallCheck(this, ShareButtonDropdownMenu);

        var _this = _possibleConstructorReturn(this, (ShareButtonDropdownMenu.__proto__ || Object.getPrototypeOf(ShareButtonDropdownMenu)).call(this, props));

        _this.getDropdownItemData = _this.getDropdownItemData.bind(_this);
        _this.onAction = _this.onAction.bind(_this);
        return _this;
    }

    _createClass(ShareButtonDropdownMenu, [{
        key: 'onAction',
        value: function onAction(data) {
            var shareData = this.props.design.shareData;
            var url = shareData.find(function (datum) {
                return datum.name === data.key;
            }).shareUrl;

            (0, _trackEvent2.default)('Element Clicked On Design Overlay', {
                element: 'social_share_menu_item',
                targetUrl: url
            });

            window.open(url, '_blank');
        }
    }, {
        key: 'getShareIcon',
        value: function getShareIcon(shareDatum) {
            return _react2.default.createElement(
                'span',
                { className: 'menu__item__action__icon' },
                _react2.default.createElement(_Icon.Icon, { variations: ['icon ' + shareDatum.iconVariation] })
            );
        }
    }, {
        key: 'getDropdownItemData',
        value: function getDropdownItemData() {
            var shareData = this.props.design.shareData;

            return shareData.map(function (shareDatum) {
                return {
                    label: this.context.intl.formatMessage({ id: shareDatum.name }),
                    key: shareDatum.name,
                    icon: this.getShareIcon(shareDatum)
                };
            }, this);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _DropdownMenu2.default,
                { itemData: this.getDropdownItemData(), onSelect: this.onAction },
                _react2.default.createElement(
                    _TrackClick2.default,
                    { element: 'share_icon' },
                    _react2.default.createElement(
                        'button',
                        { className: 'icon-button icon-button--on-white icon-button--offset-right' },
                        _react2.default.createElement('span', { className: 'icon icon--share-1' })
                    )
                ),
                _react2.default.createElement(
                    _TrackClick2.default,
                    { element: 'share_link' },
                    _react2.default.createElement(
                        'button',
                        { className: 'button button--link' },
                        this.context.intl.formatMessage({ id: 'share' })
                    )
                )
            );
        }
    }]);

    return ShareButtonDropdownMenu;
}(_react2.default.Component);

exports.default = ShareButtonDropdownMenu;


ShareButtonDropdownMenu.contextTypes = {
    intl: _propTypes2.default.object.isRequired
};

ShareButtonDropdownMenu.propTypes = {
    design: _propTypes2.default.any.isRequired // eslint-disable-line react/forbid-prop-types
};

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormattedMessage = __webpack_require__(473);

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _DisplayName = __webpack_require__(126);

var _Avatar = __webpack_require__(36);

var _FavoriteButton = __webpack_require__(115);

var _FavoriteButton2 = _interopRequireDefault(_FavoriteButton);

var _connectToOnlineStatus = __webpack_require__(474);

var _connectToOnlineStatus2 = _interopRequireDefault(_connectToOnlineStatus);

var _TrackClick = __webpack_require__(84);

var _TrackClick2 = _interopRequireDefault(_TrackClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConnectedAvatar = (0, _connectToOnlineStatus2.default)(_Avatar.Avatar);

var DesignAttribution = function (_React$Component) {
    _inherits(DesignAttribution, _React$Component);

    function DesignAttribution() {
        _classCallCheck(this, DesignAttribution);

        return _possibleConstructorReturn(this, (DesignAttribution.__proto__ || Object.getPrototypeOf(DesignAttribution)).apply(this, arguments));
    }

    _createClass(DesignAttribution, [{
        key: 'avatar',
        value: function avatar() {
            if (this.canViewOnlineStatus()) {
                return _react2.default.createElement(ConnectedAvatar, {
                    user: this.avatarUser(),
                    variations: ['small'],
                    lastSeenTimesUrl: this.props.design.links.lastSeenTimesUrl
                });
            }
            return _react2.default.createElement(_Avatar.Avatar, { user: this.avatarUser(), variations: ['small'] });
        }
    }, {
        key: 'canViewOnlineStatus',
        value: function canViewOnlineStatus() {
            return !!this.props.activeUser.id && this.props.activeUser.id !== this.props.design.creator.userId;
        }
    }, {
        key: 'userSection',
        value: function userSection() {
            var displayNameVariations = this.props.design.permission.canFavorite ? ['offset-right'] : [];
            return _react2.default.createElement(
                'div',
                { className: 'user user--padded' },
                _react2.default.createElement(
                    'a',
                    { className: 'user__avatar', href: this.props.design.creator.showUrl },
                    this.avatar()
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'user__display-name' },
                    _react2.default.createElement(
                        _TrackClick2.default,
                        {
                            event: 'Element Clicked On Design Overlay',
                            element: 'designer_attribution'
                        },
                        _react2.default.createElement(_FormattedMessage2.default, {
                            message: __('by {user}'),
                            values: {
                                user: _react2.default.createElement(_DisplayName.DisplayName, {
                                    isLinked: true,
                                    user: this.props.design.creator,
                                    variations: displayNameVariations
                                })
                            }
                        })
                    ),
                    this.favoriteAbility()
                )
            );
        }
    }, {
        key: 'favoriteAbility',
        value: function favoriteAbility() {
            if (this.props.design.permission.canFavorite) {
                return _react2.default.createElement(_FavoriteButton2.default, {
                    isFavorite: this.props.design.creator.isFavorite,
                    favoriteUrl: this.props.design.dataFavoriteDesignerUrl,
                    onFavorite: this.props.onFavorite
                });
            }

            return null;
        }
    }, {
        key: 'designOriginInfo',
        value: function designOriginInfo() {
            if (this.props.design.categoryEntryInfo) {
                return _react2.default.createElement(
                    'a',
                    { href: this.props.design.links.contestUrl, className: 'link' },
                    this.props.design.categoryEntryInfo
                );
            } else if (this.props.design.projectDesignId) {
                return _react2.default.createElement(
                    'span',
                    null,
                    '1-to-1 project design'
                );
            }

            return null;
        }
    }, {
        key: 'avatarUser',
        value: function avatarUser() {
            return {
                avatarUrl: this.props.design.creator.avatarUrl,
                id: this.props.design.creator.userId
            };
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'sidebar-header__sub-heading' },
                this.userSection(),
                this.designOriginInfo()
            );
        }
    }]);

    return DesignAttribution;
}(_react2.default.Component);

exports.default = DesignAttribution;


DesignAttribution.propTypes = {
    design: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    activeUser: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    onFavorite: _propTypes2.default.func
};

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FormattedMessage;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _formatMessage = __webpack_require__(222);

var _formatMessage2 = _interopRequireDefault(_formatMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This component is a direct TypeScript port of react-intl/FormattedMessage
 */
function FormattedMessage(props) {
    var message = props.message,
        values = props.values;
    // Creates a token with a random UID that should not be guessable or
    // conflict with other parts of the `message` string.

    var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
    var generateToken = function () {
        var counter = 0;
        return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
        };
    }();
    // Splitting with a delimiter to support IE8. When using a regex
    // with a capture group IE8 does not include the capture group in
    // the resulting array.
    var tokenDelimiter = '@__' + uid + '__@';
    var tokenizedValues = {};
    var elements = {};
    var hasValues = values && Object.keys(values).length > 0;
    if (hasValues) {
        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
            var value = values[name];
            if ((0, _react.isValidElement)(value)) {
                var token = generateToken();
                tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
                elements[token] = value;
            } else {
                tokenizedValues[name] = value;
            }
        });
    }
    var formattedMessage = (0, _formatMessage2.default)(message, tokenizedValues || values);
    var nodes = void 0;
    var hasElements = elements && Object.keys(elements).length > 0;
    if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
            return !!part;
        }).map(function (part) {
            return elements[part] || part;
        });
    } else {
        nodes = [formattedMessage];
    }
    return _react.createElement.apply(undefined, [_react2.default.Fragment, null].concat(_toConsumableArray(nodes)));
}

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = connectToOnlineStatus;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fluxibleAddonsReact = __webpack_require__(95);

var _OnlineStatusStore = __webpack_require__(118);

var _OnlineStatusStore2 = _interopRequireDefault(_OnlineStatusStore);

var _OnlineStatusActionCreators = __webpack_require__(140);

var _OnlineStatusActionCreators2 = _interopRequireDefault(_OnlineStatusActionCreators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function connectToOnlineStatus(Component) {
    var OnlineStatus = function (_React$Component) {
        _inherits(OnlineStatus, _React$Component);

        function OnlineStatus() {
            _classCallCheck(this, OnlineStatus);

            return _possibleConstructorReturn(this, (OnlineStatus.__proto__ || Object.getPrototypeOf(OnlineStatus)).apply(this, arguments));
        }

        _createClass(OnlineStatus, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.updateOnlineStatus(this.props.lastSeenTimesUrl);
                this.createUpdateTimer(this.props.lastSeenTimesUrl);
            }
        }, {
            key: 'UNSAFE_componentWillReceiveProps',
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.lastSeenTimesUrl !== this.props.lastSeenTimesUrl) {
                    this.destroyTimer();
                    this.updateOnlineStatus(nextProps.lastSeenTimesUrl);
                    this.createUpdateTimer(nextProps.lastSeenTimesUrl);
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.destroyTimer();
            }
        }, {
            key: 'destroyTimer',
            value: function destroyTimer() {
                clearInterval(this.updateTimer);
            }
        }, {
            key: 'createUpdateTimer',
            value: function createUpdateTimer(lastSeenTimesUrl) {
                var _this2 = this;

                this.updateTimer = setInterval(function () {
                    _this2.updateOnlineStatus(lastSeenTimesUrl);
                }, 60000);
            }
        }, {
            key: 'updateOnlineStatus',
            value: function updateOnlineStatus(lastSeenTimesUrl) {
                this.context.executeAction(_OnlineStatusActionCreators2.default.getOnlineStatus, {
                    lastSeenTimesUrl: lastSeenTimesUrl
                });
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Component, this.props);
            }
        }]);

        return OnlineStatus;
    }(_react2.default.Component);

    OnlineStatus.defaultProps = {
        isOnline: false
    };

    OnlineStatus.propTypes = {
        lastSeenTimesUrl: _propTypes2.default.string.isRequired,
        isOnline: _propTypes2.default.bool
    };

    OnlineStatus.contextTypes = {
        executeAction: _propTypes2.default.func.isRequired
    };

    // Connect to the store that provides the data
    return (0, _fluxibleAddonsReact.connectToStores)(OnlineStatus, [_OnlineStatusStore2.default], function (context, props) {
        return {
            isOnline: context.getStore(_OnlineStatusStore2.default).getOnlineStatus(props.user.id)
        };
    });
}

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ButtonGroup = __webpack_require__(41);

var _colors = __webpack_require__(211);

var _TrackClick = __webpack_require__(84);

var _TrackClick2 = _interopRequireDefault(_TrackClick);

var _UserInviteButton = __webpack_require__(476);

var _UserInviteButton2 = _interopRequireDefault(_UserInviteButton);

var _UserProfileButton = __webpack_require__(477);

var _UserProfileButton2 = _interopRequireDefault(_UserProfileButton);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserInteractionCtas = function UserInteractionCtas(_ref) {
    var userId = _ref.userId,
        isUserAvailable = _ref.isUserAvailable;
    return _react2.default.createElement(_ButtonGroup.ButtonGroup, { variations: ['stacked'] }, _react2.default.createElement(_ButtonGroup.ButtonGroupItem, null, isUserAvailable ? _react2.default.createElement(_TrackClick2.default, { event: "Element Clicked On Design Overlay", element: "Invite CTA" }, _react2.default.createElement(_UserInviteButton2.default, { userId: userId })) : _react2.default.createElement(_UserInviteButton2.default, { userId: userId, isDisabled: true })), _react2.default.createElement(_ButtonGroup.ButtonGroupItem, { style: { color: _colors.heritage } }, _react2.default.createElement(_TrackClick2.default, { event: "Element Clicked On Design Overlay", element: "Portfolio CTA" }, _react2.default.createElement(_UserProfileButton2.default, { userId: userId }))));
};
exports.default = UserInteractionCtas;

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(16);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserInviteButton = function UserInviteButton(_ref) {
  var _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === undefined ? false : _ref$isDisabled,
      userId = _ref.userId;
  return _react2.default.createElement(_Button.Button, { variations: ['primary', 'fluid', 'jumbo'], href: !isDisabled ? '/profiles/' + userId + '/invites' : null, isDisabled: isDisabled }, isDisabled ? __('Not available for work') : __('Invite to work'));
};
exports.default = UserInviteButton;

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(16);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserProfileButton = function UserProfileButton(_ref) {
  var userId = _ref.userId;
  return _react2.default.createElement(_Button.Button, { variations: ['marketing-secondary', 'chameleon', 'fluid', 'jumbo'], href: '/profiles/' + userId }, __('View portfolio'));
};
exports.default = UserProfileButton;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(16);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DesignEditButton = function DesignEditButton(_ref) {
  var designId = _ref.designId;
  return _react2.default.createElement(_Button.Button, { variations: ['secondary', 'fluid'], href: '/account/portfolio/edit/' + designId }, __('Edit design'));
};
exports.default = DesignEditButton;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DefaultSidebarBody = __webpack_require__(480);

var _DefaultSidebarBody2 = _interopRequireDefault(_DefaultSidebarBody);

var _LikesSidebarBody = __webpack_require__(488);

var _LikesSidebarBody2 = _interopRequireDefault(_LikesSidebarBody);

var _propTypes3 = __webpack_require__(286);

var _consts = __webpack_require__(287);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SidebarBodyPane = function (_React$Component) {
    _inherits(SidebarBodyPane, _React$Component);

    function SidebarBodyPane(props) {
        _classCallCheck(this, SidebarBodyPane);

        var _this = _possibleConstructorReturn(this, (SidebarBodyPane.__proto__ || Object.getPrototypeOf(SidebarBodyPane)).call(this, props));

        _this.setDefaultPane = _this.setDefaultPane.bind(_this);
        return _this;
    }

    _createClass(SidebarBodyPane, [{
        key: 'setDefaultPane',
        value: function setDefaultPane() {
            this.props.onPaneChange(_consts.SIDEBAR_PANE_DEFAULT);
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.activePane === _consts.SIDEBAR_PANE_LIKES_LIST) {
                return _react2.default.createElement(_LikesSidebarBody2.default, {
                    likes: this.props.design.likes,
                    onOverviewButtonClick: this.setDefaultPane,
                    designLikesUrl: this.props.design.links.designLikesUrl
                });
            }

            return _react2.default.createElement(_DefaultSidebarBody2.default, {
                design: this.props.design,
                activeUser: this.props.activeUser,
                isLoadingComments: this.props.isLoadingComments,
                comments: this.props.comments,
                selectedComment: this.props.selectedComment,
                selectedCommentStatus: this.props.selectedCommentStatus,
                selectedCommentEditingLocation: this.props.selectedCommentEditingLocation
            });
        }
    }]);

    return SidebarBodyPane;
}(_react2.default.Component);

exports.default = SidebarBodyPane;


SidebarBodyPane.defaultProps = {
    selectedComment: null,
    selectedCommentStatus: null,
    selectedCommentEditingLocation: null,
    onPaneChange: function onPaneChange() {
        return undefined;
    }
};

SidebarBodyPane.propTypes = _extends({
    onPaneChange: _propTypes2.default.func,
    activePane: _propTypes3.SidebarPanes.isRequired,
    design: _propTypes2.default.object.isRequired,
    activeUser: _propTypes2.default.object.isRequired
}, _propTypes3.DdoCommentProps);

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AsyncCommentPane = __webpack_require__(481);

var _AsyncCommentPane2 = _interopRequireDefault(_AsyncCommentPane);

var _Button = __webpack_require__(16);

var _DesignMetadata = __webpack_require__(486);

var _DesignMetadata2 = _interopRequireDefault(_DesignMetadata);

var _TrackClick = __webpack_require__(84);

var _TrackClick2 = _interopRequireDefault(_TrackClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultSidebarBody = function (_React$Component) {
    _inherits(DefaultSidebarBody, _React$Component);

    function DefaultSidebarBody() {
        _classCallCheck(this, DefaultSidebarBody);

        return _possibleConstructorReturn(this, (DefaultSidebarBody.__proto__ || Object.getPrototypeOf(DefaultSidebarBody)).apply(this, arguments));
    }

    _createClass(DefaultSidebarBody, [{
        key: 'marketingButton',
        value: function marketingButton() {
            if (!this.props.design.marketingCtaButton) return null;

            return _react2.default.createElement(
                _TrackClick2.default,
                {
                    event: 'Element Clicked On Design Overlay',
                    element: 'secondary_cta',
                    payload: { targetUrl: this.props.design.marketingCtaButton.url }
                },
                _react2.default.createElement(
                    _Button.Button,
                    {
                        variations: ['fluid', 'secondary'],
                        href: this.props.design.marketingCtaButton.url
                    },
                    this.props.design.marketingCtaButton.text
                )
            );
        }
    }, {
        key: 'commentSection',
        value: function commentSection() {
            if (!this.props.design.permission.userIdentified) return null;

            return _react2.default.createElement(_AsyncCommentPane2.default, {
                design: this.props.design,
                activeUser: this.props.activeUser,
                isLoadingComments: this.props.isLoadingComments,
                comments: this.props.comments,
                selectedComment: this.props.selectedComment,
                selectedCommentStatus: this.props.selectedCommentStatus,
                selectedCommentEditingLocation: this.props.selectedCommentEditingLocation
            });
        }

        // FIXME: sidebar-body isn't wrapping the whole sidebar body

    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'sidebar-body' },
                    _react2.default.createElement(_DesignMetadata2.default, { design: this.props.design }),
                    this.marketingButton()
                ),
                this.commentSection()
            );
        }
    }]);

    return DefaultSidebarBody;
}(_react2.default.Component);

exports.default = DefaultSidebarBody;


DefaultSidebarBody.propTypes = {
    design: _propTypes2.default.shape({
        permission: _propTypes2.default.shape({
            userIdentified: _propTypes2.default.bool.isRequired
        }),
        marketingCtaButton: _propTypes2.default.shape({
            text: _propTypes2.default.string,
            url: _propTypes2.default.string
        })
    }).isRequired,
    activeUser: _propTypes2.default.object,
    isLoadingComments: _propTypes2.default.bool,
    comments: _propTypes2.default.any,
    selectedComment: _propTypes2.default.any,
    selectedCommentEditingLocation: _propTypes2.default.any,
    selectedCommentStatus: _propTypes2.default.any
};

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoadableElement = __webpack_require__(482);

var _CommentPane = __webpack_require__(484);

var _CommentPane2 = _interopRequireDefault(_CommentPane);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AsyncCommentPane = function (_React$Component) {
    _inherits(AsyncCommentPane, _React$Component);

    function AsyncCommentPane() {
        _classCallCheck(this, AsyncCommentPane);

        return _possibleConstructorReturn(this, (AsyncCommentPane.__proto__ || Object.getPrototypeOf(AsyncCommentPane)).apply(this, arguments));
    }

    _createClass(AsyncCommentPane, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _LoadableElement.LoadableElement,
                {
                    variations: ['align-top', 'padded'],
                    spinnerVariations: ['inline'],
                    isLoading: this.props.isLoadingComments
                },
                _react2.default.createElement(_CommentPane2.default, _extends({}, this.props, {
                    canShowCommentEditing: this.props.selectedCommentEditingLocation === 'pane',
                    hasCommentForm: this.props.design.permission.canComment
                }))
            );
        }
    }]);

    return AsyncCommentPane;
}(_react2.default.Component);

exports.default = AsyncCommentPane;


AsyncCommentPane.propTypes = {
    design: _propTypes2.default.object.isRequired,
    isLoadingComments: _propTypes2.default.bool.isRequired,
    comments: _propTypes2.default.array.isRequired,
    selectedCommentEditingLocation: _propTypes2.default.oneOf(['canvas', 'pane'])
};

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoadableElement = __webpack_require__(483);

Object.defineProperty(exports, 'LoadableElement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LoadableElement).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoadableElement = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

var _Spinner = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadableElement = exports.LoadableElement = function LoadableElement(_ref) {
    var _ref$isLoading = _ref.isLoading,
        isLoading = _ref$isLoading === undefined ? false : _ref$isLoading,
        _ref$variations = _ref.variations,
        variations = _ref$variations === undefined ? [] : _ref$variations,
        _ref$spinnerVariation = _ref.spinnerVariations,
        spinnerVariations = _ref$spinnerVariation === undefined ? [] : _ref$spinnerVariation,
        children = _ref.children;
    return isLoading ? _react2.default.createElement("div", { className: (0, _app.getComponentClasses)('loadable-element', variations) }, _react2.default.createElement("div", { className: "loadable-element__spinner" }, _react2.default.createElement(_Spinner.Spinner, { variations: spinnerVariations }))) : _react2.default.createElement(_react2.default.Fragment, null, children);
};
exports.default = LoadableElement;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _clsx = __webpack_require__(11);

var _clsx2 = _interopRequireDefault(_clsx);

var _CommentForm = __webpack_require__(283);

var _CommentForm2 = _interopRequireDefault(_CommentForm);

var _CommentList = __webpack_require__(485);

var _CommentList2 = _interopRequireDefault(_CommentList);

var _designComments = __webpack_require__(139);

var _designComment = __webpack_require__(174);

var _designComment2 = _interopRequireDefault(_designComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */


var CommentPane = function (_React$Component) {
    _inherits(CommentPane, _React$Component);

    function CommentPane() {
        _classCallCheck(this, CommentPane);

        var _this = _possibleConstructorReturn(this, (CommentPane.__proto__ || Object.getPrototypeOf(CommentPane)).call(this));

        _this.state = {
            isVisible: false,
            timeLastCreated: 0
        };

        _this.handleCommentFormClick = _this.handleCommentFormClick.bind(_this);
        _this.handleCreateComment = _this.handleCreateComment.bind(_this);
        return _this;
    }

    _createClass(CommentPane, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ isVisible: true });
        }
    }, {
        key: 'commentPaneFooter',
        value: function commentPaneFooter() {
            if (this.props.hasCommentForm) {
                return _react2.default.createElement(
                    'div',
                    { className: 'comment-pane__footer' },
                    _react2.default.createElement(_CommentForm2.default, {
                        key: this.state.timeLastCreated,
                        comment: { message: this.props.draftMessage },
                        scrollingContainer: document.querySelector('#fullscreenSidebar'),
                        onClick: this.handleCommentFormClick,
                        onKeyDown: this.props.onCommentKeyDown,
                        onKeyUp: this.props.onCommentKeyUp,
                        isAutoFocus: this.props.autoFocusCommentForm,
                        onSubmit: this.handleCreateComment,
                        showErrorMessage: this.props.showErrorMessage
                    })
                );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var classes = (0, _clsx2.default)({
                'comment-pane': true,
                'comment-pane--hidden': !this.state.isVisible && this.props.hasTransition
            });

            return _react2.default.createElement(
                'div',
                { className: classes, 'data-comment-pane': true, onClick: this.handlePanelClick },
                _react2.default.createElement(
                    'div',
                    { className: 'comment-pane__body' },
                    _react2.default.createElement(_CommentList2.default, {
                        design: this.props.design,
                        comments: this.props.comments,
                        selectedComment: this.props.selectedComment,
                        selectedCommentStatus: this.props.selectedCommentStatus,
                        canShowCommentEditing: this.props.canShowCommentEditing
                    })
                ),
                this.commentPaneFooter()
            );
        }
    }, {
        key: 'handleCreateComment',
        value: function handleCreateComment(content) {
            var comment = _designComment2.default.create({
                message: content,
                creator: this.getUser()
            });

            this.context.executeAction(_designComments.createDesignComment, {
                comment: comment,
                design: this.props.design,
                csrfToken: this.context.csrfToken
            });

            // updating the key of the CommentForm element effectively clear the form
            this.setState({
                timeLastCreated: new Date().getTime()
            });
        }
    }, {
        key: 'handleCommentFormClick',
        value: function handleCommentFormClick(e) {
            if (this.props.selectedComment) {
                this.context.executeAction(_designComments.resetSelectedComment);
            }
            e.stopPropagation();
        }
    }, {
        key: 'handlePanelClick',
        value: function handlePanelClick(e) {
            e.stopPropagation();
        }
    }, {
        key: 'getUser',
        value: function getUser() {
            return this.context.activeUser;
        }
    }]);

    return CommentPane;
}(_react2.default.Component);

exports.default = CommentPane;


CommentPane.contextTypes = {
    activeUser: _propTypes2.default.object,
    executeAction: _propTypes2.default.func,
    csrfToken: _propTypes2.default.string
};

CommentPane.propTypes = {
    design: _propTypes2.default.object.isRequired,
    canShowCommentEditing: _propTypes2.default.bool,
    comments: _propTypes2.default.array,
    draftComment: _propTypes2.default.string,
    hasCommentForm: _propTypes2.default.bool,
    hasTransition: _propTypes2.default.bool,
    selectedComment: _propTypes2.default.object,
    selectedCommentStatus: _propTypes2.default.oneOf(['creating', 'editing', 'saving', 'deleting', 'error']),
    onCommentKeyDown: _propTypes2.default.func,
    onCommentKeyUp: _propTypes2.default.func,
    autoFocusCommentForm: _propTypes2.default.bool,
    showErrorMessage: _propTypes2.default.bool,
    draftMessage: _propTypes2.default.string
};

CommentPane.defaultProps = {
    canShowCommentEditing: false,
    comments: [],
    hasCommentForm: false,
    hasTransition: true,
    onCommentKeyDown: function onCommentKeyDown() {},
    onCommentKeyUp: function onCommentKeyUp() {},

    autoFocusCommentForm: false
};

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ScrollIntoViewElement = __webpack_require__(284);

var _Comment = __webpack_require__(282);

var _Comment2 = _interopRequireDefault(_Comment);

var _reactResponsive = __webpack_require__(32);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _settings = __webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommentList = function (_React$Component) {
    _inherits(CommentList, _React$Component);

    function CommentList() {
        _classCallCheck(this, CommentList);

        var _this = _possibleConstructorReturn(this, (CommentList.__proto__ || Object.getPrototypeOf(CommentList)).call(this));

        _this.commentListItem = _this.commentListItem.bind(_this);
        return _this;
    }

    _createClass(CommentList, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'comment-list' },
                _react2.default.createElement(
                    _reactResponsive2.default,
                    { maxWidth: _settings.breakpoints.normal[0] },
                    function (isMobile) {
                        return _this2.getVisibleComments().map(function (comment) {
                            return _this2.commentListItem(comment, isMobile);
                        });
                    }
                )
            );
        }
    }, {
        key: 'getVisibleComments',
        value: function getVisibleComments() {
            return this.props.comments.filter(function (comment) {
                // exclude pending annotation comment from the list
                return !!comment.id || !comment.annotation;
            });
        }
    }, {
        key: 'commentListItem',
        value: function commentListItem(comment, isMobile) {
            var isSelected = this.props.selectedComment && comment && this.props.selectedComment.id === comment.id;

            var status = isSelected ? this.props.selectedCommentStatus : null;

            if (status === 'editing' && !this.props.canShowCommentEditing) {
                status = null;
            }

            return _react2.default.createElement(
                'div',
                { key: comment.id, className: 'comment-list__item' },
                _react2.default.createElement(
                    _ScrollIntoViewElement.ScrollIntoViewElement,
                    {
                        isEnabled: isMobile ? false : isSelected,
                        scrollingTrigger: isMobile ? false : isSelected,
                        scrollingContainer: document.getElementById('fullscreenSidebar')
                    },
                    _react2.default.createElement(_Comment2.default, {
                        design: this.props.design,
                        comment: comment,
                        hasExtraPadding: true,
                        status: status,
                        isSelected: isSelected,
                        commentLocation: 'pane',
                        isEditable: !!comment.links.edit
                    })
                )
            );
        }
    }]);

    return CommentList;
}(_react2.default.Component);

exports.default = CommentList;


CommentList.propTypes = {
    design: _propTypes2.default.object.isRequired,
    canShowCommentEditing: _propTypes2.default.bool,
    comments: _propTypes2.default.array,
    selectedComment: _propTypes2.default.object,
    selectedCommentStatus: _propTypes2.default.oneOf(['creating', 'editing', 'saving', 'deleting', 'error'])
};

CommentList.defaultProps = {
    canShowCommentEditing: false,
    comments: []
};

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = DesignMetadata;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TagButtonGroup = __webpack_require__(487);

var _TagButtonGroup2 = _interopRequireDefault(_TagButtonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DesignMetadata(_ref) {
    var design = _ref.design;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: design.description } }),
        _react2.default.createElement(
            'div',
            { className: 'fullscreen__sidebar__tags' },
            _react2.default.createElement(_TagButtonGroup2.default, { tags: design.tags })
        )
    );
}

DesignMetadata.propTypes = {
    design: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
};

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _app = __webpack_require__(2);

var _TrackClick = __webpack_require__(84);

var _TrackClick2 = _interopRequireDefault(_TrackClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TagButtonGroup = function (_React$Component) {
    _inherits(TagButtonGroup, _React$Component);

    function TagButtonGroup(props) {
        _classCallCheck(this, TagButtonGroup);

        var _this = _possibleConstructorReturn(this, (TagButtonGroup.__proto__ || Object.getPrototypeOf(TagButtonGroup)).call(this, props));

        _this.state = { showMorePills: false };
        _this.showMorePills = _this.showMorePills.bind(_this);
        return _this;
    }

    _createClass(TagButtonGroup, [{
        key: 'getInitialPillItems',
        value: function getInitialPillItems() {
            var _this2 = this;

            return this.props.tags.slice(0, 5).map(function (tag, i) {
                return _this2.pillTag(tag, i);
            });
        }
    }, {
        key: 'pillTag',
        value: function pillTag(tag, key) {
            var Pill = (0, _app.bemComponent)('pill', 'Pill');
            return _react2.default.createElement(
                'div',
                { className: 'pill-group__item', key: key },
                _react2.default.createElement(
                    _TrackClick2.default,
                    { event: 'Element Clicked On Design Overlay', element: 'design_tag' },
                    _react2.default.createElement(
                        'a',
                        { href: tag.href },
                        _react2.default.createElement(
                            Pill,
                            { variations: ['tag'] },
                            tag.name
                        )
                    )
                )
            );
        }
    }, {
        key: 'maybeMorePillItems',
        value: function maybeMorePillItems() {
            if (this.props.tags.length > 5) {
                return _react2.default.createElement(
                    'span',
                    null,
                    this.state.showMorePills ? this.extraPills() : this.extraPillsButton()
                );
            }

            return null;
        }
    }, {
        key: 'showMorePills',
        value: function showMorePills() {
            this.setState({ showMorePills: true });
        }
    }, {
        key: 'extraPillsButton',
        value: function extraPillsButton() {
            return _react2.default.createElement(
                'div',
                { className: 'pill-group__item' },
                _react2.default.createElement(
                    'span',
                    { className: 'pill pill--tag pill--t1000' },
                    _react2.default.createElement(
                        _TrackClick2.default,
                        { element: 'show_more_design_tags' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'pill__button', onClick: this.showMorePills },
                            '+ ' + (this.props.tags.length - 5)
                        )
                    )
                )
            );
        }
    }, {
        key: 'extraPills',
        value: function extraPills() {
            var _this3 = this;

            return this.props.tags.slice(5).map(function (tag, i) {
                return _this3.pillTag(tag, i + 5);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'pill-group' },
                this.getInitialPillItems(),
                this.maybeMorePillItems()
            );
        }
    }]);

    return TagButtonGroup;
}(_react2.default.Component);

exports.default = TagButtonGroup;


TagButtonGroup.propTypes = {
    tags: _propTypes2.default.array.isRequired // eslint-disable-line react/forbid-prop-types
};

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(6);

var _Icon = __webpack_require__(8);

var _Avatar = __webpack_require__(36);

var _PaneSpinner = __webpack_require__(206);

var _PaneSpinner2 = _interopRequireDefault(_PaneSpinner);

var _Spinner = __webpack_require__(24);

var _xhr = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LikesSidebarBody = function (_React$Component) {
    _inherits(LikesSidebarBody, _React$Component);

    function LikesSidebarBody(props) {
        _classCallCheck(this, LikesSidebarBody);

        var _this = _possibleConstructorReturn(this, (LikesSidebarBody.__proto__ || Object.getPrototypeOf(LikesSidebarBody)).call(this, props));

        _this.state = {
            likes: props.likes,
            isLoading: false,
            totalPages: 0,
            currentPage: 0,
            designLikesUrl: props.designLikesUrl
        };

        _this.getLikes = _this.getLikes.bind(_this);
        return _this;
    }

    _createClass(LikesSidebarBody, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getLikes();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.abortRequest();
        }
    }, {
        key: 'abortRequest',
        value: function abortRequest() {
            if (this.request) {
                this.request.abort();
            }
        }
    }, {
        key: 'getLikes',
        value: function getLikes() {
            this.setState(function () {
                return {
                    isLoading: true
                };
            }, this.fetchLikes());
        }
    }, {
        key: 'fetchLikes',
        value: function fetchLikes() {
            var _this2 = this;

            this.abortRequest();

            this.request = (0, _xhr.get)(this.state.designLikesUrl);
            this.request.then(function (_ref) {
                var body = _ref.body;

                _this2.setState(function (prevState) {
                    return {
                        likes: prevState.likes.concat(body.users),
                        isLoading: false,
                        designLikesUrl: body.paginationUrl,
                        totalPages: body.totalPages,
                        currentPage: body.currentPage
                    };
                });
            }).catch(function () {
                _this2.setState(function () {
                    return {
                        likes: [],
                        isLoading: false,
                        designLikesUrl: '',
                        totalPages: 1,
                        currentPage: 1
                    };
                });
            });
        }
    }, {
        key: 'likesPanel',
        value: function likesPanel() {
            return _react2.default.createElement(
                'span',
                null,
                this.likesList(),
                this.showMore()
            );
        }
    }, {
        key: 'likesList',
        value: function likesList() {
            if (this.state.likes.length === 0 && this.state.isLoading) {
                var paneRect = this.bodyElement.getBoundingClientRect();
                return _react2.default.createElement(_PaneSpinner2.default, {
                    paneTop: paneRect.top,
                    viewportHeight: document.documentElement.clientHeight,
                    paneHeight: paneRect.height
                });
            }

            return this.state.likes.map(function (user) {
                return _react2.default.createElement(
                    'a',
                    {
                        rel: 'nofollow noopener noreferrer',
                        href: user.showUrl,
                        target: '_blank',
                        key: user.userId,
                        className: 'section-action section-action--joined'
                    },
                    _react2.default.createElement(
                        'span',
                        { className: 'section-action--joined__inner' },
                        _react2.default.createElement(
                            'span',
                            { className: 'flag flag--middle flag--small' },
                            _react2.default.createElement(
                                'span',
                                { className: 'flag__mast' },
                                _react2.default.createElement(_Avatar.Avatar, {
                                    user: { avatarUrl: user.avatarUrl, id: user.userId },
                                    variations: ['small']
                                })
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'flag--small__flag flag__flag' },
                                user.name,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'section-action__label__meta' },
                                    _react2.default.createElement(_reactIntl.FormattedRelative, { style: 'numeric', value: user.timeCreated })
                                )
                            )
                        )
                    )
                );
            });
        }
    }, {
        key: 'showMore',
        value: function showMore() {
            if (this.state.currentPage === this.state.totalPages) return null;

            return _react2.default.createElement(
                'span',
                { className: 'section-action section-action--joined' },
                _react2.default.createElement(
                    'span',
                    { className: 'section-action--joined__inner' },
                    _react2.default.createElement(
                        'button',
                        { className: 'button button--link', onClick: this.getLikes },
                        __('Show more')
                    ),
                    this.state.isLoading && _react2.default.createElement(_Spinner.Spinner, { variations: ['inline', 'soft'] })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'section-action section-action--primary',
                            onClick: this.props.onOverviewButtonClick
                        },
                        _react2.default.createElement(
                            'span',
                            { className: 'section-action__icon--left' },
                            _react2.default.createElement(_Icon.Icon, { type: 'left-2' })
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'section-action__label' },
                            __('Back to overview')
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    {
                        ref: function ref(element) {
                            _this3.bodyElement = element;
                        },
                        style: { position: 'relative' }
                    },
                    this.likesPanel()
                )
            );
        }
    }]);

    return LikesSidebarBody;
}(_react2.default.Component);

exports.default = LikesSidebarBody;


LikesSidebarBody.defaultProps = {
    designLikesUrl: ''
};

LikesSidebarBody.propTypes = {
    likes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        createdAt: _propTypes2.default.string.isRequired,
        userId: _propTypes2.default.number.isRequired,
        name: _propTypes2.default.string.isRequired,
        timeCreated: _propTypes2.default.string.isRequired,
        showUrl: _propTypes2.default.string.isRequired,
        avatarUrl: _propTypes2.default.string.isRequired
    })),
    onOverviewButtonClick: _propTypes2.default.func.isRequired,
    designLikesUrl: _propTypes2.default.string
};

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkOriginDifferentiator = function (_React$Component) {
    _inherits(WorkOriginDifferentiator, _React$Component);

    function WorkOriginDifferentiator() {
        _classCallCheck(this, WorkOriginDifferentiator);

        return _possibleConstructorReturn(this, (WorkOriginDifferentiator.__proto__ || Object.getPrototypeOf(WorkOriginDifferentiator)).apply(this, arguments));
    }

    _createClass(WorkOriginDifferentiator, [{
        key: "render",
        value: function render() {
            return this.displayIfCreatedOn99d();
        }
    }, {
        key: "displayIfCreatedOn99d",
        value: function displayIfCreatedOn99d() {
            if (this.props.design.categoryEntryInfo || this.props.design.projectDesignId) {
                return _react2.default.createElement("div", null, _react2.default.createElement("div", { className: "sidebar-body" }, _react2.default.createElement("span", { className: 'ddo__made-on-99-shield' }, "Created on 99designs")));
            }
            return null;
        }
    }]);

    return WorkOriginDifferentiator;
}(_react2.default.Component);

exports.default = WorkOriginDifferentiator;

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(22);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(51);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.created = 201 == status;
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
    this.unprocessableEntity = 422 == status;
};


/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};


/***/ }),

/***/ 52:
/***/ (function(module, exports) {

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;


/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


module.exports = __webpack_require__(92);


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Desktop = __webpack_require__(130);

Object.defineProperty(exports, 'Desktop', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Desktop).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Mobile = __webpack_require__(131);

Object.defineProperty(exports, 'Mobile', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Mobile).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pill = __webpack_require__(107);

Object.defineProperty(exports, 'Pill', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Pill).default;
  }
});

var _PillGroup = __webpack_require__(108);

Object.defineProperty(exports, 'PillGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PillGroup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _addClass = _interopRequireDefault(__webpack_require__(72));

var _removeClass = _interopRequireDefault(__webpack_require__(75));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(27));

var _PropTypes = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = trackEvent;
//
// Segment analytics event tracking that includes experiment data.
//
// https://segment.com/docs/libraries/analytics.js/
//
function trackEvent(event, params) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var callback = arguments[3];

    var trackParams = window.trackParams || {};
    params = Object.assign({ url: window.location.href }, trackParams, params);
    if (false) {
        console.info('Track event: "%s": %o', event, params); // eslint-disable-line no-console
    }
    if (window.analytics) {
        window.analytics.track(event, params, options, callback);
    } else {
        if (typeof callback == 'function') {
            callback();
        }
    }
}

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Button = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

var _Spinner = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = exports.Button = function (_React$Component) {
    _inherits(Button, _React$Component);

    function Button() {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));

        _this.onClick = function (e) {
            if (!_this.isDisabled() && _this.props.onClick) {
                _this.props.onClick(e);
            }
        };
        return _this;
    }

    _createClass(Button, [{
        key: 'classes',
        value: function classes() {
            var variations = this.props.variations ? this.props.variations.slice() : [];
            if (Boolean(this.props.icon) && !this.props.children) {
                variations.push('icon-no-label');
                variations.push('icon'); // NB: deprecated, kept for backwards compat
            }
            if (this.props.isSaving || this.props.iconAlignment === 'left') {
                variations.push('icon-left');
            }
            if (this.props.iconAlignment === 'right' && !this.props.isSaving) {
                variations.push('icon-right');
            }
            return (0, _app.getComponentClasses)('button', variations);
        }
    }, {
        key: 'attributes',
        value: function attributes() {
            var _this2 = this;

            var attrs = {
                disabled: this.isDisabled()
            };
            if (this.props.isActive) {
                attrs['data-button-selected'] = true;
            }
            var handledProps = ['onClick', 'isDisabled', 'isActive', 'isSaving', 'variations', 'icon', 'iconAlignment'];
            // Allow for underlying button/anchor api
            Object.keys(this.props).forEach(function (key) {
                if (handledProps.indexOf(key) === -1) {
                    attrs[key] = _this2.props[key];
                }
            });
            return attrs;
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled() {
            return !!(this.props.isDisabled || this.props.isSaving);
        }
    }, {
        key: 'icon',
        value: function icon() {
            if (this.props.isSaving) {
                return _react2.default.createElement("span", { className: "button__icon" }, _react2.default.createElement(_Spinner.Spinner, null));
            } else if (this.props.icon) {
                return _react2.default.createElement("span", { className: "button__icon" }, this.props.icon);
            } else {
                return null;
            }
        }
    }, {
        key: 'leftIcon',
        value: function leftIcon() {
            var hasLeftIcon = this.props.icon && this.props.iconAlignment !== 'right';
            return this.props.isSaving || hasLeftIcon ? this.icon() : null;
        }
    }, {
        key: 'rightIcon',
        value: function rightIcon() {
            var hasRightIcon = this.props.icon && this.props.iconAlignment === 'right';
            return !this.props.isSaving && hasRightIcon ? this.icon() : null;
        }
    }, {
        key: 'label',
        value: function label() {
            return this.props.children ? _react2.default.createElement("span", { className: "button__label" }, this.props.children) : null;
        }
    }, {
        key: 'render',
        value: function render() {
            // const ButtonType = this.props.href ? 'a' : 'button';
            var props = Object.assign({}, this.attributes(), { onClick: this.onClick, className: this.classes() });
            var buttonInner = _react2.default.createElement("span", { className: "button__inner" }, this.leftIcon(), this.label(), this.rightIcon());
            return this.props.href ? _react2.default.createElement("a", Object.assign({}, props), buttonInner) : _react2.default.createElement("button", Object.assign({}, props), buttonInner);
        }
    }]);

    return Button;
}(_react2.default.Component);

Button.defaultProps = {
    variations: ['primary'],
    isDisabled: false,
    isActive: false,
    isSaving: false,
    onClick: function onClick() {},
    icon: null,
    href: null,
    iconAlignment: null,
    type: 'submit'
};
exports.default = Button;

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner(_ref) {
  var variations = _ref.variations;
  return _react2.default.createElement("div", { className: (0, _app.getComponentClasses)('spinner', variations) });
};
exports.default = Spinner;

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroupItem = exports.ButtonGroup = undefined;

var _app = __webpack_require__(2);

var ButtonGroup = exports.ButtonGroup = (0, _app.bemComponent)('button-group', 'ButtonGroup');
var ButtonGroupItem = exports.ButtonGroupItem = (0, _app.bemComponent)('button-group__item', 'ButtonGroupItem');
exports.default = ButtonGroup;

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(73);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(74));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(10);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(30));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullscreenOverlay = exports.FullscreenSidebar = exports.FullscreenMain = exports.FullscreenHeader = exports.FullscreenFrame = undefined;

var _FullscreenFrame = __webpack_require__(163);

var FullscreenFrame = _interopRequireWildcard(_FullscreenFrame);

var _FullscreenHeader = __webpack_require__(164);

var FullscreenHeader = _interopRequireWildcard(_FullscreenHeader);

var _FullscreenMain = __webpack_require__(165);

var FullscreenMain = _interopRequireWildcard(_FullscreenMain);

var _FullscreenOverlay = __webpack_require__(166);

var _FullscreenOverlay2 = _interopRequireDefault(_FullscreenOverlay);

var _FullscreenSidebar = __webpack_require__(169);

var FullscreenSidebar = _interopRequireWildcard(_FullscreenSidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.FullscreenFrame = FullscreenFrame;
exports.FullscreenHeader = FullscreenHeader;
exports.FullscreenMain = FullscreenMain;
exports.FullscreenSidebar = FullscreenSidebar;
exports.FullscreenOverlay = _FullscreenOverlay2.default;

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alert = __webpack_require__(116);

Object.defineProperty(exports, 'Alert', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alert).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(47);

Object.defineProperty(exports, 'Icon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Icon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchHtml = fetchHtml;
exports.get = get;
exports.putRequest = putRequest;
exports.deleteRequest = deleteRequest;
exports.toggleRequest = toggleRequest;

var _superagent = __webpack_require__(15);

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-restricted-imports

function genericXhrHeadersWithCsrf() {
    var csrfMeta = document.querySelector('meta[name="csrf-token"]');
    var token = csrfMeta ? csrfMeta.content : 'fake-token';
    return {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': token
    };
}

function genericXhrHeaders() {
    return {
        'X-Requested-With': 'XMLHttpRequest'
    };
}

function fetchHtml(url) {
    return new Promise(function (resolve, reject) {
        var xhr = _superagent2.default.get(url).set('Accept', 'application/html');

        xhr.end(function (error, res) {
            if (error) {
                reject({ error: error, url: url });
            } else {
                resolve(res.text);
            }
        });
    });
}

function get(url) {
    return _superagent2.default.get(url).set(genericXhrHeaders());
}

function putRequest(url) {
    return _superagent2.default.put(url).set(genericXhrHeadersWithCsrf());
}

function deleteRequest(url) {
    return _superagent2.default.delete(url).set(genericXhrHeadersWithCsrf());
}

function toggleRequest(toggleState, url) {
    if (toggleState) {
        return putRequest(url);
    }
    return deleteRequest(url);
}

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


module.exports = {
    BaseStore: __webpack_require__(119),
    createStore: __webpack_require__(53)
};


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TrackClick;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _trackEvent = __webpack_require__(66);

var _trackEvent2 = _interopRequireDefault(_trackEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TrackClick(_ref) {
    var event = _ref.event,
        element = _ref.element,
        children = _ref.children,
        _ref$payload = _ref.payload,
        payload = _ref$payload === undefined ? {} : _ref$payload;

    var el = (0, _react.useRef)(null);
    var delay = 300;
    function track() {
        (0, _trackEvent2.default)(event, Object.assign({}, payload, { element: element }));
    }
    function delayNavigation(e, link) {
        e.preventDefault();
        e.stopPropagation();
        setTimeout(function () {
            window.location.href = link.getAttribute('href') || '';
        }, delay);
    }
    // Mimics the delay from segments trackLink
    (0, _react.useEffect)(function () {
        var listeners = [];
        el.current.addEventListener('click', track, true);
        var links = el.current.querySelectorAll('a');
        Array.from(links).forEach(function (link) {
            var listener = function listener(e) {
                return delayNavigation(e, link);
            };
            link.addEventListener('click', listener);
            listeners.push({ link: link, listener: listener });
        });
        return function () {
            el.current.removeEventListener('click', track, true);
            Array.from(listeners).forEach(function (_ref2) {
                var link = _ref2.link,
                    listener = _ref2.listener;

                link.removeEventListener('click', listener);
            });
        };
    });
    return _react2.default.createElement("span", { ref: el }, children);
}

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getDimensionsConstrainedToContainer = __webpack_require__(103);

Object.keys(_getDimensionsConstrainedToContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getDimensionsConstrainedToContainer[key];
    }
  });
});

var _getDimensionsConstrainedToContainerWidth = __webpack_require__(104);

Object.keys(_getDimensionsConstrainedToContainerWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getDimensionsConstrainedToContainerWidth[key];
    }
  });
});

var _getLinkTargetPath = __webpack_require__(105);

Object.keys(_getLinkTargetPath).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getLinkTargetPath[key];
    }
  });
});

var _getLinkTargetUrl = __webpack_require__(106);

Object.keys(_getLinkTargetUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getLinkTargetUrl[key];
    }
  });
});

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IconButton = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
var IconButton = exports.IconButton = function IconButton(_ref) {
    var _ref$variations = _ref.variations,
        variations = _ref$variations === undefined ? [] : _ref$variations,
        _ref$isDisabled = _ref.isDisabled,
        isDisabled = _ref$isDisabled === undefined ? false : _ref$isDisabled,
        title = _ref.title,
        href = _ref.href,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
        _ref$isSubmit = _ref.isSubmit,
        isSubmit = _ref$isSubmit === undefined ? false : _ref$isSubmit,
        children = _ref.children;

    // const ButtonType = href ? 'a' : 'button';
    var props = {
        className: (0, _app.getComponentClasses)('icon-button', variations),
        'data-disabled': isDisabled,
        type: isSubmit ? 'submit' : 'button',
        title: title,
        onClick: isDisabled ? function () {} : onClick
    };
    if (href) {
        return _react2.default.createElement("a", Object.assign({ href: href }, props), children);
    } else {
        var type = props.type,
            buttonProps = __rest(props, ["type"]);
        var buttonType = type;
        return _react2.default.createElement("button", Object.assign({ type: buttonType }, buttonProps), children);
    }
};
exports.default = IconButton;

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createBrowserHistory = __webpack_require__(132);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customHistory = (0, _createBrowserHistory2.default)();
exports.default = customHistory;

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DetachableElement = __webpack_require__(90);

Object.defineProperty(exports, 'DetachableElement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DetachableElement).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(110)();
}


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DetachableElement = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(10);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * A wrapper component for detaching the children components from their original parent to a given DOM node
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Useful for dynamically rendering a given component out of the component parent tree. For example: Modal
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Example:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <DetachableElement>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   <div>This div will appear elsewhere in the DOM</div>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * </DetachableElement>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Caveats:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * `detachTarget` must be a node outside of component tree
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var DetachableElement = exports.DetachableElement = function (_React$Component) {
    _inherits(DetachableElement, _React$Component);

    function DetachableElement() {
        _classCallCheck(this, DetachableElement);

        var _this = _possibleConstructorReturn(this, (DetachableElement.__proto__ || Object.getPrototypeOf(DetachableElement)).apply(this, arguments));

        _this.el = document.createElement('div');
        return _this;
    }

    _createClass(DetachableElement, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.appendChild(this.el);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.removeChild(this.el);
        }
    }, {
        key: 'render',
        value: function render() {
            return _reactDom2.default.createPortal(this.props.children, this.el);
        }
    }]);

    return DetachableElement;
}(_react2.default.Component);

exports.default = DetachableElement;

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var React = __webpack_require__(0);
var PropTypes = __webpack_require__(9);
var inherits = __webpack_require__(46);
var hoistNonReactStatics = __webpack_require__(414);

function createComponent(Component, stores, getStateFromStores, customContextTypes) {
    var componentName = Component.displayName || Component.name;
    var componentContextTypes = Object.assign({
        getStore: PropTypes.func.isRequired
    }, customContextTypes);

    function StoreConnector(props, context) {
        React.Component.apply(this, arguments);
        this.state = this.getStateFromStores();
        this._onStoreChange = null;
        this._isMounted = false;
    }

    inherits(StoreConnector, React.Component);

    StoreConnector.displayName = 'storeConnector(' + componentName + ')';
    StoreConnector.contextTypes = componentContextTypes;

    Object.assign(StoreConnector.prototype, {
        componentDidMount: function componentDidMount() {
            this._isMounted = true;
            this._onStoreChange = this.constructor.prototype._onStoreChange.bind(this);
            stores.forEach(function storesEach(Store) {
                this.context.getStore(Store).on('change', this._onStoreChange);
            }, this);
        },
        componentWillUnmount: function componentWillUnmount() {
            this._isMounted = false;
            stores.forEach(function storesEach(Store) {
                this.context.getStore(Store).removeListener('change', this._onStoreChange);
            }, this);
        },
        componentWillReceiveProps: function componentWillReceiveProps(nextProps){
            this.setState(this.getStateFromStores(nextProps));
        },
        getStateFromStores: function (props) {
            props = props || this.props;
            return getStateFromStores(this.context, props);
        },
        _onStoreChange: function onStoreChange() {
            if (this._isMounted) {
                this.setState(this.getStateFromStores());
            }
        },
        render: function render() {
            var props = Component.prototype && Component.prototype.isReactComponent ? {ref: 'wrappedElement'} : null;
            return React.createElement(Component, Object.assign({}, this.props, this.state, props));
        }
    });

    hoistNonReactStatics(StoreConnector, Component);
    StoreConnector.WrappedComponent = Component;

    return StoreConnector;
}

/**
 * Registers change listeners and retrieves state from stores using the `getStateFromStores`
 * method. Concept provided by Dan Abramov via
 * https://medium.com/@dan_abramov/mixins-are-dead-long-live-higher-order-components-94a0d2f9e750
 *
 * Example:
 *   connectToStores(Component, [FooStore], {
 *       FooStore: function (store, props) {
 *           return {
 *               foo: store.getFoo()
 *           }
 *       }
 *   })
 *
 * Also supports the decorator pattern:
 *   @connectToStores([FooStore],  {
 *       FooStore: function (store, props) {
 *           return {
 *               foo: store.getFoo()
 *           }
 *       }
 *   })
 *   class ConnectedComponent extends React.Component {
 *       render() {
 *           return <div/>;
 *       }
 *   }
 *
 * @method connectToStores
 * @param {React.Component} [Component] component to pass state as props to.
 * @param {array} stores List of stores to listen for changes
 * @param {function} getStateFromStores function that receives all stores and should return
 *      the full state object. Receives `stores` hash and component `props` as arguments
 * @param {Object} [customContextTypes] additional `contextTypes` that could be accessed from your `getStateFromStores`
 *      function
 * @returns {React.Component} or {Function} if using decorator pattern
 */
module.exports = function connectToStores(Component, stores, getStateFromStores, customContextTypes) {

    // support decorator pattern
    if (typeof Component !== 'function') {
        var _stores = Component;
        var _getStateFromStores = stores;
        var _customContextTypes = getStateFromStores;
        return function connectToStoresDecorator(ComponentToDecorate) {
            return createComponent(ComponentToDecorate, _stores, _getStateFromStores, _customContextTypes);
        };
    }

    return createComponent.apply(null, arguments);
};


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var inherits = __webpack_require__(46);
var BaseStore = __webpack_require__(42);
var IGNORE_ON_PROTOTYPE = ['statics', 'storeName', 'handlers', 'mixins'];

function createChainedFunction(one, two) {
    return function chainedFunction() {
        one.apply(this, arguments);
        two.apply(this, arguments);
    };
}

function mixInto(dest, src) {
    Object.keys(src).forEach(function (prop) {
        if (-1 !== IGNORE_ON_PROTOTYPE.indexOf(prop)) {
            return;
        }
        if ('initialize' === prop) {
            if (!dest[prop]) {
                dest[prop] = src[prop];
            } else {
                dest[prop] = createChainedFunction(dest[prop], src[prop]);
            }
        } else {
            if (dest.hasOwnProperty(prop)) {
                throw new Error('Mixin property collision for property "' + prop + '"');
            }
            dest[prop] = src[prop];
        }
    });
}

/**
 * Helper for creating a store class
 * @method createStore
 * @param {Object} spec
 * @param {String} spec.storeName The name of the store
 * @param {Object} spec.handlers Hash of action name to method name of action handlers
 * @param {Function} spec.initialize Function called during construction for setting the default state
 * @param {Function} spec.dehydrate Function that returns serializable data to send to the client
 * @param {Function} spec.rehydrate Function that takes in serializable data to rehydrate the store
 */
module.exports = function createStore(spec) {
    spec.statics = spec.statics || {};
    if (!spec.storeName && !spec.statics.storeName) {
        throw new Error('createStore called without a storeName');
    }
    var Store = function (dispatcher) {
        BaseStore.call(this, dispatcher);
    };

    inherits(Store, BaseStore);

    Object.keys(spec.statics).forEach(function (prop) {
        Store[prop] = spec.statics[prop];
    });

    Store.storeName = spec.storeName || Store.storeName;
    Store.handlers = spec.handlers || Store.handlers;
    Store.mixins = spec.mixins || Store.mixins;

    if (Store.mixins) {
        Store.mixins.forEach(function(mixin) {
            mixInto(Store.prototype, mixin);
        });
    }
    mixInto(Store.prototype, spec);

    return Store;
};


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MenuItemAction = __webpack_require__(216);

var _MenuItemAction2 = _interopRequireDefault(_MenuItemAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MenuItemAction2.default;

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HoverableElement = __webpack_require__(112);

Object.defineProperty(exports, 'HoverableElement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HoverableElement).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })

},[1246]);


// WEBPACK FOOTER //
// page/inline-ddo-0bff803e0b5d07c95d99.js